const states = [
  {
    "abbreviation": "AL",
    "name": "Alabama",
    "iso_3166": "US-AL",
    "country": "US"
  },
  {
    "abbreviation": "AK",
    "name": "Alaska",
    "iso_3166": "US-AK",
    "country": "US"
  },
  {
    "abbreviation": "AZ",
    "name": "Arizona",
    "iso_3166": "US-AZ",
    "country": "US"
  },
  {
    "abbreviation": "AR",
    "name": "Arkansas",
    "iso_3166": "US-AR",
    "country": "US"
  },
  {
    "abbreviation": "CA",
    "name": "California",
    "iso_3166": "US-CA",
    "country": "US"
  },
  {
    "abbreviation": "CO",
    "name": "Colorado",
    "iso_3166": "US-CO",
    "country": "US"
  },
  {
    "abbreviation": "CT",
    "name": "Connecticut",
    "iso_3166": "US-CT",
    "country": "US"
  },
  {
    "abbreviation": "DE",
    "name": "Delaware",
    "iso_3166": "US-DE",
    "country": "US"
  },
  {
    "abbreviation": "DC",
    "name": "District of Columbia",
    "iso_3166": "US-DC",
    "country": "US"
  },
  {
    "abbreviation": "FL",
    "name": "Florida",
    "iso_3166": "US-FL",
    "country": "US"
  },
  {
    "abbreviation": "GA",
    "name": "Georgia",
    "iso_3166": "US-GA",
    "country": "US"
  },
  {
    "abbreviation": "HI",
    "name": "Hawaii",
    "iso_3166": "US-HI",
    "country": "US"
  },
  {
    "abbreviation": "ID",
    "name": "Idaho",
    "iso_3166": "US-ID",
    "country": "US"
  },
  {
    "abbreviation": "IL",
    "name": "Illinois",
    "iso_3166": "US-IL",
    "country": "US"
  },
  {
    "abbreviation": "IN",
    "name": "Indiana",
    "iso_3166": "US-IN",
    "country": "US"
  },
  {
    "abbreviation": "IA",
    "name": "Iowa",
    "iso_3166": "US-IA",
    "country": "US"
  },
  {
    "abbreviation": "KS",
    "name": "Kansas",
    "iso_3166": "US-KS",
    "country": "US"
  },
  {
    "abbreviation": "KY",
    "name": "Kentucky",
    "iso_3166": "US-KY",
    "country": "US"
  },
  {
    "abbreviation": "LA",
    "name": "Louisiana",
    "iso_3166": "US-LA",
    "country": "US"
  },
  {
    "abbreviation": "ME",
    "name": "Maine",
    "iso_3166": "US-ME",
    "country": "US"
  },
  {
    "abbreviation": "MD",
    "name": "Maryland",
    "iso_3166": "US-MD",
    "country": "US"
  },
  {
    "abbreviation": "MA",
    "name": "Massachusetts",
    "iso_3166": "US-MA",
    "country": "US"
  },
  {
    "abbreviation": "MI",
    "name": "Michigan",
    "iso_3166": "US-MI",
    "country": "US"
  },
  {
    "abbreviation": "MN",
    "name": "Minnesota",
    "iso_3166": "US-MN",
    "country": "US"
  },
  {
    "abbreviation": "MS",
    "name": "Mississippi",
    "iso_3166": "US-MS",
    "country": "US"
  },
  {
    "abbreviation": "MO",
    "name": "Missouri",
    "iso_3166": "US-MO",
    "country": "US"
  },
  {
    "abbreviation": "MT",
    "name": "Montana",
    "iso_3166": "US-MT",
    "country": "US"
  },
  {
    "abbreviation": "NE",
    "name": "Nebraska",
    "iso_3166": "US-NE",
    "country": "US"
  },
  {
    "abbreviation": "NV",
    "name": "Nevada",
    "iso_3166": "US-NV",
    "country": "US"
  },
  {
    "abbreviation": "NH",
    "name": "New Hampshire",
    "iso_3166": "US-NH",
    "country": "US"
  },
  {
    "abbreviation": "NJ",
    "name": "New Jersey",
    "iso_3166": "US-NJ",
    "country": "US"
  },
  {
    "abbreviation": "NM",
    "name": "New Mexico",
    "iso_3166": "US-NM",
    "country": "US"
  },
  {
    "abbreviation": "NY",
    "name": "New York",
    "iso_3166": "US-NY",
    "country": "US"
  },
  {
    "abbreviation": "NC",
    "name": "North Carolina",
    "iso_3166": "US-NC",
    "country": "US"
  },
  {
    "abbreviation": "ND",
    "name": "North Dakota",
    "iso_3166": "US-ND",
    "country": "US"
  },
  {
    "abbreviation": "OH",
    "name": "Ohio",
    "iso_3166": "US-OH",
    "country": "US"
  },
  {
    "abbreviation": "OK",
    "name": "Oklahoma",
    "iso_3166": "US-OK",
    "country": "US"
  },
  {
    "abbreviation": "OR",
    "name": "Oregon",
    "iso_3166": "US-OR",
    "country": "US"
  },
  {
    "abbreviation": "PA",
    "name": "Pennsylvania",
    "iso_3166": "US-PA",
    "country": "US"
  },
  {
    "abbreviation": "RI",
    "name": "Rhode Island",
    "iso_3166": "US-RI",
    "country": "US"
  },
  {
    "abbreviation": "SC",
    "name": "South Carolina",
    "iso_3166": "US-SC",
    "country": "US"
  },
  {
    "abbreviation": "SD",
    "name": "South Dakota",
    "iso_3166": "US-SD",
    "country": "US"
  },
  {
    "abbreviation": "TN",
    "name": "Tennessee",
    "iso_3166": "US-TN",
    "country": "US"
  },
  {
    "abbreviation": "TX",
    "name": "Texas",
    "iso_3166": "US-TX",
    "country": "US"
  },
  {
    "abbreviation": "UT",
    "name": "Utah",
    "iso_3166": "US-UT",
    "country": "US"
  },
  {
    "abbreviation": "VT",
    "name": "Vermont",
    "iso_3166": "US-VT",
    "country": "US"
  },
  {
    "abbreviation": "VA",
    "name": "Virginia",
    "iso_3166": "US-VA",
    "country": "US"
  },
  {
    "abbreviation": "WA",
    "name": "Washington",
    "iso_3166": "US-WA",
    "country": "US"
  },
  {
    "abbreviation": "WV",
    "name": "West Virginia",
    "iso_3166": "US-WV",
    "country": "US"
  },
  {
    "abbreviation": "WI",
    "name": "Wisconsin",
    "iso_3166": "US-WI",
    "country": "US"
  },
  {
    "abbreviation": "WY",
    "name": "Wyoming",
    "iso_3166": "US-WY",
    "country": "US"
  },
  {
    "abbreviation": "AB",
    "name": "Alberta",
    "iso_3166": "CA-AB",
    "country": "CA"
  },
  {
    "abbreviation": "BC",
    "name": "British Columbia",
    "iso_3166": "CA-BC",
    "country": "CA"
  },
  {
    "abbreviation": "MB",
    "name": "Manitoba",
    "iso_3166": "CA-MB",
    "country": "CA"
  },
  {
    "abbreviation": "NB",
    "name": "New Brunswick",
    "iso_3166": "CA-NB",
    "country": "CA"
  },
  {
    "abbreviation": "NL",
    "name": "Newfoundland and Labrador",
    "iso_3166": "CA-NL",
    "country": "CA"
  },
  {
    "abbreviation": "NT",
    "name": "Northwest Territories",
    "iso_3166": "CA-NT",
    "country": "CA"
  },
  {
    "abbreviation": "NS",
    "name": "Nova Scotia",
    "iso_3166": "CA-NS",
    "country": "CA"
  },
  {
    "abbreviation": "NU",
    "name": "Nunavut",
    "iso_3166": "CA-NU",
    "country": "CA"
  },
  {
    "abbreviation": "ON",
    "name": "Ontario",
    "iso_3166": "CA-ON",
    "country": "CA"
  },
  {
    "abbreviation": "PE",
    "name": "Prince Edward Island",
    "iso_3166": "CA-PE",
    "country": "CA"
  },
  {
    "abbreviation": "QC",
    "name": "Quebec",
    "iso_3166": "CA-QC",
    "country": "CA"
  },
  {
    "abbreviation": "SK",
    "name": "Saskatchewan",
    "iso_3166": "CA-SK",
    "country": "CA"
  },
  {
    "abbreviation": "YT",
    "name": "Yukon",
    "iso_3166": "CA-YT",
    "country": "CA"
  },
  {
    "abbreviation": "BDG",
    "name": "Badghis",
    "iso_3166": "AF-BDG",
    "country": "AF"
  },
  {
    "abbreviation": "BGL",
    "name": "Baghlan",
    "iso_3166": "AF-BGL",
    "country": "AF"
  },
  {
    "abbreviation": "BAL",
    "name": "Balkh",
    "iso_3166": "AF-BAL",
    "country": "AF"
  },
  {
    "abbreviation": "BAM",
    "name": "Bamyan",
    "iso_3166": "AF-BAM",
    "country": "AF"
  },
  {
    "abbreviation": "DAY",
    "name": "Daykundi",
    "iso_3166": "AF-DAY",
    "country": "AF"
  },
  {
    "abbreviation": "FRA",
    "name": "Farah",
    "iso_3166": "AF-FRA",
    "country": "AF"
  },
  {
    "abbreviation": "FYB",
    "name": "Faryab",
    "iso_3166": "AF-FYB",
    "country": "AF"
  },
  {
    "abbreviation": "GHA",
    "name": "Ghazni",
    "iso_3166": "AF-GHA",
    "country": "AF"
  },
  {
    "abbreviation": "GHO",
    "name": "Ghor",
    "iso_3166": "AF-GHO",
    "country": "AF"
  },
  {
    "abbreviation": "HEL",
    "name": "Helmand",
    "iso_3166": "AF-HEL",
    "country": "AF"
  },
  {
    "abbreviation": "HER",
    "name": "Herat",
    "iso_3166": "AF-HER",
    "country": "AF"
  },
  {
    "abbreviation": "JOW",
    "name": "Jowzjan",
    "iso_3166": "AF-JOW",
    "country": "AF"
  },
  {
    "abbreviation": "KAB",
    "name": "Kabul",
    "iso_3166": "AF-KAB",
    "country": "AF"
  },
  {
    "abbreviation": "KAN",
    "name": "Kandahar",
    "iso_3166": "AF-KAN",
    "country": "AF"
  },
  {
    "abbreviation": "KHO",
    "name": "Khost",
    "iso_3166": "AF-KHO",
    "country": "AF"
  },
  {
    "abbreviation": "KDZ",
    "name": "Kunduz",
    "iso_3166": "AF-KDZ",
    "country": "AF"
  },
  {
    "abbreviation": "LAG",
    "name": "Laghman",
    "iso_3166": "AF-LAG",
    "country": "AF"
  },
  {
    "abbreviation": "LOG",
    "name": "Logar",
    "iso_3166": "AF-LOG",
    "country": "AF"
  },
  {
    "abbreviation": "NAN",
    "name": "Nangarhar",
    "iso_3166": "AF-NAN",
    "country": "AF"
  },
  {
    "abbreviation": "NIM",
    "name": "Nimroz",
    "iso_3166": "AF-NIM",
    "country": "AF"
  },
  {
    "abbreviation": "PKA",
    "name": "Paktika",
    "iso_3166": "AF-PKA",
    "country": "AF"
  },
  {
    "abbreviation": "PIA",
    "name": "Paktiya",
    "iso_3166": "AF-PIA",
    "country": "AF"
  },
  {
    "abbreviation": "PAR",
    "name": "Parwan",
    "iso_3166": "AF-PAR",
    "country": "AF"
  },
  {
    "abbreviation": "SAM",
    "name": "Samangan",
    "iso_3166": "AF-SAM",
    "country": "AF"
  },
  {
    "abbreviation": "SAR",
    "name": "Sar-e Pul",
    "iso_3166": "AF-SAR",
    "country": "AF"
  },
  {
    "abbreviation": "TAK",
    "name": "Takhar",
    "iso_3166": "AF-TAK",
    "country": "AF"
  },
  {
    "abbreviation": "URU",
    "name": "Uruzgan",
    "iso_3166": "AF-URU",
    "country": "AF"
  },
  {
    "abbreviation": "WAR",
    "name": "Wardak",
    "iso_3166": "AF-WAR",
    "country": "AF"
  },
  {
    "abbreviation": "-",
    "name": "Eckeroe",
    "iso_3166": "-",
    "country": "AX"
  },
  {
    "abbreviation": "-",
    "name": "Finstroem",
    "iso_3166": "-",
    "country": "AX"
  },
  {
    "abbreviation": "-",
    "name": "Hammarland",
    "iso_3166": "-",
    "country": "AX"
  },
  {
    "abbreviation": "-",
    "name": "Jomala",
    "iso_3166": "-",
    "country": "AX"
  },
  {
    "abbreviation": "-",
    "name": "Lemland",
    "iso_3166": "-",
    "country": "AX"
  },
  {
    "abbreviation": "-",
    "name": "Mariehamn",
    "iso_3166": "-",
    "country": "AX"
  },
  {
    "abbreviation": "-",
    "name": "Saltvik",
    "iso_3166": "-",
    "country": "AX"
  },
  {
    "abbreviation": "01",
    "name": "Berat",
    "iso_3166": "AL-01",
    "country": "AL"
  },
  {
    "abbreviation": "09",
    "name": "Diber",
    "iso_3166": "AL-09",
    "country": "AL"
  },
  {
    "abbreviation": "02",
    "name": "Durres",
    "iso_3166": "AL-02",
    "country": "AL"
  },
  {
    "abbreviation": "03",
    "name": "Elbasan",
    "iso_3166": "AL-03",
    "country": "AL"
  },
  {
    "abbreviation": "04",
    "name": "Fier",
    "iso_3166": "AL-04",
    "country": "AL"
  },
  {
    "abbreviation": "05",
    "name": "Gjirokaster",
    "iso_3166": "AL-05",
    "country": "AL"
  },
  {
    "abbreviation": "06",
    "name": "Korce",
    "iso_3166": "AL-06",
    "country": "AL"
  },
  {
    "abbreviation": "07",
    "name": "Kukes",
    "iso_3166": "AL-07",
    "country": "AL"
  },
  {
    "abbreviation": "08",
    "name": "Lezhe",
    "iso_3166": "AL-08",
    "country": "AL"
  },
  {
    "abbreviation": "10",
    "name": "Shkoder",
    "iso_3166": "AL-10",
    "country": "AL"
  },
  {
    "abbreviation": "11",
    "name": "Tirane",
    "iso_3166": "AL-11",
    "country": "AL"
  },
  {
    "abbreviation": "12",
    "name": "Vlore",
    "iso_3166": "AL-12",
    "country": "AL"
  },
  {
    "abbreviation": "01",
    "name": "Adrar",
    "iso_3166": "DZ-01",
    "country": "DZ"
  },
  {
    "abbreviation": "44",
    "name": "Ain Defla",
    "iso_3166": "DZ-44",
    "country": "DZ"
  },
  {
    "abbreviation": "46",
    "name": "Ain Temouchent",
    "iso_3166": "DZ-46",
    "country": "DZ"
  },
  {
    "abbreviation": "16",
    "name": "Alger",
    "iso_3166": "DZ-16",
    "country": "DZ"
  },
  {
    "abbreviation": "23",
    "name": "Annaba",
    "iso_3166": "DZ-23",
    "country": "DZ"
  },
  {
    "abbreviation": "05",
    "name": "Batna",
    "iso_3166": "DZ-05",
    "country": "DZ"
  },
  {
    "abbreviation": "08",
    "name": "Bechar",
    "iso_3166": "DZ-08",
    "country": "DZ"
  },
  {
    "abbreviation": "06",
    "name": "Bejaia",
    "iso_3166": "DZ-06",
    "country": "DZ"
  },
  {
    "abbreviation": "07",
    "name": "Biskra",
    "iso_3166": "DZ-07",
    "country": "DZ"
  },
  {
    "abbreviation": "09",
    "name": "Blida",
    "iso_3166": "DZ-09",
    "country": "DZ"
  },
  {
    "abbreviation": "34",
    "name": "Bordj Bou Arreridj",
    "iso_3166": "DZ-34",
    "country": "DZ"
  },
  {
    "abbreviation": "10",
    "name": "Bouira",
    "iso_3166": "DZ-10",
    "country": "DZ"
  },
  {
    "abbreviation": "35",
    "name": "Boumerdes",
    "iso_3166": "DZ-35",
    "country": "DZ"
  },
  {
    "abbreviation": "02",
    "name": "Chlef",
    "iso_3166": "DZ-02",
    "country": "DZ"
  },
  {
    "abbreviation": "25",
    "name": "Constantine",
    "iso_3166": "DZ-25",
    "country": "DZ"
  },
  {
    "abbreviation": "56",
    "name": "Djanet",
    "iso_3166": "DZ-56",
    "country": "DZ"
  },
  {
    "abbreviation": "17",
    "name": "Djelfa",
    "iso_3166": "DZ-17",
    "country": "DZ"
  },
  {
    "abbreviation": "32",
    "name": "El Bayadh",
    "iso_3166": "DZ-32",
    "country": "DZ"
  },
  {
    "abbreviation": "57",
    "name": "El Meghaier",
    "iso_3166": "DZ-57",
    "country": "DZ"
  },
  {
    "abbreviation": "39",
    "name": "El Oued",
    "iso_3166": "DZ-39",
    "country": "DZ"
  },
  {
    "abbreviation": "36",
    "name": "El Tarf",
    "iso_3166": "DZ-36",
    "country": "DZ"
  },
  {
    "abbreviation": "47",
    "name": "Ghardaia",
    "iso_3166": "DZ-47",
    "country": "DZ"
  },
  {
    "abbreviation": "24",
    "name": "Guelma",
    "iso_3166": "DZ-24",
    "country": "DZ"
  },
  {
    "abbreviation": "33",
    "name": "Illizi",
    "iso_3166": "DZ-33",
    "country": "DZ"
  },
  {
    "abbreviation": "53",
    "name": "In Salah",
    "iso_3166": "DZ-53",
    "country": "DZ"
  },
  {
    "abbreviation": "18",
    "name": "Jijel",
    "iso_3166": "DZ-18",
    "country": "DZ"
  },
  {
    "abbreviation": "40",
    "name": "Khenchela",
    "iso_3166": "DZ-40",
    "country": "DZ"
  },
  {
    "abbreviation": "03",
    "name": "Laghouat",
    "iso_3166": "DZ-03",
    "country": "DZ"
  },
  {
    "abbreviation": "28",
    "name": "M'sila",
    "iso_3166": "DZ-28",
    "country": "DZ"
  },
  {
    "abbreviation": "29",
    "name": "Mascara",
    "iso_3166": "DZ-29",
    "country": "DZ"
  },
  {
    "abbreviation": "26",
    "name": "Medea",
    "iso_3166": "DZ-26",
    "country": "DZ"
  },
  {
    "abbreviation": "43",
    "name": "Mila",
    "iso_3166": "DZ-43",
    "country": "DZ"
  },
  {
    "abbreviation": "27",
    "name": "Mostaganem",
    "iso_3166": "DZ-27",
    "country": "DZ"
  },
  {
    "abbreviation": "45",
    "name": "Naama",
    "iso_3166": "DZ-45",
    "country": "DZ"
  },
  {
    "abbreviation": "31",
    "name": "Oran",
    "iso_3166": "DZ-31",
    "country": "DZ"
  },
  {
    "abbreviation": "30",
    "name": "Ouargla",
    "iso_3166": "DZ-30",
    "country": "DZ"
  },
  {
    "abbreviation": "51",
    "name": "Ouled Djellal",
    "iso_3166": "DZ-51",
    "country": "DZ"
  },
  {
    "abbreviation": "04",
    "name": "Oum el Bouaghi",
    "iso_3166": "DZ-04",
    "country": "DZ"
  },
  {
    "abbreviation": "48",
    "name": "Relizane",
    "iso_3166": "DZ-48",
    "country": "DZ"
  },
  {
    "abbreviation": "20",
    "name": "Saida",
    "iso_3166": "DZ-20",
    "country": "DZ"
  },
  {
    "abbreviation": "19",
    "name": "Setif",
    "iso_3166": "DZ-19",
    "country": "DZ"
  },
  {
    "abbreviation": "22",
    "name": "Sidi Bel Abbes",
    "iso_3166": "DZ-22",
    "country": "DZ"
  },
  {
    "abbreviation": "21",
    "name": "Skikda",
    "iso_3166": "DZ-21",
    "country": "DZ"
  },
  {
    "abbreviation": "41",
    "name": "Souk Ahras",
    "iso_3166": "DZ-41",
    "country": "DZ"
  },
  {
    "abbreviation": "11",
    "name": "Tamanrasset",
    "iso_3166": "DZ-11",
    "country": "DZ"
  },
  {
    "abbreviation": "12",
    "name": "Tebessa",
    "iso_3166": "DZ-12",
    "country": "DZ"
  },
  {
    "abbreviation": "14",
    "name": "Tiaret",
    "iso_3166": "DZ-14",
    "country": "DZ"
  },
  {
    "abbreviation": "49",
    "name": "Timimoun",
    "iso_3166": "DZ-49",
    "country": "DZ"
  },
  {
    "abbreviation": "37",
    "name": "Tindouf",
    "iso_3166": "DZ-37",
    "country": "DZ"
  },
  {
    "abbreviation": "42",
    "name": "Tipaza",
    "iso_3166": "DZ-42",
    "country": "DZ"
  },
  {
    "abbreviation": "38",
    "name": "Tissemsilt",
    "iso_3166": "DZ-38",
    "country": "DZ"
  },
  {
    "abbreviation": "15",
    "name": "Tizi Ouzou",
    "iso_3166": "DZ-15",
    "country": "DZ"
  },
  {
    "abbreviation": "13",
    "name": "Tlemcen",
    "iso_3166": "DZ-13",
    "country": "DZ"
  },
  {
    "abbreviation": "55",
    "name": "Touggourt",
    "iso_3166": "DZ-55",
    "country": "DZ"
  },
  {
    "abbreviation": "-",
    "name": "Eastern District",
    "iso_3166": "-",
    "country": "AS"
  },
  {
    "abbreviation": "-",
    "name": "Western District",
    "iso_3166": "-",
    "country": "AS"
  },
  {
    "abbreviation": "07",
    "name": "Andorra la Vella",
    "iso_3166": "AD-07",
    "country": "AD"
  },
  {
    "abbreviation": "02",
    "name": "Canillo",
    "iso_3166": "AD-02",
    "country": "AD"
  },
  {
    "abbreviation": "03",
    "name": "Encamp",
    "iso_3166": "AD-03",
    "country": "AD"
  },
  {
    "abbreviation": "08",
    "name": "Escaldes-Engordany",
    "iso_3166": "AD-08",
    "country": "AD"
  },
  {
    "abbreviation": "04",
    "name": "La Massana",
    "iso_3166": "AD-04",
    "country": "AD"
  },
  {
    "abbreviation": "05",
    "name": "Ordino",
    "iso_3166": "AD-05",
    "country": "AD"
  },
  {
    "abbreviation": "06",
    "name": "Sant Julia de Loria",
    "iso_3166": "AD-06",
    "country": "AD"
  },
  {
    "abbreviation": "BGO",
    "name": "Bengo",
    "iso_3166": "AO-BGO",
    "country": "AO"
  },
  {
    "abbreviation": "BGU",
    "name": "Benguela",
    "iso_3166": "AO-BGU",
    "country": "AO"
  },
  {
    "abbreviation": "BIE",
    "name": "Bie",
    "iso_3166": "AO-BIE",
    "country": "AO"
  },
  {
    "abbreviation": "CAB",
    "name": "Cabinda",
    "iso_3166": "AO-CAB",
    "country": "AO"
  },
  {
    "abbreviation": "CCU",
    "name": "Cuando Cubango",
    "iso_3166": "AO-CCU",
    "country": "AO"
  },
  {
    "abbreviation": "CNO",
    "name": "Cuanza-Norte",
    "iso_3166": "AO-CNO",
    "country": "AO"
  },
  {
    "abbreviation": "CUS",
    "name": "Cuanza-Sul",
    "iso_3166": "AO-CUS",
    "country": "AO"
  },
  {
    "abbreviation": "CNN",
    "name": "Cunene",
    "iso_3166": "AO-CNN",
    "country": "AO"
  },
  {
    "abbreviation": "HUA",
    "name": "Huambo",
    "iso_3166": "AO-HUA",
    "country": "AO"
  },
  {
    "abbreviation": "HUI",
    "name": "Huila",
    "iso_3166": "AO-HUI",
    "country": "AO"
  },
  {
    "abbreviation": "LUA",
    "name": "Luanda",
    "iso_3166": "AO-LUA",
    "country": "AO"
  },
  {
    "abbreviation": "LNO",
    "name": "Lunda-Norte",
    "iso_3166": "AO-LNO",
    "country": "AO"
  },
  {
    "abbreviation": "LSU",
    "name": "Lunda-Sul",
    "iso_3166": "AO-LSU",
    "country": "AO"
  },
  {
    "abbreviation": "MAL",
    "name": "Malange",
    "iso_3166": "AO-MAL",
    "country": "AO"
  },
  {
    "abbreviation": "MOX",
    "name": "Moxico",
    "iso_3166": "AO-MOX",
    "country": "AO"
  },
  {
    "abbreviation": "NAM",
    "name": "Namibe",
    "iso_3166": "AO-NAM",
    "country": "AO"
  },
  {
    "abbreviation": "UIG",
    "name": "Uige",
    "iso_3166": "AO-UIG",
    "country": "AO"
  },
  {
    "abbreviation": "ZAI",
    "name": "Zaire",
    "iso_3166": "AO-ZAI",
    "country": "AO"
  },
  {
    "abbreviation": "-",
    "name": "Anguilla",
    "iso_3166": "-",
    "country": "AI"
  },
  {
    "abbreviation": "-",
    "name": "Antarctica",
    "iso_3166": "-",
    "country": "AQ"
  },
  {
    "abbreviation": "10",
    "name": "Barbuda",
    "iso_3166": "AG-10",
    "country": "AG"
  },
  {
    "abbreviation": "11",
    "name": "Redonda",
    "iso_3166": "AG-11",
    "country": "AG"
  },
  {
    "abbreviation": "03",
    "name": "Saint George",
    "iso_3166": "AG-03",
    "country": "AG"
  },
  {
    "abbreviation": "04",
    "name": "Saint John",
    "iso_3166": "AG-04",
    "country": "AG"
  },
  {
    "abbreviation": "05",
    "name": "Saint Mary",
    "iso_3166": "AG-05",
    "country": "AG"
  },
  {
    "abbreviation": "07",
    "name": "Saint Peter",
    "iso_3166": "AG-07",
    "country": "AG"
  },
  {
    "abbreviation": "08",
    "name": "Saint Philip",
    "iso_3166": "AG-08",
    "country": "AG"
  },
  {
    "abbreviation": "B",
    "name": "Buenos Aires",
    "iso_3166": "AR-B",
    "country": "AR"
  },
  {
    "abbreviation": "K",
    "name": "Catamarca",
    "iso_3166": "AR-K",
    "country": "AR"
  },
  {
    "abbreviation": "H",
    "name": "Chaco",
    "iso_3166": "AR-H",
    "country": "AR"
  },
  {
    "abbreviation": "U",
    "name": "Chubut",
    "iso_3166": "AR-U",
    "country": "AR"
  },
  {
    "abbreviation": "C",
    "name": "Ciudad Autonoma de Buenos Aires",
    "iso_3166": "AR-C",
    "country": "AR"
  },
  {
    "abbreviation": "X",
    "name": "Cordoba",
    "iso_3166": "AR-X",
    "country": "AR"
  },
  {
    "abbreviation": "W",
    "name": "Corrientes",
    "iso_3166": "AR-W",
    "country": "AR"
  },
  {
    "abbreviation": "E",
    "name": "Entre Rios",
    "iso_3166": "AR-E",
    "country": "AR"
  },
  {
    "abbreviation": "P",
    "name": "Formosa",
    "iso_3166": "AR-P",
    "country": "AR"
  },
  {
    "abbreviation": "Y",
    "name": "Jujuy",
    "iso_3166": "AR-Y",
    "country": "AR"
  },
  {
    "abbreviation": "L",
    "name": "La Pampa",
    "iso_3166": "AR-L",
    "country": "AR"
  },
  {
    "abbreviation": "F",
    "name": "La Rioja",
    "iso_3166": "AR-F",
    "country": "AR"
  },
  {
    "abbreviation": "M",
    "name": "Mendoza",
    "iso_3166": "AR-M",
    "country": "AR"
  },
  {
    "abbreviation": "N",
    "name": "Misiones",
    "iso_3166": "AR-N",
    "country": "AR"
  },
  {
    "abbreviation": "Q",
    "name": "Neuquen",
    "iso_3166": "AR-Q",
    "country": "AR"
  },
  {
    "abbreviation": "R",
    "name": "Rio Negro",
    "iso_3166": "AR-R",
    "country": "AR"
  },
  {
    "abbreviation": "A",
    "name": "Salta",
    "iso_3166": "AR-A",
    "country": "AR"
  },
  {
    "abbreviation": "J",
    "name": "San Juan",
    "iso_3166": "AR-J",
    "country": "AR"
  },
  {
    "abbreviation": "D",
    "name": "San Luis",
    "iso_3166": "AR-D",
    "country": "AR"
  },
  {
    "abbreviation": "Z",
    "name": "Santa Cruz",
    "iso_3166": "AR-Z",
    "country": "AR"
  },
  {
    "abbreviation": "S",
    "name": "Santa Fe",
    "iso_3166": "AR-S",
    "country": "AR"
  },
  {
    "abbreviation": "G",
    "name": "Santiago del Estero",
    "iso_3166": "AR-G",
    "country": "AR"
  },
  {
    "abbreviation": "V",
    "name": "Tierra del Fuego",
    "iso_3166": "AR-V",
    "country": "AR"
  },
  {
    "abbreviation": "T",
    "name": "Tucuman",
    "iso_3166": "AR-T",
    "country": "AR"
  },
  {
    "abbreviation": "AG",
    "name": "Aragacotn",
    "iso_3166": "AM-AG",
    "country": "AM"
  },
  {
    "abbreviation": "AR",
    "name": "Ararat",
    "iso_3166": "AM-AR",
    "country": "AM"
  },
  {
    "abbreviation": "AV",
    "name": "Armavir",
    "iso_3166": "AM-AV",
    "country": "AM"
  },
  {
    "abbreviation": "ER",
    "name": "Erevan",
    "iso_3166": "AM-ER",
    "country": "AM"
  },
  {
    "abbreviation": "GR",
    "name": "Gegark'unik'",
    "iso_3166": "AM-GR",
    "country": "AM"
  },
  {
    "abbreviation": "KT",
    "name": "Kotayk'",
    "iso_3166": "AM-KT",
    "country": "AM"
  },
  {
    "abbreviation": "LO",
    "name": "Lori",
    "iso_3166": "AM-LO",
    "country": "AM"
  },
  {
    "abbreviation": "SH",
    "name": "Sirak",
    "iso_3166": "AM-SH",
    "country": "AM"
  },
  {
    "abbreviation": "SU",
    "name": "Syunik'",
    "iso_3166": "AM-SU",
    "country": "AM"
  },
  {
    "abbreviation": "TV",
    "name": "Tavus",
    "iso_3166": "AM-TV",
    "country": "AM"
  },
  {
    "abbreviation": "VD",
    "name": "Vayoc Jor",
    "iso_3166": "AM-VD",
    "country": "AM"
  },
  {
    "abbreviation": "-",
    "name": "Aruba",
    "iso_3166": "-",
    "country": "AW"
  },
  {
    "abbreviation": "ACT",
    "name": "Australian Capital Territory",
    "iso_3166": "AU-ACT",
    "country": "AU"
  },
  {
    "abbreviation": "NSW",
    "name": "New South Wales",
    "iso_3166": "AU-NSW",
    "country": "AU"
  },
  {
    "abbreviation": "NT",
    "name": "Northern Territory",
    "iso_3166": "AU-NT",
    "country": "AU"
  },
  {
    "abbreviation": "QLD",
    "name": "Queensland",
    "iso_3166": "AU-QLD",
    "country": "AU"
  },
  {
    "abbreviation": "SA",
    "name": "South Australia",
    "iso_3166": "AU-SA",
    "country": "AU"
  },
  {
    "abbreviation": "TAS",
    "name": "Tasmania",
    "iso_3166": "AU-TAS",
    "country": "AU"
  },
  {
    "abbreviation": "VIC",
    "name": "Victoria",
    "iso_3166": "AU-VIC",
    "country": "AU"
  },
  {
    "abbreviation": "WA",
    "name": "Western Australia",
    "iso_3166": "AU-WA",
    "country": "AU"
  },
  {
    "abbreviation": "1",
    "name": "Burgenland",
    "iso_3166": "AT-1",
    "country": "AT"
  },
  {
    "abbreviation": "2",
    "name": "Karnten",
    "iso_3166": "AT-2",
    "country": "AT"
  },
  {
    "abbreviation": "3",
    "name": "Niederosterreich",
    "iso_3166": "AT-3",
    "country": "AT"
  },
  {
    "abbreviation": "4",
    "name": "Oberosterreich",
    "iso_3166": "AT-4",
    "country": "AT"
  },
  {
    "abbreviation": "5",
    "name": "Salzburg",
    "iso_3166": "AT-5",
    "country": "AT"
  },
  {
    "abbreviation": "6",
    "name": "Steiermark",
    "iso_3166": "AT-6",
    "country": "AT"
  },
  {
    "abbreviation": "7",
    "name": "Tirol",
    "iso_3166": "AT-7",
    "country": "AT"
  },
  {
    "abbreviation": "8",
    "name": "Vorarlberg",
    "iso_3166": "AT-8",
    "country": "AT"
  },
  {
    "abbreviation": "9",
    "name": "Wien",
    "iso_3166": "AT-9",
    "country": "AT"
  },
  {
    "abbreviation": "ABS",
    "name": "Abseron",
    "iso_3166": "AZ-ABS",
    "country": "AZ"
  },
  {
    "abbreviation": "AGC",
    "name": "Agcabadi",
    "iso_3166": "AZ-AGC",
    "country": "AZ"
  },
  {
    "abbreviation": "AGS",
    "name": "Agdas",
    "iso_3166": "AZ-AGS",
    "country": "AZ"
  },
  {
    "abbreviation": "AGA",
    "name": "Agstafa",
    "iso_3166": "AZ-AGA",
    "country": "AZ"
  },
  {
    "abbreviation": "AGU",
    "name": "Agsu",
    "iso_3166": "AZ-AGU",
    "country": "AZ"
  },
  {
    "abbreviation": "AST",
    "name": "Astara",
    "iso_3166": "AZ-AST",
    "country": "AZ"
  },
  {
    "abbreviation": "BA",
    "name": "Baki",
    "iso_3166": "AZ-BA",
    "country": "AZ"
  },
  {
    "abbreviation": "BAL",
    "name": "Balakan",
    "iso_3166": "AZ-BAL",
    "country": "AZ"
  },
  {
    "abbreviation": "BAR",
    "name": "Barda",
    "iso_3166": "AZ-BAR",
    "country": "AZ"
  },
  {
    "abbreviation": "BEY",
    "name": "Beylaqan",
    "iso_3166": "AZ-BEY",
    "country": "AZ"
  },
  {
    "abbreviation": "BIL",
    "name": "Bilasuvar",
    "iso_3166": "AZ-BIL",
    "country": "AZ"
  },
  {
    "abbreviation": "CAL",
    "name": "Calilabad",
    "iso_3166": "AZ-CAL",
    "country": "AZ"
  },
  {
    "abbreviation": "DAS",
    "name": "Daskasan",
    "iso_3166": "AZ-DAS",
    "country": "AZ"
  },
  {
    "abbreviation": "FUZ",
    "name": "Fuzuli",
    "iso_3166": "AZ-FUZ",
    "country": "AZ"
  },
  {
    "abbreviation": "GAD",
    "name": "Gadabay",
    "iso_3166": "AZ-GAD",
    "country": "AZ"
  },
  {
    "abbreviation": "GA",
    "name": "Ganca",
    "iso_3166": "AZ-GA",
    "country": "AZ"
  },
  {
    "abbreviation": "GOY",
    "name": "Goycay",
    "iso_3166": "AZ-GOY",
    "country": "AZ"
  },
  {
    "abbreviation": "GYG",
    "name": "Goygol",
    "iso_3166": "AZ-GYG",
    "country": "AZ"
  },
  {
    "abbreviation": "IMI",
    "name": "Imisli",
    "iso_3166": "AZ-IMI",
    "country": "AZ"
  },
  {
    "abbreviation": "ISM",
    "name": "Ismayilli",
    "iso_3166": "AZ-ISM",
    "country": "AZ"
  },
  {
    "abbreviation": "KUR",
    "name": "Kurdamir",
    "iso_3166": "AZ-KUR",
    "country": "AZ"
  },
  {
    "abbreviation": "LA",
    "name": "Lankaran",
    "iso_3166": "AZ-LA",
    "country": "AZ"
  },
  {
    "abbreviation": "MAS",
    "name": "Masalli",
    "iso_3166": "AZ-MAS",
    "country": "AZ"
  },
  {
    "abbreviation": "MI",
    "name": "Mingacevir",
    "iso_3166": "AZ-MI",
    "country": "AZ"
  },
  {
    "abbreviation": "NA",
    "name": "Naftalan",
    "iso_3166": "AZ-NA",
    "country": "AZ"
  },
  {
    "abbreviation": "NX",
    "name": "Naxcivan",
    "iso_3166": "AZ-NX",
    "country": "AZ"
  },
  {
    "abbreviation": "NEF",
    "name": "Neftcala",
    "iso_3166": "AZ-NEF",
    "country": "AZ"
  },
  {
    "abbreviation": "OGU",
    "name": "Oguz",
    "iso_3166": "AZ-OGU",
    "country": "AZ"
  },
  {
    "abbreviation": "QAB",
    "name": "Qabala",
    "iso_3166": "AZ-QAB",
    "country": "AZ"
  },
  {
    "abbreviation": "QAX",
    "name": "Qax",
    "iso_3166": "AZ-QAX",
    "country": "AZ"
  },
  {
    "abbreviation": "QAZ",
    "name": "Qazax",
    "iso_3166": "AZ-QAZ",
    "country": "AZ"
  },
  {
    "abbreviation": "QBA",
    "name": "Quba",
    "iso_3166": "AZ-QBA",
    "country": "AZ"
  },
  {
    "abbreviation": "QUS",
    "name": "Qusar",
    "iso_3166": "AZ-QUS",
    "country": "AZ"
  },
  {
    "abbreviation": "SAT",
    "name": "Saatli",
    "iso_3166": "AZ-SAT",
    "country": "AZ"
  },
  {
    "abbreviation": "SAB",
    "name": "Sabirabad",
    "iso_3166": "AZ-SAB",
    "country": "AZ"
  },
  {
    "abbreviation": "SAK",
    "name": "Saki",
    "iso_3166": "AZ-SAK",
    "country": "AZ"
  },
  {
    "abbreviation": "SAL",
    "name": "Salyan",
    "iso_3166": "AZ-SAL",
    "country": "AZ"
  },
  {
    "abbreviation": "SMI",
    "name": "Samaxi",
    "iso_3166": "AZ-SMI",
    "country": "AZ"
  },
  {
    "abbreviation": "SKR",
    "name": "Samkir",
    "iso_3166": "AZ-SKR",
    "country": "AZ"
  },
  {
    "abbreviation": "SMX",
    "name": "Samux",
    "iso_3166": "AZ-SMX",
    "country": "AZ"
  },
  {
    "abbreviation": "SR",
    "name": "Sirvan",
    "iso_3166": "AZ-SR",
    "country": "AZ"
  },
  {
    "abbreviation": "SIY",
    "name": "Siyazan",
    "iso_3166": "AZ-SIY",
    "country": "AZ"
  },
  {
    "abbreviation": "SM",
    "name": "Sumqayit",
    "iso_3166": "AZ-SM",
    "country": "AZ"
  },
  {
    "abbreviation": "TAR",
    "name": "Tartar",
    "iso_3166": "AZ-TAR",
    "country": "AZ"
  },
  {
    "abbreviation": "TOV",
    "name": "Tovuz",
    "iso_3166": "AZ-TOV",
    "country": "AZ"
  },
  {
    "abbreviation": "UCA",
    "name": "Ucar",
    "iso_3166": "AZ-UCA",
    "country": "AZ"
  },
  {
    "abbreviation": "XAC",
    "name": "Xacmaz",
    "iso_3166": "AZ-XAC",
    "country": "AZ"
  },
  {
    "abbreviation": "XIZ",
    "name": "Xizi",
    "iso_3166": "AZ-XIZ",
    "country": "AZ"
  },
  {
    "abbreviation": "YAR",
    "name": "Yardimli",
    "iso_3166": "AZ-YAR",
    "country": "AZ"
  },
  {
    "abbreviation": "YEV",
    "name": "Yevlax",
    "iso_3166": "AZ-YEV",
    "country": "AZ"
  },
  {
    "abbreviation": "ZAQ",
    "name": "Zaqatala",
    "iso_3166": "AZ-ZAQ",
    "country": "AZ"
  },
  {
    "abbreviation": "ZAR",
    "name": "Zardab",
    "iso_3166": "AZ-ZAR",
    "country": "AZ"
  },
  {
    "abbreviation": "BP",
    "name": "Black Point",
    "iso_3166": "BS-BP",
    "country": "BS"
  },
  {
    "abbreviation": "CO",
    "name": "Central Abaco",
    "iso_3166": "BS-CO",
    "country": "BS"
  },
  {
    "abbreviation": "FP",
    "name": "City of Freeport",
    "iso_3166": "BS-FP",
    "country": "BS"
  },
  {
    "abbreviation": "EG",
    "name": "East Grand Bahama",
    "iso_3166": "BS-EG",
    "country": "BS"
  },
  {
    "abbreviation": "HI",
    "name": "Harbour Island",
    "iso_3166": "BS-HI",
    "country": "BS"
  },
  {
    "abbreviation": "LI",
    "name": "Long Island",
    "iso_3166": "BS-LI",
    "country": "BS"
  },
  {
    "abbreviation": "NP",
    "name": "New Providence",
    "iso_3166": "BS-NP",
    "country": "BS"
  },
  {
    "abbreviation": "NS",
    "name": "North Andros",
    "iso_3166": "BS-NS",
    "country": "BS"
  },
  {
    "abbreviation": "NE",
    "name": "North Eleuthera",
    "iso_3166": "BS-NE",
    "country": "BS"
  },
  {
    "abbreviation": "SS",
    "name": "San Salvador",
    "iso_3166": "BS-SS",
    "country": "BS"
  },
  {
    "abbreviation": "SE",
    "name": "South Eleuthera",
    "iso_3166": "BS-SE",
    "country": "BS"
  },
  {
    "abbreviation": "WG",
    "name": "West Grand Bahama",
    "iso_3166": "BS-WG",
    "country": "BS"
  },
  {
    "abbreviation": "13",
    "name": "Al 'Asimah",
    "iso_3166": "BH-13",
    "country": "BH"
  },
  {
    "abbreviation": "14",
    "name": "Al Janubiyah",
    "iso_3166": "BH-14",
    "country": "BH"
  },
  {
    "abbreviation": "15",
    "name": "Al Muharraq",
    "iso_3166": "BH-15",
    "country": "BH"
  },
  {
    "abbreviation": "17",
    "name": "Ash Shamaliyah",
    "iso_3166": "BH-17",
    "country": "BH"
  },
  {
    "abbreviation": "A",
    "name": "Barishal",
    "iso_3166": "BD-A",
    "country": "BD"
  },
  {
    "abbreviation": "B",
    "name": "Chattogram",
    "iso_3166": "BD-B",
    "country": "BD"
  },
  {
    "abbreviation": "C",
    "name": "Dhaka",
    "iso_3166": "BD-C",
    "country": "BD"
  },
  {
    "abbreviation": "D",
    "name": "Khulna",
    "iso_3166": "BD-D",
    "country": "BD"
  },
  {
    "abbreviation": "E",
    "name": "Rajshahi",
    "iso_3166": "BD-E",
    "country": "BD"
  },
  {
    "abbreviation": "F",
    "name": "Rangpur",
    "iso_3166": "BD-F",
    "country": "BD"
  },
  {
    "abbreviation": "G",
    "name": "Sylhet",
    "iso_3166": "BD-G",
    "country": "BD"
  },
  {
    "abbreviation": "01",
    "name": "Christ Church",
    "iso_3166": "BB-01",
    "country": "BB"
  },
  {
    "abbreviation": "02",
    "name": "Saint Andrew",
    "iso_3166": "BB-02",
    "country": "BB"
  },
  {
    "abbreviation": "03",
    "name": "Saint George",
    "iso_3166": "BB-03",
    "country": "BB"
  },
  {
    "abbreviation": "04",
    "name": "Saint James",
    "iso_3166": "BB-04",
    "country": "BB"
  },
  {
    "abbreviation": "05",
    "name": "Saint John",
    "iso_3166": "BB-05",
    "country": "BB"
  },
  {
    "abbreviation": "07",
    "name": "Saint Lucy",
    "iso_3166": "BB-07",
    "country": "BB"
  },
  {
    "abbreviation": "08",
    "name": "Saint Michael",
    "iso_3166": "BB-08",
    "country": "BB"
  },
  {
    "abbreviation": "09",
    "name": "Saint Peter",
    "iso_3166": "BB-09",
    "country": "BB"
  },
  {
    "abbreviation": "10",
    "name": "Saint Philip",
    "iso_3166": "BB-10",
    "country": "BB"
  },
  {
    "abbreviation": "11",
    "name": "Saint Thomas",
    "iso_3166": "BB-11",
    "country": "BB"
  },
  {
    "abbreviation": "BR",
    "name": "Brestskaya voblasts'",
    "iso_3166": "BY-BR",
    "country": "BY"
  },
  {
    "abbreviation": "HO",
    "name": "Homyel'skaya voblasts'",
    "iso_3166": "BY-HO",
    "country": "BY"
  },
  {
    "abbreviation": "HM",
    "name": "Horad Minsk",
    "iso_3166": "BY-HM",
    "country": "BY"
  },
  {
    "abbreviation": "HR",
    "name": "Hrodzyenskaya voblasts'",
    "iso_3166": "BY-HR",
    "country": "BY"
  },
  {
    "abbreviation": "MA",
    "name": "Mahilyowskaya voblasts'",
    "iso_3166": "BY-MA",
    "country": "BY"
  },
  {
    "abbreviation": "MI",
    "name": "Minskaya voblasts'",
    "iso_3166": "BY-MI",
    "country": "BY"
  },
  {
    "abbreviation": "VI",
    "name": "Vitsyebskaya voblasts'",
    "iso_3166": "BY-VI",
    "country": "BY"
  },
  {
    "abbreviation": "VAN",
    "name": "Antwerpen",
    "iso_3166": "BE-VAN",
    "country": "BE"
  },
  {
    "abbreviation": "WBR",
    "name": "Brabant wallon",
    "iso_3166": "BE-WBR",
    "country": "BE"
  },
  {
    "abbreviation": "BRU",
    "name": "Brussels Hoofdstedelijk Gewest",
    "iso_3166": "BE-BRU",
    "country": "BE"
  },
  {
    "abbreviation": "WHT",
    "name": "Hainaut",
    "iso_3166": "BE-WHT",
    "country": "BE"
  },
  {
    "abbreviation": "WLG",
    "name": "Liege",
    "iso_3166": "BE-WLG",
    "country": "BE"
  },
  {
    "abbreviation": "VLI",
    "name": "Limburg",
    "iso_3166": "BE-VLI",
    "country": "BE"
  },
  {
    "abbreviation": "WLX",
    "name": "Luxembourg",
    "iso_3166": "BE-WLX",
    "country": "BE"
  },
  {
    "abbreviation": "WNA",
    "name": "Namur",
    "iso_3166": "BE-WNA",
    "country": "BE"
  },
  {
    "abbreviation": "VOV",
    "name": "Oost-Vlaanderen",
    "iso_3166": "BE-VOV",
    "country": "BE"
  },
  {
    "abbreviation": "VBR",
    "name": "Vlaams-Brabant",
    "iso_3166": "BE-VBR",
    "country": "BE"
  },
  {
    "abbreviation": "VWV",
    "name": "West-Vlaanderen",
    "iso_3166": "BE-VWV",
    "country": "BE"
  },
  {
    "abbreviation": "BZ",
    "name": "Belize",
    "iso_3166": "BZ-BZ",
    "country": "BZ"
  },
  {
    "abbreviation": "CY",
    "name": "Cayo",
    "iso_3166": "BZ-CY",
    "country": "BZ"
  },
  {
    "abbreviation": "CZL",
    "name": "Corozal",
    "iso_3166": "BZ-CZL",
    "country": "BZ"
  },
  {
    "abbreviation": "OW",
    "name": "Orange Walk",
    "iso_3166": "BZ-OW",
    "country": "BZ"
  },
  {
    "abbreviation": "SC",
    "name": "Stann Creek",
    "iso_3166": "BZ-SC",
    "country": "BZ"
  },
  {
    "abbreviation": "TOL",
    "name": "Toledo",
    "iso_3166": "BZ-TOL",
    "country": "BZ"
  },
  {
    "abbreviation": "AK",
    "name": "Atacora",
    "iso_3166": "BJ-AK",
    "country": "BJ"
  },
  {
    "abbreviation": "AQ",
    "name": "Atlantique",
    "iso_3166": "BJ-AQ",
    "country": "BJ"
  },
  {
    "abbreviation": "BO",
    "name": "Borgou",
    "iso_3166": "BJ-BO",
    "country": "BJ"
  },
  {
    "abbreviation": "CO",
    "name": "Collines",
    "iso_3166": "BJ-CO",
    "country": "BJ"
  },
  {
    "abbreviation": "DO",
    "name": "Donga",
    "iso_3166": "BJ-DO",
    "country": "BJ"
  },
  {
    "abbreviation": "LI",
    "name": "Littoral",
    "iso_3166": "BJ-LI",
    "country": "BJ"
  },
  {
    "abbreviation": "MO",
    "name": "Mono",
    "iso_3166": "BJ-MO",
    "country": "BJ"
  },
  {
    "abbreviation": "OU",
    "name": "Oueme",
    "iso_3166": "BJ-OU",
    "country": "BJ"
  },
  {
    "abbreviation": "PL",
    "name": "Plateau",
    "iso_3166": "BJ-PL",
    "country": "BJ"
  },
  {
    "abbreviation": "ZO",
    "name": "Zou",
    "iso_3166": "BJ-ZO",
    "country": "BJ"
  },
  {
    "abbreviation": "-",
    "name": "Hamilton",
    "iso_3166": "-",
    "country": "BM"
  },
  {
    "abbreviation": "-",
    "name": "Saint George",
    "iso_3166": "-",
    "country": "BM"
  },
  {
    "abbreviation": "33",
    "name": "Bumthang",
    "iso_3166": "BT-33",
    "country": "BT"
  },
  {
    "abbreviation": "12",
    "name": "Chhukha",
    "iso_3166": "BT-12",
    "country": "BT"
  },
  {
    "abbreviation": "22",
    "name": "Dagana",
    "iso_3166": "BT-22",
    "country": "BT"
  },
  {
    "abbreviation": "GA",
    "name": "Gasa",
    "iso_3166": "BT-GA",
    "country": "BT"
  },
  {
    "abbreviation": "44",
    "name": "Lhuentse",
    "iso_3166": "BT-44",
    "country": "BT"
  },
  {
    "abbreviation": "42",
    "name": "Monggar",
    "iso_3166": "BT-42",
    "country": "BT"
  },
  {
    "abbreviation": "11",
    "name": "Paro",
    "iso_3166": "BT-11",
    "country": "BT"
  },
  {
    "abbreviation": "43",
    "name": "Pema Gatshel",
    "iso_3166": "BT-43",
    "country": "BT"
  },
  {
    "abbreviation": "23",
    "name": "Punakha",
    "iso_3166": "BT-23",
    "country": "BT"
  },
  {
    "abbreviation": "45",
    "name": "Samdrup Jongkhar",
    "iso_3166": "BT-45",
    "country": "BT"
  },
  {
    "abbreviation": "14",
    "name": "Samtse",
    "iso_3166": "BT-14",
    "country": "BT"
  },
  {
    "abbreviation": "31",
    "name": "Sarpang",
    "iso_3166": "BT-31",
    "country": "BT"
  },
  {
    "abbreviation": "15",
    "name": "Thimphu",
    "iso_3166": "BT-15",
    "country": "BT"
  },
  {
    "abbreviation": "41",
    "name": "Trashigang",
    "iso_3166": "BT-41",
    "country": "BT"
  },
  {
    "abbreviation": "32",
    "name": "Trongsa",
    "iso_3166": "BT-32",
    "country": "BT"
  },
  {
    "abbreviation": "21",
    "name": "Tsirang",
    "iso_3166": "BT-21",
    "country": "BT"
  },
  {
    "abbreviation": "24",
    "name": "Wangdue Phodrang",
    "iso_3166": "BT-24",
    "country": "BT"
  },
  {
    "abbreviation": "34",
    "name": "Zhemgang",
    "iso_3166": "BT-34",
    "country": "BT"
  },
  {
    "abbreviation": "H",
    "name": "Chuquisaca",
    "iso_3166": "BO-H",
    "country": "BO"
  },
  {
    "abbreviation": "C",
    "name": "Cochabamba",
    "iso_3166": "BO-C",
    "country": "BO"
  },
  {
    "abbreviation": "B",
    "name": "El Beni",
    "iso_3166": "BO-B",
    "country": "BO"
  },
  {
    "abbreviation": "L",
    "name": "La Paz",
    "iso_3166": "BO-L",
    "country": "BO"
  },
  {
    "abbreviation": "O",
    "name": "Oruro",
    "iso_3166": "BO-O",
    "country": "BO"
  },
  {
    "abbreviation": "N",
    "name": "Pando",
    "iso_3166": "BO-N",
    "country": "BO"
  },
  {
    "abbreviation": "P",
    "name": "Potosi",
    "iso_3166": "BO-P",
    "country": "BO"
  },
  {
    "abbreviation": "S",
    "name": "Santa Cruz",
    "iso_3166": "BO-S",
    "country": "BO"
  },
  {
    "abbreviation": "T",
    "name": "Tarija",
    "iso_3166": "BO-T",
    "country": "BO"
  },
  {
    "abbreviation": "BO",
    "name": "Bonaire",
    "iso_3166": "BQ-BO",
    "country": "BQ"
  },
  {
    "abbreviation": "SA",
    "name": "Saba",
    "iso_3166": "BQ-SA",
    "country": "BQ"
  },
  {
    "abbreviation": "SE",
    "name": "Sint Eustatius",
    "iso_3166": "BQ-SE",
    "country": "BQ"
  },
  {
    "abbreviation": "BRC",
    "name": "Brcko distrikt",
    "iso_3166": "BA-BRC",
    "country": "BA"
  },
  {
    "abbreviation": "BIH",
    "name": "Federacija Bosne i Hercegovine",
    "iso_3166": "BA-BIH",
    "country": "BA"
  },
  {
    "abbreviation": "SRP",
    "name": "Republika Srpska",
    "iso_3166": "BA-SRP",
    "country": "BA"
  },
  {
    "abbreviation": "CE",
    "name": "Central",
    "iso_3166": "BW-CE",
    "country": "BW"
  },
  {
    "abbreviation": "CH",
    "name": "Chobe",
    "iso_3166": "BW-CH",
    "country": "BW"
  },
  {
    "abbreviation": "GH",
    "name": "Ghanzi",
    "iso_3166": "BW-GH",
    "country": "BW"
  },
  {
    "abbreviation": "KG",
    "name": "Kgalagadi",
    "iso_3166": "BW-KG",
    "country": "BW"
  },
  {
    "abbreviation": "KL",
    "name": "Kgatleng",
    "iso_3166": "BW-KL",
    "country": "BW"
  },
  {
    "abbreviation": "KW",
    "name": "Kweneng",
    "iso_3166": "BW-KW",
    "country": "BW"
  },
  {
    "abbreviation": "NE",
    "name": "North East",
    "iso_3166": "BW-NE",
    "country": "BW"
  },
  {
    "abbreviation": "NW",
    "name": "North West",
    "iso_3166": "BW-NW",
    "country": "BW"
  },
  {
    "abbreviation": "SE",
    "name": "South East",
    "iso_3166": "BW-SE",
    "country": "BW"
  },
  {
    "abbreviation": "SO",
    "name": "Southern",
    "iso_3166": "BW-SO",
    "country": "BW"
  },
  {
    "abbreviation": "-",
    "name": "Bouvet Island",
    "iso_3166": "-",
    "country": "BV"
  },
  {
    "abbreviation": "AC",
    "name": "Acre",
    "iso_3166": "BR-AC",
    "country": "BR"
  },
  {
    "abbreviation": "AL",
    "name": "Alagoas",
    "iso_3166": "BR-AL",
    "country": "BR"
  },
  {
    "abbreviation": "AP",
    "name": "Amapa",
    "iso_3166": "BR-AP",
    "country": "BR"
  },
  {
    "abbreviation": "AM",
    "name": "Amazonas",
    "iso_3166": "BR-AM",
    "country": "BR"
  },
  {
    "abbreviation": "BA",
    "name": "Bahia",
    "iso_3166": "BR-BA",
    "country": "BR"
  },
  {
    "abbreviation": "CE",
    "name": "Ceara",
    "iso_3166": "BR-CE",
    "country": "BR"
  },
  {
    "abbreviation": "DF",
    "name": "Distrito Federal",
    "iso_3166": "BR-DF",
    "country": "BR"
  },
  {
    "abbreviation": "ES",
    "name": "Espirito Santo",
    "iso_3166": "BR-ES",
    "country": "BR"
  },
  {
    "abbreviation": "GO",
    "name": "Goias",
    "iso_3166": "BR-GO",
    "country": "BR"
  },
  {
    "abbreviation": "MA",
    "name": "Maranhao",
    "iso_3166": "BR-MA",
    "country": "BR"
  },
  {
    "abbreviation": "MT",
    "name": "Mato Grosso",
    "iso_3166": "BR-MT",
    "country": "BR"
  },
  {
    "abbreviation": "MS",
    "name": "Mato Grosso do Sul",
    "iso_3166": "BR-MS",
    "country": "BR"
  },
  {
    "abbreviation": "MG",
    "name": "Minas Gerais",
    "iso_3166": "BR-MG",
    "country": "BR"
  },
  {
    "abbreviation": "PA",
    "name": "Para",
    "iso_3166": "BR-PA",
    "country": "BR"
  },
  {
    "abbreviation": "PB",
    "name": "Paraiba",
    "iso_3166": "BR-PB",
    "country": "BR"
  },
  {
    "abbreviation": "PR",
    "name": "Parana",
    "iso_3166": "BR-PR",
    "country": "BR"
  },
  {
    "abbreviation": "PE",
    "name": "Pernambuco",
    "iso_3166": "BR-PE",
    "country": "BR"
  },
  {
    "abbreviation": "PI",
    "name": "Piaui",
    "iso_3166": "BR-PI",
    "country": "BR"
  },
  {
    "abbreviation": "RN",
    "name": "Rio Grande do Norte",
    "iso_3166": "BR-RN",
    "country": "BR"
  },
  {
    "abbreviation": "RS",
    "name": "Rio Grande do Sul",
    "iso_3166": "BR-RS",
    "country": "BR"
  },
  {
    "abbreviation": "RJ",
    "name": "Rio de Janeiro",
    "iso_3166": "BR-RJ",
    "country": "BR"
  },
  {
    "abbreviation": "RO",
    "name": "Rondonia",
    "iso_3166": "BR-RO",
    "country": "BR"
  },
  {
    "abbreviation": "RR",
    "name": "Roraima",
    "iso_3166": "BR-RR",
    "country": "BR"
  },
  {
    "abbreviation": "SC",
    "name": "Santa Catarina",
    "iso_3166": "BR-SC",
    "country": "BR"
  },
  {
    "abbreviation": "SP",
    "name": "Sao Paulo",
    "iso_3166": "BR-SP",
    "country": "BR"
  },
  {
    "abbreviation": "SE",
    "name": "Sergipe",
    "iso_3166": "BR-SE",
    "country": "BR"
  },
  {
    "abbreviation": "TO",
    "name": "Tocantins",
    "iso_3166": "BR-TO",
    "country": "BR"
  },
  {
    "abbreviation": "-",
    "name": "British Indian Ocean Territory",
    "iso_3166": "-",
    "country": "IO"
  },
  {
    "abbreviation": "95",
    "name": "Palmyra Atoll",
    "iso_3166": "UM-95",
    "country": "UM"
  },
  {
    "abbreviation": "-",
    "name": "Virgin Islands, British",
    "iso_3166": "-",
    "country": "VG"
  },
  {
    "abbreviation": "-",
    "name": "Virgin Islands, U.S.",
    "iso_3166": "-",
    "country": "VI"
  },
  {
    "abbreviation": "BE",
    "name": "Belait",
    "iso_3166": "BN-BE",
    "country": "BN"
  },
  {
    "abbreviation": "BM",
    "name": "Brunei-Muara",
    "iso_3166": "BN-BM",
    "country": "BN"
  },
  {
    "abbreviation": "TE",
    "name": "Temburong",
    "iso_3166": "BN-TE",
    "country": "BN"
  },
  {
    "abbreviation": "TU",
    "name": "Tutong",
    "iso_3166": "BN-TU",
    "country": "BN"
  },
  {
    "abbreviation": "01",
    "name": "Blagoevgrad",
    "iso_3166": "BG-01",
    "country": "BG"
  },
  {
    "abbreviation": "02",
    "name": "Burgas",
    "iso_3166": "BG-02",
    "country": "BG"
  },
  {
    "abbreviation": "08",
    "name": "Dobrich",
    "iso_3166": "BG-08",
    "country": "BG"
  },
  {
    "abbreviation": "07",
    "name": "Gabrovo",
    "iso_3166": "BG-07",
    "country": "BG"
  },
  {
    "abbreviation": "26",
    "name": "Haskovo",
    "iso_3166": "BG-26",
    "country": "BG"
  },
  {
    "abbreviation": "09",
    "name": "Kardzhali",
    "iso_3166": "BG-09",
    "country": "BG"
  },
  {
    "abbreviation": "10",
    "name": "Kyustendil",
    "iso_3166": "BG-10",
    "country": "BG"
  },
  {
    "abbreviation": "11",
    "name": "Lovech",
    "iso_3166": "BG-11",
    "country": "BG"
  },
  {
    "abbreviation": "12",
    "name": "Montana",
    "iso_3166": "BG-12",
    "country": "BG"
  },
  {
    "abbreviation": "13",
    "name": "Pazardzhik",
    "iso_3166": "BG-13",
    "country": "BG"
  },
  {
    "abbreviation": "14",
    "name": "Pernik",
    "iso_3166": "BG-14",
    "country": "BG"
  },
  {
    "abbreviation": "15",
    "name": "Pleven",
    "iso_3166": "BG-15",
    "country": "BG"
  },
  {
    "abbreviation": "16",
    "name": "Plovdiv",
    "iso_3166": "BG-16",
    "country": "BG"
  },
  {
    "abbreviation": "17",
    "name": "Razgrad",
    "iso_3166": "BG-17",
    "country": "BG"
  },
  {
    "abbreviation": "18",
    "name": "Ruse",
    "iso_3166": "BG-18",
    "country": "BG"
  },
  {
    "abbreviation": "27",
    "name": "Shumen",
    "iso_3166": "BG-27",
    "country": "BG"
  },
  {
    "abbreviation": "19",
    "name": "Silistra",
    "iso_3166": "BG-19",
    "country": "BG"
  },
  {
    "abbreviation": "20",
    "name": "Sliven",
    "iso_3166": "BG-20",
    "country": "BG"
  },
  {
    "abbreviation": "21",
    "name": "Smolyan",
    "iso_3166": "BG-21",
    "country": "BG"
  },
  {
    "abbreviation": "23",
    "name": "Sofia",
    "iso_3166": "BG-23",
    "country": "BG"
  },
  {
    "abbreviation": "22",
    "name": "Sofia (stolitsa)",
    "iso_3166": "BG-22",
    "country": "BG"
  },
  {
    "abbreviation": "24",
    "name": "Stara Zagora",
    "iso_3166": "BG-24",
    "country": "BG"
  },
  {
    "abbreviation": "25",
    "name": "Targovishte",
    "iso_3166": "BG-25",
    "country": "BG"
  },
  {
    "abbreviation": "03",
    "name": "Varna",
    "iso_3166": "BG-03",
    "country": "BG"
  },
  {
    "abbreviation": "04",
    "name": "Veliko Tarnovo",
    "iso_3166": "BG-04",
    "country": "BG"
  },
  {
    "abbreviation": "05",
    "name": "Vidin",
    "iso_3166": "BG-05",
    "country": "BG"
  },
  {
    "abbreviation": "06",
    "name": "Vratsa",
    "iso_3166": "BG-06",
    "country": "BG"
  },
  {
    "abbreviation": "28",
    "name": "Yambol",
    "iso_3166": "BG-28",
    "country": "BG"
  },
  {
    "abbreviation": "BAL",
    "name": "Bale",
    "iso_3166": "BF-BAL",
    "country": "BF"
  },
  {
    "abbreviation": "BAM",
    "name": "Bam",
    "iso_3166": "BF-BAM",
    "country": "BF"
  },
  {
    "abbreviation": "BAN",
    "name": "Banwa",
    "iso_3166": "BF-BAN",
    "country": "BF"
  },
  {
    "abbreviation": "BAZ",
    "name": "Bazega",
    "iso_3166": "BF-BAZ",
    "country": "BF"
  },
  {
    "abbreviation": "BGR",
    "name": "Bougouriba",
    "iso_3166": "BF-BGR",
    "country": "BF"
  },
  {
    "abbreviation": "BLG",
    "name": "Boulgou",
    "iso_3166": "BF-BLG",
    "country": "BF"
  },
  {
    "abbreviation": "BLK",
    "name": "Boulkiemde",
    "iso_3166": "BF-BLK",
    "country": "BF"
  },
  {
    "abbreviation": "COM",
    "name": "Comoe",
    "iso_3166": "BF-COM",
    "country": "BF"
  },
  {
    "abbreviation": "GAN",
    "name": "Ganzourgou",
    "iso_3166": "BF-GAN",
    "country": "BF"
  },
  {
    "abbreviation": "GNA",
    "name": "Gnagna",
    "iso_3166": "BF-GNA",
    "country": "BF"
  },
  {
    "abbreviation": "GOU",
    "name": "Gourma",
    "iso_3166": "BF-GOU",
    "country": "BF"
  },
  {
    "abbreviation": "HOU",
    "name": "Houet",
    "iso_3166": "BF-HOU",
    "country": "BF"
  },
  {
    "abbreviation": "IOB",
    "name": "Ioba",
    "iso_3166": "BF-IOB",
    "country": "BF"
  },
  {
    "abbreviation": "KAD",
    "name": "Kadiogo",
    "iso_3166": "BF-KAD",
    "country": "BF"
  },
  {
    "abbreviation": "KEN",
    "name": "Kenedougou",
    "iso_3166": "BF-KEN",
    "country": "BF"
  },
  {
    "abbreviation": "KMP",
    "name": "Kompienga",
    "iso_3166": "BF-KMP",
    "country": "BF"
  },
  {
    "abbreviation": "KOS",
    "name": "Kossi",
    "iso_3166": "BF-KOS",
    "country": "BF"
  },
  {
    "abbreviation": "KOT",
    "name": "Kouritenga",
    "iso_3166": "BF-KOT",
    "country": "BF"
  },
  {
    "abbreviation": "KOW",
    "name": "Kourweogo",
    "iso_3166": "BF-KOW",
    "country": "BF"
  },
  {
    "abbreviation": "LER",
    "name": "Leraba",
    "iso_3166": "BF-LER",
    "country": "BF"
  },
  {
    "abbreviation": "LOR",
    "name": "Loroum",
    "iso_3166": "BF-LOR",
    "country": "BF"
  },
  {
    "abbreviation": "MOU",
    "name": "Mouhoun",
    "iso_3166": "BF-MOU",
    "country": "BF"
  },
  {
    "abbreviation": "NAO",
    "name": "Nahouri",
    "iso_3166": "BF-NAO",
    "country": "BF"
  },
  {
    "abbreviation": "NAM",
    "name": "Namentenga",
    "iso_3166": "BF-NAM",
    "country": "BF"
  },
  {
    "abbreviation": "NAY",
    "name": "Nayala",
    "iso_3166": "BF-NAY",
    "country": "BF"
  },
  {
    "abbreviation": "OUB",
    "name": "Oubritenga",
    "iso_3166": "BF-OUB",
    "country": "BF"
  },
  {
    "abbreviation": "OUD",
    "name": "Oudalan",
    "iso_3166": "BF-OUD",
    "country": "BF"
  },
  {
    "abbreviation": "PAS",
    "name": "Passore",
    "iso_3166": "BF-PAS",
    "country": "BF"
  },
  {
    "abbreviation": "SMT",
    "name": "Sanmatenga",
    "iso_3166": "BF-SMT",
    "country": "BF"
  },
  {
    "abbreviation": "SEN",
    "name": "Seno",
    "iso_3166": "BF-SEN",
    "country": "BF"
  },
  {
    "abbreviation": "SIS",
    "name": "Sissili",
    "iso_3166": "BF-SIS",
    "country": "BF"
  },
  {
    "abbreviation": "SOM",
    "name": "Soum",
    "iso_3166": "BF-SOM",
    "country": "BF"
  },
  {
    "abbreviation": "SOR",
    "name": "Sourou",
    "iso_3166": "BF-SOR",
    "country": "BF"
  },
  {
    "abbreviation": "TAP",
    "name": "Tapoa",
    "iso_3166": "BF-TAP",
    "country": "BF"
  },
  {
    "abbreviation": "TUI",
    "name": "Tuy",
    "iso_3166": "BF-TUI",
    "country": "BF"
  },
  {
    "abbreviation": "YAT",
    "name": "Yatenga",
    "iso_3166": "BF-YAT",
    "country": "BF"
  },
  {
    "abbreviation": "ZIR",
    "name": "Ziro",
    "iso_3166": "BF-ZIR",
    "country": "BF"
  },
  {
    "abbreviation": "ZON",
    "name": "Zondoma",
    "iso_3166": "BF-ZON",
    "country": "BF"
  },
  {
    "abbreviation": "ZOU",
    "name": "Zoundweogo",
    "iso_3166": "BF-ZOU",
    "country": "BF"
  },
  {
    "abbreviation": "BM",
    "name": "Bujumbura Mairie",
    "iso_3166": "BI-BM",
    "country": "BI"
  },
  {
    "abbreviation": "BR",
    "name": "Bururi",
    "iso_3166": "BI-BR",
    "country": "BI"
  },
  {
    "abbreviation": "CI",
    "name": "Cibitoke",
    "iso_3166": "BI-CI",
    "country": "BI"
  },
  {
    "abbreviation": "GI",
    "name": "Gitega",
    "iso_3166": "BI-GI",
    "country": "BI"
  },
  {
    "abbreviation": "KI",
    "name": "Kirundo",
    "iso_3166": "BI-KI",
    "country": "BI"
  },
  {
    "abbreviation": "MW",
    "name": "Mwaro",
    "iso_3166": "BI-MW",
    "country": "BI"
  },
  {
    "abbreviation": "NG",
    "name": "Ngozi",
    "iso_3166": "BI-NG",
    "country": "BI"
  },
  {
    "abbreviation": "RM",
    "name": "Rumonge",
    "iso_3166": "BI-RM",
    "country": "BI"
  },
  {
    "abbreviation": "RT",
    "name": "Rutana",
    "iso_3166": "BI-RT",
    "country": "BI"
  },
  {
    "abbreviation": "RY",
    "name": "Ruyigi",
    "iso_3166": "BI-RY",
    "country": "BI"
  },
  {
    "abbreviation": "2",
    "name": "Baat Dambang",
    "iso_3166": "KH-2",
    "country": "KH"
  },
  {
    "abbreviation": "1",
    "name": "Banteay Mean Choay",
    "iso_3166": "KH-1",
    "country": "KH"
  },
  {
    "abbreviation": "23",
    "name": "Kaeb",
    "iso_3166": "KH-23",
    "country": "KH"
  },
  {
    "abbreviation": "3",
    "name": "Kampong Chaam",
    "iso_3166": "KH-3",
    "country": "KH"
  },
  {
    "abbreviation": "4",
    "name": "Kampong Chhnang",
    "iso_3166": "KH-4",
    "country": "KH"
  },
  {
    "abbreviation": "5",
    "name": "Kampong Spueu",
    "iso_3166": "KH-5",
    "country": "KH"
  },
  {
    "abbreviation": "6",
    "name": "Kampong Thum",
    "iso_3166": "KH-6",
    "country": "KH"
  },
  {
    "abbreviation": "7",
    "name": "Kampot",
    "iso_3166": "KH-7",
    "country": "KH"
  },
  {
    "abbreviation": "8",
    "name": "Kandaal",
    "iso_3166": "KH-8",
    "country": "KH"
  },
  {
    "abbreviation": "10",
    "name": "Kracheh",
    "iso_3166": "KH-10",
    "country": "KH"
  },
  {
    "abbreviation": "11",
    "name": "Mondol Kiri",
    "iso_3166": "KH-11",
    "country": "KH"
  },
  {
    "abbreviation": "24",
    "name": "Pailin",
    "iso_3166": "KH-24",
    "country": "KH"
  },
  {
    "abbreviation": "12",
    "name": "Phnom Penh",
    "iso_3166": "KH-12",
    "country": "KH"
  },
  {
    "abbreviation": "15",
    "name": "Pousaat",
    "iso_3166": "KH-15",
    "country": "KH"
  },
  {
    "abbreviation": "18",
    "name": "Preah Sihanouk",
    "iso_3166": "KH-18",
    "country": "KH"
  },
  {
    "abbreviation": "13",
    "name": "Preah Vihear",
    "iso_3166": "KH-13",
    "country": "KH"
  },
  {
    "abbreviation": "14",
    "name": "Prey Veaeng",
    "iso_3166": "KH-14",
    "country": "KH"
  },
  {
    "abbreviation": "17",
    "name": "Siem Reab",
    "iso_3166": "KH-17",
    "country": "KH"
  },
  {
    "abbreviation": "19",
    "name": "Stueng Traeng",
    "iso_3166": "KH-19",
    "country": "KH"
  },
  {
    "abbreviation": "20",
    "name": "Svaay Rieng",
    "iso_3166": "KH-20",
    "country": "KH"
  },
  {
    "abbreviation": "21",
    "name": "Taakaev",
    "iso_3166": "KH-21",
    "country": "KH"
  },
  {
    "abbreviation": "AD",
    "name": "Adamaoua",
    "iso_3166": "CM-AD",
    "country": "CM"
  },
  {
    "abbreviation": "CE",
    "name": "Centre",
    "iso_3166": "CM-CE",
    "country": "CM"
  },
  {
    "abbreviation": "ES",
    "name": "Est",
    "iso_3166": "CM-ES",
    "country": "CM"
  },
  {
    "abbreviation": "EN",
    "name": "Extreme-Nord",
    "iso_3166": "CM-EN",
    "country": "CM"
  },
  {
    "abbreviation": "LT",
    "name": "Littoral",
    "iso_3166": "CM-LT",
    "country": "CM"
  },
  {
    "abbreviation": "NO",
    "name": "Nord",
    "iso_3166": "CM-NO",
    "country": "CM"
  },
  {
    "abbreviation": "NW",
    "name": "Nord-Ouest",
    "iso_3166": "CM-NW",
    "country": "CM"
  },
  {
    "abbreviation": "OU",
    "name": "Ouest",
    "iso_3166": "CM-OU",
    "country": "CM"
  },
  {
    "abbreviation": "SU",
    "name": "Sud",
    "iso_3166": "CM-SU",
    "country": "CM"
  },
  {
    "abbreviation": "SW",
    "name": "Sud-Ouest",
    "iso_3166": "CM-SW",
    "country": "CM"
  },
  {
    "abbreviation": "BV",
    "name": "Boa Vista",
    "iso_3166": "CV-BV",
    "country": "CV"
  },
  {
    "abbreviation": "BR",
    "name": "Brava",
    "iso_3166": "CV-BR",
    "country": "CV"
  },
  {
    "abbreviation": "MO",
    "name": "Mosteiros",
    "iso_3166": "CV-MO",
    "country": "CV"
  },
  {
    "abbreviation": "PN",
    "name": "Porto Novo",
    "iso_3166": "CV-PN",
    "country": "CV"
  },
  {
    "abbreviation": "PR",
    "name": "Praia",
    "iso_3166": "CV-PR",
    "country": "CV"
  },
  {
    "abbreviation": "RS",
    "name": "Ribeira Grande de Santiago",
    "iso_3166": "CV-RS",
    "country": "CV"
  },
  {
    "abbreviation": "SL",
    "name": "Sal",
    "iso_3166": "CV-SL",
    "country": "CV"
  },
  {
    "abbreviation": "SV",
    "name": "Sao Vicente",
    "iso_3166": "CV-SV",
    "country": "CV"
  },
  {
    "abbreviation": "TA",
    "name": "Tarrafal",
    "iso_3166": "CV-TA",
    "country": "CV"
  },
  {
    "abbreviation": "-",
    "name": "Cayman Islands",
    "iso_3166": "-",
    "country": "KY"
  },
  {
    "abbreviation": "BB",
    "name": "Bamingui-Bangoran",
    "iso_3166": "CF-BB",
    "country": "CF"
  },
  {
    "abbreviation": "BGF",
    "name": "Bangui",
    "iso_3166": "CF-BGF",
    "country": "CF"
  },
  {
    "abbreviation": "KB",
    "name": "Gribingui",
    "iso_3166": "CF-KB",
    "country": "CF"
  },
  {
    "abbreviation": "KG",
    "name": "Kemo-Gribingui",
    "iso_3166": "CF-KG",
    "country": "CF"
  },
  {
    "abbreviation": "HS",
    "name": "Mambere-Kadei",
    "iso_3166": "CF-HS",
    "country": "CF"
  },
  {
    "abbreviation": "NM",
    "name": "Nana-Mambere",
    "iso_3166": "CF-NM",
    "country": "CF"
  },
  {
    "abbreviation": "UK",
    "name": "Ouaka",
    "iso_3166": "CF-UK",
    "country": "CF"
  },
  {
    "abbreviation": "AC",
    "name": "Ouham",
    "iso_3166": "CF-AC",
    "country": "CF"
  },
  {
    "abbreviation": "OP",
    "name": "Ouham-Pende",
    "iso_3166": "CF-OP",
    "country": "CF"
  },
  {
    "abbreviation": "VK",
    "name": "Vakaga",
    "iso_3166": "CF-VK",
    "country": "CF"
  },
  {
    "abbreviation": "BG",
    "name": "Bahr el Ghazal",
    "iso_3166": "TD-BG",
    "country": "TD"
  },
  {
    "abbreviation": "CB",
    "name": "Chari-Baguirmi",
    "iso_3166": "TD-CB",
    "country": "TD"
  },
  {
    "abbreviation": "GR",
    "name": "Guera",
    "iso_3166": "TD-GR",
    "country": "TD"
  },
  {
    "abbreviation": "LC",
    "name": "Lac",
    "iso_3166": "TD-LC",
    "country": "TD"
  },
  {
    "abbreviation": "LR",
    "name": "Logone-Oriental",
    "iso_3166": "TD-LR",
    "country": "TD"
  },
  {
    "abbreviation": "OD",
    "name": "Ouaddai",
    "iso_3166": "TD-OD",
    "country": "TD"
  },
  {
    "abbreviation": "ND",
    "name": "Ville de Ndjamena",
    "iso_3166": "TD-ND",
    "country": "TD"
  },
  {
    "abbreviation": "AI",
    "name": "Aisen del General Carlos Ibanez del Campo",
    "iso_3166": "CL-AI",
    "country": "CL"
  },
  {
    "abbreviation": "AN",
    "name": "Antofagasta",
    "iso_3166": "CL-AN",
    "country": "CL"
  },
  {
    "abbreviation": "AP",
    "name": "Arica y Parinacota",
    "iso_3166": "CL-AP",
    "country": "CL"
  },
  {
    "abbreviation": "AT",
    "name": "Atacama",
    "iso_3166": "CL-AT",
    "country": "CL"
  },
  {
    "abbreviation": "BI",
    "name": "Biobio",
    "iso_3166": "CL-BI",
    "country": "CL"
  },
  {
    "abbreviation": "CO",
    "name": "Coquimbo",
    "iso_3166": "CL-CO",
    "country": "CL"
  },
  {
    "abbreviation": "AR",
    "name": "La Araucania",
    "iso_3166": "CL-AR",
    "country": "CL"
  },
  {
    "abbreviation": "LI",
    "name": "Libertador General Bernardo O'Higgins",
    "iso_3166": "CL-LI",
    "country": "CL"
  },
  {
    "abbreviation": "LL",
    "name": "Los Lagos",
    "iso_3166": "CL-LL",
    "country": "CL"
  },
  {
    "abbreviation": "LR",
    "name": "Los Rios",
    "iso_3166": "CL-LR",
    "country": "CL"
  },
  {
    "abbreviation": "MA",
    "name": "Magallanes",
    "iso_3166": "CL-MA",
    "country": "CL"
  },
  {
    "abbreviation": "ML",
    "name": "Maule",
    "iso_3166": "CL-ML",
    "country": "CL"
  },
  {
    "abbreviation": "NB",
    "name": "Nuble",
    "iso_3166": "CL-NB",
    "country": "CL"
  },
  {
    "abbreviation": "RM",
    "name": "Region Metropolitana de Santiago",
    "iso_3166": "CL-RM",
    "country": "CL"
  },
  {
    "abbreviation": "TA",
    "name": "Tarapaca",
    "iso_3166": "CL-TA",
    "country": "CL"
  },
  {
    "abbreviation": "VS",
    "name": "Valparaiso",
    "iso_3166": "CL-VS",
    "country": "CL"
  },
  {
    "abbreviation": "AH",
    "name": "Anhui",
    "iso_3166": "CN-AH",
    "country": "CN"
  },
  {
    "abbreviation": "BJ",
    "name": "Beijing",
    "iso_3166": "CN-BJ",
    "country": "CN"
  },
  {
    "abbreviation": "CQ",
    "name": "Chongqing",
    "iso_3166": "CN-CQ",
    "country": "CN"
  },
  {
    "abbreviation": "FJ",
    "name": "Fujian",
    "iso_3166": "CN-FJ",
    "country": "CN"
  },
  {
    "abbreviation": "GS",
    "name": "Gansu",
    "iso_3166": "CN-GS",
    "country": "CN"
  },
  {
    "abbreviation": "GD",
    "name": "Guangdong",
    "iso_3166": "CN-GD",
    "country": "CN"
  },
  {
    "abbreviation": "GX",
    "name": "Guangxi Zhuangzu",
    "iso_3166": "CN-GX",
    "country": "CN"
  },
  {
    "abbreviation": "GZ",
    "name": "Guizhou",
    "iso_3166": "CN-GZ",
    "country": "CN"
  },
  {
    "abbreviation": "HI",
    "name": "Hainan",
    "iso_3166": "CN-HI",
    "country": "CN"
  },
  {
    "abbreviation": "HE",
    "name": "Hebei",
    "iso_3166": "CN-HE",
    "country": "CN"
  },
  {
    "abbreviation": "HL",
    "name": "Heilongjiang",
    "iso_3166": "CN-HL",
    "country": "CN"
  },
  {
    "abbreviation": "HA",
    "name": "Henan",
    "iso_3166": "CN-HA",
    "country": "CN"
  },
  {
    "abbreviation": "HB",
    "name": "Hubei",
    "iso_3166": "CN-HB",
    "country": "CN"
  },
  {
    "abbreviation": "HN",
    "name": "Hunan",
    "iso_3166": "CN-HN",
    "country": "CN"
  },
  {
    "abbreviation": "JS",
    "name": "Jiangsu",
    "iso_3166": "CN-JS",
    "country": "CN"
  },
  {
    "abbreviation": "JX",
    "name": "Jiangxi",
    "iso_3166": "CN-JX",
    "country": "CN"
  },
  {
    "abbreviation": "JL",
    "name": "Jilin",
    "iso_3166": "CN-JL",
    "country": "CN"
  },
  {
    "abbreviation": "LN",
    "name": "Liaoning",
    "iso_3166": "CN-LN",
    "country": "CN"
  },
  {
    "abbreviation": "NM",
    "name": "Nei Mongol",
    "iso_3166": "CN-NM",
    "country": "CN"
  },
  {
    "abbreviation": "NX",
    "name": "Ningxia Huizu",
    "iso_3166": "CN-NX",
    "country": "CN"
  },
  {
    "abbreviation": "QH",
    "name": "Qinghai",
    "iso_3166": "CN-QH",
    "country": "CN"
  },
  {
    "abbreviation": "SN",
    "name": "Shaanxi",
    "iso_3166": "CN-SN",
    "country": "CN"
  },
  {
    "abbreviation": "SD",
    "name": "Shandong",
    "iso_3166": "CN-SD",
    "country": "CN"
  },
  {
    "abbreviation": "SH",
    "name": "Shanghai",
    "iso_3166": "CN-SH",
    "country": "CN"
  },
  {
    "abbreviation": "SX",
    "name": "Shanxi",
    "iso_3166": "CN-SX",
    "country": "CN"
  },
  {
    "abbreviation": "SC",
    "name": "Sichuan",
    "iso_3166": "CN-SC",
    "country": "CN"
  },
  {
    "abbreviation": "TJ",
    "name": "Tianjin",
    "iso_3166": "CN-TJ",
    "country": "CN"
  },
  {
    "abbreviation": "XJ",
    "name": "Xinjiang Uygur",
    "iso_3166": "CN-XJ",
    "country": "CN"
  },
  {
    "abbreviation": "XZ",
    "name": "Xizang",
    "iso_3166": "CN-XZ",
    "country": "CN"
  },
  {
    "abbreviation": "YN",
    "name": "Yunnan",
    "iso_3166": "CN-YN",
    "country": "CN"
  },
  {
    "abbreviation": "ZJ",
    "name": "Zhejiang",
    "iso_3166": "CN-ZJ",
    "country": "CN"
  },
  {
    "abbreviation": "-",
    "name": "Christmas Island",
    "iso_3166": "-",
    "country": "CX"
  },
  {
    "abbreviation": "-",
    "name": "Cocos (Keeling) Islands",
    "iso_3166": "-",
    "country": "CC"
  },
  {
    "abbreviation": "AMA",
    "name": "Amazonas",
    "iso_3166": "CO-AMA",
    "country": "CO"
  },
  {
    "abbreviation": "ANT",
    "name": "Antioquia",
    "iso_3166": "CO-ANT",
    "country": "CO"
  },
  {
    "abbreviation": "ARA",
    "name": "Arauca",
    "iso_3166": "CO-ARA",
    "country": "CO"
  },
  {
    "abbreviation": "ATL",
    "name": "Atlantico",
    "iso_3166": "CO-ATL",
    "country": "CO"
  },
  {
    "abbreviation": "BOL",
    "name": "Bolivar",
    "iso_3166": "CO-BOL",
    "country": "CO"
  },
  {
    "abbreviation": "BOY",
    "name": "Boyaca",
    "iso_3166": "CO-BOY",
    "country": "CO"
  },
  {
    "abbreviation": "CAL",
    "name": "Caldas",
    "iso_3166": "CO-CAL",
    "country": "CO"
  },
  {
    "abbreviation": "CAQ",
    "name": "Caqueta",
    "iso_3166": "CO-CAQ",
    "country": "CO"
  },
  {
    "abbreviation": "CAS",
    "name": "Casanare",
    "iso_3166": "CO-CAS",
    "country": "CO"
  },
  {
    "abbreviation": "CAU",
    "name": "Cauca",
    "iso_3166": "CO-CAU",
    "country": "CO"
  },
  {
    "abbreviation": "CES",
    "name": "Cesar",
    "iso_3166": "CO-CES",
    "country": "CO"
  },
  {
    "abbreviation": "CHO",
    "name": "Choco",
    "iso_3166": "CO-CHO",
    "country": "CO"
  },
  {
    "abbreviation": "COR",
    "name": "Cordoba",
    "iso_3166": "CO-COR",
    "country": "CO"
  },
  {
    "abbreviation": "CUN",
    "name": "Cundinamarca",
    "iso_3166": "CO-CUN",
    "country": "CO"
  },
  {
    "abbreviation": "DC",
    "name": "Distrito Capital de Bogota",
    "iso_3166": "CO-DC",
    "country": "CO"
  },
  {
    "abbreviation": "GUA",
    "name": "Guainia",
    "iso_3166": "CO-GUA",
    "country": "CO"
  },
  {
    "abbreviation": "GUV",
    "name": "Guaviare",
    "iso_3166": "CO-GUV",
    "country": "CO"
  },
  {
    "abbreviation": "HUI",
    "name": "Huila",
    "iso_3166": "CO-HUI",
    "country": "CO"
  },
  {
    "abbreviation": "LAG",
    "name": "La Guajira",
    "iso_3166": "CO-LAG",
    "country": "CO"
  },
  {
    "abbreviation": "MAG",
    "name": "Magdalena",
    "iso_3166": "CO-MAG",
    "country": "CO"
  },
  {
    "abbreviation": "MET",
    "name": "Meta",
    "iso_3166": "CO-MET",
    "country": "CO"
  },
  {
    "abbreviation": "NAR",
    "name": "Narino",
    "iso_3166": "CO-NAR",
    "country": "CO"
  },
  {
    "abbreviation": "NSA",
    "name": "Norte de Santander",
    "iso_3166": "CO-NSA",
    "country": "CO"
  },
  {
    "abbreviation": "PUT",
    "name": "Putumayo",
    "iso_3166": "CO-PUT",
    "country": "CO"
  },
  {
    "abbreviation": "QUI",
    "name": "Quindio",
    "iso_3166": "CO-QUI",
    "country": "CO"
  },
  {
    "abbreviation": "RIS",
    "name": "Risaralda",
    "iso_3166": "CO-RIS",
    "country": "CO"
  },
  {
    "abbreviation": "SAP",
    "name": "San Andres, Providencia y Santa Catalina",
    "iso_3166": "CO-SAP",
    "country": "CO"
  },
  {
    "abbreviation": "SAN",
    "name": "Santander",
    "iso_3166": "CO-SAN",
    "country": "CO"
  },
  {
    "abbreviation": "SUC",
    "name": "Sucre",
    "iso_3166": "CO-SUC",
    "country": "CO"
  },
  {
    "abbreviation": "TOL",
    "name": "Tolima",
    "iso_3166": "CO-TOL",
    "country": "CO"
  },
  {
    "abbreviation": "VAC",
    "name": "Valle del Cauca",
    "iso_3166": "CO-VAC",
    "country": "CO"
  },
  {
    "abbreviation": "VID",
    "name": "Vichada",
    "iso_3166": "CO-VID",
    "country": "CO"
  },
  {
    "abbreviation": "G",
    "name": "Grande Comore",
    "iso_3166": "KM-G",
    "country": "KM"
  },
  {
    "abbreviation": "M",
    "name": "Moheli",
    "iso_3166": "KM-M",
    "country": "KM"
  },
  {
    "abbreviation": "11",
    "name": "Bouenza",
    "iso_3166": "CG-11",
    "country": "CG"
  },
  {
    "abbreviation": "BZV",
    "name": "Brazzaville",
    "iso_3166": "CG-BZV",
    "country": "CG"
  },
  {
    "abbreviation": "8",
    "name": "Cuvette",
    "iso_3166": "CG-8",
    "country": "CG"
  },
  {
    "abbreviation": "9",
    "name": "Niari",
    "iso_3166": "CG-9",
    "country": "CG"
  },
  {
    "abbreviation": "14",
    "name": "Plateaux",
    "iso_3166": "CG-14",
    "country": "CG"
  },
  {
    "abbreviation": "16",
    "name": "Pointe-Noire",
    "iso_3166": "CG-16",
    "country": "CG"
  },
  {
    "abbreviation": "13",
    "name": "Sangha",
    "iso_3166": "CG-13",
    "country": "CG"
  },
  {
    "abbreviation": "EQ",
    "name": "Equateur",
    "iso_3166": "CD-EQ",
    "country": "CD"
  },
  {
    "abbreviation": "HK",
    "name": "Haut-Katanga",
    "iso_3166": "CD-HK",
    "country": "CD"
  },
  {
    "abbreviation": "HL",
    "name": "Haut-Lomami",
    "iso_3166": "CD-HL",
    "country": "CD"
  },
  {
    "abbreviation": "IT",
    "name": "Ituri",
    "iso_3166": "CD-IT",
    "country": "CD"
  },
  {
    "abbreviation": "KS",
    "name": "Kasai",
    "iso_3166": "CD-KS",
    "country": "CD"
  },
  {
    "abbreviation": "KC",
    "name": "Kasai Central",
    "iso_3166": "CD-KC",
    "country": "CD"
  },
  {
    "abbreviation": "KE",
    "name": "Kasai Oriental",
    "iso_3166": "CD-KE",
    "country": "CD"
  },
  {
    "abbreviation": "KN",
    "name": "Kinshasa",
    "iso_3166": "CD-KN",
    "country": "CD"
  },
  {
    "abbreviation": "LU",
    "name": "Lualaba",
    "iso_3166": "CD-LU",
    "country": "CD"
  },
  {
    "abbreviation": "MA",
    "name": "Maniema",
    "iso_3166": "CD-MA",
    "country": "CD"
  },
  {
    "abbreviation": "NK",
    "name": "Nord-Kivu",
    "iso_3166": "CD-NK",
    "country": "CD"
  },
  {
    "abbreviation": "SA",
    "name": "Sankuru",
    "iso_3166": "CD-SA",
    "country": "CD"
  },
  {
    "abbreviation": "SK",
    "name": "Sud-Kivu",
    "iso_3166": "CD-SK",
    "country": "CD"
  },
  {
    "abbreviation": "TA",
    "name": "Tanganyika",
    "iso_3166": "CD-TA",
    "country": "CD"
  },
  {
    "abbreviation": "TO",
    "name": "Tshopo",
    "iso_3166": "CD-TO",
    "country": "CD"
  },
  {
    "abbreviation": "-",
    "name": "Cook Islands",
    "iso_3166": "-",
    "country": "CK"
  },
  {
    "abbreviation": "A",
    "name": "Alajuela",
    "iso_3166": "CR-A",
    "country": "CR"
  },
  {
    "abbreviation": "C",
    "name": "Cartago",
    "iso_3166": "CR-C",
    "country": "CR"
  },
  {
    "abbreviation": "G",
    "name": "Guanacaste",
    "iso_3166": "CR-G",
    "country": "CR"
  },
  {
    "abbreviation": "H",
    "name": "Heredia",
    "iso_3166": "CR-H",
    "country": "CR"
  },
  {
    "abbreviation": "L",
    "name": "Limon",
    "iso_3166": "CR-L",
    "country": "CR"
  },
  {
    "abbreviation": "P",
    "name": "Puntarenas",
    "iso_3166": "CR-P",
    "country": "CR"
  },
  {
    "abbreviation": "SJ",
    "name": "San Jose",
    "iso_3166": "CR-SJ",
    "country": "CR"
  },
  {
    "abbreviation": "07",
    "name": "Bjelovarsko-bilogorska zupanija",
    "iso_3166": "HR-07",
    "country": "HR"
  },
  {
    "abbreviation": "12",
    "name": "Brodsko-posavska zupanija",
    "iso_3166": "HR-12",
    "country": "HR"
  },
  {
    "abbreviation": "19",
    "name": "Dubrovacko-neretvanska zupanija",
    "iso_3166": "HR-19",
    "country": "HR"
  },
  {
    "abbreviation": "21",
    "name": "Grad Zagreb",
    "iso_3166": "HR-21",
    "country": "HR"
  },
  {
    "abbreviation": "18",
    "name": "Istarska zupanija",
    "iso_3166": "HR-18",
    "country": "HR"
  },
  {
    "abbreviation": "04",
    "name": "Karlovacka zupanija",
    "iso_3166": "HR-04",
    "country": "HR"
  },
  {
    "abbreviation": "06",
    "name": "Koprivnicko-krizevacka zupanija",
    "iso_3166": "HR-06",
    "country": "HR"
  },
  {
    "abbreviation": "02",
    "name": "Krapinsko-zagorska zupanija",
    "iso_3166": "HR-02",
    "country": "HR"
  },
  {
    "abbreviation": "09",
    "name": "Licko-senjska zupanija",
    "iso_3166": "HR-09",
    "country": "HR"
  },
  {
    "abbreviation": "20",
    "name": "Medimurska zupanija",
    "iso_3166": "HR-20",
    "country": "HR"
  },
  {
    "abbreviation": "14",
    "name": "Osjecko-baranjska zupanija",
    "iso_3166": "HR-14",
    "country": "HR"
  },
  {
    "abbreviation": "11",
    "name": "Pozesko-slavonska zupanija",
    "iso_3166": "HR-11",
    "country": "HR"
  },
  {
    "abbreviation": "08",
    "name": "Primorsko-goranska zupanija",
    "iso_3166": "HR-08",
    "country": "HR"
  },
  {
    "abbreviation": "15",
    "name": "Sibensko-kninska zupanija",
    "iso_3166": "HR-15",
    "country": "HR"
  },
  {
    "abbreviation": "03",
    "name": "Sisacko-moslavacka zupanija",
    "iso_3166": "HR-03",
    "country": "HR"
  },
  {
    "abbreviation": "17",
    "name": "Splitsko-dalmatinska zupanija",
    "iso_3166": "HR-17",
    "country": "HR"
  },
  {
    "abbreviation": "05",
    "name": "Varazdinska zupanija",
    "iso_3166": "HR-05",
    "country": "HR"
  },
  {
    "abbreviation": "10",
    "name": "Viroviticko-podravska zupanija",
    "iso_3166": "HR-10",
    "country": "HR"
  },
  {
    "abbreviation": "16",
    "name": "Vukovarsko-srijemska zupanija",
    "iso_3166": "HR-16",
    "country": "HR"
  },
  {
    "abbreviation": "13",
    "name": "Zadarska zupanija",
    "iso_3166": "HR-13",
    "country": "HR"
  },
  {
    "abbreviation": "01",
    "name": "Zagrebacka zupanija",
    "iso_3166": "HR-01",
    "country": "HR"
  },
  {
    "abbreviation": "15",
    "name": "Artemisa",
    "iso_3166": "CU-15",
    "country": "CU"
  },
  {
    "abbreviation": "09",
    "name": "Camaguey",
    "iso_3166": "CU-09",
    "country": "CU"
  },
  {
    "abbreviation": "08",
    "name": "Ciego de Avila",
    "iso_3166": "CU-08",
    "country": "CU"
  },
  {
    "abbreviation": "06",
    "name": "Cienfuegos",
    "iso_3166": "CU-06",
    "country": "CU"
  },
  {
    "abbreviation": "12",
    "name": "Granma",
    "iso_3166": "CU-12",
    "country": "CU"
  },
  {
    "abbreviation": "14",
    "name": "Guantanamo",
    "iso_3166": "CU-14",
    "country": "CU"
  },
  {
    "abbreviation": "11",
    "name": "Holguin",
    "iso_3166": "CU-11",
    "country": "CU"
  },
  {
    "abbreviation": "99",
    "name": "Isla de la Juventud",
    "iso_3166": "CU-99",
    "country": "CU"
  },
  {
    "abbreviation": "03",
    "name": "La Habana",
    "iso_3166": "CU-03",
    "country": "CU"
  },
  {
    "abbreviation": "10",
    "name": "Las Tunas",
    "iso_3166": "CU-10",
    "country": "CU"
  },
  {
    "abbreviation": "04",
    "name": "Matanzas",
    "iso_3166": "CU-04",
    "country": "CU"
  },
  {
    "abbreviation": "16",
    "name": "Mayabeque",
    "iso_3166": "CU-16",
    "country": "CU"
  },
  {
    "abbreviation": "01",
    "name": "Pinar del Rio",
    "iso_3166": "CU-01",
    "country": "CU"
  },
  {
    "abbreviation": "07",
    "name": "Sancti Spiritus",
    "iso_3166": "CU-07",
    "country": "CU"
  },
  {
    "abbreviation": "13",
    "name": "Santiago de Cuba",
    "iso_3166": "CU-13",
    "country": "CU"
  },
  {
    "abbreviation": "05",
    "name": "Villa Clara",
    "iso_3166": "CU-05",
    "country": "CU"
  },
  {
    "abbreviation": "-",
    "name": "Curacao",
    "iso_3166": "-",
    "country": "CW"
  },
  {
    "abbreviation": "04",
    "name": "Ammochostos",
    "iso_3166": "CY-04",
    "country": "CY"
  },
  {
    "abbreviation": "06",
    "name": "Keryneia",
    "iso_3166": "CY-06",
    "country": "CY"
  },
  {
    "abbreviation": "03",
    "name": "Larnaka",
    "iso_3166": "CY-03",
    "country": "CY"
  },
  {
    "abbreviation": "01",
    "name": "Lefkosia",
    "iso_3166": "CY-01",
    "country": "CY"
  },
  {
    "abbreviation": "02",
    "name": "Lemesos",
    "iso_3166": "CY-02",
    "country": "CY"
  },
  {
    "abbreviation": "05",
    "name": "Pafos",
    "iso_3166": "CY-05",
    "country": "CY"
  },
  {
    "abbreviation": "31",
    "name": "Jihocesky kraj",
    "iso_3166": "CZ-31",
    "country": "CZ"
  },
  {
    "abbreviation": "64",
    "name": "Jihomoravsky kraj",
    "iso_3166": "CZ-64",
    "country": "CZ"
  },
  {
    "abbreviation": "41",
    "name": "Karlovarsky kraj",
    "iso_3166": "CZ-41",
    "country": "CZ"
  },
  {
    "abbreviation": "63",
    "name": "Kraj Vysocina",
    "iso_3166": "CZ-63",
    "country": "CZ"
  },
  {
    "abbreviation": "52",
    "name": "Kralovehradecky kraj",
    "iso_3166": "CZ-52",
    "country": "CZ"
  },
  {
    "abbreviation": "51",
    "name": "Liberecky kraj",
    "iso_3166": "CZ-51",
    "country": "CZ"
  },
  {
    "abbreviation": "80",
    "name": "Moravskoslezsky kraj",
    "iso_3166": "CZ-80",
    "country": "CZ"
  },
  {
    "abbreviation": "71",
    "name": "Olomoucky kraj",
    "iso_3166": "CZ-71",
    "country": "CZ"
  },
  {
    "abbreviation": "53",
    "name": "Pardubicky kraj",
    "iso_3166": "CZ-53",
    "country": "CZ"
  },
  {
    "abbreviation": "32",
    "name": "Plzensky kraj",
    "iso_3166": "CZ-32",
    "country": "CZ"
  },
  {
    "abbreviation": "10",
    "name": "Praha, Hlavni mesto",
    "iso_3166": "CZ-10",
    "country": "CZ"
  },
  {
    "abbreviation": "20",
    "name": "Stredocesky kraj",
    "iso_3166": "CZ-20",
    "country": "CZ"
  },
  {
    "abbreviation": "42",
    "name": "Ustecky kraj",
    "iso_3166": "CZ-42",
    "country": "CZ"
  },
  {
    "abbreviation": "72",
    "name": "Zlinsky kraj",
    "iso_3166": "CZ-72",
    "country": "CZ"
  },
  {
    "abbreviation": "84",
    "name": "Hovedstaden",
    "iso_3166": "DK-84",
    "country": "DK"
  },
  {
    "abbreviation": "82",
    "name": "Midtjylland",
    "iso_3166": "DK-82",
    "country": "DK"
  },
  {
    "abbreviation": "81",
    "name": "Nordjylland",
    "iso_3166": "DK-81",
    "country": "DK"
  },
  {
    "abbreviation": "85",
    "name": "Sjaelland",
    "iso_3166": "DK-85",
    "country": "DK"
  },
  {
    "abbreviation": "83",
    "name": "Syddanmark",
    "iso_3166": "DK-83",
    "country": "DK"
  },
  {
    "abbreviation": "AR",
    "name": "Arta",
    "iso_3166": "DJ-AR",
    "country": "DJ"
  },
  {
    "abbreviation": "DI",
    "name": "Dikhil",
    "iso_3166": "DJ-DI",
    "country": "DJ"
  },
  {
    "abbreviation": "DJ",
    "name": "Djibouti",
    "iso_3166": "DJ-DJ",
    "country": "DJ"
  },
  {
    "abbreviation": "02",
    "name": "Saint Andrew",
    "iso_3166": "DM-02",
    "country": "DM"
  },
  {
    "abbreviation": "04",
    "name": "Saint George",
    "iso_3166": "DM-04",
    "country": "DM"
  },
  {
    "abbreviation": "05",
    "name": "Saint John",
    "iso_3166": "DM-05",
    "country": "DM"
  },
  {
    "abbreviation": "06",
    "name": "Saint Joseph",
    "iso_3166": "DM-06",
    "country": "DM"
  },
  {
    "abbreviation": "07",
    "name": "Saint Luke",
    "iso_3166": "DM-07",
    "country": "DM"
  },
  {
    "abbreviation": "09",
    "name": "Saint Patrick",
    "iso_3166": "DM-09",
    "country": "DM"
  },
  {
    "abbreviation": "10",
    "name": "Saint Paul",
    "iso_3166": "DM-10",
    "country": "DM"
  },
  {
    "abbreviation": "02",
    "name": "Azua",
    "iso_3166": "DO-02",
    "country": "DO"
  },
  {
    "abbreviation": "03",
    "name": "Baoruco",
    "iso_3166": "DO-03",
    "country": "DO"
  },
  {
    "abbreviation": "04",
    "name": "Barahona",
    "iso_3166": "DO-04",
    "country": "DO"
  },
  {
    "abbreviation": "05",
    "name": "Dajabon",
    "iso_3166": "DO-05",
    "country": "DO"
  },
  {
    "abbreviation": "01",
    "name": "Distrito Nacional (Santo Domingo)",
    "iso_3166": "DO-01",
    "country": "DO"
  },
  {
    "abbreviation": "06",
    "name": "Duarte",
    "iso_3166": "DO-06",
    "country": "DO"
  },
  {
    "abbreviation": "08",
    "name": "El Seibo",
    "iso_3166": "DO-08",
    "country": "DO"
  },
  {
    "abbreviation": "07",
    "name": "Elias Pina",
    "iso_3166": "DO-07",
    "country": "DO"
  },
  {
    "abbreviation": "09",
    "name": "Espaillat",
    "iso_3166": "DO-09",
    "country": "DO"
  },
  {
    "abbreviation": "30",
    "name": "Hato Mayor",
    "iso_3166": "DO-30",
    "country": "DO"
  },
  {
    "abbreviation": "19",
    "name": "Hermanas Mirabal",
    "iso_3166": "DO-19",
    "country": "DO"
  },
  {
    "abbreviation": "10",
    "name": "Independencia",
    "iso_3166": "DO-10",
    "country": "DO"
  },
  {
    "abbreviation": "11",
    "name": "La Altagracia",
    "iso_3166": "DO-11",
    "country": "DO"
  },
  {
    "abbreviation": "12",
    "name": "La Romana",
    "iso_3166": "DO-12",
    "country": "DO"
  },
  {
    "abbreviation": "13",
    "name": "La Vega",
    "iso_3166": "DO-13",
    "country": "DO"
  },
  {
    "abbreviation": "14",
    "name": "Maria Trinidad Sanchez",
    "iso_3166": "DO-14",
    "country": "DO"
  },
  {
    "abbreviation": "28",
    "name": "Monsenor Nouel",
    "iso_3166": "DO-28",
    "country": "DO"
  },
  {
    "abbreviation": "15",
    "name": "Monte Cristi",
    "iso_3166": "DO-15",
    "country": "DO"
  },
  {
    "abbreviation": "29",
    "name": "Monte Plata",
    "iso_3166": "DO-29",
    "country": "DO"
  },
  {
    "abbreviation": "16",
    "name": "Pedernales",
    "iso_3166": "DO-16",
    "country": "DO"
  },
  {
    "abbreviation": "17",
    "name": "Peravia",
    "iso_3166": "DO-17",
    "country": "DO"
  },
  {
    "abbreviation": "18",
    "name": "Puerto Plata",
    "iso_3166": "DO-18",
    "country": "DO"
  },
  {
    "abbreviation": "20",
    "name": "Samana",
    "iso_3166": "DO-20",
    "country": "DO"
  },
  {
    "abbreviation": "21",
    "name": "San Cristobal",
    "iso_3166": "DO-21",
    "country": "DO"
  },
  {
    "abbreviation": "31",
    "name": "San Jose de Ocoa",
    "iso_3166": "DO-31",
    "country": "DO"
  },
  {
    "abbreviation": "22",
    "name": "San Juan",
    "iso_3166": "DO-22",
    "country": "DO"
  },
  {
    "abbreviation": "23",
    "name": "San Pedro de Macoris",
    "iso_3166": "DO-23",
    "country": "DO"
  },
  {
    "abbreviation": "24",
    "name": "Sanchez Ramirez",
    "iso_3166": "DO-24",
    "country": "DO"
  },
  {
    "abbreviation": "25",
    "name": "Santiago",
    "iso_3166": "DO-25",
    "country": "DO"
  },
  {
    "abbreviation": "26",
    "name": "Santiago Rodriguez",
    "iso_3166": "DO-26",
    "country": "DO"
  },
  {
    "abbreviation": "27",
    "name": "Valverde",
    "iso_3166": "DO-27",
    "country": "DO"
  },
  {
    "abbreviation": "A",
    "name": "Azuay",
    "iso_3166": "EC-A",
    "country": "EC"
  },
  {
    "abbreviation": "B",
    "name": "Bolivar",
    "iso_3166": "EC-B",
    "country": "EC"
  },
  {
    "abbreviation": "F",
    "name": "Canar",
    "iso_3166": "EC-F",
    "country": "EC"
  },
  {
    "abbreviation": "C",
    "name": "Carchi",
    "iso_3166": "EC-C",
    "country": "EC"
  },
  {
    "abbreviation": "H",
    "name": "Chimborazo",
    "iso_3166": "EC-H",
    "country": "EC"
  },
  {
    "abbreviation": "X",
    "name": "Cotopaxi",
    "iso_3166": "EC-X",
    "country": "EC"
  },
  {
    "abbreviation": "O",
    "name": "El Oro",
    "iso_3166": "EC-O",
    "country": "EC"
  },
  {
    "abbreviation": "E",
    "name": "Esmeraldas",
    "iso_3166": "EC-E",
    "country": "EC"
  },
  {
    "abbreviation": "W",
    "name": "Galapagos",
    "iso_3166": "EC-W",
    "country": "EC"
  },
  {
    "abbreviation": "G",
    "name": "Guayas",
    "iso_3166": "EC-G",
    "country": "EC"
  },
  {
    "abbreviation": "I",
    "name": "Imbabura",
    "iso_3166": "EC-I",
    "country": "EC"
  },
  {
    "abbreviation": "L",
    "name": "Loja",
    "iso_3166": "EC-L",
    "country": "EC"
  },
  {
    "abbreviation": "R",
    "name": "Los Rios",
    "iso_3166": "EC-R",
    "country": "EC"
  },
  {
    "abbreviation": "M",
    "name": "Manabi",
    "iso_3166": "EC-M",
    "country": "EC"
  },
  {
    "abbreviation": "S",
    "name": "Morona Santiago",
    "iso_3166": "EC-S",
    "country": "EC"
  },
  {
    "abbreviation": "N",
    "name": "Napo",
    "iso_3166": "EC-N",
    "country": "EC"
  },
  {
    "abbreviation": "D",
    "name": "Orellana",
    "iso_3166": "EC-D",
    "country": "EC"
  },
  {
    "abbreviation": "Y",
    "name": "Pastaza",
    "iso_3166": "EC-Y",
    "country": "EC"
  },
  {
    "abbreviation": "P",
    "name": "Pichincha",
    "iso_3166": "EC-P",
    "country": "EC"
  },
  {
    "abbreviation": "SE",
    "name": "Santa Elena",
    "iso_3166": "EC-SE",
    "country": "EC"
  },
  {
    "abbreviation": "SD",
    "name": "Santo Domingo de los Tsachilas",
    "iso_3166": "EC-SD",
    "country": "EC"
  },
  {
    "abbreviation": "U",
    "name": "Sucumbios",
    "iso_3166": "EC-U",
    "country": "EC"
  },
  {
    "abbreviation": "T",
    "name": "Tungurahua",
    "iso_3166": "EC-T",
    "country": "EC"
  },
  {
    "abbreviation": "Z",
    "name": "Zamora Chinchipe",
    "iso_3166": "EC-Z",
    "country": "EC"
  },
  {
    "abbreviation": "DK",
    "name": "Ad Daqahliyah",
    "iso_3166": "EG-DK",
    "country": "EG"
  },
  {
    "abbreviation": "BA",
    "name": "Al Bahr al Ahmar",
    "iso_3166": "EG-BA",
    "country": "EG"
  },
  {
    "abbreviation": "BH",
    "name": "Al Buhayrah",
    "iso_3166": "EG-BH",
    "country": "EG"
  },
  {
    "abbreviation": "FYM",
    "name": "Al Fayyum",
    "iso_3166": "EG-FYM",
    "country": "EG"
  },
  {
    "abbreviation": "GH",
    "name": "Al Gharbiyah",
    "iso_3166": "EG-GH",
    "country": "EG"
  },
  {
    "abbreviation": "ALX",
    "name": "Al Iskandariyah",
    "iso_3166": "EG-ALX",
    "country": "EG"
  },
  {
    "abbreviation": "IS",
    "name": "Al Isma'iliyah",
    "iso_3166": "EG-IS",
    "country": "EG"
  },
  {
    "abbreviation": "GZ",
    "name": "Al Jizah",
    "iso_3166": "EG-GZ",
    "country": "EG"
  },
  {
    "abbreviation": "MNF",
    "name": "Al Minufiyah",
    "iso_3166": "EG-MNF",
    "country": "EG"
  },
  {
    "abbreviation": "MN",
    "name": "Al Minya",
    "iso_3166": "EG-MN",
    "country": "EG"
  },
  {
    "abbreviation": "C",
    "name": "Al Qahirah",
    "iso_3166": "EG-C",
    "country": "EG"
  },
  {
    "abbreviation": "KB",
    "name": "Al Qalyubiyah",
    "iso_3166": "EG-KB",
    "country": "EG"
  },
  {
    "abbreviation": "LX",
    "name": "Al Uqsur",
    "iso_3166": "EG-LX",
    "country": "EG"
  },
  {
    "abbreviation": "WAD",
    "name": "Al Wadi al Jadid",
    "iso_3166": "EG-WAD",
    "country": "EG"
  },
  {
    "abbreviation": "SUZ",
    "name": "As Suways",
    "iso_3166": "EG-SUZ",
    "country": "EG"
  },
  {
    "abbreviation": "SHR",
    "name": "Ash Sharqiyah",
    "iso_3166": "EG-SHR",
    "country": "EG"
  },
  {
    "abbreviation": "ASN",
    "name": "Aswan",
    "iso_3166": "EG-ASN",
    "country": "EG"
  },
  {
    "abbreviation": "AST",
    "name": "Asyut",
    "iso_3166": "EG-AST",
    "country": "EG"
  },
  {
    "abbreviation": "BNS",
    "name": "Bani Suwayf",
    "iso_3166": "EG-BNS",
    "country": "EG"
  },
  {
    "abbreviation": "PTS",
    "name": "Bur Sa'id",
    "iso_3166": "EG-PTS",
    "country": "EG"
  },
  {
    "abbreviation": "DT",
    "name": "Dumyat",
    "iso_3166": "EG-DT",
    "country": "EG"
  },
  {
    "abbreviation": "JS",
    "name": "Janub Sina'",
    "iso_3166": "EG-JS",
    "country": "EG"
  },
  {
    "abbreviation": "KFS",
    "name": "Kafr ash Shaykh",
    "iso_3166": "EG-KFS",
    "country": "EG"
  },
  {
    "abbreviation": "MT",
    "name": "Matruh",
    "iso_3166": "EG-MT",
    "country": "EG"
  },
  {
    "abbreviation": "KN",
    "name": "Qina",
    "iso_3166": "EG-KN",
    "country": "EG"
  },
  {
    "abbreviation": "SIN",
    "name": "Shamal Sina'",
    "iso_3166": "EG-SIN",
    "country": "EG"
  },
  {
    "abbreviation": "SHG",
    "name": "Suhaj",
    "iso_3166": "EG-SHG",
    "country": "EG"
  },
  {
    "abbreviation": "AH",
    "name": "Ahuachapan",
    "iso_3166": "SV-AH",
    "country": "SV"
  },
  {
    "abbreviation": "CA",
    "name": "Cabanas",
    "iso_3166": "SV-CA",
    "country": "SV"
  },
  {
    "abbreviation": "CH",
    "name": "Chalatenango",
    "iso_3166": "SV-CH",
    "country": "SV"
  },
  {
    "abbreviation": "CU",
    "name": "Cuscatlan",
    "iso_3166": "SV-CU",
    "country": "SV"
  },
  {
    "abbreviation": "LI",
    "name": "La Libertad",
    "iso_3166": "SV-LI",
    "country": "SV"
  },
  {
    "abbreviation": "PA",
    "name": "La Paz",
    "iso_3166": "SV-PA",
    "country": "SV"
  },
  {
    "abbreviation": "UN",
    "name": "La Union",
    "iso_3166": "SV-UN",
    "country": "SV"
  },
  {
    "abbreviation": "MO",
    "name": "Morazan",
    "iso_3166": "SV-MO",
    "country": "SV"
  },
  {
    "abbreviation": "SM",
    "name": "San Miguel",
    "iso_3166": "SV-SM",
    "country": "SV"
  },
  {
    "abbreviation": "SS",
    "name": "San Salvador",
    "iso_3166": "SV-SS",
    "country": "SV"
  },
  {
    "abbreviation": "SV",
    "name": "San Vicente",
    "iso_3166": "SV-SV",
    "country": "SV"
  },
  {
    "abbreviation": "SA",
    "name": "Santa Ana",
    "iso_3166": "SV-SA",
    "country": "SV"
  },
  {
    "abbreviation": "SO",
    "name": "Sonsonate",
    "iso_3166": "SV-SO",
    "country": "SV"
  },
  {
    "abbreviation": "US",
    "name": "Usulutan",
    "iso_3166": "SV-US",
    "country": "SV"
  },
  {
    "abbreviation": "AN",
    "name": "Annobon",
    "iso_3166": "GQ-AN",
    "country": "GQ"
  },
  {
    "abbreviation": "BN",
    "name": "Bioko Norte",
    "iso_3166": "GQ-BN",
    "country": "GQ"
  },
  {
    "abbreviation": "CS",
    "name": "Centro Sur",
    "iso_3166": "GQ-CS",
    "country": "GQ"
  },
  {
    "abbreviation": "KN",
    "name": "Kie-Ntem",
    "iso_3166": "GQ-KN",
    "country": "GQ"
  },
  {
    "abbreviation": "LI",
    "name": "Litoral",
    "iso_3166": "GQ-LI",
    "country": "GQ"
  },
  {
    "abbreviation": "WN",
    "name": "Wele-Nzas",
    "iso_3166": "GQ-WN",
    "country": "GQ"
  },
  {
    "abbreviation": "MA",
    "name": "Al Awsat",
    "iso_3166": "ER-MA",
    "country": "ER"
  },
  {
    "abbreviation": "GB",
    "name": "Qash-Barkah",
    "iso_3166": "ER-GB",
    "country": "ER"
  },
  {
    "abbreviation": "37",
    "name": "Harjumaa",
    "iso_3166": "EE-37",
    "country": "EE"
  },
  {
    "abbreviation": "39",
    "name": "Hiiumaa",
    "iso_3166": "EE-39",
    "country": "EE"
  },
  {
    "abbreviation": "45",
    "name": "Ida-Virumaa",
    "iso_3166": "EE-45",
    "country": "EE"
  },
  {
    "abbreviation": "52",
    "name": "Jarvamaa",
    "iso_3166": "EE-52",
    "country": "EE"
  },
  {
    "abbreviation": "50",
    "name": "Jogevamaa",
    "iso_3166": "EE-50",
    "country": "EE"
  },
  {
    "abbreviation": "60",
    "name": "Laane-Virumaa",
    "iso_3166": "EE-60",
    "country": "EE"
  },
  {
    "abbreviation": "56",
    "name": "Laanemaa",
    "iso_3166": "EE-56",
    "country": "EE"
  },
  {
    "abbreviation": "68",
    "name": "Parnumaa",
    "iso_3166": "EE-68",
    "country": "EE"
  },
  {
    "abbreviation": "64",
    "name": "Polvamaa",
    "iso_3166": "EE-64",
    "country": "EE"
  },
  {
    "abbreviation": "71",
    "name": "Raplamaa",
    "iso_3166": "EE-71",
    "country": "EE"
  },
  {
    "abbreviation": "74",
    "name": "Saaremaa",
    "iso_3166": "EE-74",
    "country": "EE"
  },
  {
    "abbreviation": "79",
    "name": "Tartumaa",
    "iso_3166": "EE-79",
    "country": "EE"
  },
  {
    "abbreviation": "81",
    "name": "Valgamaa",
    "iso_3166": "EE-81",
    "country": "EE"
  },
  {
    "abbreviation": "84",
    "name": "Viljandimaa",
    "iso_3166": "EE-84",
    "country": "EE"
  },
  {
    "abbreviation": "87",
    "name": "Vorumaa",
    "iso_3166": "EE-87",
    "country": "EE"
  },
  {
    "abbreviation": "AA",
    "name": "Addis Ababa",
    "iso_3166": "ET-AA",
    "country": "ET"
  },
  {
    "abbreviation": "AF",
    "name": "Afar",
    "iso_3166": "ET-AF",
    "country": "ET"
  },
  {
    "abbreviation": "AM",
    "name": "Amara",
    "iso_3166": "ET-AM",
    "country": "ET"
  },
  {
    "abbreviation": "BE",
    "name": "Benshangul-Gumaz",
    "iso_3166": "ET-BE",
    "country": "ET"
  },
  {
    "abbreviation": "DD",
    "name": "Dire Dawa",
    "iso_3166": "ET-DD",
    "country": "ET"
  },
  {
    "abbreviation": "HA",
    "name": "Harari People",
    "iso_3166": "ET-HA",
    "country": "ET"
  },
  {
    "abbreviation": "OR",
    "name": "Oromia",
    "iso_3166": "ET-OR",
    "country": "ET"
  },
  {
    "abbreviation": "SO",
    "name": "Somali",
    "iso_3166": "ET-SO",
    "country": "ET"
  },
  {
    "abbreviation": "SN",
    "name": "Southern Nations, Nationalities and Peoples",
    "iso_3166": "ET-SN",
    "country": "ET"
  },
  {
    "abbreviation": "TI",
    "name": "Tigrai",
    "iso_3166": "ET-TI",
    "country": "ET"
  },
  {
    "abbreviation": "-",
    "name": "Falkland Islands (Malvinas)",
    "iso_3166": "-",
    "country": "FK"
  },
  {
    "abbreviation": "-",
    "name": "Eysturoy",
    "iso_3166": "-",
    "country": "FO"
  },
  {
    "abbreviation": "-",
    "name": "Nordoyar",
    "iso_3166": "-",
    "country": "FO"
  },
  {
    "abbreviation": "-",
    "name": "Streymoy",
    "iso_3166": "-",
    "country": "FO"
  },
  {
    "abbreviation": "-",
    "name": "Suduroy",
    "iso_3166": "-",
    "country": "FO"
  },
  {
    "abbreviation": "-",
    "name": "Vagar",
    "iso_3166": "-",
    "country": "FO"
  },
  {
    "abbreviation": "C",
    "name": "Central",
    "iso_3166": "FJ-C",
    "country": "FJ"
  },
  {
    "abbreviation": "E",
    "name": "Eastern",
    "iso_3166": "FJ-E",
    "country": "FJ"
  },
  {
    "abbreviation": "N",
    "name": "Northern",
    "iso_3166": "FJ-N",
    "country": "FJ"
  },
  {
    "abbreviation": "R",
    "name": "Rotuma",
    "iso_3166": "FJ-R",
    "country": "FJ"
  },
  {
    "abbreviation": "W",
    "name": "Western",
    "iso_3166": "FJ-W",
    "country": "FJ"
  },
  {
    "abbreviation": "02",
    "name": "Etela-Karjala",
    "iso_3166": "FI-02",
    "country": "FI"
  },
  {
    "abbreviation": "03",
    "name": "Etela-Pohjanmaa",
    "iso_3166": "FI-03",
    "country": "FI"
  },
  {
    "abbreviation": "04",
    "name": "Etela-Savo",
    "iso_3166": "FI-04",
    "country": "FI"
  },
  {
    "abbreviation": "05",
    "name": "Kainuu",
    "iso_3166": "FI-05",
    "country": "FI"
  },
  {
    "abbreviation": "06",
    "name": "Kanta-Hame",
    "iso_3166": "FI-06",
    "country": "FI"
  },
  {
    "abbreviation": "07",
    "name": "Keski-Pohjanmaa",
    "iso_3166": "FI-07",
    "country": "FI"
  },
  {
    "abbreviation": "08",
    "name": "Keski-Suomi",
    "iso_3166": "FI-08",
    "country": "FI"
  },
  {
    "abbreviation": "09",
    "name": "Kymenlaakso",
    "iso_3166": "FI-09",
    "country": "FI"
  },
  {
    "abbreviation": "10",
    "name": "Lappi",
    "iso_3166": "FI-10",
    "country": "FI"
  },
  {
    "abbreviation": "16",
    "name": "Paijat-Hame",
    "iso_3166": "FI-16",
    "country": "FI"
  },
  {
    "abbreviation": "11",
    "name": "Pirkanmaa",
    "iso_3166": "FI-11",
    "country": "FI"
  },
  {
    "abbreviation": "12",
    "name": "Pohjanmaa",
    "iso_3166": "FI-12",
    "country": "FI"
  },
  {
    "abbreviation": "13",
    "name": "Pohjois-Karjala",
    "iso_3166": "FI-13",
    "country": "FI"
  },
  {
    "abbreviation": "14",
    "name": "Pohjois-Pohjanmaa",
    "iso_3166": "FI-14",
    "country": "FI"
  },
  {
    "abbreviation": "15",
    "name": "Pohjois-Savo",
    "iso_3166": "FI-15",
    "country": "FI"
  },
  {
    "abbreviation": "17",
    "name": "Satakunta",
    "iso_3166": "FI-17",
    "country": "FI"
  },
  {
    "abbreviation": "18",
    "name": "Uusimaa",
    "iso_3166": "FI-18",
    "country": "FI"
  },
  {
    "abbreviation": "19",
    "name": "Varsinais-Suomi",
    "iso_3166": "FI-19",
    "country": "FI"
  },
  {
    "abbreviation": "ARA",
    "name": "Auvergne-Rhone-Alpes",
    "iso_3166": "FR-ARA",
    "country": "FR"
  },
  {
    "abbreviation": "BFC",
    "name": "Bourgogne-Franche-Comte",
    "iso_3166": "FR-BFC",
    "country": "FR"
  },
  {
    "abbreviation": "BRE",
    "name": "Bretagne",
    "iso_3166": "FR-BRE",
    "country": "FR"
  },
  {
    "abbreviation": "CVL",
    "name": "Centre-Val de Loire",
    "iso_3166": "FR-CVL",
    "country": "FR"
  },
  {
    "abbreviation": "20R",
    "name": "Corse",
    "iso_3166": "FR-20R",
    "country": "FR"
  },
  {
    "abbreviation": "GES",
    "name": "Grand-Est",
    "iso_3166": "FR-GES",
    "country": "FR"
  },
  {
    "abbreviation": "HDF",
    "name": "Hauts-de-France",
    "iso_3166": "FR-HDF",
    "country": "FR"
  },
  {
    "abbreviation": "IDF",
    "name": "Ile-de-France",
    "iso_3166": "FR-IDF",
    "country": "FR"
  },
  {
    "abbreviation": "NOR",
    "name": "Normandie",
    "iso_3166": "FR-NOR",
    "country": "FR"
  },
  {
    "abbreviation": "NAQ",
    "name": "Nouvelle-Aquitaine",
    "iso_3166": "FR-NAQ",
    "country": "FR"
  },
  {
    "abbreviation": "OCC",
    "name": "Occitanie",
    "iso_3166": "FR-OCC",
    "country": "FR"
  },
  {
    "abbreviation": "PDL",
    "name": "Pays-de-la-Loire",
    "iso_3166": "FR-PDL",
    "country": "FR"
  },
  {
    "abbreviation": "PAC",
    "name": "Provence-Alpes-Cote-d'Azur",
    "iso_3166": "FR-PAC",
    "country": "FR"
  },
  {
    "abbreviation": "-",
    "name": "Guyane",
    "iso_3166": "-",
    "country": "GF"
  },
  {
    "abbreviation": "-",
    "name": "Iles Australes",
    "iso_3166": "-",
    "country": "PF"
  },
  {
    "abbreviation": "-",
    "name": "Iles Marquises",
    "iso_3166": "-",
    "country": "PF"
  },
  {
    "abbreviation": "-",
    "name": "Iles Sous-le-Vent",
    "iso_3166": "-",
    "country": "PF"
  },
  {
    "abbreviation": "-",
    "name": "Iles Tuamotu-Gambier",
    "iso_3166": "-",
    "country": "PF"
  },
  {
    "abbreviation": "-",
    "name": "Iles du Vent",
    "iso_3166": "-",
    "country": "PF"
  },
  {
    "abbreviation": "-",
    "name": "French Southern Territories",
    "iso_3166": "-",
    "country": "TF"
  },
  {
    "abbreviation": "1",
    "name": "Estuaire",
    "iso_3166": "GA-1",
    "country": "GA"
  },
  {
    "abbreviation": "2",
    "name": "Haut-Ogooue",
    "iso_3166": "GA-2",
    "country": "GA"
  },
  {
    "abbreviation": "3",
    "name": "Moyen-Ogooue",
    "iso_3166": "GA-3",
    "country": "GA"
  },
  {
    "abbreviation": "4",
    "name": "Ngounie",
    "iso_3166": "GA-4",
    "country": "GA"
  },
  {
    "abbreviation": "5",
    "name": "Nyanga",
    "iso_3166": "GA-5",
    "country": "GA"
  },
  {
    "abbreviation": "8",
    "name": "Ogooue-Maritime",
    "iso_3166": "GA-8",
    "country": "GA"
  },
  {
    "abbreviation": "9",
    "name": "Woleu-Ntem",
    "iso_3166": "GA-9",
    "country": "GA"
  },
  {
    "abbreviation": "B",
    "name": "Banjul",
    "iso_3166": "GM-B",
    "country": "GM"
  },
  {
    "abbreviation": "M",
    "name": "Central River",
    "iso_3166": "GM-M",
    "country": "GM"
  },
  {
    "abbreviation": "L",
    "name": "Lower River",
    "iso_3166": "GM-L",
    "country": "GM"
  },
  {
    "abbreviation": "N",
    "name": "North Bank",
    "iso_3166": "GM-N",
    "country": "GM"
  },
  {
    "abbreviation": "U",
    "name": "Upper River",
    "iso_3166": "GM-U",
    "country": "GM"
  },
  {
    "abbreviation": "W",
    "name": "Western",
    "iso_3166": "GM-W",
    "country": "GM"
  },
  {
    "abbreviation": "AB",
    "name": "Abkhazia",
    "iso_3166": "GE-AB",
    "country": "GE"
  },
  {
    "abbreviation": "AJ",
    "name": "Ajaria",
    "iso_3166": "GE-AJ",
    "country": "GE"
  },
  {
    "abbreviation": "GU",
    "name": "Guria",
    "iso_3166": "GE-GU",
    "country": "GE"
  },
  {
    "abbreviation": "IM",
    "name": "Imereti",
    "iso_3166": "GE-IM",
    "country": "GE"
  },
  {
    "abbreviation": "KA",
    "name": "K'akheti",
    "iso_3166": "GE-KA",
    "country": "GE"
  },
  {
    "abbreviation": "KK",
    "name": "Kvemo Kartli",
    "iso_3166": "GE-KK",
    "country": "GE"
  },
  {
    "abbreviation": "MM",
    "name": "Mtskheta-Mtianeti",
    "iso_3166": "GE-MM",
    "country": "GE"
  },
  {
    "abbreviation": "RL",
    "name": "Rach'a-Lechkhumi-Kvemo Svaneti",
    "iso_3166": "GE-RL",
    "country": "GE"
  },
  {
    "abbreviation": "SZ",
    "name": "Samegrelo-Zemo Svaneti",
    "iso_3166": "GE-SZ",
    "country": "GE"
  },
  {
    "abbreviation": "SJ",
    "name": "Samtskhe-Javakheti",
    "iso_3166": "GE-SJ",
    "country": "GE"
  },
  {
    "abbreviation": "SK",
    "name": "Shida Kartli",
    "iso_3166": "GE-SK",
    "country": "GE"
  },
  {
    "abbreviation": "TB",
    "name": "Tbilisi",
    "iso_3166": "GE-TB",
    "country": "GE"
  },
  {
    "abbreviation": "BW",
    "name": "Baden-Wurttemberg",
    "iso_3166": "DE-BW",
    "country": "DE"
  },
  {
    "abbreviation": "BY",
    "name": "Bayern",
    "iso_3166": "DE-BY",
    "country": "DE"
  },
  {
    "abbreviation": "BE",
    "name": "Berlin",
    "iso_3166": "DE-BE",
    "country": "DE"
  },
  {
    "abbreviation": "BB",
    "name": "Brandenburg",
    "iso_3166": "DE-BB",
    "country": "DE"
  },
  {
    "abbreviation": "HB",
    "name": "Bremen",
    "iso_3166": "DE-HB",
    "country": "DE"
  },
  {
    "abbreviation": "HH",
    "name": "Hamburg",
    "iso_3166": "DE-HH",
    "country": "DE"
  },
  {
    "abbreviation": "HE",
    "name": "Hessen",
    "iso_3166": "DE-HE",
    "country": "DE"
  },
  {
    "abbreviation": "MV",
    "name": "Mecklenburg-Vorpommern",
    "iso_3166": "DE-MV",
    "country": "DE"
  },
  {
    "abbreviation": "NI",
    "name": "Niedersachsen",
    "iso_3166": "DE-NI",
    "country": "DE"
  },
  {
    "abbreviation": "NW",
    "name": "Nordrhein-Westfalen",
    "iso_3166": "DE-NW",
    "country": "DE"
  },
  {
    "abbreviation": "RP",
    "name": "Rheinland-Pfalz",
    "iso_3166": "DE-RP",
    "country": "DE"
  },
  {
    "abbreviation": "SL",
    "name": "Saarland",
    "iso_3166": "DE-SL",
    "country": "DE"
  },
  {
    "abbreviation": "SN",
    "name": "Sachsen",
    "iso_3166": "DE-SN",
    "country": "DE"
  },
  {
    "abbreviation": "ST",
    "name": "Sachsen-Anhalt",
    "iso_3166": "DE-ST",
    "country": "DE"
  },
  {
    "abbreviation": "SH",
    "name": "Schleswig-Holstein",
    "iso_3166": "DE-SH",
    "country": "DE"
  },
  {
    "abbreviation": "TH",
    "name": "Thuringen",
    "iso_3166": "DE-TH",
    "country": "DE"
  },
  {
    "abbreviation": "AF",
    "name": "Ahafo",
    "iso_3166": "GH-AF",
    "country": "GH"
  },
  {
    "abbreviation": "AH",
    "name": "Ashanti",
    "iso_3166": "GH-AH",
    "country": "GH"
  },
  {
    "abbreviation": "BO",
    "name": "Bono",
    "iso_3166": "GH-BO",
    "country": "GH"
  },
  {
    "abbreviation": "BE",
    "name": "Bono East",
    "iso_3166": "GH-BE",
    "country": "GH"
  },
  {
    "abbreviation": "CP",
    "name": "Central",
    "iso_3166": "GH-CP",
    "country": "GH"
  },
  {
    "abbreviation": "EP",
    "name": "Eastern",
    "iso_3166": "GH-EP",
    "country": "GH"
  },
  {
    "abbreviation": "AA",
    "name": "Greater Accra",
    "iso_3166": "GH-AA",
    "country": "GH"
  },
  {
    "abbreviation": "NP",
    "name": "Northern",
    "iso_3166": "GH-NP",
    "country": "GH"
  },
  {
    "abbreviation": "UE",
    "name": "Upper East",
    "iso_3166": "GH-UE",
    "country": "GH"
  },
  {
    "abbreviation": "UW",
    "name": "Upper West",
    "iso_3166": "GH-UW",
    "country": "GH"
  },
  {
    "abbreviation": "TV",
    "name": "Volta",
    "iso_3166": "GH-TV",
    "country": "GH"
  },
  {
    "abbreviation": "WP",
    "name": "Western",
    "iso_3166": "GH-WP",
    "country": "GH"
  },
  {
    "abbreviation": "-",
    "name": "Gibraltar",
    "iso_3166": "-",
    "country": "GI"
  },
  {
    "abbreviation": "A",
    "name": "Anatoliki Makedonia kai Thraki",
    "iso_3166": "GR-A",
    "country": "GR"
  },
  {
    "abbreviation": "I",
    "name": "Attiki",
    "iso_3166": "GR-I",
    "country": "GR"
  },
  {
    "abbreviation": "G",
    "name": "Dytiki Ellada",
    "iso_3166": "GR-G",
    "country": "GR"
  },
  {
    "abbreviation": "C",
    "name": "Dytiki Makedonia",
    "iso_3166": "GR-C",
    "country": "GR"
  },
  {
    "abbreviation": "F",
    "name": "Ionia Nisia",
    "iso_3166": "GR-F",
    "country": "GR"
  },
  {
    "abbreviation": "D",
    "name": "Ipeiros",
    "iso_3166": "GR-D",
    "country": "GR"
  },
  {
    "abbreviation": "B",
    "name": "Kentriki Makedonia",
    "iso_3166": "GR-B",
    "country": "GR"
  },
  {
    "abbreviation": "M",
    "name": "Kriti",
    "iso_3166": "GR-M",
    "country": "GR"
  },
  {
    "abbreviation": "L",
    "name": "Notio Aigaio",
    "iso_3166": "GR-L",
    "country": "GR"
  },
  {
    "abbreviation": "J",
    "name": "Peloponnisos",
    "iso_3166": "GR-J",
    "country": "GR"
  },
  {
    "abbreviation": "H",
    "name": "Sterea Ellada",
    "iso_3166": "GR-H",
    "country": "GR"
  },
  {
    "abbreviation": "E",
    "name": "Thessalia",
    "iso_3166": "GR-E",
    "country": "GR"
  },
  {
    "abbreviation": "K",
    "name": "Voreio Aigaio",
    "iso_3166": "GR-K",
    "country": "GR"
  },
  {
    "abbreviation": "AV",
    "name": "Avannaata Kommunia",
    "iso_3166": "GL-AV",
    "country": "GL"
  },
  {
    "abbreviation": "KU",
    "name": "Kommune Kujalleq",
    "iso_3166": "GL-KU",
    "country": "GL"
  },
  {
    "abbreviation": "QT",
    "name": "Kommune Qeqertalik",
    "iso_3166": "GL-QT",
    "country": "GL"
  },
  {
    "abbreviation": "SM",
    "name": "Kommuneqarfik Sermersooq",
    "iso_3166": "GL-SM",
    "country": "GL"
  },
  {
    "abbreviation": "QE",
    "name": "Qeqqata Kommunia",
    "iso_3166": "GL-QE",
    "country": "GL"
  },
  {
    "abbreviation": "01",
    "name": "Saint Andrew",
    "iso_3166": "GD-01",
    "country": "GD"
  },
  {
    "abbreviation": "02",
    "name": "Saint David",
    "iso_3166": "GD-02",
    "country": "GD"
  },
  {
    "abbreviation": "03",
    "name": "Saint George",
    "iso_3166": "GD-03",
    "country": "GD"
  },
  {
    "abbreviation": "04",
    "name": "Saint John",
    "iso_3166": "GD-04",
    "country": "GD"
  },
  {
    "abbreviation": "05",
    "name": "Saint Mark",
    "iso_3166": "GD-05",
    "country": "GD"
  },
  {
    "abbreviation": "06",
    "name": "Saint Patrick",
    "iso_3166": "GD-06",
    "country": "GD"
  },
  {
    "abbreviation": "10",
    "name": "Southern Grenadine Islands",
    "iso_3166": "GD-10",
    "country": "GD"
  },
  {
    "abbreviation": "-",
    "name": "Guadeloupe",
    "iso_3166": "-",
    "country": "GP"
  },
  {
    "abbreviation": "-",
    "name": "Agana Heights",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Agat",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Barrigada",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Chalan Pago-Ordot",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Dededo",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Hagatna",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Inarajan",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Mangilao",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Mongmong-Toto-Maite",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Piti",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Santa Rita",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Sinajana",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Talofofo",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Tamuning-Tumon-Harmon",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Yigo",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "-",
    "name": "Yona",
    "iso_3166": "-",
    "country": "GU"
  },
  {
    "abbreviation": "16",
    "name": "Alta Verapaz",
    "iso_3166": "GT-16",
    "country": "GT"
  },
  {
    "abbreviation": "15",
    "name": "Baja Verapaz",
    "iso_3166": "GT-15",
    "country": "GT"
  },
  {
    "abbreviation": "04",
    "name": "Chimaltenango",
    "iso_3166": "GT-04",
    "country": "GT"
  },
  {
    "abbreviation": "20",
    "name": "Chiquimula",
    "iso_3166": "GT-20",
    "country": "GT"
  },
  {
    "abbreviation": "02",
    "name": "El Progreso",
    "iso_3166": "GT-02",
    "country": "GT"
  },
  {
    "abbreviation": "05",
    "name": "Escuintla",
    "iso_3166": "GT-05",
    "country": "GT"
  },
  {
    "abbreviation": "01",
    "name": "Guatemala",
    "iso_3166": "GT-01",
    "country": "GT"
  },
  {
    "abbreviation": "13",
    "name": "Huehuetenango",
    "iso_3166": "GT-13",
    "country": "GT"
  },
  {
    "abbreviation": "18",
    "name": "Izabal",
    "iso_3166": "GT-18",
    "country": "GT"
  },
  {
    "abbreviation": "21",
    "name": "Jalapa",
    "iso_3166": "GT-21",
    "country": "GT"
  },
  {
    "abbreviation": "22",
    "name": "Jutiapa",
    "iso_3166": "GT-22",
    "country": "GT"
  },
  {
    "abbreviation": "17",
    "name": "Peten",
    "iso_3166": "GT-17",
    "country": "GT"
  },
  {
    "abbreviation": "09",
    "name": "Quetzaltenango",
    "iso_3166": "GT-09",
    "country": "GT"
  },
  {
    "abbreviation": "14",
    "name": "Quiche",
    "iso_3166": "GT-14",
    "country": "GT"
  },
  {
    "abbreviation": "11",
    "name": "Retalhuleu",
    "iso_3166": "GT-11",
    "country": "GT"
  },
  {
    "abbreviation": "03",
    "name": "Sacatepequez",
    "iso_3166": "GT-03",
    "country": "GT"
  },
  {
    "abbreviation": "12",
    "name": "San Marcos",
    "iso_3166": "GT-12",
    "country": "GT"
  },
  {
    "abbreviation": "06",
    "name": "Santa Rosa",
    "iso_3166": "GT-06",
    "country": "GT"
  },
  {
    "abbreviation": "07",
    "name": "Solola",
    "iso_3166": "GT-07",
    "country": "GT"
  },
  {
    "abbreviation": "10",
    "name": "Suchitepequez",
    "iso_3166": "GT-10",
    "country": "GT"
  },
  {
    "abbreviation": "08",
    "name": "Totonicapan",
    "iso_3166": "GT-08",
    "country": "GT"
  },
  {
    "abbreviation": "19",
    "name": "Zacapa",
    "iso_3166": "GT-19",
    "country": "GT"
  },
  {
    "abbreviation": "-",
    "name": "Guernsey",
    "iso_3166": "-",
    "country": "GG"
  },
  {
    "abbreviation": "BF",
    "name": "Boffa",
    "iso_3166": "GN-BF",
    "country": "GN"
  },
  {
    "abbreviation": "BK",
    "name": "Boke",
    "iso_3166": "GN-BK",
    "country": "GN"
  },
  {
    "abbreviation": "C",
    "name": "Conakry",
    "iso_3166": "GN-C",
    "country": "GN"
  },
  {
    "abbreviation": "DB",
    "name": "Dabola",
    "iso_3166": "GN-DB",
    "country": "GN"
  },
  {
    "abbreviation": "DL",
    "name": "Dalaba",
    "iso_3166": "GN-DL",
    "country": "GN"
  },
  {
    "abbreviation": "DI",
    "name": "Dinguiraye",
    "iso_3166": "GN-DI",
    "country": "GN"
  },
  {
    "abbreviation": "FR",
    "name": "Fria",
    "iso_3166": "GN-FR",
    "country": "GN"
  },
  {
    "abbreviation": "KA",
    "name": "Kankan",
    "iso_3166": "GN-KA",
    "country": "GN"
  },
  {
    "abbreviation": "KO",
    "name": "Kouroussa",
    "iso_3166": "GN-KO",
    "country": "GN"
  },
  {
    "abbreviation": "LA",
    "name": "Labe",
    "iso_3166": "GN-LA",
    "country": "GN"
  },
  {
    "abbreviation": "SI",
    "name": "Siguiri",
    "iso_3166": "GN-SI",
    "country": "GN"
  },
  {
    "abbreviation": "BA",
    "name": "Bafata",
    "iso_3166": "GW-BA",
    "country": "GW"
  },
  {
    "abbreviation": "BS",
    "name": "Bissau",
    "iso_3166": "GW-BS",
    "country": "GW"
  },
  {
    "abbreviation": "CA",
    "name": "Cacheu",
    "iso_3166": "GW-CA",
    "country": "GW"
  },
  {
    "abbreviation": "GA",
    "name": "Gabu",
    "iso_3166": "GW-GA",
    "country": "GW"
  },
  {
    "abbreviation": "OI",
    "name": "Oio",
    "iso_3166": "GW-OI",
    "country": "GW"
  },
  {
    "abbreviation": "BA",
    "name": "Barima-Waini",
    "iso_3166": "GY-BA",
    "country": "GY"
  },
  {
    "abbreviation": "CU",
    "name": "Cuyuni-Mazaruni",
    "iso_3166": "GY-CU",
    "country": "GY"
  },
  {
    "abbreviation": "DE",
    "name": "Demerara-Mahaica",
    "iso_3166": "GY-DE",
    "country": "GY"
  },
  {
    "abbreviation": "EB",
    "name": "East Berbice-Corentyne",
    "iso_3166": "GY-EB",
    "country": "GY"
  },
  {
    "abbreviation": "ES",
    "name": "Essequibo Islands-West Demerara",
    "iso_3166": "GY-ES",
    "country": "GY"
  },
  {
    "abbreviation": "MA",
    "name": "Mahaica-Berbice",
    "iso_3166": "GY-MA",
    "country": "GY"
  },
  {
    "abbreviation": "PM",
    "name": "Pomeroon-Supenaam",
    "iso_3166": "GY-PM",
    "country": "GY"
  },
  {
    "abbreviation": "PT",
    "name": "Potaro-Siparuni",
    "iso_3166": "GY-PT",
    "country": "GY"
  },
  {
    "abbreviation": "UD",
    "name": "Upper Demerara-Berbice",
    "iso_3166": "GY-UD",
    "country": "GY"
  },
  {
    "abbreviation": "AR",
    "name": "Artibonite",
    "iso_3166": "HT-AR",
    "country": "HT"
  },
  {
    "abbreviation": "CE",
    "name": "Centre",
    "iso_3166": "HT-CE",
    "country": "HT"
  },
  {
    "abbreviation": "GA",
    "name": "Grande'Anse",
    "iso_3166": "HT-GA",
    "country": "HT"
  },
  {
    "abbreviation": "NI",
    "name": "Nippes",
    "iso_3166": "HT-NI",
    "country": "HT"
  },
  {
    "abbreviation": "ND",
    "name": "Nord",
    "iso_3166": "HT-ND",
    "country": "HT"
  },
  {
    "abbreviation": "NO",
    "name": "Nord-Ouest",
    "iso_3166": "HT-NO",
    "country": "HT"
  },
  {
    "abbreviation": "OU",
    "name": "Ouest",
    "iso_3166": "HT-OU",
    "country": "HT"
  },
  {
    "abbreviation": "SD",
    "name": "Sud",
    "iso_3166": "HT-SD",
    "country": "HT"
  },
  {
    "abbreviation": "SE",
    "name": "Sud-Est",
    "iso_3166": "HT-SE",
    "country": "HT"
  },
  {
    "abbreviation": "-",
    "name": "Heard Island and McDonald Islands",
    "iso_3166": "-",
    "country": "HM"
  },
  {
    "abbreviation": "-",
    "name": "Vatican City",
    "iso_3166": "-",
    "country": "VA"
  },
  {
    "abbreviation": "AT",
    "name": "Atlantida",
    "iso_3166": "HN-AT",
    "country": "HN"
  },
  {
    "abbreviation": "CH",
    "name": "Choluteca",
    "iso_3166": "HN-CH",
    "country": "HN"
  },
  {
    "abbreviation": "CL",
    "name": "Colon",
    "iso_3166": "HN-CL",
    "country": "HN"
  },
  {
    "abbreviation": "CM",
    "name": "Comayagua",
    "iso_3166": "HN-CM",
    "country": "HN"
  },
  {
    "abbreviation": "CP",
    "name": "Copan",
    "iso_3166": "HN-CP",
    "country": "HN"
  },
  {
    "abbreviation": "CR",
    "name": "Cortes",
    "iso_3166": "HN-CR",
    "country": "HN"
  },
  {
    "abbreviation": "EP",
    "name": "El Paraiso",
    "iso_3166": "HN-EP",
    "country": "HN"
  },
  {
    "abbreviation": "FM",
    "name": "Francisco Morazan",
    "iso_3166": "HN-FM",
    "country": "HN"
  },
  {
    "abbreviation": "GD",
    "name": "Gracias a Dios",
    "iso_3166": "HN-GD",
    "country": "HN"
  },
  {
    "abbreviation": "IN",
    "name": "Intibuca",
    "iso_3166": "HN-IN",
    "country": "HN"
  },
  {
    "abbreviation": "IB",
    "name": "Islas de la Bahia",
    "iso_3166": "HN-IB",
    "country": "HN"
  },
  {
    "abbreviation": "LP",
    "name": "La Paz",
    "iso_3166": "HN-LP",
    "country": "HN"
  },
  {
    "abbreviation": "LE",
    "name": "Lempira",
    "iso_3166": "HN-LE",
    "country": "HN"
  },
  {
    "abbreviation": "OC",
    "name": "Ocotepeque",
    "iso_3166": "HN-OC",
    "country": "HN"
  },
  {
    "abbreviation": "OL",
    "name": "Olancho",
    "iso_3166": "HN-OL",
    "country": "HN"
  },
  {
    "abbreviation": "SB",
    "name": "Santa Barbara",
    "iso_3166": "HN-SB",
    "country": "HN"
  },
  {
    "abbreviation": "VA",
    "name": "Valle",
    "iso_3166": "HN-VA",
    "country": "HN"
  },
  {
    "abbreviation": "YO",
    "name": "Yoro",
    "iso_3166": "HN-YO",
    "country": "HN"
  },
  {
    "abbreviation": "-",
    "name": "Hong Kong",
    "iso_3166": "-",
    "country": "HK"
  },
  {
    "abbreviation": "BK",
    "name": "Bacs-Kiskun",
    "iso_3166": "HU-BK",
    "country": "HU"
  },
  {
    "abbreviation": "BA",
    "name": "Baranya",
    "iso_3166": "HU-BA",
    "country": "HU"
  },
  {
    "abbreviation": "BE",
    "name": "Bekes",
    "iso_3166": "HU-BE",
    "country": "HU"
  },
  {
    "abbreviation": "BZ",
    "name": "Borsod-Abauj-Zemplen",
    "iso_3166": "HU-BZ",
    "country": "HU"
  },
  {
    "abbreviation": "BU",
    "name": "Budapest",
    "iso_3166": "HU-BU",
    "country": "HU"
  },
  {
    "abbreviation": "CS",
    "name": "Csongrad-Csanad",
    "iso_3166": "HU-CS",
    "country": "HU"
  },
  {
    "abbreviation": "FE",
    "name": "Fejer",
    "iso_3166": "HU-FE",
    "country": "HU"
  },
  {
    "abbreviation": "GS",
    "name": "Gyor-Moson-Sopron",
    "iso_3166": "HU-GS",
    "country": "HU"
  },
  {
    "abbreviation": "HB",
    "name": "Hajdu-Bihar",
    "iso_3166": "HU-HB",
    "country": "HU"
  },
  {
    "abbreviation": "HE",
    "name": "Heves",
    "iso_3166": "HU-HE",
    "country": "HU"
  },
  {
    "abbreviation": "JN",
    "name": "Jasz-Nagykun-Szolnok",
    "iso_3166": "HU-JN",
    "country": "HU"
  },
  {
    "abbreviation": "KE",
    "name": "Komarom-Esztergom",
    "iso_3166": "HU-KE",
    "country": "HU"
  },
  {
    "abbreviation": "NO",
    "name": "Nograd",
    "iso_3166": "HU-NO",
    "country": "HU"
  },
  {
    "abbreviation": "PE",
    "name": "Pest",
    "iso_3166": "HU-PE",
    "country": "HU"
  },
  {
    "abbreviation": "SO",
    "name": "Somogy",
    "iso_3166": "HU-SO",
    "country": "HU"
  },
  {
    "abbreviation": "SZ",
    "name": "Szabolcs-Szatmar-Bereg",
    "iso_3166": "HU-SZ",
    "country": "HU"
  },
  {
    "abbreviation": "TO",
    "name": "Tolna",
    "iso_3166": "HU-TO",
    "country": "HU"
  },
  {
    "abbreviation": "VA",
    "name": "Vas",
    "iso_3166": "HU-VA",
    "country": "HU"
  },
  {
    "abbreviation": "VE",
    "name": "Veszprem",
    "iso_3166": "HU-VE",
    "country": "HU"
  },
  {
    "abbreviation": "ZA",
    "name": "Zala",
    "iso_3166": "HU-ZA",
    "country": "HU"
  },
  {
    "abbreviation": "7",
    "name": "Austurland",
    "iso_3166": "IS-7",
    "country": "IS"
  },
  {
    "abbreviation": "1",
    "name": "Hofudborgarsvaedi",
    "iso_3166": "IS-1",
    "country": "IS"
  },
  {
    "abbreviation": "6",
    "name": "Nordurland eystra",
    "iso_3166": "IS-6",
    "country": "IS"
  },
  {
    "abbreviation": "5",
    "name": "Nordurland vestra",
    "iso_3166": "IS-5",
    "country": "IS"
  },
  {
    "abbreviation": "8",
    "name": "Sudurland",
    "iso_3166": "IS-8",
    "country": "IS"
  },
  {
    "abbreviation": "2",
    "name": "Sudurnes",
    "iso_3166": "IS-2",
    "country": "IS"
  },
  {
    "abbreviation": "4",
    "name": "Vestfirdir",
    "iso_3166": "IS-4",
    "country": "IS"
  },
  {
    "abbreviation": "3",
    "name": "Vesturland",
    "iso_3166": "IS-3",
    "country": "IS"
  },
  {
    "abbreviation": "AN",
    "name": "Andaman and Nicobar Islands",
    "iso_3166": "IN-AN",
    "country": "IN"
  },
  {
    "abbreviation": "AP",
    "name": "Andhra Pradesh",
    "iso_3166": "IN-AP",
    "country": "IN"
  },
  {
    "abbreviation": "AR",
    "name": "Arunachal Pradesh",
    "iso_3166": "IN-AR",
    "country": "IN"
  },
  {
    "abbreviation": "AS",
    "name": "Assam",
    "iso_3166": "IN-AS",
    "country": "IN"
  },
  {
    "abbreviation": "BR",
    "name": "Bihar",
    "iso_3166": "IN-BR",
    "country": "IN"
  },
  {
    "abbreviation": "CH",
    "name": "Chandigarh",
    "iso_3166": "IN-CH",
    "country": "IN"
  },
  {
    "abbreviation": "CT",
    "name": "Chhattisgarh",
    "iso_3166": "IN-CT",
    "country": "IN"
  },
  {
    "abbreviation": "DN",
    "name": "Dadra and Nagar Haveli",
    "iso_3166": "IN-DN",
    "country": "IN"
  },
  {
    "abbreviation": "DH",
    "name": "Dadra and Nagar Haveli and Daman and Diu",
    "iso_3166": "IN-DH",
    "country": "IN"
  },
  {
    "abbreviation": "DL",
    "name": "Delhi",
    "iso_3166": "IN-DL",
    "country": "IN"
  },
  {
    "abbreviation": "GA",
    "name": "Goa",
    "iso_3166": "IN-GA",
    "country": "IN"
  },
  {
    "abbreviation": "GJ",
    "name": "Gujarat",
    "iso_3166": "IN-GJ",
    "country": "IN"
  },
  {
    "abbreviation": "HR",
    "name": "Haryana",
    "iso_3166": "IN-HR",
    "country": "IN"
  },
  {
    "abbreviation": "HP",
    "name": "Himachal Pradesh",
    "iso_3166": "IN-HP",
    "country": "IN"
  },
  {
    "abbreviation": "JK",
    "name": "Jammu and Kashmir",
    "iso_3166": "IN-JK",
    "country": "IN"
  },
  {
    "abbreviation": "JH",
    "name": "Jharkhand",
    "iso_3166": "IN-JH",
    "country": "IN"
  },
  {
    "abbreviation": "KA",
    "name": "Karnataka",
    "iso_3166": "IN-KA",
    "country": "IN"
  },
  {
    "abbreviation": "KL",
    "name": "Kerala",
    "iso_3166": "IN-KL",
    "country": "IN"
  },
  {
    "abbreviation": "LD",
    "name": "Lakshadweep",
    "iso_3166": "IN-LD",
    "country": "IN"
  },
  {
    "abbreviation": "MP",
    "name": "Madhya Pradesh",
    "iso_3166": "IN-MP",
    "country": "IN"
  },
  {
    "abbreviation": "MH",
    "name": "Maharashtra",
    "iso_3166": "IN-MH",
    "country": "IN"
  },
  {
    "abbreviation": "MN",
    "name": "Manipur",
    "iso_3166": "IN-MN",
    "country": "IN"
  },
  {
    "abbreviation": "ML",
    "name": "Meghalaya",
    "iso_3166": "IN-ML",
    "country": "IN"
  },
  {
    "abbreviation": "MZ",
    "name": "Mizoram",
    "iso_3166": "IN-MZ",
    "country": "IN"
  },
  {
    "abbreviation": "NL",
    "name": "Nagaland",
    "iso_3166": "IN-NL",
    "country": "IN"
  },
  {
    "abbreviation": "OR",
    "name": "Odisha",
    "iso_3166": "IN-OR",
    "country": "IN"
  },
  {
    "abbreviation": "PY",
    "name": "Puducherry",
    "iso_3166": "IN-PY",
    "country": "IN"
  },
  {
    "abbreviation": "PB",
    "name": "Punjab",
    "iso_3166": "IN-PB",
    "country": "IN"
  },
  {
    "abbreviation": "RJ",
    "name": "Rajasthan",
    "iso_3166": "IN-RJ",
    "country": "IN"
  },
  {
    "abbreviation": "SK",
    "name": "Sikkim",
    "iso_3166": "IN-SK",
    "country": "IN"
  },
  {
    "abbreviation": "TN",
    "name": "Tamil Nadu",
    "iso_3166": "IN-TN",
    "country": "IN"
  },
  {
    "abbreviation": "TG",
    "name": "Telangana",
    "iso_3166": "IN-TG",
    "country": "IN"
  },
  {
    "abbreviation": "TR",
    "name": "Tripura",
    "iso_3166": "IN-TR",
    "country": "IN"
  },
  {
    "abbreviation": "UP",
    "name": "Uttar Pradesh",
    "iso_3166": "IN-UP",
    "country": "IN"
  },
  {
    "abbreviation": "UT",
    "name": "Uttarakhand",
    "iso_3166": "IN-UT",
    "country": "IN"
  },
  {
    "abbreviation": "WB",
    "name": "West Bengal",
    "iso_3166": "IN-WB",
    "country": "IN"
  },
  {
    "abbreviation": "AC",
    "name": "Aceh",
    "iso_3166": "ID-AC",
    "country": "ID"
  },
  {
    "abbreviation": "BA",
    "name": "Bali",
    "iso_3166": "ID-BA",
    "country": "ID"
  },
  {
    "abbreviation": "BT",
    "name": "Banten",
    "iso_3166": "ID-BT",
    "country": "ID"
  },
  {
    "abbreviation": "BE",
    "name": "Bengkulu",
    "iso_3166": "ID-BE",
    "country": "ID"
  },
  {
    "abbreviation": "GO",
    "name": "Gorontalo",
    "iso_3166": "ID-GO",
    "country": "ID"
  },
  {
    "abbreviation": "JK",
    "name": "Jakarta Raya",
    "iso_3166": "ID-JK",
    "country": "ID"
  },
  {
    "abbreviation": "JA",
    "name": "Jambi",
    "iso_3166": "ID-JA",
    "country": "ID"
  },
  {
    "abbreviation": "JB",
    "name": "Jawa Barat",
    "iso_3166": "ID-JB",
    "country": "ID"
  },
  {
    "abbreviation": "JT",
    "name": "Jawa Tengah",
    "iso_3166": "ID-JT",
    "country": "ID"
  },
  {
    "abbreviation": "JI",
    "name": "Jawa Timur",
    "iso_3166": "ID-JI",
    "country": "ID"
  },
  {
    "abbreviation": "KB",
    "name": "Kalimantan Barat",
    "iso_3166": "ID-KB",
    "country": "ID"
  },
  {
    "abbreviation": "KS",
    "name": "Kalimantan Selatan",
    "iso_3166": "ID-KS",
    "country": "ID"
  },
  {
    "abbreviation": "KT",
    "name": "Kalimantan Tengah",
    "iso_3166": "ID-KT",
    "country": "ID"
  },
  {
    "abbreviation": "KI",
    "name": "Kalimantan Timur",
    "iso_3166": "ID-KI",
    "country": "ID"
  },
  {
    "abbreviation": "KU",
    "name": "Kalimantan Utara",
    "iso_3166": "ID-KU",
    "country": "ID"
  },
  {
    "abbreviation": "BB",
    "name": "Kepulauan Bangka Belitung",
    "iso_3166": "ID-BB",
    "country": "ID"
  },
  {
    "abbreviation": "KR",
    "name": "Kepulauan Riau",
    "iso_3166": "ID-KR",
    "country": "ID"
  },
  {
    "abbreviation": "LA",
    "name": "Lampung",
    "iso_3166": "ID-LA",
    "country": "ID"
  },
  {
    "abbreviation": "ML",
    "name": "Maluku",
    "iso_3166": "ID-ML",
    "country": "ID"
  },
  {
    "abbreviation": "MU",
    "name": "Maluku Utara",
    "iso_3166": "ID-MU",
    "country": "ID"
  },
  {
    "abbreviation": "NB",
    "name": "Nusa Tenggara Barat",
    "iso_3166": "ID-NB",
    "country": "ID"
  },
  {
    "abbreviation": "NT",
    "name": "Nusa Tenggara Timur",
    "iso_3166": "ID-NT",
    "country": "ID"
  },
  {
    "abbreviation": "PP",
    "name": "Papua",
    "iso_3166": "ID-PP",
    "country": "ID"
  },
  {
    "abbreviation": "PB",
    "name": "Papua Barat",
    "iso_3166": "ID-PB",
    "country": "ID"
  },
  {
    "abbreviation": "PE",
    "name": "Papua Pengunungan",
    "iso_3166": "ID-PE",
    "country": "ID"
  },
  {
    "abbreviation": "PS",
    "name": "Papua Selatan",
    "iso_3166": "ID-PS",
    "country": "ID"
  },
  {
    "abbreviation": "PT",
    "name": "Papua Tengah",
    "iso_3166": "ID-PT",
    "country": "ID"
  },
  {
    "abbreviation": "RI",
    "name": "Riau",
    "iso_3166": "ID-RI",
    "country": "ID"
  },
  {
    "abbreviation": "SR",
    "name": "Sulawesi Barat",
    "iso_3166": "ID-SR",
    "country": "ID"
  },
  {
    "abbreviation": "SN",
    "name": "Sulawesi Selatan",
    "iso_3166": "ID-SN",
    "country": "ID"
  },
  {
    "abbreviation": "ST",
    "name": "Sulawesi Tengah",
    "iso_3166": "ID-ST",
    "country": "ID"
  },
  {
    "abbreviation": "SG",
    "name": "Sulawesi Tenggara",
    "iso_3166": "ID-SG",
    "country": "ID"
  },
  {
    "abbreviation": "SA",
    "name": "Sulawesi Utara",
    "iso_3166": "ID-SA",
    "country": "ID"
  },
  {
    "abbreviation": "SB",
    "name": "Sumatera Barat",
    "iso_3166": "ID-SB",
    "country": "ID"
  },
  {
    "abbreviation": "SS",
    "name": "Sumatera Selatan",
    "iso_3166": "ID-SS",
    "country": "ID"
  },
  {
    "abbreviation": "SU",
    "name": "Sumatera Utara",
    "iso_3166": "ID-SU",
    "country": "ID"
  },
  {
    "abbreviation": "YO",
    "name": "Yogyakarta",
    "iso_3166": "ID-YO",
    "country": "ID"
  },
  {
    "abbreviation": "AB",
    "name": "Abidjan",
    "iso_3166": "CI-AB",
    "country": "CI"
  },
  {
    "abbreviation": "BS",
    "name": "Bas-Sassandra",
    "iso_3166": "CI-BS",
    "country": "CI"
  },
  {
    "abbreviation": "CM",
    "name": "Comoe",
    "iso_3166": "CI-CM",
    "country": "CI"
  },
  {
    "abbreviation": "DN",
    "name": "Denguele",
    "iso_3166": "CI-DN",
    "country": "CI"
  },
  {
    "abbreviation": "GD",
    "name": "Goh-Djiboua",
    "iso_3166": "CI-GD",
    "country": "CI"
  },
  {
    "abbreviation": "LC",
    "name": "Lacs",
    "iso_3166": "CI-LC",
    "country": "CI"
  },
  {
    "abbreviation": "LG",
    "name": "Lagunes",
    "iso_3166": "CI-LG",
    "country": "CI"
  },
  {
    "abbreviation": "MG",
    "name": "Montagnes",
    "iso_3166": "CI-MG",
    "country": "CI"
  },
  {
    "abbreviation": "SM",
    "name": "Sassandra-Marahoue",
    "iso_3166": "CI-SM",
    "country": "CI"
  },
  {
    "abbreviation": "SV",
    "name": "Savanes",
    "iso_3166": "CI-SV",
    "country": "CI"
  },
  {
    "abbreviation": "VB",
    "name": "Vallee du Bandama",
    "iso_3166": "CI-VB",
    "country": "CI"
  },
  {
    "abbreviation": "WR",
    "name": "Woroba",
    "iso_3166": "CI-WR",
    "country": "CI"
  },
  {
    "abbreviation": "YM",
    "name": "Yamoussoukro",
    "iso_3166": "CI-YM",
    "country": "CI"
  },
  {
    "abbreviation": "ZZ",
    "name": "Zanzan",
    "iso_3166": "CI-ZZ",
    "country": "CI"
  },
  {
    "abbreviation": "30",
    "name": "Alborz",
    "iso_3166": "IR-30",
    "country": "IR"
  },
  {
    "abbreviation": "24",
    "name": "Ardabil",
    "iso_3166": "IR-24",
    "country": "IR"
  },
  {
    "abbreviation": "04",
    "name": "Azarbayjan-e Gharbi",
    "iso_3166": "IR-04",
    "country": "IR"
  },
  {
    "abbreviation": "03",
    "name": "Azarbayjan-e Sharqi",
    "iso_3166": "IR-03",
    "country": "IR"
  },
  {
    "abbreviation": "18",
    "name": "Bushehr",
    "iso_3166": "IR-18",
    "country": "IR"
  },
  {
    "abbreviation": "14",
    "name": "Chahar Mahal va Bakhtiari",
    "iso_3166": "IR-14",
    "country": "IR"
  },
  {
    "abbreviation": "10",
    "name": "Esfahan",
    "iso_3166": "IR-10",
    "country": "IR"
  },
  {
    "abbreviation": "07",
    "name": "Fars",
    "iso_3166": "IR-07",
    "country": "IR"
  },
  {
    "abbreviation": "01",
    "name": "Gilan",
    "iso_3166": "IR-01",
    "country": "IR"
  },
  {
    "abbreviation": "27",
    "name": "Golestan",
    "iso_3166": "IR-27",
    "country": "IR"
  },
  {
    "abbreviation": "13",
    "name": "Hamadan",
    "iso_3166": "IR-13",
    "country": "IR"
  },
  {
    "abbreviation": "22",
    "name": "Hormozgan",
    "iso_3166": "IR-22",
    "country": "IR"
  },
  {
    "abbreviation": "16",
    "name": "Ilam",
    "iso_3166": "IR-16",
    "country": "IR"
  },
  {
    "abbreviation": "08",
    "name": "Kerman",
    "iso_3166": "IR-08",
    "country": "IR"
  },
  {
    "abbreviation": "05",
    "name": "Kermanshah",
    "iso_3166": "IR-05",
    "country": "IR"
  },
  {
    "abbreviation": "29",
    "name": "Khorasan-e Jonubi",
    "iso_3166": "IR-29",
    "country": "IR"
  },
  {
    "abbreviation": "09",
    "name": "Khorasan-e Razavi",
    "iso_3166": "IR-09",
    "country": "IR"
  },
  {
    "abbreviation": "28",
    "name": "Khorasan-e Shomali",
    "iso_3166": "IR-28",
    "country": "IR"
  },
  {
    "abbreviation": "06",
    "name": "Khuzestan",
    "iso_3166": "IR-06",
    "country": "IR"
  },
  {
    "abbreviation": "17",
    "name": "Kohgiluyeh va Bowyer Ahmad",
    "iso_3166": "IR-17",
    "country": "IR"
  },
  {
    "abbreviation": "12",
    "name": "Kordestan",
    "iso_3166": "IR-12",
    "country": "IR"
  },
  {
    "abbreviation": "15",
    "name": "Lorestan",
    "iso_3166": "IR-15",
    "country": "IR"
  },
  {
    "abbreviation": "00",
    "name": "Markazi",
    "iso_3166": "IR-00",
    "country": "IR"
  },
  {
    "abbreviation": "02",
    "name": "Mazandaran",
    "iso_3166": "IR-02",
    "country": "IR"
  },
  {
    "abbreviation": "26",
    "name": "Qazvin",
    "iso_3166": "IR-26",
    "country": "IR"
  },
  {
    "abbreviation": "25",
    "name": "Qom",
    "iso_3166": "IR-25",
    "country": "IR"
  },
  {
    "abbreviation": "20",
    "name": "Semnan",
    "iso_3166": "IR-20",
    "country": "IR"
  },
  {
    "abbreviation": "11",
    "name": "Sistan va Baluchestan",
    "iso_3166": "IR-11",
    "country": "IR"
  },
  {
    "abbreviation": "23",
    "name": "Tehran",
    "iso_3166": "IR-23",
    "country": "IR"
  },
  {
    "abbreviation": "21",
    "name": "Yazd",
    "iso_3166": "IR-21",
    "country": "IR"
  },
  {
    "abbreviation": "19",
    "name": "Zanjan",
    "iso_3166": "IR-19",
    "country": "IR"
  },
  {
    "abbreviation": "AN",
    "name": "Al Anbar",
    "iso_3166": "IQ-AN",
    "country": "IQ"
  },
  {
    "abbreviation": "BA",
    "name": "Al Basrah",
    "iso_3166": "IQ-BA",
    "country": "IQ"
  },
  {
    "abbreviation": "MU",
    "name": "Al Muthanna",
    "iso_3166": "IQ-MU",
    "country": "IQ"
  },
  {
    "abbreviation": "QA",
    "name": "Al Qadisiyah",
    "iso_3166": "IQ-QA",
    "country": "IQ"
  },
  {
    "abbreviation": "NA",
    "name": "An Najaf",
    "iso_3166": "IQ-NA",
    "country": "IQ"
  },
  {
    "abbreviation": "AR",
    "name": "Arbil",
    "iso_3166": "IQ-AR",
    "country": "IQ"
  },
  {
    "abbreviation": "SU",
    "name": "As Sulaymaniyah",
    "iso_3166": "IQ-SU",
    "country": "IQ"
  },
  {
    "abbreviation": "BB",
    "name": "Babil",
    "iso_3166": "IQ-BB",
    "country": "IQ"
  },
  {
    "abbreviation": "BG",
    "name": "Baghdad",
    "iso_3166": "IQ-BG",
    "country": "IQ"
  },
  {
    "abbreviation": "DA",
    "name": "Dahuk",
    "iso_3166": "IQ-DA",
    "country": "IQ"
  },
  {
    "abbreviation": "DQ",
    "name": "Dhi Qar",
    "iso_3166": "IQ-DQ",
    "country": "IQ"
  },
  {
    "abbreviation": "DI",
    "name": "Diyala",
    "iso_3166": "IQ-DI",
    "country": "IQ"
  },
  {
    "abbreviation": "KA",
    "name": "Karbala'",
    "iso_3166": "IQ-KA",
    "country": "IQ"
  },
  {
    "abbreviation": "KI",
    "name": "Kirkuk",
    "iso_3166": "IQ-KI",
    "country": "IQ"
  },
  {
    "abbreviation": "MA",
    "name": "Maysan",
    "iso_3166": "IQ-MA",
    "country": "IQ"
  },
  {
    "abbreviation": "NI",
    "name": "Ninawa",
    "iso_3166": "IQ-NI",
    "country": "IQ"
  },
  {
    "abbreviation": "SD",
    "name": "Salah ad Din",
    "iso_3166": "IQ-SD",
    "country": "IQ"
  },
  {
    "abbreviation": "WA",
    "name": "Wasit",
    "iso_3166": "IQ-WA",
    "country": "IQ"
  },
  {
    "abbreviation": "CW",
    "name": "Carlow",
    "iso_3166": "IE-CW",
    "country": "IE"
  },
  {
    "abbreviation": "CN",
    "name": "Cavan",
    "iso_3166": "IE-CN",
    "country": "IE"
  },
  {
    "abbreviation": "CE",
    "name": "Clare",
    "iso_3166": "IE-CE",
    "country": "IE"
  },
  {
    "abbreviation": "CO",
    "name": "Cork",
    "iso_3166": "IE-CO",
    "country": "IE"
  },
  {
    "abbreviation": "DL",
    "name": "Donegal",
    "iso_3166": "IE-DL",
    "country": "IE"
  },
  {
    "abbreviation": "D",
    "name": "Dublin",
    "iso_3166": "IE-D",
    "country": "IE"
  },
  {
    "abbreviation": "G",
    "name": "Galway",
    "iso_3166": "IE-G",
    "country": "IE"
  },
  {
    "abbreviation": "KY",
    "name": "Kerry",
    "iso_3166": "IE-KY",
    "country": "IE"
  },
  {
    "abbreviation": "KE",
    "name": "Kildare",
    "iso_3166": "IE-KE",
    "country": "IE"
  },
  {
    "abbreviation": "KK",
    "name": "Kilkenny",
    "iso_3166": "IE-KK",
    "country": "IE"
  },
  {
    "abbreviation": "LS",
    "name": "Laois",
    "iso_3166": "IE-LS",
    "country": "IE"
  },
  {
    "abbreviation": "LM",
    "name": "Leitrim",
    "iso_3166": "IE-LM",
    "country": "IE"
  },
  {
    "abbreviation": "LK",
    "name": "Limerick",
    "iso_3166": "IE-LK",
    "country": "IE"
  },
  {
    "abbreviation": "LD",
    "name": "Longford",
    "iso_3166": "IE-LD",
    "country": "IE"
  },
  {
    "abbreviation": "LH",
    "name": "Louth",
    "iso_3166": "IE-LH",
    "country": "IE"
  },
  {
    "abbreviation": "MO",
    "name": "Mayo",
    "iso_3166": "IE-MO",
    "country": "IE"
  },
  {
    "abbreviation": "MH",
    "name": "Meath",
    "iso_3166": "IE-MH",
    "country": "IE"
  },
  {
    "abbreviation": "MN",
    "name": "Monaghan",
    "iso_3166": "IE-MN",
    "country": "IE"
  },
  {
    "abbreviation": "OY",
    "name": "Offaly",
    "iso_3166": "IE-OY",
    "country": "IE"
  },
  {
    "abbreviation": "RN",
    "name": "Roscommon",
    "iso_3166": "IE-RN",
    "country": "IE"
  },
  {
    "abbreviation": "SO",
    "name": "Sligo",
    "iso_3166": "IE-SO",
    "country": "IE"
  },
  {
    "abbreviation": "TA",
    "name": "Tipperary",
    "iso_3166": "IE-TA",
    "country": "IE"
  },
  {
    "abbreviation": "WD",
    "name": "Waterford",
    "iso_3166": "IE-WD",
    "country": "IE"
  },
  {
    "abbreviation": "WH",
    "name": "Westmeath",
    "iso_3166": "IE-WH",
    "country": "IE"
  },
  {
    "abbreviation": "WX",
    "name": "Wexford",
    "iso_3166": "IE-WX",
    "country": "IE"
  },
  {
    "abbreviation": "WW",
    "name": "Wicklow",
    "iso_3166": "IE-WW",
    "country": "IE"
  },
  {
    "abbreviation": "-",
    "name": "Isle of Man",
    "iso_3166": "-",
    "country": "IM"
  },
  {
    "abbreviation": "D",
    "name": "HaDarom",
    "iso_3166": "IL-D",
    "country": "IL"
  },
  {
    "abbreviation": "M",
    "name": "HaMerkaz",
    "iso_3166": "IL-M",
    "country": "IL"
  },
  {
    "abbreviation": "Z",
    "name": "HaTsafon",
    "iso_3166": "IL-Z",
    "country": "IL"
  },
  {
    "abbreviation": "HA",
    "name": "Hefa",
    "iso_3166": "IL-HA",
    "country": "IL"
  },
  {
    "abbreviation": "TA",
    "name": "Tel Aviv",
    "iso_3166": "IL-TA",
    "country": "IL"
  },
  {
    "abbreviation": "JM",
    "name": "Yerushalayim",
    "iso_3166": "IL-JM",
    "country": "IL"
  },
  {
    "abbreviation": "65",
    "name": "Abruzzo",
    "iso_3166": "IT-65",
    "country": "IT"
  },
  {
    "abbreviation": "77",
    "name": "Basilicata",
    "iso_3166": "IT-77",
    "country": "IT"
  },
  {
    "abbreviation": "78",
    "name": "Calabria",
    "iso_3166": "IT-78",
    "country": "IT"
  },
  {
    "abbreviation": "72",
    "name": "Campania",
    "iso_3166": "IT-72",
    "country": "IT"
  },
  {
    "abbreviation": "45",
    "name": "Emilia-Romagna",
    "iso_3166": "IT-45",
    "country": "IT"
  },
  {
    "abbreviation": "36",
    "name": "Friuli-Venezia Giulia",
    "iso_3166": "IT-36",
    "country": "IT"
  },
  {
    "abbreviation": "62",
    "name": "Lazio",
    "iso_3166": "IT-62",
    "country": "IT"
  },
  {
    "abbreviation": "42",
    "name": "Liguria",
    "iso_3166": "IT-42",
    "country": "IT"
  },
  {
    "abbreviation": "25",
    "name": "Lombardia",
    "iso_3166": "IT-25",
    "country": "IT"
  },
  {
    "abbreviation": "57",
    "name": "Marche",
    "iso_3166": "IT-57",
    "country": "IT"
  },
  {
    "abbreviation": "67",
    "name": "Molise",
    "iso_3166": "IT-67",
    "country": "IT"
  },
  {
    "abbreviation": "21",
    "name": "Piemonte",
    "iso_3166": "IT-21",
    "country": "IT"
  },
  {
    "abbreviation": "75",
    "name": "Puglia",
    "iso_3166": "IT-75",
    "country": "IT"
  },
  {
    "abbreviation": "88",
    "name": "Sardegna",
    "iso_3166": "IT-88",
    "country": "IT"
  },
  {
    "abbreviation": "82",
    "name": "Sicilia",
    "iso_3166": "IT-82",
    "country": "IT"
  },
  {
    "abbreviation": "52",
    "name": "Toscana",
    "iso_3166": "IT-52",
    "country": "IT"
  },
  {
    "abbreviation": "32",
    "name": "Trentino-Alto Adige",
    "iso_3166": "IT-32",
    "country": "IT"
  },
  {
    "abbreviation": "55",
    "name": "Umbria",
    "iso_3166": "IT-55",
    "country": "IT"
  },
  {
    "abbreviation": "23",
    "name": "Valle d'Aosta",
    "iso_3166": "IT-23",
    "country": "IT"
  },
  {
    "abbreviation": "34",
    "name": "Veneto",
    "iso_3166": "IT-34",
    "country": "IT"
  },
  {
    "abbreviation": "13",
    "name": "Clarendon",
    "iso_3166": "JM-13",
    "country": "JM"
  },
  {
    "abbreviation": "09",
    "name": "Hanover",
    "iso_3166": "JM-09",
    "country": "JM"
  },
  {
    "abbreviation": "01",
    "name": "Kingston",
    "iso_3166": "JM-01",
    "country": "JM"
  },
  {
    "abbreviation": "12",
    "name": "Manchester",
    "iso_3166": "JM-12",
    "country": "JM"
  },
  {
    "abbreviation": "04",
    "name": "Portland",
    "iso_3166": "JM-04",
    "country": "JM"
  },
  {
    "abbreviation": "02",
    "name": "Saint Andrew",
    "iso_3166": "JM-02",
    "country": "JM"
  },
  {
    "abbreviation": "06",
    "name": "Saint Ann",
    "iso_3166": "JM-06",
    "country": "JM"
  },
  {
    "abbreviation": "14",
    "name": "Saint Catherine",
    "iso_3166": "JM-14",
    "country": "JM"
  },
  {
    "abbreviation": "11",
    "name": "Saint Elizabeth",
    "iso_3166": "JM-11",
    "country": "JM"
  },
  {
    "abbreviation": "08",
    "name": "Saint James",
    "iso_3166": "JM-08",
    "country": "JM"
  },
  {
    "abbreviation": "05",
    "name": "Saint Mary",
    "iso_3166": "JM-05",
    "country": "JM"
  },
  {
    "abbreviation": "03",
    "name": "Saint Thomas",
    "iso_3166": "JM-03",
    "country": "JM"
  },
  {
    "abbreviation": "07",
    "name": "Trelawny",
    "iso_3166": "JM-07",
    "country": "JM"
  },
  {
    "abbreviation": "10",
    "name": "Westmoreland",
    "iso_3166": "JM-10",
    "country": "JM"
  },
  {
    "abbreviation": "23",
    "name": "Aichi",
    "iso_3166": "JP-23",
    "country": "JP"
  },
  {
    "abbreviation": "05",
    "name": "Akita",
    "iso_3166": "JP-05",
    "country": "JP"
  },
  {
    "abbreviation": "02",
    "name": "Aomori",
    "iso_3166": "JP-02",
    "country": "JP"
  },
  {
    "abbreviation": "12",
    "name": "Chiba",
    "iso_3166": "JP-12",
    "country": "JP"
  },
  {
    "abbreviation": "38",
    "name": "Ehime",
    "iso_3166": "JP-38",
    "country": "JP"
  },
  {
    "abbreviation": "18",
    "name": "Fukui",
    "iso_3166": "JP-18",
    "country": "JP"
  },
  {
    "abbreviation": "40",
    "name": "Fukuoka",
    "iso_3166": "JP-40",
    "country": "JP"
  },
  {
    "abbreviation": "07",
    "name": "Fukushima",
    "iso_3166": "JP-07",
    "country": "JP"
  },
  {
    "abbreviation": "21",
    "name": "Gifu",
    "iso_3166": "JP-21",
    "country": "JP"
  },
  {
    "abbreviation": "10",
    "name": "Gunma",
    "iso_3166": "JP-10",
    "country": "JP"
  },
  {
    "abbreviation": "34",
    "name": "Hiroshima",
    "iso_3166": "JP-34",
    "country": "JP"
  },
  {
    "abbreviation": "01",
    "name": "Hokkaido",
    "iso_3166": "JP-01",
    "country": "JP"
  },
  {
    "abbreviation": "28",
    "name": "Hyogo",
    "iso_3166": "JP-28",
    "country": "JP"
  },
  {
    "abbreviation": "08",
    "name": "Ibaraki",
    "iso_3166": "JP-08",
    "country": "JP"
  },
  {
    "abbreviation": "17",
    "name": "Ishikawa",
    "iso_3166": "JP-17",
    "country": "JP"
  },
  {
    "abbreviation": "03",
    "name": "Iwate",
    "iso_3166": "JP-03",
    "country": "JP"
  },
  {
    "abbreviation": "37",
    "name": "Kagawa",
    "iso_3166": "JP-37",
    "country": "JP"
  },
  {
    "abbreviation": "46",
    "name": "Kagoshima",
    "iso_3166": "JP-46",
    "country": "JP"
  },
  {
    "abbreviation": "14",
    "name": "Kanagawa",
    "iso_3166": "JP-14",
    "country": "JP"
  },
  {
    "abbreviation": "39",
    "name": "Kochi",
    "iso_3166": "JP-39",
    "country": "JP"
  },
  {
    "abbreviation": "43",
    "name": "Kumamoto",
    "iso_3166": "JP-43",
    "country": "JP"
  },
  {
    "abbreviation": "26",
    "name": "Kyoto",
    "iso_3166": "JP-26",
    "country": "JP"
  },
  {
    "abbreviation": "24",
    "name": "Mie",
    "iso_3166": "JP-24",
    "country": "JP"
  },
  {
    "abbreviation": "04",
    "name": "Miyagi",
    "iso_3166": "JP-04",
    "country": "JP"
  },
  {
    "abbreviation": "45",
    "name": "Miyazaki",
    "iso_3166": "JP-45",
    "country": "JP"
  },
  {
    "abbreviation": "20",
    "name": "Nagano",
    "iso_3166": "JP-20",
    "country": "JP"
  },
  {
    "abbreviation": "42",
    "name": "Nagasaki",
    "iso_3166": "JP-42",
    "country": "JP"
  },
  {
    "abbreviation": "29",
    "name": "Nara",
    "iso_3166": "JP-29",
    "country": "JP"
  },
  {
    "abbreviation": "15",
    "name": "Niigata",
    "iso_3166": "JP-15",
    "country": "JP"
  },
  {
    "abbreviation": "44",
    "name": "Oita",
    "iso_3166": "JP-44",
    "country": "JP"
  },
  {
    "abbreviation": "33",
    "name": "Okayama",
    "iso_3166": "JP-33",
    "country": "JP"
  },
  {
    "abbreviation": "47",
    "name": "Okinawa",
    "iso_3166": "JP-47",
    "country": "JP"
  },
  {
    "abbreviation": "27",
    "name": "Osaka",
    "iso_3166": "JP-27",
    "country": "JP"
  },
  {
    "abbreviation": "41",
    "name": "Saga",
    "iso_3166": "JP-41",
    "country": "JP"
  },
  {
    "abbreviation": "11",
    "name": "Saitama",
    "iso_3166": "JP-11",
    "country": "JP"
  },
  {
    "abbreviation": "25",
    "name": "Shiga",
    "iso_3166": "JP-25",
    "country": "JP"
  },
  {
    "abbreviation": "32",
    "name": "Shimane",
    "iso_3166": "JP-32",
    "country": "JP"
  },
  {
    "abbreviation": "22",
    "name": "Shizuoka",
    "iso_3166": "JP-22",
    "country": "JP"
  },
  {
    "abbreviation": "09",
    "name": "Tochigi",
    "iso_3166": "JP-09",
    "country": "JP"
  },
  {
    "abbreviation": "36",
    "name": "Tokushima",
    "iso_3166": "JP-36",
    "country": "JP"
  },
  {
    "abbreviation": "13",
    "name": "Tokyo",
    "iso_3166": "JP-13",
    "country": "JP"
  },
  {
    "abbreviation": "31",
    "name": "Tottori",
    "iso_3166": "JP-31",
    "country": "JP"
  },
  {
    "abbreviation": "16",
    "name": "Toyama",
    "iso_3166": "JP-16",
    "country": "JP"
  },
  {
    "abbreviation": "30",
    "name": "Wakayama",
    "iso_3166": "JP-30",
    "country": "JP"
  },
  {
    "abbreviation": "06",
    "name": "Yamagata",
    "iso_3166": "JP-06",
    "country": "JP"
  },
  {
    "abbreviation": "35",
    "name": "Yamaguchi",
    "iso_3166": "JP-35",
    "country": "JP"
  },
  {
    "abbreviation": "19",
    "name": "Yamanashi",
    "iso_3166": "JP-19",
    "country": "JP"
  },
  {
    "abbreviation": "-",
    "name": "Jersey",
    "iso_3166": "-",
    "country": "JE"
  },
  {
    "abbreviation": "AJ",
    "name": "'Ajlun",
    "iso_3166": "JO-AJ",
    "country": "JO"
  },
  {
    "abbreviation": "AQ",
    "name": "Al 'Aqabah",
    "iso_3166": "JO-AQ",
    "country": "JO"
  },
  {
    "abbreviation": "AM",
    "name": "Al 'Asimah",
    "iso_3166": "JO-AM",
    "country": "JO"
  },
  {
    "abbreviation": "BA",
    "name": "Al Balqa'",
    "iso_3166": "JO-BA",
    "country": "JO"
  },
  {
    "abbreviation": "KA",
    "name": "Al Karak",
    "iso_3166": "JO-KA",
    "country": "JO"
  },
  {
    "abbreviation": "MA",
    "name": "Al Mafraq",
    "iso_3166": "JO-MA",
    "country": "JO"
  },
  {
    "abbreviation": "AT",
    "name": "At Tafilah",
    "iso_3166": "JO-AT",
    "country": "JO"
  },
  {
    "abbreviation": "AZ",
    "name": "Az Zarqa'",
    "iso_3166": "JO-AZ",
    "country": "JO"
  },
  {
    "abbreviation": "IR",
    "name": "Irbid",
    "iso_3166": "JO-IR",
    "country": "JO"
  },
  {
    "abbreviation": "JA",
    "name": "Jarash",
    "iso_3166": "JO-JA",
    "country": "JO"
  },
  {
    "abbreviation": "MN",
    "name": "Ma'an",
    "iso_3166": "JO-MN",
    "country": "JO"
  },
  {
    "abbreviation": "MD",
    "name": "Madaba",
    "iso_3166": "JO-MD",
    "country": "JO"
  },
  {
    "abbreviation": "10",
    "name": "Abay oblysy",
    "iso_3166": "KZ-10",
    "country": "KZ"
  },
  {
    "abbreviation": "75",
    "name": "Almaty",
    "iso_3166": "KZ-75",
    "country": "KZ"
  },
  {
    "abbreviation": "19",
    "name": "Almaty oblysy",
    "iso_3166": "KZ-19",
    "country": "KZ"
  },
  {
    "abbreviation": "11",
    "name": "Aqmola oblysy",
    "iso_3166": "KZ-11",
    "country": "KZ"
  },
  {
    "abbreviation": "15",
    "name": "Aqtobe oblysy",
    "iso_3166": "KZ-15",
    "country": "KZ"
  },
  {
    "abbreviation": "71",
    "name": "Astana",
    "iso_3166": "KZ-71",
    "country": "KZ"
  },
  {
    "abbreviation": "23",
    "name": "Atyrau oblysy",
    "iso_3166": "KZ-23",
    "country": "KZ"
  },
  {
    "abbreviation": "27",
    "name": "Batys Qazaqstan oblysy",
    "iso_3166": "KZ-27",
    "country": "KZ"
  },
  {
    "abbreviation": "47",
    "name": "Mangghystau oblysy",
    "iso_3166": "KZ-47",
    "country": "KZ"
  },
  {
    "abbreviation": "55",
    "name": "Pavlodar oblysy",
    "iso_3166": "KZ-55",
    "country": "KZ"
  },
  {
    "abbreviation": "35",
    "name": "Qaraghandy oblysy",
    "iso_3166": "KZ-35",
    "country": "KZ"
  },
  {
    "abbreviation": "39",
    "name": "Qostanay oblysy",
    "iso_3166": "KZ-39",
    "country": "KZ"
  },
  {
    "abbreviation": "43",
    "name": "Qyzylorda oblysy",
    "iso_3166": "KZ-43",
    "country": "KZ"
  },
  {
    "abbreviation": "63",
    "name": "Shyghys Qazaqstan oblysy",
    "iso_3166": "KZ-63",
    "country": "KZ"
  },
  {
    "abbreviation": "79",
    "name": "Shymkent",
    "iso_3166": "KZ-79",
    "country": "KZ"
  },
  {
    "abbreviation": "59",
    "name": "Soltustik Qazaqstan oblysy",
    "iso_3166": "KZ-59",
    "country": "KZ"
  },
  {
    "abbreviation": "61",
    "name": "Turkistan oblysy",
    "iso_3166": "KZ-61",
    "country": "KZ"
  },
  {
    "abbreviation": "62",
    "name": "Ulytau oblysy",
    "iso_3166": "KZ-62",
    "country": "KZ"
  },
  {
    "abbreviation": "31",
    "name": "Zhambyl oblysy",
    "iso_3166": "KZ-31",
    "country": "KZ"
  },
  {
    "abbreviation": "33",
    "name": "Zhetisu oblysy",
    "iso_3166": "KZ-33",
    "country": "KZ"
  },
  {
    "abbreviation": "01",
    "name": "Baringo",
    "iso_3166": "KE-01",
    "country": "KE"
  },
  {
    "abbreviation": "02",
    "name": "Bomet",
    "iso_3166": "KE-02",
    "country": "KE"
  },
  {
    "abbreviation": "03",
    "name": "Bungoma",
    "iso_3166": "KE-03",
    "country": "KE"
  },
  {
    "abbreviation": "04",
    "name": "Busia",
    "iso_3166": "KE-04",
    "country": "KE"
  },
  {
    "abbreviation": "05",
    "name": "Elgeyo/Marakwet",
    "iso_3166": "KE-05",
    "country": "KE"
  },
  {
    "abbreviation": "06",
    "name": "Embu",
    "iso_3166": "KE-06",
    "country": "KE"
  },
  {
    "abbreviation": "07",
    "name": "Garissa",
    "iso_3166": "KE-07",
    "country": "KE"
  },
  {
    "abbreviation": "08",
    "name": "Homa Bay",
    "iso_3166": "KE-08",
    "country": "KE"
  },
  {
    "abbreviation": "09",
    "name": "Isiolo",
    "iso_3166": "KE-09",
    "country": "KE"
  },
  {
    "abbreviation": "10",
    "name": "Kajiado",
    "iso_3166": "KE-10",
    "country": "KE"
  },
  {
    "abbreviation": "11",
    "name": "Kakamega",
    "iso_3166": "KE-11",
    "country": "KE"
  },
  {
    "abbreviation": "12",
    "name": "Kericho",
    "iso_3166": "KE-12",
    "country": "KE"
  },
  {
    "abbreviation": "13",
    "name": "Kiambu",
    "iso_3166": "KE-13",
    "country": "KE"
  },
  {
    "abbreviation": "14",
    "name": "Kilifi",
    "iso_3166": "KE-14",
    "country": "KE"
  },
  {
    "abbreviation": "15",
    "name": "Kirinyaga",
    "iso_3166": "KE-15",
    "country": "KE"
  },
  {
    "abbreviation": "16",
    "name": "Kisii",
    "iso_3166": "KE-16",
    "country": "KE"
  },
  {
    "abbreviation": "17",
    "name": "Kisumu",
    "iso_3166": "KE-17",
    "country": "KE"
  },
  {
    "abbreviation": "18",
    "name": "Kitui",
    "iso_3166": "KE-18",
    "country": "KE"
  },
  {
    "abbreviation": "19",
    "name": "Kwale",
    "iso_3166": "KE-19",
    "country": "KE"
  },
  {
    "abbreviation": "20",
    "name": "Laikipia",
    "iso_3166": "KE-20",
    "country": "KE"
  },
  {
    "abbreviation": "21",
    "name": "Lamu",
    "iso_3166": "KE-21",
    "country": "KE"
  },
  {
    "abbreviation": "22",
    "name": "Machakos",
    "iso_3166": "KE-22",
    "country": "KE"
  },
  {
    "abbreviation": "23",
    "name": "Makueni",
    "iso_3166": "KE-23",
    "country": "KE"
  },
  {
    "abbreviation": "24",
    "name": "Mandera",
    "iso_3166": "KE-24",
    "country": "KE"
  },
  {
    "abbreviation": "25",
    "name": "Marsabit",
    "iso_3166": "KE-25",
    "country": "KE"
  },
  {
    "abbreviation": "26",
    "name": "Meru",
    "iso_3166": "KE-26",
    "country": "KE"
  },
  {
    "abbreviation": "27",
    "name": "Migori",
    "iso_3166": "KE-27",
    "country": "KE"
  },
  {
    "abbreviation": "28",
    "name": "Mombasa",
    "iso_3166": "KE-28",
    "country": "KE"
  },
  {
    "abbreviation": "29",
    "name": "Murang'a",
    "iso_3166": "KE-29",
    "country": "KE"
  },
  {
    "abbreviation": "30",
    "name": "Nairobi City",
    "iso_3166": "KE-30",
    "country": "KE"
  },
  {
    "abbreviation": "31",
    "name": "Nakuru",
    "iso_3166": "KE-31",
    "country": "KE"
  },
  {
    "abbreviation": "32",
    "name": "Nandi",
    "iso_3166": "KE-32",
    "country": "KE"
  },
  {
    "abbreviation": "33",
    "name": "Narok",
    "iso_3166": "KE-33",
    "country": "KE"
  },
  {
    "abbreviation": "34",
    "name": "Nyamira",
    "iso_3166": "KE-34",
    "country": "KE"
  },
  {
    "abbreviation": "35",
    "name": "Nyandarua",
    "iso_3166": "KE-35",
    "country": "KE"
  },
  {
    "abbreviation": "36",
    "name": "Nyeri",
    "iso_3166": "KE-36",
    "country": "KE"
  },
  {
    "abbreviation": "37",
    "name": "Samburu",
    "iso_3166": "KE-37",
    "country": "KE"
  },
  {
    "abbreviation": "38",
    "name": "Siaya",
    "iso_3166": "KE-38",
    "country": "KE"
  },
  {
    "abbreviation": "39",
    "name": "Taita/Taveta",
    "iso_3166": "KE-39",
    "country": "KE"
  },
  {
    "abbreviation": "40",
    "name": "Tana River",
    "iso_3166": "KE-40",
    "country": "KE"
  },
  {
    "abbreviation": "41",
    "name": "Tharaka-Nithi",
    "iso_3166": "KE-41",
    "country": "KE"
  },
  {
    "abbreviation": "42",
    "name": "Trans Nzoia",
    "iso_3166": "KE-42",
    "country": "KE"
  },
  {
    "abbreviation": "43",
    "name": "Turkana",
    "iso_3166": "KE-43",
    "country": "KE"
  },
  {
    "abbreviation": "44",
    "name": "Uasin Gishu",
    "iso_3166": "KE-44",
    "country": "KE"
  },
  {
    "abbreviation": "45",
    "name": "Vihiga",
    "iso_3166": "KE-45",
    "country": "KE"
  },
  {
    "abbreviation": "46",
    "name": "Wajir",
    "iso_3166": "KE-46",
    "country": "KE"
  },
  {
    "abbreviation": "47",
    "name": "West Pokot",
    "iso_3166": "KE-47",
    "country": "KE"
  },
  {
    "abbreviation": "G",
    "name": "Gilbert Islands",
    "iso_3166": "KI-G",
    "country": "KI"
  },
  {
    "abbreviation": "L",
    "name": "Line Islands",
    "iso_3166": "KI-L",
    "country": "KI"
  },
  {
    "abbreviation": "KU",
    "name": "Al 'Asimah",
    "iso_3166": "KW-KU",
    "country": "KW"
  },
  {
    "abbreviation": "AH",
    "name": "Al Ahmadi",
    "iso_3166": "KW-AH",
    "country": "KW"
  },
  {
    "abbreviation": "FA",
    "name": "Al Farwaniyah",
    "iso_3166": "KW-FA",
    "country": "KW"
  },
  {
    "abbreviation": "JA",
    "name": "Al Jahra'",
    "iso_3166": "KW-JA",
    "country": "KW"
  },
  {
    "abbreviation": "HA",
    "name": "Hawalli",
    "iso_3166": "KW-HA",
    "country": "KW"
  },
  {
    "abbreviation": "MU",
    "name": "Mubarak al Kabir",
    "iso_3166": "KW-MU",
    "country": "KW"
  },
  {
    "abbreviation": "B",
    "name": "Batken",
    "iso_3166": "KG-B",
    "country": "KG"
  },
  {
    "abbreviation": "GB",
    "name": "Bishkek Shaary",
    "iso_3166": "KG-GB",
    "country": "KG"
  },
  {
    "abbreviation": "C",
    "name": "Chuy",
    "iso_3166": "KG-C",
    "country": "KG"
  },
  {
    "abbreviation": "J",
    "name": "Jalal-Abad",
    "iso_3166": "KG-J",
    "country": "KG"
  },
  {
    "abbreviation": "N",
    "name": "Naryn",
    "iso_3166": "KG-N",
    "country": "KG"
  },
  {
    "abbreviation": "GO",
    "name": "Osh Shaary",
    "iso_3166": "KG-GO",
    "country": "KG"
  },
  {
    "abbreviation": "T",
    "name": "Talas",
    "iso_3166": "KG-T",
    "country": "KG"
  },
  {
    "abbreviation": "Y",
    "name": "Ysyk-Kol",
    "iso_3166": "KG-Y",
    "country": "KG"
  },
  {
    "abbreviation": "AT",
    "name": "Attapu",
    "iso_3166": "LA-AT",
    "country": "LA"
  },
  {
    "abbreviation": "BK",
    "name": "Bokeo",
    "iso_3166": "LA-BK",
    "country": "LA"
  },
  {
    "abbreviation": "BL",
    "name": "Bolikhamxai",
    "iso_3166": "LA-BL",
    "country": "LA"
  },
  {
    "abbreviation": "CH",
    "name": "Champasak",
    "iso_3166": "LA-CH",
    "country": "LA"
  },
  {
    "abbreviation": "KH",
    "name": "Khammouan",
    "iso_3166": "LA-KH",
    "country": "LA"
  },
  {
    "abbreviation": "LP",
    "name": "Louangphabang",
    "iso_3166": "LA-LP",
    "country": "LA"
  },
  {
    "abbreviation": "OU",
    "name": "Oudomxai",
    "iso_3166": "LA-OU",
    "country": "LA"
  },
  {
    "abbreviation": "PH",
    "name": "Phongsali",
    "iso_3166": "LA-PH",
    "country": "LA"
  },
  {
    "abbreviation": "SV",
    "name": "Savannakhet",
    "iso_3166": "LA-SV",
    "country": "LA"
  },
  {
    "abbreviation": "VI",
    "name": "Viangchan",
    "iso_3166": "LA-VI",
    "country": "LA"
  },
  {
    "abbreviation": "XA",
    "name": "Xaignabouli",
    "iso_3166": "LA-XA",
    "country": "LA"
  },
  {
    "abbreviation": "XE",
    "name": "Xekong",
    "iso_3166": "LA-XE",
    "country": "LA"
  },
  {
    "abbreviation": "XI",
    "name": "Xiangkhouang",
    "iso_3166": "LA-XI",
    "country": "LA"
  },
  {
    "abbreviation": "011",
    "name": "Adazu novads",
    "iso_3166": "LV-011",
    "country": "LV"
  },
  {
    "abbreviation": "002",
    "name": "Aizkraukles novads",
    "iso_3166": "LV-002",
    "country": "LV"
  },
  {
    "abbreviation": "007",
    "name": "Aluksnes novads",
    "iso_3166": "LV-007",
    "country": "LV"
  },
  {
    "abbreviation": "111",
    "name": "Augsdaugavas novads",
    "iso_3166": "LV-111",
    "country": "LV"
  },
  {
    "abbreviation": "015",
    "name": "Balvu novads",
    "iso_3166": "LV-015",
    "country": "LV"
  },
  {
    "abbreviation": "016",
    "name": "Bauskas novads",
    "iso_3166": "LV-016",
    "country": "LV"
  },
  {
    "abbreviation": "022",
    "name": "Cesu novads",
    "iso_3166": "LV-022",
    "country": "LV"
  },
  {
    "abbreviation": "DGV",
    "name": "Daugavpils",
    "iso_3166": "LV-DGV",
    "country": "LV"
  },
  {
    "abbreviation": "112",
    "name": "Dienvidkurzemes novads",
    "iso_3166": "LV-112",
    "country": "LV"
  },
  {
    "abbreviation": "026",
    "name": "Dobeles novads",
    "iso_3166": "LV-026",
    "country": "LV"
  },
  {
    "abbreviation": "033",
    "name": "Gulbenes novads",
    "iso_3166": "LV-033",
    "country": "LV"
  },
  {
    "abbreviation": "042",
    "name": "Jekabpils novads",
    "iso_3166": "LV-042",
    "country": "LV"
  },
  {
    "abbreviation": "JEL",
    "name": "Jelgava",
    "iso_3166": "LV-JEL",
    "country": "LV"
  },
  {
    "abbreviation": "041",
    "name": "Jelgavas novads",
    "iso_3166": "LV-041",
    "country": "LV"
  },
  {
    "abbreviation": "JUR",
    "name": "Jurmala",
    "iso_3166": "LV-JUR",
    "country": "LV"
  },
  {
    "abbreviation": "052",
    "name": "Kekavas novads",
    "iso_3166": "LV-052",
    "country": "LV"
  },
  {
    "abbreviation": "047",
    "name": "Kraslavas novads",
    "iso_3166": "LV-047",
    "country": "LV"
  },
  {
    "abbreviation": "050",
    "name": "Kuldigas novads",
    "iso_3166": "LV-050",
    "country": "LV"
  },
  {
    "abbreviation": "LPX",
    "name": "Liepaja",
    "iso_3166": "LV-LPX",
    "country": "LV"
  },
  {
    "abbreviation": "054",
    "name": "Limbazu novads",
    "iso_3166": "LV-054",
    "country": "LV"
  },
  {
    "abbreviation": "056",
    "name": "Livanu novads",
    "iso_3166": "LV-056",
    "country": "LV"
  },
  {
    "abbreviation": "058",
    "name": "Ludzas novads",
    "iso_3166": "LV-058",
    "country": "LV"
  },
  {
    "abbreviation": "059",
    "name": "Madonas novads",
    "iso_3166": "LV-059",
    "country": "LV"
  },
  {
    "abbreviation": "062",
    "name": "Marupes novads",
    "iso_3166": "LV-062",
    "country": "LV"
  },
  {
    "abbreviation": "067",
    "name": "Ogres novads",
    "iso_3166": "LV-067",
    "country": "LV"
  },
  {
    "abbreviation": "068",
    "name": "Olaines novads",
    "iso_3166": "LV-068",
    "country": "LV"
  },
  {
    "abbreviation": "073",
    "name": "Preilu novads",
    "iso_3166": "LV-073",
    "country": "LV"
  },
  {
    "abbreviation": "077",
    "name": "Rezeknes novads",
    "iso_3166": "LV-077",
    "country": "LV"
  },
  {
    "abbreviation": "RIX",
    "name": "Riga",
    "iso_3166": "LV-RIX",
    "country": "LV"
  },
  {
    "abbreviation": "080",
    "name": "Ropazu novads",
    "iso_3166": "LV-080",
    "country": "LV"
  },
  {
    "abbreviation": "087",
    "name": "Salaspils novads",
    "iso_3166": "LV-087",
    "country": "LV"
  },
  {
    "abbreviation": "088",
    "name": "Saldus novads",
    "iso_3166": "LV-088",
    "country": "LV"
  },
  {
    "abbreviation": "089",
    "name": "Saulkrastu novads",
    "iso_3166": "LV-089",
    "country": "LV"
  },
  {
    "abbreviation": "091",
    "name": "Siguldas novads",
    "iso_3166": "LV-091",
    "country": "LV"
  },
  {
    "abbreviation": "094",
    "name": "Smiltenes novads",
    "iso_3166": "LV-094",
    "country": "LV"
  },
  {
    "abbreviation": "097",
    "name": "Talsu novads",
    "iso_3166": "LV-097",
    "country": "LV"
  },
  {
    "abbreviation": "099",
    "name": "Tukuma novads",
    "iso_3166": "LV-099",
    "country": "LV"
  },
  {
    "abbreviation": "101",
    "name": "Valkas novads",
    "iso_3166": "LV-101",
    "country": "LV"
  },
  {
    "abbreviation": "113",
    "name": "Valmieras novads",
    "iso_3166": "LV-113",
    "country": "LV"
  },
  {
    "abbreviation": "102",
    "name": "Varaklanu novads",
    "iso_3166": "LV-102",
    "country": "LV"
  },
  {
    "abbreviation": "106",
    "name": "Ventspils novads",
    "iso_3166": "LV-106",
    "country": "LV"
  },
  {
    "abbreviation": "AK",
    "name": "Aakkar",
    "iso_3166": "LB-AK",
    "country": "LB"
  },
  {
    "abbreviation": "BH",
    "name": "Baalbek-Hermel",
    "iso_3166": "LB-BH",
    "country": "LB"
  },
  {
    "abbreviation": "BI",
    "name": "Beqaa",
    "iso_3166": "LB-BI",
    "country": "LB"
  },
  {
    "abbreviation": "BA",
    "name": "Beyrouth",
    "iso_3166": "LB-BA",
    "country": "LB"
  },
  {
    "abbreviation": "AS",
    "name": "Liban-Nord",
    "iso_3166": "LB-AS",
    "country": "LB"
  },
  {
    "abbreviation": "JA",
    "name": "Liban-Sud",
    "iso_3166": "LB-JA",
    "country": "LB"
  },
  {
    "abbreviation": "JL",
    "name": "Mont-Liban",
    "iso_3166": "LB-JL",
    "country": "LB"
  },
  {
    "abbreviation": "NA",
    "name": "Nabatiye",
    "iso_3166": "LB-NA",
    "country": "LB"
  },
  {
    "abbreviation": "D",
    "name": "Berea",
    "iso_3166": "LS-D",
    "country": "LS"
  },
  {
    "abbreviation": "B",
    "name": "Botha-Bothe",
    "iso_3166": "LS-B",
    "country": "LS"
  },
  {
    "abbreviation": "C",
    "name": "Leribe",
    "iso_3166": "LS-C",
    "country": "LS"
  },
  {
    "abbreviation": "E",
    "name": "Mafeteng",
    "iso_3166": "LS-E",
    "country": "LS"
  },
  {
    "abbreviation": "A",
    "name": "Maseru",
    "iso_3166": "LS-A",
    "country": "LS"
  },
  {
    "abbreviation": "F",
    "name": "Mohale's Hoek",
    "iso_3166": "LS-F",
    "country": "LS"
  },
  {
    "abbreviation": "J",
    "name": "Mokhotlong",
    "iso_3166": "LS-J",
    "country": "LS"
  },
  {
    "abbreviation": "H",
    "name": "Qacha's Nek",
    "iso_3166": "LS-H",
    "country": "LS"
  },
  {
    "abbreviation": "G",
    "name": "Quthing",
    "iso_3166": "LS-G",
    "country": "LS"
  },
  {
    "abbreviation": "K",
    "name": "Thaba-Tseka",
    "iso_3166": "LS-K",
    "country": "LS"
  },
  {
    "abbreviation": "BM",
    "name": "Bomi",
    "iso_3166": "LR-BM",
    "country": "LR"
  },
  {
    "abbreviation": "BG",
    "name": "Bong",
    "iso_3166": "LR-BG",
    "country": "LR"
  },
  {
    "abbreviation": "CM",
    "name": "Grand Cape Mount",
    "iso_3166": "LR-CM",
    "country": "LR"
  },
  {
    "abbreviation": "GG",
    "name": "Grand Gedeh",
    "iso_3166": "LR-GG",
    "country": "LR"
  },
  {
    "abbreviation": "MG",
    "name": "Margibi",
    "iso_3166": "LR-MG",
    "country": "LR"
  },
  {
    "abbreviation": "MO",
    "name": "Montserrado",
    "iso_3166": "LR-MO",
    "country": "LR"
  },
  {
    "abbreviation": "RI",
    "name": "River Cess",
    "iso_3166": "LR-RI",
    "country": "LR"
  },
  {
    "abbreviation": "SI",
    "name": "Sinoe",
    "iso_3166": "LR-SI",
    "country": "LR"
  },
  {
    "abbreviation": "BU",
    "name": "Al Butnan",
    "iso_3166": "LY-BU",
    "country": "LY"
  },
  {
    "abbreviation": "JA",
    "name": "Al Jabal al Akhdar",
    "iso_3166": "LY-JA",
    "country": "LY"
  },
  {
    "abbreviation": "JG",
    "name": "Al Jabal al Gharbi",
    "iso_3166": "LY-JG",
    "country": "LY"
  },
  {
    "abbreviation": "JI",
    "name": "Al Jafarah",
    "iso_3166": "LY-JI",
    "country": "LY"
  },
  {
    "abbreviation": "JU",
    "name": "Al Jufrah",
    "iso_3166": "LY-JU",
    "country": "LY"
  },
  {
    "abbreviation": "KF",
    "name": "Al Kufrah",
    "iso_3166": "LY-KF",
    "country": "LY"
  },
  {
    "abbreviation": "MJ",
    "name": "Al Marj",
    "iso_3166": "LY-MJ",
    "country": "LY"
  },
  {
    "abbreviation": "MB",
    "name": "Al Marqab",
    "iso_3166": "LY-MB",
    "country": "LY"
  },
  {
    "abbreviation": "WA",
    "name": "Al Wahat",
    "iso_3166": "LY-WA",
    "country": "LY"
  },
  {
    "abbreviation": "NQ",
    "name": "An Nuqat al Khams",
    "iso_3166": "LY-NQ",
    "country": "LY"
  },
  {
    "abbreviation": "ZA",
    "name": "Az Zawiyah",
    "iso_3166": "LY-ZA",
    "country": "LY"
  },
  {
    "abbreviation": "BA",
    "name": "Banghazi",
    "iso_3166": "LY-BA",
    "country": "LY"
  },
  {
    "abbreviation": "DR",
    "name": "Darnah",
    "iso_3166": "LY-DR",
    "country": "LY"
  },
  {
    "abbreviation": "MI",
    "name": "Misratah",
    "iso_3166": "LY-MI",
    "country": "LY"
  },
  {
    "abbreviation": "MQ",
    "name": "Murzuq",
    "iso_3166": "LY-MQ",
    "country": "LY"
  },
  {
    "abbreviation": "NL",
    "name": "Nalut",
    "iso_3166": "LY-NL",
    "country": "LY"
  },
  {
    "abbreviation": "SB",
    "name": "Sabha",
    "iso_3166": "LY-SB",
    "country": "LY"
  },
  {
    "abbreviation": "SR",
    "name": "Surt",
    "iso_3166": "LY-SR",
    "country": "LY"
  },
  {
    "abbreviation": "TB",
    "name": "Tarabulus",
    "iso_3166": "LY-TB",
    "country": "LY"
  },
  {
    "abbreviation": "WS",
    "name": "Wadi ash Shati'",
    "iso_3166": "LY-WS",
    "country": "LY"
  },
  {
    "abbreviation": "01",
    "name": "Balzers",
    "iso_3166": "LI-01",
    "country": "LI"
  },
  {
    "abbreviation": "02",
    "name": "Eschen",
    "iso_3166": "LI-02",
    "country": "LI"
  },
  {
    "abbreviation": "03",
    "name": "Gamprin",
    "iso_3166": "LI-03",
    "country": "LI"
  },
  {
    "abbreviation": "04",
    "name": "Mauren",
    "iso_3166": "LI-04",
    "country": "LI"
  },
  {
    "abbreviation": "06",
    "name": "Ruggell",
    "iso_3166": "LI-06",
    "country": "LI"
  },
  {
    "abbreviation": "07",
    "name": "Schaan",
    "iso_3166": "LI-07",
    "country": "LI"
  },
  {
    "abbreviation": "09",
    "name": "Triesen",
    "iso_3166": "LI-09",
    "country": "LI"
  },
  {
    "abbreviation": "10",
    "name": "Triesenberg",
    "iso_3166": "LI-10",
    "country": "LI"
  },
  {
    "abbreviation": "11",
    "name": "Vaduz",
    "iso_3166": "LI-11",
    "country": "LI"
  },
  {
    "abbreviation": "AL",
    "name": "Alytaus apskritis",
    "iso_3166": "LT-AL",
    "country": "LT"
  },
  {
    "abbreviation": "KU",
    "name": "Kauno apskritis",
    "iso_3166": "LT-KU",
    "country": "LT"
  },
  {
    "abbreviation": "KL",
    "name": "Klaipedos apskritis",
    "iso_3166": "LT-KL",
    "country": "LT"
  },
  {
    "abbreviation": "MR",
    "name": "Marijampoles apskritis",
    "iso_3166": "LT-MR",
    "country": "LT"
  },
  {
    "abbreviation": "PN",
    "name": "Panevezio apskritis",
    "iso_3166": "LT-PN",
    "country": "LT"
  },
  {
    "abbreviation": "SA",
    "name": "Siauliu apskritis",
    "iso_3166": "LT-SA",
    "country": "LT"
  },
  {
    "abbreviation": "TA",
    "name": "Taurages apskritis",
    "iso_3166": "LT-TA",
    "country": "LT"
  },
  {
    "abbreviation": "TE",
    "name": "Telsiu apskritis",
    "iso_3166": "LT-TE",
    "country": "LT"
  },
  {
    "abbreviation": "UT",
    "name": "Utenos apskritis",
    "iso_3166": "LT-UT",
    "country": "LT"
  },
  {
    "abbreviation": "VL",
    "name": "Vilniaus apskritis",
    "iso_3166": "LT-VL",
    "country": "LT"
  },
  {
    "abbreviation": "CA",
    "name": "Capellen",
    "iso_3166": "LU-CA",
    "country": "LU"
  },
  {
    "abbreviation": "CL",
    "name": "Clervaux",
    "iso_3166": "LU-CL",
    "country": "LU"
  },
  {
    "abbreviation": "DI",
    "name": "Diekirch",
    "iso_3166": "LU-DI",
    "country": "LU"
  },
  {
    "abbreviation": "EC",
    "name": "Echternach",
    "iso_3166": "LU-EC",
    "country": "LU"
  },
  {
    "abbreviation": "ES",
    "name": "Esch-sur-Alzette",
    "iso_3166": "LU-ES",
    "country": "LU"
  },
  {
    "abbreviation": "GR",
    "name": "Grevenmacher",
    "iso_3166": "LU-GR",
    "country": "LU"
  },
  {
    "abbreviation": "LU",
    "name": "Luxembourg",
    "iso_3166": "LU-LU",
    "country": "LU"
  },
  {
    "abbreviation": "ME",
    "name": "Mersch",
    "iso_3166": "LU-ME",
    "country": "LU"
  },
  {
    "abbreviation": "RD",
    "name": "Redange",
    "iso_3166": "LU-RD",
    "country": "LU"
  },
  {
    "abbreviation": "RM",
    "name": "Remich",
    "iso_3166": "LU-RM",
    "country": "LU"
  },
  {
    "abbreviation": "VD",
    "name": "Vianden",
    "iso_3166": "LU-VD",
    "country": "LU"
  },
  {
    "abbreviation": "WI",
    "name": "Wiltz",
    "iso_3166": "LU-WI",
    "country": "LU"
  },
  {
    "abbreviation": "-",
    "name": "Macao",
    "iso_3166": "-",
    "country": "MO"
  },
  {
    "abbreviation": "201",
    "name": "Berovo",
    "iso_3166": "MK-201",
    "country": "MK"
  },
  {
    "abbreviation": "501",
    "name": "Bitola",
    "iso_3166": "MK-501",
    "country": "MK"
  },
  {
    "abbreviation": "401",
    "name": "Bogdanci",
    "iso_3166": "MK-401",
    "country": "MK"
  },
  {
    "abbreviation": "601",
    "name": "Bogovinje",
    "iso_3166": "MK-601",
    "country": "MK"
  },
  {
    "abbreviation": "402",
    "name": "Bosilovo",
    "iso_3166": "MK-402",
    "country": "MK"
  },
  {
    "abbreviation": "602",
    "name": "Brvenica",
    "iso_3166": "MK-602",
    "country": "MK"
  },
  {
    "abbreviation": "803",
    "name": "Butel",
    "iso_3166": "MK-803",
    "country": "MK"
  },
  {
    "abbreviation": "109",
    "name": "Caska",
    "iso_3166": "MK-109",
    "country": "MK"
  },
  {
    "abbreviation": "814",
    "name": "Centar",
    "iso_3166": "MK-814",
    "country": "MK"
  },
  {
    "abbreviation": "210",
    "name": "Cesinovo-Oblesevo",
    "iso_3166": "MK-210",
    "country": "MK"
  },
  {
    "abbreviation": "816",
    "name": "Cucer Sandevo",
    "iso_3166": "MK-816",
    "country": "MK"
  },
  {
    "abbreviation": "303",
    "name": "Debar",
    "iso_3166": "MK-303",
    "country": "MK"
  },
  {
    "abbreviation": "502",
    "name": "Demir Hisar",
    "iso_3166": "MK-502",
    "country": "MK"
  },
  {
    "abbreviation": "103",
    "name": "Demir Kapija",
    "iso_3166": "MK-103",
    "country": "MK"
  },
  {
    "abbreviation": "406",
    "name": "Dojran",
    "iso_3166": "MK-406",
    "country": "MK"
  },
  {
    "abbreviation": "503",
    "name": "Dolneni",
    "iso_3166": "MK-503",
    "country": "MK"
  },
  {
    "abbreviation": "804",
    "name": "Gazi Baba",
    "iso_3166": "MK-804",
    "country": "MK"
  },
  {
    "abbreviation": "405",
    "name": "Gevgelija",
    "iso_3166": "MK-405",
    "country": "MK"
  },
  {
    "abbreviation": "604",
    "name": "Gostivar",
    "iso_3166": "MK-604",
    "country": "MK"
  },
  {
    "abbreviation": "102",
    "name": "Gradsko",
    "iso_3166": "MK-102",
    "country": "MK"
  },
  {
    "abbreviation": "807",
    "name": "Ilinden",
    "iso_3166": "MK-807",
    "country": "MK"
  },
  {
    "abbreviation": "606",
    "name": "Jegunovce",
    "iso_3166": "MK-606",
    "country": "MK"
  },
  {
    "abbreviation": "205",
    "name": "Karbinci",
    "iso_3166": "MK-205",
    "country": "MK"
  },
  {
    "abbreviation": "104",
    "name": "Kavadarci",
    "iso_3166": "MK-104",
    "country": "MK"
  },
  {
    "abbreviation": "307",
    "name": "Kicevo",
    "iso_3166": "MK-307",
    "country": "MK"
  },
  {
    "abbreviation": "809",
    "name": "Kisela Voda",
    "iso_3166": "MK-809",
    "country": "MK"
  },
  {
    "abbreviation": "206",
    "name": "Kocani",
    "iso_3166": "MK-206",
    "country": "MK"
  },
  {
    "abbreviation": "701",
    "name": "Kratovo",
    "iso_3166": "MK-701",
    "country": "MK"
  },
  {
    "abbreviation": "702",
    "name": "Kriva Palanka",
    "iso_3166": "MK-702",
    "country": "MK"
  },
  {
    "abbreviation": "504",
    "name": "Krivogastani",
    "iso_3166": "MK-504",
    "country": "MK"
  },
  {
    "abbreviation": "505",
    "name": "Krusevo",
    "iso_3166": "MK-505",
    "country": "MK"
  },
  {
    "abbreviation": "703",
    "name": "Kumanovo",
    "iso_3166": "MK-703",
    "country": "MK"
  },
  {
    "abbreviation": "704",
    "name": "Lipkovo",
    "iso_3166": "MK-704",
    "country": "MK"
  },
  {
    "abbreviation": "105",
    "name": "Lozovo",
    "iso_3166": "MK-105",
    "country": "MK"
  },
  {
    "abbreviation": "207",
    "name": "Makedonska Kamenica",
    "iso_3166": "MK-207",
    "country": "MK"
  },
  {
    "abbreviation": "308",
    "name": "Makedonski Brod",
    "iso_3166": "MK-308",
    "country": "MK"
  },
  {
    "abbreviation": "607",
    "name": "Mavrovo i Rostusa",
    "iso_3166": "MK-607",
    "country": "MK"
  },
  {
    "abbreviation": "506",
    "name": "Mogila",
    "iso_3166": "MK-506",
    "country": "MK"
  },
  {
    "abbreviation": "106",
    "name": "Negotino",
    "iso_3166": "MK-106",
    "country": "MK"
  },
  {
    "abbreviation": "507",
    "name": "Novaci",
    "iso_3166": "MK-507",
    "country": "MK"
  },
  {
    "abbreviation": "408",
    "name": "Novo Selo",
    "iso_3166": "MK-408",
    "country": "MK"
  },
  {
    "abbreviation": "310",
    "name": "Ohrid",
    "iso_3166": "MK-310",
    "country": "MK"
  },
  {
    "abbreviation": "208",
    "name": "Pehcevo",
    "iso_3166": "MK-208",
    "country": "MK"
  },
  {
    "abbreviation": "810",
    "name": "Petrovec",
    "iso_3166": "MK-810",
    "country": "MK"
  },
  {
    "abbreviation": "311",
    "name": "Plasnica",
    "iso_3166": "MK-311",
    "country": "MK"
  },
  {
    "abbreviation": "508",
    "name": "Prilep",
    "iso_3166": "MK-508",
    "country": "MK"
  },
  {
    "abbreviation": "209",
    "name": "Probistip",
    "iso_3166": "MK-209",
    "country": "MK"
  },
  {
    "abbreviation": "409",
    "name": "Radovis",
    "iso_3166": "MK-409",
    "country": "MK"
  },
  {
    "abbreviation": "705",
    "name": "Rankovce",
    "iso_3166": "MK-705",
    "country": "MK"
  },
  {
    "abbreviation": "509",
    "name": "Resen",
    "iso_3166": "MK-509",
    "country": "MK"
  },
  {
    "abbreviation": "107",
    "name": "Rosoman",
    "iso_3166": "MK-107",
    "country": "MK"
  },
  {
    "abbreviation": "811",
    "name": "Saraj",
    "iso_3166": "MK-811",
    "country": "MK"
  },
  {
    "abbreviation": "812",
    "name": "Sopiste",
    "iso_3166": "MK-812",
    "country": "MK"
  },
  {
    "abbreviation": "211",
    "name": "Stip",
    "iso_3166": "MK-211",
    "country": "MK"
  },
  {
    "abbreviation": "312",
    "name": "Struga",
    "iso_3166": "MK-312",
    "country": "MK"
  },
  {
    "abbreviation": "410",
    "name": "Strumica",
    "iso_3166": "MK-410",
    "country": "MK"
  },
  {
    "abbreviation": "813",
    "name": "Studenicani",
    "iso_3166": "MK-813",
    "country": "MK"
  },
  {
    "abbreviation": "108",
    "name": "Sveti Nikole",
    "iso_3166": "MK-108",
    "country": "MK"
  },
  {
    "abbreviation": "608",
    "name": "Tearce",
    "iso_3166": "MK-608",
    "country": "MK"
  },
  {
    "abbreviation": "609",
    "name": "Tetovo",
    "iso_3166": "MK-609",
    "country": "MK"
  },
  {
    "abbreviation": "403",
    "name": "Valandovo",
    "iso_3166": "MK-403",
    "country": "MK"
  },
  {
    "abbreviation": "404",
    "name": "Vasilevo",
    "iso_3166": "MK-404",
    "country": "MK"
  },
  {
    "abbreviation": "101",
    "name": "Veles",
    "iso_3166": "MK-101",
    "country": "MK"
  },
  {
    "abbreviation": "301",
    "name": "Vevcani",
    "iso_3166": "MK-301",
    "country": "MK"
  },
  {
    "abbreviation": "202",
    "name": "Vinica",
    "iso_3166": "MK-202",
    "country": "MK"
  },
  {
    "abbreviation": "806",
    "name": "Zelenikovo",
    "iso_3166": "MK-806",
    "country": "MK"
  },
  {
    "abbreviation": "605",
    "name": "Zelino",
    "iso_3166": "MK-605",
    "country": "MK"
  },
  {
    "abbreviation": "T",
    "name": "Antananarivo",
    "iso_3166": "MG-T",
    "country": "MG"
  },
  {
    "abbreviation": "D",
    "name": "Antsiranana",
    "iso_3166": "MG-D",
    "country": "MG"
  },
  {
    "abbreviation": "F",
    "name": "Fianarantsoa",
    "iso_3166": "MG-F",
    "country": "MG"
  },
  {
    "abbreviation": "M",
    "name": "Mahajanga",
    "iso_3166": "MG-M",
    "country": "MG"
  },
  {
    "abbreviation": "A",
    "name": "Toamasina",
    "iso_3166": "MG-A",
    "country": "MG"
  },
  {
    "abbreviation": "U",
    "name": "Toliara",
    "iso_3166": "MG-U",
    "country": "MG"
  },
  {
    "abbreviation": "BA",
    "name": "Balaka",
    "iso_3166": "MW-BA",
    "country": "MW"
  },
  {
    "abbreviation": "BL",
    "name": "Blantyre",
    "iso_3166": "MW-BL",
    "country": "MW"
  },
  {
    "abbreviation": "CK",
    "name": "Chikwawa",
    "iso_3166": "MW-CK",
    "country": "MW"
  },
  {
    "abbreviation": "CR",
    "name": "Chiradzulu",
    "iso_3166": "MW-CR",
    "country": "MW"
  },
  {
    "abbreviation": "DE",
    "name": "Dedza",
    "iso_3166": "MW-DE",
    "country": "MW"
  },
  {
    "abbreviation": "DO",
    "name": "Dowa",
    "iso_3166": "MW-DO",
    "country": "MW"
  },
  {
    "abbreviation": "KR",
    "name": "Karonga",
    "iso_3166": "MW-KR",
    "country": "MW"
  },
  {
    "abbreviation": "LI",
    "name": "Lilongwe",
    "iso_3166": "MW-LI",
    "country": "MW"
  },
  {
    "abbreviation": "MH",
    "name": "Machinga",
    "iso_3166": "MW-MH",
    "country": "MW"
  },
  {
    "abbreviation": "MG",
    "name": "Mangochi",
    "iso_3166": "MW-MG",
    "country": "MW"
  },
  {
    "abbreviation": "MW",
    "name": "Mwanza",
    "iso_3166": "MW-MW",
    "country": "MW"
  },
  {
    "abbreviation": "MZ",
    "name": "Mzimba",
    "iso_3166": "MW-MZ",
    "country": "MW"
  },
  {
    "abbreviation": "NE",
    "name": "Neno",
    "iso_3166": "MW-NE",
    "country": "MW"
  },
  {
    "abbreviation": "NK",
    "name": "Nkhotakota",
    "iso_3166": "MW-NK",
    "country": "MW"
  },
  {
    "abbreviation": "NI",
    "name": "Ntchisi",
    "iso_3166": "MW-NI",
    "country": "MW"
  },
  {
    "abbreviation": "SA",
    "name": "Salima",
    "iso_3166": "MW-SA",
    "country": "MW"
  },
  {
    "abbreviation": "TH",
    "name": "Thyolo",
    "iso_3166": "MW-TH",
    "country": "MW"
  },
  {
    "abbreviation": "ZO",
    "name": "Zomba",
    "iso_3166": "MW-ZO",
    "country": "MW"
  },
  {
    "abbreviation": "01",
    "name": "Johor",
    "iso_3166": "MY-01",
    "country": "MY"
  },
  {
    "abbreviation": "02",
    "name": "Kedah",
    "iso_3166": "MY-02",
    "country": "MY"
  },
  {
    "abbreviation": "03",
    "name": "Kelantan",
    "iso_3166": "MY-03",
    "country": "MY"
  },
  {
    "abbreviation": "04",
    "name": "Melaka",
    "iso_3166": "MY-04",
    "country": "MY"
  },
  {
    "abbreviation": "05",
    "name": "Negeri Sembilan",
    "iso_3166": "MY-05",
    "country": "MY"
  },
  {
    "abbreviation": "06",
    "name": "Pahang",
    "iso_3166": "MY-06",
    "country": "MY"
  },
  {
    "abbreviation": "08",
    "name": "Perak",
    "iso_3166": "MY-08",
    "country": "MY"
  },
  {
    "abbreviation": "09",
    "name": "Perlis",
    "iso_3166": "MY-09",
    "country": "MY"
  },
  {
    "abbreviation": "07",
    "name": "Pulau Pinang",
    "iso_3166": "MY-07",
    "country": "MY"
  },
  {
    "abbreviation": "12",
    "name": "Sabah",
    "iso_3166": "MY-12",
    "country": "MY"
  },
  {
    "abbreviation": "13",
    "name": "Sarawak",
    "iso_3166": "MY-13",
    "country": "MY"
  },
  {
    "abbreviation": "10",
    "name": "Selangor",
    "iso_3166": "MY-10",
    "country": "MY"
  },
  {
    "abbreviation": "11",
    "name": "Terengganu",
    "iso_3166": "MY-11",
    "country": "MY"
  },
  {
    "abbreviation": "14",
    "name": "Wilayah Persekutuan Kuala Lumpur",
    "iso_3166": "MY-14",
    "country": "MY"
  },
  {
    "abbreviation": "15",
    "name": "Wilayah Persekutuan Labuan",
    "iso_3166": "MY-15",
    "country": "MY"
  },
  {
    "abbreviation": "16",
    "name": "Wilayah Persekutuan Putrajaya",
    "iso_3166": "MY-16",
    "country": "MY"
  },
  {
    "abbreviation": "01",
    "name": "Addu City",
    "iso_3166": "MV-01",
    "country": "MV"
  },
  {
    "abbreviation": "03",
    "name": "Faadhippolhu",
    "iso_3166": "MV-03",
    "country": "MV"
  },
  {
    "abbreviation": "04",
    "name": "Felidhu Atoll",
    "iso_3166": "MV-04",
    "country": "MV"
  },
  {
    "abbreviation": "05",
    "name": "Hahdhunmathi",
    "iso_3166": "MV-05",
    "country": "MV"
  },
  {
    "abbreviation": "MLE",
    "name": "Male",
    "iso_3166": "MV-MLE",
    "country": "MV"
  },
  {
    "abbreviation": "12",
    "name": "Mulaku Atoll",
    "iso_3166": "MV-12",
    "country": "MV"
  },
  {
    "abbreviation": "02",
    "name": "North Ari Atoll",
    "iso_3166": "MV-02",
    "country": "MV"
  },
  {
    "abbreviation": "27",
    "name": "North Huvadhu Atoll",
    "iso_3166": "MV-27",
    "country": "MV"
  },
  {
    "abbreviation": "13",
    "name": "North Maalhosmadulu",
    "iso_3166": "MV-13",
    "country": "MV"
  },
  {
    "abbreviation": "07",
    "name": "North Thiladhunmathi",
    "iso_3166": "MV-07",
    "country": "MV"
  },
  {
    "abbreviation": "00",
    "name": "South Ari Atoll",
    "iso_3166": "MV-00",
    "country": "MV"
  },
  {
    "abbreviation": "28",
    "name": "South Huvadhu Atoll",
    "iso_3166": "MV-28",
    "country": "MV"
  },
  {
    "abbreviation": "20",
    "name": "South Maalhosmadulu",
    "iso_3166": "MV-20",
    "country": "MV"
  },
  {
    "abbreviation": "25",
    "name": "South Miladhunmadulu",
    "iso_3166": "MV-25",
    "country": "MV"
  },
  {
    "abbreviation": "23",
    "name": "South Thiladhunmathi",
    "iso_3166": "MV-23",
    "country": "MV"
  },
  {
    "abbreviation": "BKO",
    "name": "Bamako",
    "iso_3166": "ML-BKO",
    "country": "ML"
  },
  {
    "abbreviation": "7",
    "name": "Gao",
    "iso_3166": "ML-7",
    "country": "ML"
  },
  {
    "abbreviation": "1",
    "name": "Kayes",
    "iso_3166": "ML-1",
    "country": "ML"
  },
  {
    "abbreviation": "8",
    "name": "Kidal",
    "iso_3166": "ML-8",
    "country": "ML"
  },
  {
    "abbreviation": "2",
    "name": "Koulikoro",
    "iso_3166": "ML-2",
    "country": "ML"
  },
  {
    "abbreviation": "5",
    "name": "Mopti",
    "iso_3166": "ML-5",
    "country": "ML"
  },
  {
    "abbreviation": "4",
    "name": "Segou",
    "iso_3166": "ML-4",
    "country": "ML"
  },
  {
    "abbreviation": "3",
    "name": "Sikasso",
    "iso_3166": "ML-3",
    "country": "ML"
  },
  {
    "abbreviation": "6",
    "name": "Tombouctou",
    "iso_3166": "ML-6",
    "country": "ML"
  },
  {
    "abbreviation": "01",
    "name": "Attard",
    "iso_3166": "MT-01",
    "country": "MT"
  },
  {
    "abbreviation": "02",
    "name": "Balzan",
    "iso_3166": "MT-02",
    "country": "MT"
  },
  {
    "abbreviation": "03",
    "name": "Birgu",
    "iso_3166": "MT-03",
    "country": "MT"
  },
  {
    "abbreviation": "04",
    "name": "Birkirkara",
    "iso_3166": "MT-04",
    "country": "MT"
  },
  {
    "abbreviation": "05",
    "name": "Birzebbuga",
    "iso_3166": "MT-05",
    "country": "MT"
  },
  {
    "abbreviation": "06",
    "name": "Bormla",
    "iso_3166": "MT-06",
    "country": "MT"
  },
  {
    "abbreviation": "07",
    "name": "Dingli",
    "iso_3166": "MT-07",
    "country": "MT"
  },
  {
    "abbreviation": "08",
    "name": "Fgura",
    "iso_3166": "MT-08",
    "country": "MT"
  },
  {
    "abbreviation": "09",
    "name": "Floriana",
    "iso_3166": "MT-09",
    "country": "MT"
  },
  {
    "abbreviation": "10",
    "name": "Fontana",
    "iso_3166": "MT-10",
    "country": "MT"
  },
  {
    "abbreviation": "13",
    "name": "Ghajnsielem",
    "iso_3166": "MT-13",
    "country": "MT"
  },
  {
    "abbreviation": "14",
    "name": "Gharb",
    "iso_3166": "MT-14",
    "country": "MT"
  },
  {
    "abbreviation": "15",
    "name": "Gharghur",
    "iso_3166": "MT-15",
    "country": "MT"
  },
  {
    "abbreviation": "16",
    "name": "Ghasri",
    "iso_3166": "MT-16",
    "country": "MT"
  },
  {
    "abbreviation": "17",
    "name": "Ghaxaq",
    "iso_3166": "MT-17",
    "country": "MT"
  },
  {
    "abbreviation": "11",
    "name": "Gudja",
    "iso_3166": "MT-11",
    "country": "MT"
  },
  {
    "abbreviation": "12",
    "name": "Gzira",
    "iso_3166": "MT-12",
    "country": "MT"
  },
  {
    "abbreviation": "18",
    "name": "Hamrun",
    "iso_3166": "MT-18",
    "country": "MT"
  },
  {
    "abbreviation": "19",
    "name": "Iklin",
    "iso_3166": "MT-19",
    "country": "MT"
  },
  {
    "abbreviation": "20",
    "name": "Isla",
    "iso_3166": "MT-20",
    "country": "MT"
  },
  {
    "abbreviation": "21",
    "name": "Kalkara",
    "iso_3166": "MT-21",
    "country": "MT"
  },
  {
    "abbreviation": "23",
    "name": "Kirkop",
    "iso_3166": "MT-23",
    "country": "MT"
  },
  {
    "abbreviation": "24",
    "name": "Lija",
    "iso_3166": "MT-24",
    "country": "MT"
  },
  {
    "abbreviation": "25",
    "name": "Luqa",
    "iso_3166": "MT-25",
    "country": "MT"
  },
  {
    "abbreviation": "26",
    "name": "Marsa",
    "iso_3166": "MT-26",
    "country": "MT"
  },
  {
    "abbreviation": "27",
    "name": "Marsaskala",
    "iso_3166": "MT-27",
    "country": "MT"
  },
  {
    "abbreviation": "28",
    "name": "Marsaxlokk",
    "iso_3166": "MT-28",
    "country": "MT"
  },
  {
    "abbreviation": "29",
    "name": "Mdina",
    "iso_3166": "MT-29",
    "country": "MT"
  },
  {
    "abbreviation": "30",
    "name": "Mellieha",
    "iso_3166": "MT-30",
    "country": "MT"
  },
  {
    "abbreviation": "31",
    "name": "Mgarr",
    "iso_3166": "MT-31",
    "country": "MT"
  },
  {
    "abbreviation": "32",
    "name": "Mosta",
    "iso_3166": "MT-32",
    "country": "MT"
  },
  {
    "abbreviation": "33",
    "name": "Mqabba",
    "iso_3166": "MT-33",
    "country": "MT"
  },
  {
    "abbreviation": "34",
    "name": "Msida",
    "iso_3166": "MT-34",
    "country": "MT"
  },
  {
    "abbreviation": "35",
    "name": "Mtarfa",
    "iso_3166": "MT-35",
    "country": "MT"
  },
  {
    "abbreviation": "36",
    "name": "Munxar",
    "iso_3166": "MT-36",
    "country": "MT"
  },
  {
    "abbreviation": "37",
    "name": "Nadur",
    "iso_3166": "MT-37",
    "country": "MT"
  },
  {
    "abbreviation": "38",
    "name": "Naxxar",
    "iso_3166": "MT-38",
    "country": "MT"
  },
  {
    "abbreviation": "39",
    "name": "Paola",
    "iso_3166": "MT-39",
    "country": "MT"
  },
  {
    "abbreviation": "40",
    "name": "Pembroke",
    "iso_3166": "MT-40",
    "country": "MT"
  },
  {
    "abbreviation": "41",
    "name": "Pieta",
    "iso_3166": "MT-41",
    "country": "MT"
  },
  {
    "abbreviation": "42",
    "name": "Qala",
    "iso_3166": "MT-42",
    "country": "MT"
  },
  {
    "abbreviation": "43",
    "name": "Qormi",
    "iso_3166": "MT-43",
    "country": "MT"
  },
  {
    "abbreviation": "44",
    "name": "Qrendi",
    "iso_3166": "MT-44",
    "country": "MT"
  },
  {
    "abbreviation": "45",
    "name": "Rabat Gozo",
    "iso_3166": "MT-45",
    "country": "MT"
  },
  {
    "abbreviation": "46",
    "name": "Rabat Malta",
    "iso_3166": "MT-46",
    "country": "MT"
  },
  {
    "abbreviation": "47",
    "name": "Safi",
    "iso_3166": "MT-47",
    "country": "MT"
  },
  {
    "abbreviation": "49",
    "name": "Saint John",
    "iso_3166": "MT-49",
    "country": "MT"
  },
  {
    "abbreviation": "48",
    "name": "Saint Julian's",
    "iso_3166": "MT-48",
    "country": "MT"
  },
  {
    "abbreviation": "50",
    "name": "Saint Lawrence",
    "iso_3166": "MT-50",
    "country": "MT"
  },
  {
    "abbreviation": "53",
    "name": "Saint Lucia's",
    "iso_3166": "MT-53",
    "country": "MT"
  },
  {
    "abbreviation": "51",
    "name": "Saint Paul's Bay",
    "iso_3166": "MT-51",
    "country": "MT"
  },
  {
    "abbreviation": "52",
    "name": "Sannat",
    "iso_3166": "MT-52",
    "country": "MT"
  },
  {
    "abbreviation": "54",
    "name": "Santa Venera",
    "iso_3166": "MT-54",
    "country": "MT"
  },
  {
    "abbreviation": "55",
    "name": "Siggiewi",
    "iso_3166": "MT-55",
    "country": "MT"
  },
  {
    "abbreviation": "56",
    "name": "Sliema",
    "iso_3166": "MT-56",
    "country": "MT"
  },
  {
    "abbreviation": "57",
    "name": "Swieqi",
    "iso_3166": "MT-57",
    "country": "MT"
  },
  {
    "abbreviation": "58",
    "name": "Ta' Xbiex",
    "iso_3166": "MT-58",
    "country": "MT"
  },
  {
    "abbreviation": "59",
    "name": "Tarxien",
    "iso_3166": "MT-59",
    "country": "MT"
  },
  {
    "abbreviation": "60",
    "name": "Valletta",
    "iso_3166": "MT-60",
    "country": "MT"
  },
  {
    "abbreviation": "61",
    "name": "Xaghra",
    "iso_3166": "MT-61",
    "country": "MT"
  },
  {
    "abbreviation": "62",
    "name": "Xewkija",
    "iso_3166": "MT-62",
    "country": "MT"
  },
  {
    "abbreviation": "63",
    "name": "Xghajra",
    "iso_3166": "MT-63",
    "country": "MT"
  },
  {
    "abbreviation": "64",
    "name": "Zabbar",
    "iso_3166": "MT-64",
    "country": "MT"
  },
  {
    "abbreviation": "65",
    "name": "Zebbug Gozo",
    "iso_3166": "MT-65",
    "country": "MT"
  },
  {
    "abbreviation": "67",
    "name": "Zejtun",
    "iso_3166": "MT-67",
    "country": "MT"
  },
  {
    "abbreviation": "68",
    "name": "Zurrieq",
    "iso_3166": "MT-68",
    "country": "MT"
  },
  {
    "abbreviation": "KWA",
    "name": "Kwajalein",
    "iso_3166": "MH-KWA",
    "country": "MH"
  },
  {
    "abbreviation": "MAJ",
    "name": "Majuro",
    "iso_3166": "MH-MAJ",
    "country": "MH"
  },
  {
    "abbreviation": "-",
    "name": "Martinique",
    "iso_3166": "-",
    "country": "MQ"
  },
  {
    "abbreviation": "07",
    "name": "Adrar",
    "iso_3166": "MR-07",
    "country": "MR"
  },
  {
    "abbreviation": "03",
    "name": "Assaba",
    "iso_3166": "MR-03",
    "country": "MR"
  },
  {
    "abbreviation": "05",
    "name": "Brakna",
    "iso_3166": "MR-05",
    "country": "MR"
  },
  {
    "abbreviation": "08",
    "name": "Dakhlet Nouadhibou",
    "iso_3166": "MR-08",
    "country": "MR"
  },
  {
    "abbreviation": "04",
    "name": "Gorgol",
    "iso_3166": "MR-04",
    "country": "MR"
  },
  {
    "abbreviation": "02",
    "name": "Hodh el Gharbi",
    "iso_3166": "MR-02",
    "country": "MR"
  },
  {
    "abbreviation": "12",
    "name": "Inchiri",
    "iso_3166": "MR-12",
    "country": "MR"
  },
  {
    "abbreviation": "13",
    "name": "Nouakchott Ouest",
    "iso_3166": "MR-13",
    "country": "MR"
  },
  {
    "abbreviation": "09",
    "name": "Tagant",
    "iso_3166": "MR-09",
    "country": "MR"
  },
  {
    "abbreviation": "11",
    "name": "Tiris Zemmour",
    "iso_3166": "MR-11",
    "country": "MR"
  },
  {
    "abbreviation": "06",
    "name": "Trarza",
    "iso_3166": "MR-06",
    "country": "MR"
  },
  {
    "abbreviation": "BL",
    "name": "Black River",
    "iso_3166": "MU-BL",
    "country": "MU"
  },
  {
    "abbreviation": "FL",
    "name": "Flacq",
    "iso_3166": "MU-FL",
    "country": "MU"
  },
  {
    "abbreviation": "GP",
    "name": "Grand Port",
    "iso_3166": "MU-GP",
    "country": "MU"
  },
  {
    "abbreviation": "MO",
    "name": "Moka",
    "iso_3166": "MU-MO",
    "country": "MU"
  },
  {
    "abbreviation": "PA",
    "name": "Pamplemousses",
    "iso_3166": "MU-PA",
    "country": "MU"
  },
  {
    "abbreviation": "PW",
    "name": "Plaines Wilhems",
    "iso_3166": "MU-PW",
    "country": "MU"
  },
  {
    "abbreviation": "PL",
    "name": "Port Louis",
    "iso_3166": "MU-PL",
    "country": "MU"
  },
  {
    "abbreviation": "RR",
    "name": "Riviere du Rempart",
    "iso_3166": "MU-RR",
    "country": "MU"
  },
  {
    "abbreviation": "RO",
    "name": "Rodrigues Islands",
    "iso_3166": "MU-RO",
    "country": "MU"
  },
  {
    "abbreviation": "SA",
    "name": "Savanne",
    "iso_3166": "MU-SA",
    "country": "MU"
  },
  {
    "abbreviation": "-",
    "name": "Bandraboua",
    "iso_3166": "-",
    "country": "YT"
  },
  {
    "abbreviation": "-",
    "name": "Bandrele",
    "iso_3166": "-",
    "country": "YT"
  },
  {
    "abbreviation": "-",
    "name": "Kani-Keli",
    "iso_3166": "-",
    "country": "YT"
  },
  {
    "abbreviation": "-",
    "name": "Mamoudzou",
    "iso_3166": "-",
    "country": "YT"
  },
  {
    "abbreviation": "-",
    "name": "Ouangani",
    "iso_3166": "-",
    "country": "YT"
  },
  {
    "abbreviation": "-",
    "name": "Pamandzi",
    "iso_3166": "-",
    "country": "YT"
  },
  {
    "abbreviation": "-",
    "name": "Sada",
    "iso_3166": "-",
    "country": "YT"
  },
  {
    "abbreviation": "-",
    "name": "Tsingoni",
    "iso_3166": "-",
    "country": "YT"
  },
  {
    "abbreviation": "AGU",
    "name": "Aguascalientes",
    "iso_3166": "MX-AGU",
    "country": "MX"
  },
  {
    "abbreviation": "BCN",
    "name": "Baja California",
    "iso_3166": "MX-BCN",
    "country": "MX"
  },
  {
    "abbreviation": "BCS",
    "name": "Baja California Sur",
    "iso_3166": "MX-BCS",
    "country": "MX"
  },
  {
    "abbreviation": "CAM",
    "name": "Campeche",
    "iso_3166": "MX-CAM",
    "country": "MX"
  },
  {
    "abbreviation": "CHP",
    "name": "Chiapas",
    "iso_3166": "MX-CHP",
    "country": "MX"
  },
  {
    "abbreviation": "CHH",
    "name": "Chihuahua",
    "iso_3166": "MX-CHH",
    "country": "MX"
  },
  {
    "abbreviation": "CMX",
    "name": "Ciudad de Mexico",
    "iso_3166": "MX-CMX",
    "country": "MX"
  },
  {
    "abbreviation": "COA",
    "name": "Coahuila de Zaragoza",
    "iso_3166": "MX-COA",
    "country": "MX"
  },
  {
    "abbreviation": "COL",
    "name": "Colima",
    "iso_3166": "MX-COL",
    "country": "MX"
  },
  {
    "abbreviation": "DUR",
    "name": "Durango",
    "iso_3166": "MX-DUR",
    "country": "MX"
  },
  {
    "abbreviation": "GUA",
    "name": "Guanajuato",
    "iso_3166": "MX-GUA",
    "country": "MX"
  },
  {
    "abbreviation": "GRO",
    "name": "Guerrero",
    "iso_3166": "MX-GRO",
    "country": "MX"
  },
  {
    "abbreviation": "HID",
    "name": "Hidalgo",
    "iso_3166": "MX-HID",
    "country": "MX"
  },
  {
    "abbreviation": "JAL",
    "name": "Jalisco",
    "iso_3166": "MX-JAL",
    "country": "MX"
  },
  {
    "abbreviation": "MEX",
    "name": "Mexico",
    "iso_3166": "MX-MEX",
    "country": "MX"
  },
  {
    "abbreviation": "MIC",
    "name": "Michoacan de Ocampo",
    "iso_3166": "MX-MIC",
    "country": "MX"
  },
  {
    "abbreviation": "MOR",
    "name": "Morelos",
    "iso_3166": "MX-MOR",
    "country": "MX"
  },
  {
    "abbreviation": "NAY",
    "name": "Nayarit",
    "iso_3166": "MX-NAY",
    "country": "MX"
  },
  {
    "abbreviation": "NLE",
    "name": "Nuevo Leon",
    "iso_3166": "MX-NLE",
    "country": "MX"
  },
  {
    "abbreviation": "OAX",
    "name": "Oaxaca",
    "iso_3166": "MX-OAX",
    "country": "MX"
  },
  {
    "abbreviation": "PUE",
    "name": "Puebla",
    "iso_3166": "MX-PUE",
    "country": "MX"
  },
  {
    "abbreviation": "QUE",
    "name": "Queretaro",
    "iso_3166": "MX-QUE",
    "country": "MX"
  },
  {
    "abbreviation": "ROO",
    "name": "Quintana Roo",
    "iso_3166": "MX-ROO",
    "country": "MX"
  },
  {
    "abbreviation": "SLP",
    "name": "San Luis Potosi",
    "iso_3166": "MX-SLP",
    "country": "MX"
  },
  {
    "abbreviation": "SIN",
    "name": "Sinaloa",
    "iso_3166": "MX-SIN",
    "country": "MX"
  },
  {
    "abbreviation": "SON",
    "name": "Sonora",
    "iso_3166": "MX-SON",
    "country": "MX"
  },
  {
    "abbreviation": "TAB",
    "name": "Tabasco",
    "iso_3166": "MX-TAB",
    "country": "MX"
  },
  {
    "abbreviation": "TAM",
    "name": "Tamaulipas",
    "iso_3166": "MX-TAM",
    "country": "MX"
  },
  {
    "abbreviation": "TLA",
    "name": "Tlaxcala",
    "iso_3166": "MX-TLA",
    "country": "MX"
  },
  {
    "abbreviation": "VER",
    "name": "Veracruz de Ignacio de la Llave",
    "iso_3166": "MX-VER",
    "country": "MX"
  },
  {
    "abbreviation": "YUC",
    "name": "Yucatan",
    "iso_3166": "MX-YUC",
    "country": "MX"
  },
  {
    "abbreviation": "ZAC",
    "name": "Zacatecas",
    "iso_3166": "MX-ZAC",
    "country": "MX"
  },
  {
    "abbreviation": "TRK",
    "name": "Chuuk",
    "iso_3166": "FM-TRK",
    "country": "FM"
  },
  {
    "abbreviation": "KSA",
    "name": "Kosrae",
    "iso_3166": "FM-KSA",
    "country": "FM"
  },
  {
    "abbreviation": "PNI",
    "name": "Pohnpei",
    "iso_3166": "FM-PNI",
    "country": "FM"
  },
  {
    "abbreviation": "YAP",
    "name": "Yap",
    "iso_3166": "FM-YAP",
    "country": "FM"
  },
  {
    "abbreviation": "AN",
    "name": "Anenii Noi",
    "iso_3166": "MD-AN",
    "country": "MD"
  },
  {
    "abbreviation": "BA",
    "name": "Balti",
    "iso_3166": "MD-BA",
    "country": "MD"
  },
  {
    "abbreviation": "BS",
    "name": "Basarabeasca",
    "iso_3166": "MD-BS",
    "country": "MD"
  },
  {
    "abbreviation": "BD",
    "name": "Bender",
    "iso_3166": "MD-BD",
    "country": "MD"
  },
  {
    "abbreviation": "BR",
    "name": "Briceni",
    "iso_3166": "MD-BR",
    "country": "MD"
  },
  {
    "abbreviation": "CA",
    "name": "Cahul",
    "iso_3166": "MD-CA",
    "country": "MD"
  },
  {
    "abbreviation": "CL",
    "name": "Calarasi",
    "iso_3166": "MD-CL",
    "country": "MD"
  },
  {
    "abbreviation": "CT",
    "name": "Cantemir",
    "iso_3166": "MD-CT",
    "country": "MD"
  },
  {
    "abbreviation": "CS",
    "name": "Causeni",
    "iso_3166": "MD-CS",
    "country": "MD"
  },
  {
    "abbreviation": "CU",
    "name": "Chisinau",
    "iso_3166": "MD-CU",
    "country": "MD"
  },
  {
    "abbreviation": "CM",
    "name": "Cimislia",
    "iso_3166": "MD-CM",
    "country": "MD"
  },
  {
    "abbreviation": "CR",
    "name": "Criuleni",
    "iso_3166": "MD-CR",
    "country": "MD"
  },
  {
    "abbreviation": "DO",
    "name": "Donduseni",
    "iso_3166": "MD-DO",
    "country": "MD"
  },
  {
    "abbreviation": "DR",
    "name": "Drochia",
    "iso_3166": "MD-DR",
    "country": "MD"
  },
  {
    "abbreviation": "DU",
    "name": "Dubasari",
    "iso_3166": "MD-DU",
    "country": "MD"
  },
  {
    "abbreviation": "ED",
    "name": "Edinet",
    "iso_3166": "MD-ED",
    "country": "MD"
  },
  {
    "abbreviation": "FA",
    "name": "Falesti",
    "iso_3166": "MD-FA",
    "country": "MD"
  },
  {
    "abbreviation": "FL",
    "name": "Floresti",
    "iso_3166": "MD-FL",
    "country": "MD"
  },
  {
    "abbreviation": "GA",
    "name": "Gagauzia, Unitatea teritoriala autonoma",
    "iso_3166": "MD-GA",
    "country": "MD"
  },
  {
    "abbreviation": "GL",
    "name": "Glodeni",
    "iso_3166": "MD-GL",
    "country": "MD"
  },
  {
    "abbreviation": "HI",
    "name": "Hincesti",
    "iso_3166": "MD-HI",
    "country": "MD"
  },
  {
    "abbreviation": "IA",
    "name": "Ialoveni",
    "iso_3166": "MD-IA",
    "country": "MD"
  },
  {
    "abbreviation": "LE",
    "name": "Leova",
    "iso_3166": "MD-LE",
    "country": "MD"
  },
  {
    "abbreviation": "NI",
    "name": "Nisporeni",
    "iso_3166": "MD-NI",
    "country": "MD"
  },
  {
    "abbreviation": "OC",
    "name": "Ocnita",
    "iso_3166": "MD-OC",
    "country": "MD"
  },
  {
    "abbreviation": "OR",
    "name": "Orhei",
    "iso_3166": "MD-OR",
    "country": "MD"
  },
  {
    "abbreviation": "RE",
    "name": "Rezina",
    "iso_3166": "MD-RE",
    "country": "MD"
  },
  {
    "abbreviation": "RI",
    "name": "Riscani",
    "iso_3166": "MD-RI",
    "country": "MD"
  },
  {
    "abbreviation": "SI",
    "name": "Singerei",
    "iso_3166": "MD-SI",
    "country": "MD"
  },
  {
    "abbreviation": "SD",
    "name": "Soldanesti",
    "iso_3166": "MD-SD",
    "country": "MD"
  },
  {
    "abbreviation": "SO",
    "name": "Soroca",
    "iso_3166": "MD-SO",
    "country": "MD"
  },
  {
    "abbreviation": "SV",
    "name": "Stefan Voda",
    "iso_3166": "MD-SV",
    "country": "MD"
  },
  {
    "abbreviation": "SN",
    "name": "Stinga Nistrului, unitatea teritoriala din",
    "iso_3166": "MD-SN",
    "country": "MD"
  },
  {
    "abbreviation": "ST",
    "name": "Straseni",
    "iso_3166": "MD-ST",
    "country": "MD"
  },
  {
    "abbreviation": "TA",
    "name": "Taraclia",
    "iso_3166": "MD-TA",
    "country": "MD"
  },
  {
    "abbreviation": "TE",
    "name": "Telenesti",
    "iso_3166": "MD-TE",
    "country": "MD"
  },
  {
    "abbreviation": "UN",
    "name": "Ungheni",
    "iso_3166": "MD-UN",
    "country": "MD"
  },
  {
    "abbreviation": "FO",
    "name": "Fontvieille",
    "iso_3166": "MC-FO",
    "country": "MC"
  },
  {
    "abbreviation": "CO",
    "name": "La Condamine",
    "iso_3166": "MC-CO",
    "country": "MC"
  },
  {
    "abbreviation": "MO",
    "name": "Monaco-Ville",
    "iso_3166": "MC-MO",
    "country": "MC"
  },
  {
    "abbreviation": "MG",
    "name": "Moneghetti",
    "iso_3166": "MC-MG",
    "country": "MC"
  },
  {
    "abbreviation": "MC",
    "name": "Monte-Carlo",
    "iso_3166": "MC-MC",
    "country": "MC"
  },
  {
    "abbreviation": "SR",
    "name": "Saint-Roman",
    "iso_3166": "MC-SR",
    "country": "MC"
  },
  {
    "abbreviation": "069",
    "name": "Bayanhongor",
    "iso_3166": "MN-069",
    "country": "MN"
  },
  {
    "abbreviation": "037",
    "name": "Darhan uul",
    "iso_3166": "MN-037",
    "country": "MN"
  },
  {
    "abbreviation": "061",
    "name": "Dornod",
    "iso_3166": "MN-061",
    "country": "MN"
  },
  {
    "abbreviation": "065",
    "name": "Govi-Altay",
    "iso_3166": "MN-065",
    "country": "MN"
  },
  {
    "abbreviation": "039",
    "name": "Hentiy",
    "iso_3166": "MN-039",
    "country": "MN"
  },
  {
    "abbreviation": "043",
    "name": "Hovd",
    "iso_3166": "MN-043",
    "country": "MN"
  },
  {
    "abbreviation": "053",
    "name": "Omnogovi",
    "iso_3166": "MN-053",
    "country": "MN"
  },
  {
    "abbreviation": "055",
    "name": "Ovorhangay",
    "iso_3166": "MN-055",
    "country": "MN"
  },
  {
    "abbreviation": "049",
    "name": "Selenge",
    "iso_3166": "MN-049",
    "country": "MN"
  },
  {
    "abbreviation": "047",
    "name": "Tov",
    "iso_3166": "MN-047",
    "country": "MN"
  },
  {
    "abbreviation": "1",
    "name": "Ulaanbaatar",
    "iso_3166": "MN-1",
    "country": "MN"
  },
  {
    "abbreviation": "01",
    "name": "Andrijevica",
    "iso_3166": "ME-01",
    "country": "ME"
  },
  {
    "abbreviation": "02",
    "name": "Bar",
    "iso_3166": "ME-02",
    "country": "ME"
  },
  {
    "abbreviation": "03",
    "name": "Berane",
    "iso_3166": "ME-03",
    "country": "ME"
  },
  {
    "abbreviation": "04",
    "name": "Bijelo Polje",
    "iso_3166": "ME-04",
    "country": "ME"
  },
  {
    "abbreviation": "05",
    "name": "Budva",
    "iso_3166": "ME-05",
    "country": "ME"
  },
  {
    "abbreviation": "06",
    "name": "Cetinje",
    "iso_3166": "ME-06",
    "country": "ME"
  },
  {
    "abbreviation": "07",
    "name": "Danilovgrad",
    "iso_3166": "ME-07",
    "country": "ME"
  },
  {
    "abbreviation": "08",
    "name": "Herceg-Novi",
    "iso_3166": "ME-08",
    "country": "ME"
  },
  {
    "abbreviation": "09",
    "name": "Kolasin",
    "iso_3166": "ME-09",
    "country": "ME"
  },
  {
    "abbreviation": "10",
    "name": "Kotor",
    "iso_3166": "ME-10",
    "country": "ME"
  },
  {
    "abbreviation": "12",
    "name": "Niksic",
    "iso_3166": "ME-12",
    "country": "ME"
  },
  {
    "abbreviation": "13",
    "name": "Plav",
    "iso_3166": "ME-13",
    "country": "ME"
  },
  {
    "abbreviation": "14",
    "name": "Pljevlja",
    "iso_3166": "ME-14",
    "country": "ME"
  },
  {
    "abbreviation": "15",
    "name": "Pluzine",
    "iso_3166": "ME-15",
    "country": "ME"
  },
  {
    "abbreviation": "16",
    "name": "Podgorica",
    "iso_3166": "ME-16",
    "country": "ME"
  },
  {
    "abbreviation": "17",
    "name": "Rozaje",
    "iso_3166": "ME-17",
    "country": "ME"
  },
  {
    "abbreviation": "19",
    "name": "Tivat",
    "iso_3166": "ME-19",
    "country": "ME"
  },
  {
    "abbreviation": "24",
    "name": "Tuzi",
    "iso_3166": "ME-24",
    "country": "ME"
  },
  {
    "abbreviation": "20",
    "name": "Ulcinj",
    "iso_3166": "ME-20",
    "country": "ME"
  },
  {
    "abbreviation": "21",
    "name": "Zabljak",
    "iso_3166": "ME-21",
    "country": "ME"
  },
  {
    "abbreviation": "-",
    "name": "Saint Anthony",
    "iso_3166": "-",
    "country": "MS"
  },
  {
    "abbreviation": "-",
    "name": "Saint Peter",
    "iso_3166": "-",
    "country": "MS"
  },
  {
    "abbreviation": "05",
    "name": "Beni-Mellal-Khenifra",
    "iso_3166": "MA-05",
    "country": "MA"
  },
  {
    "abbreviation": "06",
    "name": "Casablanca-Settat",
    "iso_3166": "MA-06",
    "country": "MA"
  },
  {
    "abbreviation": "08",
    "name": "Draa-Tafilalet",
    "iso_3166": "MA-08",
    "country": "MA"
  },
  {
    "abbreviation": "03",
    "name": "Fes- Meknes",
    "iso_3166": "MA-03",
    "country": "MA"
  },
  {
    "abbreviation": "10",
    "name": "Guelmim-Oued Noun (EH-partial)",
    "iso_3166": "MA-10",
    "country": "MA"
  },
  {
    "abbreviation": "02",
    "name": "L'Oriental",
    "iso_3166": "MA-02",
    "country": "MA"
  },
  {
    "abbreviation": "11",
    "name": "Laayoune-Sakia El Hamra (EH-partial)",
    "iso_3166": "MA-11",
    "country": "MA"
  },
  {
    "abbreviation": "07",
    "name": "Marrakech-Safi",
    "iso_3166": "MA-07",
    "country": "MA"
  },
  {
    "abbreviation": "04",
    "name": "Rabat-Sale-Kenitra",
    "iso_3166": "MA-04",
    "country": "MA"
  },
  {
    "abbreviation": "09",
    "name": "Souss-Massa",
    "iso_3166": "MA-09",
    "country": "MA"
  },
  {
    "abbreviation": "01",
    "name": "Tanger-Tetouan-Al Hoceima",
    "iso_3166": "MA-01",
    "country": "MA"
  },
  {
    "abbreviation": "P",
    "name": "Cabo Delgado",
    "iso_3166": "MZ-P",
    "country": "MZ"
  },
  {
    "abbreviation": "G",
    "name": "Gaza",
    "iso_3166": "MZ-G",
    "country": "MZ"
  },
  {
    "abbreviation": "I",
    "name": "Inhambane",
    "iso_3166": "MZ-I",
    "country": "MZ"
  },
  {
    "abbreviation": "B",
    "name": "Manica",
    "iso_3166": "MZ-B",
    "country": "MZ"
  },
  {
    "abbreviation": "L",
    "name": "Maputo",
    "iso_3166": "MZ-L",
    "country": "MZ"
  },
  {
    "abbreviation": "N",
    "name": "Nampula",
    "iso_3166": "MZ-N",
    "country": "MZ"
  },
  {
    "abbreviation": "A",
    "name": "Niassa",
    "iso_3166": "MZ-A",
    "country": "MZ"
  },
  {
    "abbreviation": "S",
    "name": "Sofala",
    "iso_3166": "MZ-S",
    "country": "MZ"
  },
  {
    "abbreviation": "T",
    "name": "Tete",
    "iso_3166": "MZ-T",
    "country": "MZ"
  },
  {
    "abbreviation": "Q",
    "name": "Zambezia",
    "iso_3166": "MZ-Q",
    "country": "MZ"
  },
  {
    "abbreviation": "07",
    "name": "Ayeyarwady",
    "iso_3166": "MM-07",
    "country": "MM"
  },
  {
    "abbreviation": "02",
    "name": "Bago",
    "iso_3166": "MM-02",
    "country": "MM"
  },
  {
    "abbreviation": "14",
    "name": "Chin",
    "iso_3166": "MM-14",
    "country": "MM"
  },
  {
    "abbreviation": "11",
    "name": "Kachin",
    "iso_3166": "MM-11",
    "country": "MM"
  },
  {
    "abbreviation": "12",
    "name": "Kayah",
    "iso_3166": "MM-12",
    "country": "MM"
  },
  {
    "abbreviation": "13",
    "name": "Kayin",
    "iso_3166": "MM-13",
    "country": "MM"
  },
  {
    "abbreviation": "03",
    "name": "Magway",
    "iso_3166": "MM-03",
    "country": "MM"
  },
  {
    "abbreviation": "04",
    "name": "Mandalay",
    "iso_3166": "MM-04",
    "country": "MM"
  },
  {
    "abbreviation": "15",
    "name": "Mon",
    "iso_3166": "MM-15",
    "country": "MM"
  },
  {
    "abbreviation": "18",
    "name": "Nay Pyi Taw",
    "iso_3166": "MM-18",
    "country": "MM"
  },
  {
    "abbreviation": "16",
    "name": "Rakhine",
    "iso_3166": "MM-16",
    "country": "MM"
  },
  {
    "abbreviation": "01",
    "name": "Sagaing",
    "iso_3166": "MM-01",
    "country": "MM"
  },
  {
    "abbreviation": "17",
    "name": "Shan",
    "iso_3166": "MM-17",
    "country": "MM"
  },
  {
    "abbreviation": "05",
    "name": "Tanintharyi",
    "iso_3166": "MM-05",
    "country": "MM"
  },
  {
    "abbreviation": "06",
    "name": "Yangon",
    "iso_3166": "MM-06",
    "country": "MM"
  },
  {
    "abbreviation": "ER",
    "name": "Erongo",
    "iso_3166": "NA-ER",
    "country": "NA"
  },
  {
    "abbreviation": "HA",
    "name": "Hardap",
    "iso_3166": "NA-HA",
    "country": "NA"
  },
  {
    "abbreviation": "KA",
    "name": "Karas",
    "iso_3166": "NA-KA",
    "country": "NA"
  },
  {
    "abbreviation": "KE",
    "name": "Kavango East",
    "iso_3166": "NA-KE",
    "country": "NA"
  },
  {
    "abbreviation": "KW",
    "name": "Kavango West",
    "iso_3166": "NA-KW",
    "country": "NA"
  },
  {
    "abbreviation": "KH",
    "name": "Khomas",
    "iso_3166": "NA-KH",
    "country": "NA"
  },
  {
    "abbreviation": "KU",
    "name": "Kunene",
    "iso_3166": "NA-KU",
    "country": "NA"
  },
  {
    "abbreviation": "OW",
    "name": "Ohangwena",
    "iso_3166": "NA-OW",
    "country": "NA"
  },
  {
    "abbreviation": "OH",
    "name": "Omaheke",
    "iso_3166": "NA-OH",
    "country": "NA"
  },
  {
    "abbreviation": "OS",
    "name": "Omusati",
    "iso_3166": "NA-OS",
    "country": "NA"
  },
  {
    "abbreviation": "ON",
    "name": "Oshana",
    "iso_3166": "NA-ON",
    "country": "NA"
  },
  {
    "abbreviation": "OT",
    "name": "Oshikoto",
    "iso_3166": "NA-OT",
    "country": "NA"
  },
  {
    "abbreviation": "OD",
    "name": "Otjozondjupa",
    "iso_3166": "NA-OD",
    "country": "NA"
  },
  {
    "abbreviation": "CA",
    "name": "Zambezi",
    "iso_3166": "NA-CA",
    "country": "NA"
  },
  {
    "abbreviation": "01",
    "name": "Aiwo",
    "iso_3166": "NR-01",
    "country": "NR"
  },
  {
    "abbreviation": "03",
    "name": "Anetan",
    "iso_3166": "NR-03",
    "country": "NR"
  },
  {
    "abbreviation": "14",
    "name": "Yaren",
    "iso_3166": "NR-14",
    "country": "NR"
  },
  {
    "abbreviation": "BA",
    "name": "Bagmati",
    "iso_3166": "NP-BA",
    "country": "NP"
  },
  {
    "abbreviation": "BH",
    "name": "Bheri",
    "iso_3166": "NP-BH",
    "country": "NP"
  },
  {
    "abbreviation": "DH",
    "name": "Dhawalagiri",
    "iso_3166": "NP-DH",
    "country": "NP"
  },
  {
    "abbreviation": "GA",
    "name": "Gandaki",
    "iso_3166": "NP-GA",
    "country": "NP"
  },
  {
    "abbreviation": "JA",
    "name": "Janakpur",
    "iso_3166": "NP-JA",
    "country": "NP"
  },
  {
    "abbreviation": "KA",
    "name": "Karnali",
    "iso_3166": "NP-KA",
    "country": "NP"
  },
  {
    "abbreviation": "KO",
    "name": "Kosi",
    "iso_3166": "NP-KO",
    "country": "NP"
  },
  {
    "abbreviation": "LU",
    "name": "Lumbini",
    "iso_3166": "NP-LU",
    "country": "NP"
  },
  {
    "abbreviation": "MA",
    "name": "Mahakali",
    "iso_3166": "NP-MA",
    "country": "NP"
  },
  {
    "abbreviation": "ME",
    "name": "Mechi",
    "iso_3166": "NP-ME",
    "country": "NP"
  },
  {
    "abbreviation": "NA",
    "name": "Narayani",
    "iso_3166": "NP-NA",
    "country": "NP"
  },
  {
    "abbreviation": "RA",
    "name": "Rapti",
    "iso_3166": "NP-RA",
    "country": "NP"
  },
  {
    "abbreviation": "SA",
    "name": "Sagarmatha",
    "iso_3166": "NP-SA",
    "country": "NP"
  },
  {
    "abbreviation": "SE",
    "name": "Seti",
    "iso_3166": "NP-SE",
    "country": "NP"
  },
  {
    "abbreviation": "DR",
    "name": "Drenthe",
    "iso_3166": "NL-DR",
    "country": "NL"
  },
  {
    "abbreviation": "FL",
    "name": "Flevoland",
    "iso_3166": "NL-FL",
    "country": "NL"
  },
  {
    "abbreviation": "FR",
    "name": "Fryslan",
    "iso_3166": "NL-FR",
    "country": "NL"
  },
  {
    "abbreviation": "GE",
    "name": "Gelderland",
    "iso_3166": "NL-GE",
    "country": "NL"
  },
  {
    "abbreviation": "GR",
    "name": "Groningen",
    "iso_3166": "NL-GR",
    "country": "NL"
  },
  {
    "abbreviation": "LI",
    "name": "Limburg",
    "iso_3166": "NL-LI",
    "country": "NL"
  },
  {
    "abbreviation": "NB",
    "name": "Noord-Brabant",
    "iso_3166": "NL-NB",
    "country": "NL"
  },
  {
    "abbreviation": "NH",
    "name": "Noord-Holland",
    "iso_3166": "NL-NH",
    "country": "NL"
  },
  {
    "abbreviation": "OV",
    "name": "Overijssel",
    "iso_3166": "NL-OV",
    "country": "NL"
  },
  {
    "abbreviation": "UT",
    "name": "Utrecht",
    "iso_3166": "NL-UT",
    "country": "NL"
  },
  {
    "abbreviation": "ZE",
    "name": "Zeeland",
    "iso_3166": "NL-ZE",
    "country": "NL"
  },
  {
    "abbreviation": "ZH",
    "name": "Zuid-Holland",
    "iso_3166": "NL-ZH",
    "country": "NL"
  },
  {
    "abbreviation": "-",
    "name": "Province Nord",
    "iso_3166": "-",
    "country": "NC"
  },
  {
    "abbreviation": "-",
    "name": "Province Sud",
    "iso_3166": "-",
    "country": "NC"
  },
  {
    "abbreviation": "AUK",
    "name": "Auckland",
    "iso_3166": "NZ-AUK",
    "country": "NZ"
  },
  {
    "abbreviation": "BOP",
    "name": "Bay of Plenty",
    "iso_3166": "NZ-BOP",
    "country": "NZ"
  },
  {
    "abbreviation": "CAN",
    "name": "Canterbury",
    "iso_3166": "NZ-CAN",
    "country": "NZ"
  },
  {
    "abbreviation": "CIT",
    "name": "Chatham Islands Territory",
    "iso_3166": "NZ-CIT",
    "country": "NZ"
  },
  {
    "abbreviation": "GIS",
    "name": "Gisborne",
    "iso_3166": "NZ-GIS",
    "country": "NZ"
  },
  {
    "abbreviation": "HKB",
    "name": "Hawke's Bay",
    "iso_3166": "NZ-HKB",
    "country": "NZ"
  },
  {
    "abbreviation": "MWT",
    "name": "Manawatu-Wanganui",
    "iso_3166": "NZ-MWT",
    "country": "NZ"
  },
  {
    "abbreviation": "MBH",
    "name": "Marlborough",
    "iso_3166": "NZ-MBH",
    "country": "NZ"
  },
  {
    "abbreviation": "NSN",
    "name": "Nelson",
    "iso_3166": "NZ-NSN",
    "country": "NZ"
  },
  {
    "abbreviation": "NTL",
    "name": "Northland",
    "iso_3166": "NZ-NTL",
    "country": "NZ"
  },
  {
    "abbreviation": "OTA",
    "name": "Otago",
    "iso_3166": "NZ-OTA",
    "country": "NZ"
  },
  {
    "abbreviation": "STL",
    "name": "Southland",
    "iso_3166": "NZ-STL",
    "country": "NZ"
  },
  {
    "abbreviation": "TKI",
    "name": "Taranaki",
    "iso_3166": "NZ-TKI",
    "country": "NZ"
  },
  {
    "abbreviation": "TAS",
    "name": "Tasman",
    "iso_3166": "NZ-TAS",
    "country": "NZ"
  },
  {
    "abbreviation": "WKO",
    "name": "Waikato",
    "iso_3166": "NZ-WKO",
    "country": "NZ"
  },
  {
    "abbreviation": "WGN",
    "name": "Wellington",
    "iso_3166": "NZ-WGN",
    "country": "NZ"
  },
  {
    "abbreviation": "WTC",
    "name": "West Coast",
    "iso_3166": "NZ-WTC",
    "country": "NZ"
  },
  {
    "abbreviation": "BO",
    "name": "Boaco",
    "iso_3166": "NI-BO",
    "country": "NI"
  },
  {
    "abbreviation": "CA",
    "name": "Carazo",
    "iso_3166": "NI-CA",
    "country": "NI"
  },
  {
    "abbreviation": "CI",
    "name": "Chinandega",
    "iso_3166": "NI-CI",
    "country": "NI"
  },
  {
    "abbreviation": "CO",
    "name": "Chontales",
    "iso_3166": "NI-CO",
    "country": "NI"
  },
  {
    "abbreviation": "AN",
    "name": "Costa Caribe Norte",
    "iso_3166": "NI-AN",
    "country": "NI"
  },
  {
    "abbreviation": "AS",
    "name": "Costa Caribe Sur",
    "iso_3166": "NI-AS",
    "country": "NI"
  },
  {
    "abbreviation": "ES",
    "name": "Esteli",
    "iso_3166": "NI-ES",
    "country": "NI"
  },
  {
    "abbreviation": "GR",
    "name": "Granada",
    "iso_3166": "NI-GR",
    "country": "NI"
  },
  {
    "abbreviation": "JI",
    "name": "Jinotega",
    "iso_3166": "NI-JI",
    "country": "NI"
  },
  {
    "abbreviation": "LE",
    "name": "Leon",
    "iso_3166": "NI-LE",
    "country": "NI"
  },
  {
    "abbreviation": "MD",
    "name": "Madriz",
    "iso_3166": "NI-MD",
    "country": "NI"
  },
  {
    "abbreviation": "MN",
    "name": "Managua",
    "iso_3166": "NI-MN",
    "country": "NI"
  },
  {
    "abbreviation": "MS",
    "name": "Masaya",
    "iso_3166": "NI-MS",
    "country": "NI"
  },
  {
    "abbreviation": "MT",
    "name": "Matagalpa",
    "iso_3166": "NI-MT",
    "country": "NI"
  },
  {
    "abbreviation": "NS",
    "name": "Nueva Segovia",
    "iso_3166": "NI-NS",
    "country": "NI"
  },
  {
    "abbreviation": "SJ",
    "name": "Rio San Juan",
    "iso_3166": "NI-SJ",
    "country": "NI"
  },
  {
    "abbreviation": "RI",
    "name": "Rivas",
    "iso_3166": "NI-RI",
    "country": "NI"
  },
  {
    "abbreviation": "1",
    "name": "Agadez",
    "iso_3166": "NE-1",
    "country": "NE"
  },
  {
    "abbreviation": "2",
    "name": "Diffa",
    "iso_3166": "NE-2",
    "country": "NE"
  },
  {
    "abbreviation": "3",
    "name": "Dosso",
    "iso_3166": "NE-3",
    "country": "NE"
  },
  {
    "abbreviation": "4",
    "name": "Maradi",
    "iso_3166": "NE-4",
    "country": "NE"
  },
  {
    "abbreviation": "8",
    "name": "Niamey",
    "iso_3166": "NE-8",
    "country": "NE"
  },
  {
    "abbreviation": "5",
    "name": "Tahoua",
    "iso_3166": "NE-5",
    "country": "NE"
  },
  {
    "abbreviation": "6",
    "name": "Tillaberi",
    "iso_3166": "NE-6",
    "country": "NE"
  },
  {
    "abbreviation": "7",
    "name": "Zinder",
    "iso_3166": "NE-7",
    "country": "NE"
  },
  {
    "abbreviation": "AB",
    "name": "Abia",
    "iso_3166": "NG-AB",
    "country": "NG"
  },
  {
    "abbreviation": "FC",
    "name": "Abuja Federal Capital Territory",
    "iso_3166": "NG-FC",
    "country": "NG"
  },
  {
    "abbreviation": "AD",
    "name": "Adamawa",
    "iso_3166": "NG-AD",
    "country": "NG"
  },
  {
    "abbreviation": "AK",
    "name": "Akwa Ibom",
    "iso_3166": "NG-AK",
    "country": "NG"
  },
  {
    "abbreviation": "AN",
    "name": "Anambra",
    "iso_3166": "NG-AN",
    "country": "NG"
  },
  {
    "abbreviation": "BA",
    "name": "Bauchi",
    "iso_3166": "NG-BA",
    "country": "NG"
  },
  {
    "abbreviation": "BY",
    "name": "Bayelsa",
    "iso_3166": "NG-BY",
    "country": "NG"
  },
  {
    "abbreviation": "BE",
    "name": "Benue",
    "iso_3166": "NG-BE",
    "country": "NG"
  },
  {
    "abbreviation": "BO",
    "name": "Borno",
    "iso_3166": "NG-BO",
    "country": "NG"
  },
  {
    "abbreviation": "CR",
    "name": "Cross River",
    "iso_3166": "NG-CR",
    "country": "NG"
  },
  {
    "abbreviation": "DE",
    "name": "Delta",
    "iso_3166": "NG-DE",
    "country": "NG"
  },
  {
    "abbreviation": "EB",
    "name": "Ebonyi",
    "iso_3166": "NG-EB",
    "country": "NG"
  },
  {
    "abbreviation": "ED",
    "name": "Edo",
    "iso_3166": "NG-ED",
    "country": "NG"
  },
  {
    "abbreviation": "EK",
    "name": "Ekiti",
    "iso_3166": "NG-EK",
    "country": "NG"
  },
  {
    "abbreviation": "EN",
    "name": "Enugu",
    "iso_3166": "NG-EN",
    "country": "NG"
  },
  {
    "abbreviation": "GO",
    "name": "Gombe",
    "iso_3166": "NG-GO",
    "country": "NG"
  },
  {
    "abbreviation": "IM",
    "name": "Imo",
    "iso_3166": "NG-IM",
    "country": "NG"
  },
  {
    "abbreviation": "JI",
    "name": "Jigawa",
    "iso_3166": "NG-JI",
    "country": "NG"
  },
  {
    "abbreviation": "KD",
    "name": "Kaduna",
    "iso_3166": "NG-KD",
    "country": "NG"
  },
  {
    "abbreviation": "KN",
    "name": "Kano",
    "iso_3166": "NG-KN",
    "country": "NG"
  },
  {
    "abbreviation": "KT",
    "name": "Katsina",
    "iso_3166": "NG-KT",
    "country": "NG"
  },
  {
    "abbreviation": "KE",
    "name": "Kebbi",
    "iso_3166": "NG-KE",
    "country": "NG"
  },
  {
    "abbreviation": "KO",
    "name": "Kogi",
    "iso_3166": "NG-KO",
    "country": "NG"
  },
  {
    "abbreviation": "KW",
    "name": "Kwara",
    "iso_3166": "NG-KW",
    "country": "NG"
  },
  {
    "abbreviation": "LA",
    "name": "Lagos",
    "iso_3166": "NG-LA",
    "country": "NG"
  },
  {
    "abbreviation": "NA",
    "name": "Nasarawa",
    "iso_3166": "NG-NA",
    "country": "NG"
  },
  {
    "abbreviation": "NI",
    "name": "Niger",
    "iso_3166": "NG-NI",
    "country": "NG"
  },
  {
    "abbreviation": "OG",
    "name": "Ogun",
    "iso_3166": "NG-OG",
    "country": "NG"
  },
  {
    "abbreviation": "ON",
    "name": "Ondo",
    "iso_3166": "NG-ON",
    "country": "NG"
  },
  {
    "abbreviation": "OS",
    "name": "Osun",
    "iso_3166": "NG-OS",
    "country": "NG"
  },
  {
    "abbreviation": "OY",
    "name": "Oyo",
    "iso_3166": "NG-OY",
    "country": "NG"
  },
  {
    "abbreviation": "PL",
    "name": "Plateau",
    "iso_3166": "NG-PL",
    "country": "NG"
  },
  {
    "abbreviation": "RI",
    "name": "Rivers",
    "iso_3166": "NG-RI",
    "country": "NG"
  },
  {
    "abbreviation": "SO",
    "name": "Sokoto",
    "iso_3166": "NG-SO",
    "country": "NG"
  },
  {
    "abbreviation": "TA",
    "name": "Taraba",
    "iso_3166": "NG-TA",
    "country": "NG"
  },
  {
    "abbreviation": "YO",
    "name": "Yobe",
    "iso_3166": "NG-YO",
    "country": "NG"
  },
  {
    "abbreviation": "ZA",
    "name": "Zamfara",
    "iso_3166": "NG-ZA",
    "country": "NG"
  },
  {
    "abbreviation": "-",
    "name": "Niue",
    "iso_3166": "-",
    "country": "NU"
  },
  {
    "abbreviation": "-",
    "name": "Norfolk Island",
    "iso_3166": "-",
    "country": "NF"
  },
  {
    "abbreviation": "01",
    "name": "P'yongyang",
    "iso_3166": "KP-01",
    "country": "KP"
  },
  {
    "abbreviation": "-",
    "name": "Northern Mariana Islands",
    "iso_3166": "-",
    "country": "MP"
  },
  {
    "abbreviation": "42",
    "name": "Agder",
    "iso_3166": "NO-42",
    "country": "NO"
  },
  {
    "abbreviation": "34",
    "name": "Innlandet",
    "iso_3166": "NO-34",
    "country": "NO"
  },
  {
    "abbreviation": "15",
    "name": "More og Romsdal",
    "iso_3166": "NO-15",
    "country": "NO"
  },
  {
    "abbreviation": "18",
    "name": "Nordland",
    "iso_3166": "NO-18",
    "country": "NO"
  },
  {
    "abbreviation": "03",
    "name": "Oslo",
    "iso_3166": "NO-03",
    "country": "NO"
  },
  {
    "abbreviation": "11",
    "name": "Rogaland",
    "iso_3166": "NO-11",
    "country": "NO"
  },
  {
    "abbreviation": "54",
    "name": "Troms og Finnmark",
    "iso_3166": "NO-54",
    "country": "NO"
  },
  {
    "abbreviation": "50",
    "name": "Trondelag",
    "iso_3166": "NO-50",
    "country": "NO"
  },
  {
    "abbreviation": "38",
    "name": "Vestfold og Telemark",
    "iso_3166": "NO-38",
    "country": "NO"
  },
  {
    "abbreviation": "46",
    "name": "Vestland",
    "iso_3166": "NO-46",
    "country": "NO"
  },
  {
    "abbreviation": "30",
    "name": "Viken",
    "iso_3166": "NO-30",
    "country": "NO"
  },
  {
    "abbreviation": "DA",
    "name": "Ad Dakhiliyah",
    "iso_3166": "OM-DA",
    "country": "OM"
  },
  {
    "abbreviation": "BU",
    "name": "Al Buraymi",
    "iso_3166": "OM-BU",
    "country": "OM"
  },
  {
    "abbreviation": "WU",
    "name": "Al Wusta",
    "iso_3166": "OM-WU",
    "country": "OM"
  },
  {
    "abbreviation": "ZA",
    "name": "Az Zahirah",
    "iso_3166": "OM-ZA",
    "country": "OM"
  },
  {
    "abbreviation": "BJ",
    "name": "Janub al Batinah",
    "iso_3166": "OM-BJ",
    "country": "OM"
  },
  {
    "abbreviation": "SJ",
    "name": "Janub ash Sharqiyah",
    "iso_3166": "OM-SJ",
    "country": "OM"
  },
  {
    "abbreviation": "MA",
    "name": "Masqat",
    "iso_3166": "OM-MA",
    "country": "OM"
  },
  {
    "abbreviation": "MU",
    "name": "Musandam",
    "iso_3166": "OM-MU",
    "country": "OM"
  },
  {
    "abbreviation": "BS",
    "name": "Shamal al Batinah",
    "iso_3166": "OM-BS",
    "country": "OM"
  },
  {
    "abbreviation": "SS",
    "name": "Shamal ash Sharqiyah",
    "iso_3166": "OM-SS",
    "country": "OM"
  },
  {
    "abbreviation": "ZU",
    "name": "Zufar",
    "iso_3166": "OM-ZU",
    "country": "OM"
  },
  {
    "abbreviation": "JK",
    "name": "Azad Jammu and Kashmir",
    "iso_3166": "PK-JK",
    "country": "PK"
  },
  {
    "abbreviation": "BA",
    "name": "Balochistan",
    "iso_3166": "PK-BA",
    "country": "PK"
  },
  {
    "abbreviation": "GB",
    "name": "Gilgit-Baltistan",
    "iso_3166": "PK-GB",
    "country": "PK"
  },
  {
    "abbreviation": "IS",
    "name": "Islamabad",
    "iso_3166": "PK-IS",
    "country": "PK"
  },
  {
    "abbreviation": "KP",
    "name": "Khyber Pakhtunkhwa",
    "iso_3166": "PK-KP",
    "country": "PK"
  },
  {
    "abbreviation": "PB",
    "name": "Punjab",
    "iso_3166": "PK-PB",
    "country": "PK"
  },
  {
    "abbreviation": "SD",
    "name": "Sindh",
    "iso_3166": "PK-SD",
    "country": "PK"
  },
  {
    "abbreviation": "004",
    "name": "Airai",
    "iso_3166": "PW-004",
    "country": "PW"
  },
  {
    "abbreviation": "150",
    "name": "Koror",
    "iso_3166": "PW-150",
    "country": "PW"
  },
  {
    "abbreviation": "212",
    "name": "Melekeok",
    "iso_3166": "PW-212",
    "country": "PW"
  },
  {
    "abbreviation": "BTH",
    "name": "Bethlehem",
    "iso_3166": "PS-BTH",
    "country": "PS"
  },
  {
    "abbreviation": "DEB",
    "name": "Deir El Balah",
    "iso_3166": "PS-DEB",
    "country": "PS"
  },
  {
    "abbreviation": "GZA",
    "name": "Gaza",
    "iso_3166": "PS-GZA",
    "country": "PS"
  },
  {
    "abbreviation": "HBN",
    "name": "Hebron",
    "iso_3166": "PS-HBN",
    "country": "PS"
  },
  {
    "abbreviation": "JEN",
    "name": "Jenin",
    "iso_3166": "PS-JEN",
    "country": "PS"
  },
  {
    "abbreviation": "JRH",
    "name": "Jericho and Al Aghwar",
    "iso_3166": "PS-JRH",
    "country": "PS"
  },
  {
    "abbreviation": "JEM",
    "name": "Jerusalem",
    "iso_3166": "PS-JEM",
    "country": "PS"
  },
  {
    "abbreviation": "KYS",
    "name": "Khan Yunis",
    "iso_3166": "PS-KYS",
    "country": "PS"
  },
  {
    "abbreviation": "NBS",
    "name": "Nablus",
    "iso_3166": "PS-NBS",
    "country": "PS"
  },
  {
    "abbreviation": "QQA",
    "name": "Qalqilya",
    "iso_3166": "PS-QQA",
    "country": "PS"
  },
  {
    "abbreviation": "RFH",
    "name": "Rafah",
    "iso_3166": "PS-RFH",
    "country": "PS"
  },
  {
    "abbreviation": "RBH",
    "name": "Ramallah",
    "iso_3166": "PS-RBH",
    "country": "PS"
  },
  {
    "abbreviation": "SLT",
    "name": "Salfit",
    "iso_3166": "PS-SLT",
    "country": "PS"
  },
  {
    "abbreviation": "TBS",
    "name": "Tubas",
    "iso_3166": "PS-TBS",
    "country": "PS"
  },
  {
    "abbreviation": "TKM",
    "name": "Tulkarm",
    "iso_3166": "PS-TKM",
    "country": "PS"
  },
  {
    "abbreviation": "1",
    "name": "Bocas del Toro",
    "iso_3166": "PA-1",
    "country": "PA"
  },
  {
    "abbreviation": "4",
    "name": "Chiriqui",
    "iso_3166": "PA-4",
    "country": "PA"
  },
  {
    "abbreviation": "2",
    "name": "Cocle",
    "iso_3166": "PA-2",
    "country": "PA"
  },
  {
    "abbreviation": "3",
    "name": "Colon",
    "iso_3166": "PA-3",
    "country": "PA"
  },
  {
    "abbreviation": "5",
    "name": "Darien",
    "iso_3166": "PA-5",
    "country": "PA"
  },
  {
    "abbreviation": "6",
    "name": "Herrera",
    "iso_3166": "PA-6",
    "country": "PA"
  },
  {
    "abbreviation": "7",
    "name": "Los Santos",
    "iso_3166": "PA-7",
    "country": "PA"
  },
  {
    "abbreviation": "NB",
    "name": "Ngobe-Bugle",
    "iso_3166": "PA-NB",
    "country": "PA"
  },
  {
    "abbreviation": "8",
    "name": "Panama",
    "iso_3166": "PA-8",
    "country": "PA"
  },
  {
    "abbreviation": "9",
    "name": "Veraguas",
    "iso_3166": "PA-9",
    "country": "PA"
  },
  {
    "abbreviation": "NSB",
    "name": "Bougainville",
    "iso_3166": "PG-NSB",
    "country": "PG"
  },
  {
    "abbreviation": "CPM",
    "name": "Central",
    "iso_3166": "PG-CPM",
    "country": "PG"
  },
  {
    "abbreviation": "CPK",
    "name": "Chimbu",
    "iso_3166": "PG-CPK",
    "country": "PG"
  },
  {
    "abbreviation": "EBR",
    "name": "East New Britain",
    "iso_3166": "PG-EBR",
    "country": "PG"
  },
  {
    "abbreviation": "ESW",
    "name": "East Sepik",
    "iso_3166": "PG-ESW",
    "country": "PG"
  },
  {
    "abbreviation": "EHG",
    "name": "Eastern Highlands",
    "iso_3166": "PG-EHG",
    "country": "PG"
  },
  {
    "abbreviation": "MPM",
    "name": "Madang",
    "iso_3166": "PG-MPM",
    "country": "PG"
  },
  {
    "abbreviation": "MRL",
    "name": "Manus",
    "iso_3166": "PG-MRL",
    "country": "PG"
  },
  {
    "abbreviation": "MBA",
    "name": "Milne Bay",
    "iso_3166": "PG-MBA",
    "country": "PG"
  },
  {
    "abbreviation": "MPL",
    "name": "Morobe",
    "iso_3166": "PG-MPL",
    "country": "PG"
  },
  {
    "abbreviation": "NCD",
    "name": "National Capital District (Port Moresby)",
    "iso_3166": "PG-NCD",
    "country": "PG"
  },
  {
    "abbreviation": "NIK",
    "name": "New Ireland",
    "iso_3166": "PG-NIK",
    "country": "PG"
  },
  {
    "abbreviation": "SHM",
    "name": "Southern Highlands",
    "iso_3166": "PG-SHM",
    "country": "PG"
  },
  {
    "abbreviation": "WBK",
    "name": "West New Britain",
    "iso_3166": "PG-WBK",
    "country": "PG"
  },
  {
    "abbreviation": "SAN",
    "name": "West Sepik",
    "iso_3166": "PG-SAN",
    "country": "PG"
  },
  {
    "abbreviation": "WPD",
    "name": "Western",
    "iso_3166": "PG-WPD",
    "country": "PG"
  },
  {
    "abbreviation": "WHM",
    "name": "Western Highlands",
    "iso_3166": "PG-WHM",
    "country": "PG"
  },
  {
    "abbreviation": "10",
    "name": "Alto Parana",
    "iso_3166": "PY-10",
    "country": "PY"
  },
  {
    "abbreviation": "13",
    "name": "Amambay",
    "iso_3166": "PY-13",
    "country": "PY"
  },
  {
    "abbreviation": "ASU",
    "name": "Asuncion",
    "iso_3166": "PY-ASU",
    "country": "PY"
  },
  {
    "abbreviation": "19",
    "name": "Boqueron",
    "iso_3166": "PY-19",
    "country": "PY"
  },
  {
    "abbreviation": "5",
    "name": "Caaguazu",
    "iso_3166": "PY-5",
    "country": "PY"
  },
  {
    "abbreviation": "6",
    "name": "Caazapa",
    "iso_3166": "PY-6",
    "country": "PY"
  },
  {
    "abbreviation": "14",
    "name": "Canindeyu",
    "iso_3166": "PY-14",
    "country": "PY"
  },
  {
    "abbreviation": "11",
    "name": "Central",
    "iso_3166": "PY-11",
    "country": "PY"
  },
  {
    "abbreviation": "1",
    "name": "Concepcion",
    "iso_3166": "PY-1",
    "country": "PY"
  },
  {
    "abbreviation": "3",
    "name": "Cordillera",
    "iso_3166": "PY-3",
    "country": "PY"
  },
  {
    "abbreviation": "4",
    "name": "Guaira",
    "iso_3166": "PY-4",
    "country": "PY"
  },
  {
    "abbreviation": "7",
    "name": "Itapua",
    "iso_3166": "PY-7",
    "country": "PY"
  },
  {
    "abbreviation": "8",
    "name": "Misiones",
    "iso_3166": "PY-8",
    "country": "PY"
  },
  {
    "abbreviation": "12",
    "name": "Neembucu",
    "iso_3166": "PY-12",
    "country": "PY"
  },
  {
    "abbreviation": "9",
    "name": "Paraguari",
    "iso_3166": "PY-9",
    "country": "PY"
  },
  {
    "abbreviation": "15",
    "name": "Presidente Hayes",
    "iso_3166": "PY-15",
    "country": "PY"
  },
  {
    "abbreviation": "2",
    "name": "San Pedro",
    "iso_3166": "PY-2",
    "country": "PY"
  },
  {
    "abbreviation": "AMA",
    "name": "Amazonas",
    "iso_3166": "PE-AMA",
    "country": "PE"
  },
  {
    "abbreviation": "ANC",
    "name": "Ancash",
    "iso_3166": "PE-ANC",
    "country": "PE"
  },
  {
    "abbreviation": "APU",
    "name": "Apurimac",
    "iso_3166": "PE-APU",
    "country": "PE"
  },
  {
    "abbreviation": "ARE",
    "name": "Arequipa",
    "iso_3166": "PE-ARE",
    "country": "PE"
  },
  {
    "abbreviation": "AYA",
    "name": "Ayacucho",
    "iso_3166": "PE-AYA",
    "country": "PE"
  },
  {
    "abbreviation": "CAJ",
    "name": "Cajamarca",
    "iso_3166": "PE-CAJ",
    "country": "PE"
  },
  {
    "abbreviation": "CUS",
    "name": "Cusco",
    "iso_3166": "PE-CUS",
    "country": "PE"
  },
  {
    "abbreviation": "CAL",
    "name": "El Callao",
    "iso_3166": "PE-CAL",
    "country": "PE"
  },
  {
    "abbreviation": "HUV",
    "name": "Huancavelica",
    "iso_3166": "PE-HUV",
    "country": "PE"
  },
  {
    "abbreviation": "HUC",
    "name": "Huanuco",
    "iso_3166": "PE-HUC",
    "country": "PE"
  },
  {
    "abbreviation": "ICA",
    "name": "Ica",
    "iso_3166": "PE-ICA",
    "country": "PE"
  },
  {
    "abbreviation": "JUN",
    "name": "Junin",
    "iso_3166": "PE-JUN",
    "country": "PE"
  },
  {
    "abbreviation": "LAL",
    "name": "La Libertad",
    "iso_3166": "PE-LAL",
    "country": "PE"
  },
  {
    "abbreviation": "LAM",
    "name": "Lambayeque",
    "iso_3166": "PE-LAM",
    "country": "PE"
  },
  {
    "abbreviation": "LIM",
    "name": "Lima",
    "iso_3166": "PE-LIM",
    "country": "PE"
  },
  {
    "abbreviation": "LOR",
    "name": "Loreto",
    "iso_3166": "PE-LOR",
    "country": "PE"
  },
  {
    "abbreviation": "MDD",
    "name": "Madre de Dios",
    "iso_3166": "PE-MDD",
    "country": "PE"
  },
  {
    "abbreviation": "MOQ",
    "name": "Moquegua",
    "iso_3166": "PE-MOQ",
    "country": "PE"
  },
  {
    "abbreviation": "PAS",
    "name": "Pasco",
    "iso_3166": "PE-PAS",
    "country": "PE"
  },
  {
    "abbreviation": "PIU",
    "name": "Piura",
    "iso_3166": "PE-PIU",
    "country": "PE"
  },
  {
    "abbreviation": "PUN",
    "name": "Puno",
    "iso_3166": "PE-PUN",
    "country": "PE"
  },
  {
    "abbreviation": "SAM",
    "name": "San Martin",
    "iso_3166": "PE-SAM",
    "country": "PE"
  },
  {
    "abbreviation": "TAC",
    "name": "Tacna",
    "iso_3166": "PE-TAC",
    "country": "PE"
  },
  {
    "abbreviation": "TUM",
    "name": "Tumbes",
    "iso_3166": "PE-TUM",
    "country": "PE"
  },
  {
    "abbreviation": "UCA",
    "name": "Ucayali",
    "iso_3166": "PE-UCA",
    "country": "PE"
  },
  {
    "abbreviation": "ABR",
    "name": "Abra",
    "iso_3166": "PH-ABR",
    "country": "PH"
  },
  {
    "abbreviation": "AGN",
    "name": "Agusan del Norte",
    "iso_3166": "PH-AGN",
    "country": "PH"
  },
  {
    "abbreviation": "AGS",
    "name": "Agusan del Sur",
    "iso_3166": "PH-AGS",
    "country": "PH"
  },
  {
    "abbreviation": "AKL",
    "name": "Aklan",
    "iso_3166": "PH-AKL",
    "country": "PH"
  },
  {
    "abbreviation": "ALB",
    "name": "Albay",
    "iso_3166": "PH-ALB",
    "country": "PH"
  },
  {
    "abbreviation": "ANT",
    "name": "Antique",
    "iso_3166": "PH-ANT",
    "country": "PH"
  },
  {
    "abbreviation": "APA",
    "name": "Apayao",
    "iso_3166": "PH-APA",
    "country": "PH"
  },
  {
    "abbreviation": "AUR",
    "name": "Aurora",
    "iso_3166": "PH-AUR",
    "country": "PH"
  },
  {
    "abbreviation": "BAS",
    "name": "Basilan",
    "iso_3166": "PH-BAS",
    "country": "PH"
  },
  {
    "abbreviation": "BAN",
    "name": "Bataan",
    "iso_3166": "PH-BAN",
    "country": "PH"
  },
  {
    "abbreviation": "BTN",
    "name": "Batanes",
    "iso_3166": "PH-BTN",
    "country": "PH"
  },
  {
    "abbreviation": "BTG",
    "name": "Batangas",
    "iso_3166": "PH-BTG",
    "country": "PH"
  },
  {
    "abbreviation": "BEN",
    "name": "Benguet",
    "iso_3166": "PH-BEN",
    "country": "PH"
  },
  {
    "abbreviation": "BIL",
    "name": "Biliran",
    "iso_3166": "PH-BIL",
    "country": "PH"
  },
  {
    "abbreviation": "BOH",
    "name": "Bohol",
    "iso_3166": "PH-BOH",
    "country": "PH"
  },
  {
    "abbreviation": "BUK",
    "name": "Bukidnon",
    "iso_3166": "PH-BUK",
    "country": "PH"
  },
  {
    "abbreviation": "BUL",
    "name": "Bulacan",
    "iso_3166": "PH-BUL",
    "country": "PH"
  },
  {
    "abbreviation": "CAG",
    "name": "Cagayan",
    "iso_3166": "PH-CAG",
    "country": "PH"
  },
  {
    "abbreviation": "CAN",
    "name": "Camarines Norte",
    "iso_3166": "PH-CAN",
    "country": "PH"
  },
  {
    "abbreviation": "CAS",
    "name": "Camarines Sur",
    "iso_3166": "PH-CAS",
    "country": "PH"
  },
  {
    "abbreviation": "CAM",
    "name": "Camiguin",
    "iso_3166": "PH-CAM",
    "country": "PH"
  },
  {
    "abbreviation": "CAP",
    "name": "Capiz",
    "iso_3166": "PH-CAP",
    "country": "PH"
  },
  {
    "abbreviation": "CAT",
    "name": "Catanduanes",
    "iso_3166": "PH-CAT",
    "country": "PH"
  },
  {
    "abbreviation": "CAV",
    "name": "Cavite",
    "iso_3166": "PH-CAV",
    "country": "PH"
  },
  {
    "abbreviation": "CEB",
    "name": "Cebu",
    "iso_3166": "PH-CEB",
    "country": "PH"
  },
  {
    "abbreviation": "NCO",
    "name": "Cotabato",
    "iso_3166": "PH-NCO",
    "country": "PH"
  },
  {
    "abbreviation": "DAO",
    "name": "Davao Oriental",
    "iso_3166": "PH-DAO",
    "country": "PH"
  },
  {
    "abbreviation": "COM",
    "name": "Davao de Oro",
    "iso_3166": "PH-COM",
    "country": "PH"
  },
  {
    "abbreviation": "DAV",
    "name": "Davao del Norte",
    "iso_3166": "PH-DAV",
    "country": "PH"
  },
  {
    "abbreviation": "DAS",
    "name": "Davao del Sur",
    "iso_3166": "PH-DAS",
    "country": "PH"
  },
  {
    "abbreviation": "DIN",
    "name": "Dinagat Islands",
    "iso_3166": "PH-DIN",
    "country": "PH"
  },
  {
    "abbreviation": "EAS",
    "name": "Eastern Samar",
    "iso_3166": "PH-EAS",
    "country": "PH"
  },
  {
    "abbreviation": "GUI",
    "name": "Guimaras",
    "iso_3166": "PH-GUI",
    "country": "PH"
  },
  {
    "abbreviation": "IFU",
    "name": "Ifugao",
    "iso_3166": "PH-IFU",
    "country": "PH"
  },
  {
    "abbreviation": "ILN",
    "name": "Ilocos Norte",
    "iso_3166": "PH-ILN",
    "country": "PH"
  },
  {
    "abbreviation": "ILS",
    "name": "Ilocos Sur",
    "iso_3166": "PH-ILS",
    "country": "PH"
  },
  {
    "abbreviation": "ILI",
    "name": "Iloilo",
    "iso_3166": "PH-ILI",
    "country": "PH"
  },
  {
    "abbreviation": "ISA",
    "name": "Isabela",
    "iso_3166": "PH-ISA",
    "country": "PH"
  },
  {
    "abbreviation": "KAL",
    "name": "Kalinga",
    "iso_3166": "PH-KAL",
    "country": "PH"
  },
  {
    "abbreviation": "LUN",
    "name": "La Union",
    "iso_3166": "PH-LUN",
    "country": "PH"
  },
  {
    "abbreviation": "LAG",
    "name": "Laguna",
    "iso_3166": "PH-LAG",
    "country": "PH"
  },
  {
    "abbreviation": "LAN",
    "name": "Lanao del Norte",
    "iso_3166": "PH-LAN",
    "country": "PH"
  },
  {
    "abbreviation": "LAS",
    "name": "Lanao del Sur",
    "iso_3166": "PH-LAS",
    "country": "PH"
  },
  {
    "abbreviation": "LEY",
    "name": "Leyte",
    "iso_3166": "PH-LEY",
    "country": "PH"
  },
  {
    "abbreviation": "MAG",
    "name": "Maguindanao",
    "iso_3166": "PH-MAG",
    "country": "PH"
  },
  {
    "abbreviation": "MAD",
    "name": "Marinduque",
    "iso_3166": "PH-MAD",
    "country": "PH"
  },
  {
    "abbreviation": "MAS",
    "name": "Masbate",
    "iso_3166": "PH-MAS",
    "country": "PH"
  },
  {
    "abbreviation": "MDC",
    "name": "Mindoro Occidental",
    "iso_3166": "PH-MDC",
    "country": "PH"
  },
  {
    "abbreviation": "MDR",
    "name": "Mindoro Oriental",
    "iso_3166": "PH-MDR",
    "country": "PH"
  },
  {
    "abbreviation": "MSC",
    "name": "Misamis Occidental",
    "iso_3166": "PH-MSC",
    "country": "PH"
  },
  {
    "abbreviation": "MSR",
    "name": "Misamis Oriental",
    "iso_3166": "PH-MSR",
    "country": "PH"
  },
  {
    "abbreviation": "MOU",
    "name": "Mountain Province",
    "iso_3166": "PH-MOU",
    "country": "PH"
  },
  {
    "abbreviation": "00",
    "name": "National Capital Region",
    "iso_3166": "PH-00",
    "country": "PH"
  },
  {
    "abbreviation": "NEC",
    "name": "Negros Occidental",
    "iso_3166": "PH-NEC",
    "country": "PH"
  },
  {
    "abbreviation": "NER",
    "name": "Negros Oriental",
    "iso_3166": "PH-NER",
    "country": "PH"
  },
  {
    "abbreviation": "NSA",
    "name": "Northern Samar",
    "iso_3166": "PH-NSA",
    "country": "PH"
  },
  {
    "abbreviation": "NUE",
    "name": "Nueva Ecija",
    "iso_3166": "PH-NUE",
    "country": "PH"
  },
  {
    "abbreviation": "NUV",
    "name": "Nueva Vizcaya",
    "iso_3166": "PH-NUV",
    "country": "PH"
  },
  {
    "abbreviation": "PLW",
    "name": "Palawan",
    "iso_3166": "PH-PLW",
    "country": "PH"
  },
  {
    "abbreviation": "PAM",
    "name": "Pampanga",
    "iso_3166": "PH-PAM",
    "country": "PH"
  },
  {
    "abbreviation": "PAN",
    "name": "Pangasinan",
    "iso_3166": "PH-PAN",
    "country": "PH"
  },
  {
    "abbreviation": "QUE",
    "name": "Quezon",
    "iso_3166": "PH-QUE",
    "country": "PH"
  },
  {
    "abbreviation": "QUI",
    "name": "Quirino",
    "iso_3166": "PH-QUI",
    "country": "PH"
  },
  {
    "abbreviation": "RIZ",
    "name": "Rizal",
    "iso_3166": "PH-RIZ",
    "country": "PH"
  },
  {
    "abbreviation": "ROM",
    "name": "Romblon",
    "iso_3166": "PH-ROM",
    "country": "PH"
  },
  {
    "abbreviation": "WSA",
    "name": "Samar",
    "iso_3166": "PH-WSA",
    "country": "PH"
  },
  {
    "abbreviation": "SAR",
    "name": "Sarangani",
    "iso_3166": "PH-SAR",
    "country": "PH"
  },
  {
    "abbreviation": "SIG",
    "name": "Siquijor",
    "iso_3166": "PH-SIG",
    "country": "PH"
  },
  {
    "abbreviation": "SOR",
    "name": "Sorsogon",
    "iso_3166": "PH-SOR",
    "country": "PH"
  },
  {
    "abbreviation": "SCO",
    "name": "South Cotabato",
    "iso_3166": "PH-SCO",
    "country": "PH"
  },
  {
    "abbreviation": "SLE",
    "name": "Southern Leyte",
    "iso_3166": "PH-SLE",
    "country": "PH"
  },
  {
    "abbreviation": "SUK",
    "name": "Sultan Kudarat",
    "iso_3166": "PH-SUK",
    "country": "PH"
  },
  {
    "abbreviation": "SLU",
    "name": "Sulu",
    "iso_3166": "PH-SLU",
    "country": "PH"
  },
  {
    "abbreviation": "SUN",
    "name": "Surigao del Norte",
    "iso_3166": "PH-SUN",
    "country": "PH"
  },
  {
    "abbreviation": "SUR",
    "name": "Surigao del Sur",
    "iso_3166": "PH-SUR",
    "country": "PH"
  },
  {
    "abbreviation": "TAR",
    "name": "Tarlac",
    "iso_3166": "PH-TAR",
    "country": "PH"
  },
  {
    "abbreviation": "TAW",
    "name": "Tawi-Tawi",
    "iso_3166": "PH-TAW",
    "country": "PH"
  },
  {
    "abbreviation": "ZMB",
    "name": "Zambales",
    "iso_3166": "PH-ZMB",
    "country": "PH"
  },
  {
    "abbreviation": "ZSI",
    "name": "Zamboanga Sibugay",
    "iso_3166": "PH-ZSI",
    "country": "PH"
  },
  {
    "abbreviation": "ZAN",
    "name": "Zamboanga del Norte",
    "iso_3166": "PH-ZAN",
    "country": "PH"
  },
  {
    "abbreviation": "ZAS",
    "name": "Zamboanga del Sur",
    "iso_3166": "PH-ZAS",
    "country": "PH"
  },
  {
    "abbreviation": "-",
    "name": "Pitcairn",
    "iso_3166": "-",
    "country": "PN"
  },
  {
    "abbreviation": "02",
    "name": "Dolnoslaskie",
    "iso_3166": "PL-02",
    "country": "PL"
  },
  {
    "abbreviation": "04",
    "name": "Kujawsko-pomorskie",
    "iso_3166": "PL-04",
    "country": "PL"
  },
  {
    "abbreviation": "10",
    "name": "Lodzkie",
    "iso_3166": "PL-10",
    "country": "PL"
  },
  {
    "abbreviation": "06",
    "name": "Lubelskie",
    "iso_3166": "PL-06",
    "country": "PL"
  },
  {
    "abbreviation": "08",
    "name": "Lubuskie",
    "iso_3166": "PL-08",
    "country": "PL"
  },
  {
    "abbreviation": "12",
    "name": "Malopolskie",
    "iso_3166": "PL-12",
    "country": "PL"
  },
  {
    "abbreviation": "14",
    "name": "Mazowieckie",
    "iso_3166": "PL-14",
    "country": "PL"
  },
  {
    "abbreviation": "16",
    "name": "Opolskie",
    "iso_3166": "PL-16",
    "country": "PL"
  },
  {
    "abbreviation": "18",
    "name": "Podkarpackie",
    "iso_3166": "PL-18",
    "country": "PL"
  },
  {
    "abbreviation": "20",
    "name": "Podlaskie",
    "iso_3166": "PL-20",
    "country": "PL"
  },
  {
    "abbreviation": "22",
    "name": "Pomorskie",
    "iso_3166": "PL-22",
    "country": "PL"
  },
  {
    "abbreviation": "24",
    "name": "Slaskie",
    "iso_3166": "PL-24",
    "country": "PL"
  },
  {
    "abbreviation": "26",
    "name": "Swietokrzyskie",
    "iso_3166": "PL-26",
    "country": "PL"
  },
  {
    "abbreviation": "28",
    "name": "Warminsko-mazurskie",
    "iso_3166": "PL-28",
    "country": "PL"
  },
  {
    "abbreviation": "30",
    "name": "Wielkopolskie",
    "iso_3166": "PL-30",
    "country": "PL"
  },
  {
    "abbreviation": "32",
    "name": "Zachodniopomorskie",
    "iso_3166": "PL-32",
    "country": "PL"
  },
  {
    "abbreviation": "01",
    "name": "Aveiro",
    "iso_3166": "PT-01",
    "country": "PT"
  },
  {
    "abbreviation": "02",
    "name": "Beja",
    "iso_3166": "PT-02",
    "country": "PT"
  },
  {
    "abbreviation": "03",
    "name": "Braga",
    "iso_3166": "PT-03",
    "country": "PT"
  },
  {
    "abbreviation": "04",
    "name": "Braganca",
    "iso_3166": "PT-04",
    "country": "PT"
  },
  {
    "abbreviation": "05",
    "name": "Castelo Branco",
    "iso_3166": "PT-05",
    "country": "PT"
  },
  {
    "abbreviation": "06",
    "name": "Coimbra",
    "iso_3166": "PT-06",
    "country": "PT"
  },
  {
    "abbreviation": "07",
    "name": "Evora",
    "iso_3166": "PT-07",
    "country": "PT"
  },
  {
    "abbreviation": "08",
    "name": "Faro",
    "iso_3166": "PT-08",
    "country": "PT"
  },
  {
    "abbreviation": "09",
    "name": "Guarda",
    "iso_3166": "PT-09",
    "country": "PT"
  },
  {
    "abbreviation": "10",
    "name": "Leiria",
    "iso_3166": "PT-10",
    "country": "PT"
  },
  {
    "abbreviation": "11",
    "name": "Lisboa",
    "iso_3166": "PT-11",
    "country": "PT"
  },
  {
    "abbreviation": "12",
    "name": "Portalegre",
    "iso_3166": "PT-12",
    "country": "PT"
  },
  {
    "abbreviation": "13",
    "name": "Porto",
    "iso_3166": "PT-13",
    "country": "PT"
  },
  {
    "abbreviation": "30",
    "name": "Regiao Autonoma da Madeira",
    "iso_3166": "PT-30",
    "country": "PT"
  },
  {
    "abbreviation": "20",
    "name": "Regiao Autonoma dos Acores",
    "iso_3166": "PT-20",
    "country": "PT"
  },
  {
    "abbreviation": "14",
    "name": "Santarem",
    "iso_3166": "PT-14",
    "country": "PT"
  },
  {
    "abbreviation": "15",
    "name": "Setubal",
    "iso_3166": "PT-15",
    "country": "PT"
  },
  {
    "abbreviation": "16",
    "name": "Viana do Castelo",
    "iso_3166": "PT-16",
    "country": "PT"
  },
  {
    "abbreviation": "17",
    "name": "Vila Real",
    "iso_3166": "PT-17",
    "country": "PT"
  },
  {
    "abbreviation": "18",
    "name": "Viseu",
    "iso_3166": "PT-18",
    "country": "PT"
  },
  {
    "abbreviation": "-",
    "name": "Adjuntas",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Aguada",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Aguadilla",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Aguas Buenas",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Aibonito",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Anasco",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Arecibo",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Arroyo",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Barceloneta",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Barranquitas",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Bayamon",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Cabo Rojo",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Caguas",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Camuy",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Canovanas",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Carolina",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Catano",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Cayey",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Ceiba",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Ciales",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Cidra",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Coamo",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Comerio",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Corozal",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Culebra",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Dorado",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Fajardo",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Florida",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Guanica",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Guayama",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Guayanilla",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Guaynabo",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Gurabo",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Hatillo",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Hormigueros",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Humacao",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Isabela",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Juana Diaz",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Lajas",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Lares",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Las Marias",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Las Piedras",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Loiza",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Luquillo",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Manati",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Maunabo",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Mayaguez",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Moca",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Morovis",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Municipio de Jayuya",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Municipio de Juncos",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Naguabo",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Naranjito",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Patillas",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Penuelas",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Ponce",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Quebradillas",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Rincon",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Rio Grande",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Sabana Grande",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Salinas",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "San German",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "San Juan",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "San Lorenzo",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "San Sebastian",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Santa Isabel Municipio",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Toa Alta",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Toa Baja",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Trujillo Alto",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Utuado",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Vega Alta",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Vega Baja",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Vieques",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Villalba",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Yabucoa",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "-",
    "name": "Yauco",
    "iso_3166": "-",
    "country": "PR"
  },
  {
    "abbreviation": "DA",
    "name": "Ad Dawhah",
    "iso_3166": "QA-DA",
    "country": "QA"
  },
  {
    "abbreviation": "KH",
    "name": "Al Khawr wa adh Dhakhirah",
    "iso_3166": "QA-KH",
    "country": "QA"
  },
  {
    "abbreviation": "WA",
    "name": "Al Wakrah",
    "iso_3166": "QA-WA",
    "country": "QA"
  },
  {
    "abbreviation": "RA",
    "name": "Ar Rayyan",
    "iso_3166": "QA-RA",
    "country": "QA"
  },
  {
    "abbreviation": "MS",
    "name": "Ash Shamal",
    "iso_3166": "QA-MS",
    "country": "QA"
  },
  {
    "abbreviation": "ZA",
    "name": "Az Za'ayin",
    "iso_3166": "QA-ZA",
    "country": "QA"
  },
  {
    "abbreviation": "US",
    "name": "Umm Salal",
    "iso_3166": "QA-US",
    "country": "QA"
  },
  {
    "abbreviation": "-",
    "name": "Reunion",
    "iso_3166": "-",
    "country": "RE"
  },
  {
    "abbreviation": "AB",
    "name": "Alba",
    "iso_3166": "RO-AB",
    "country": "RO"
  },
  {
    "abbreviation": "AR",
    "name": "Arad",
    "iso_3166": "RO-AR",
    "country": "RO"
  },
  {
    "abbreviation": "AG",
    "name": "Arges",
    "iso_3166": "RO-AG",
    "country": "RO"
  },
  {
    "abbreviation": "BC",
    "name": "Bacau",
    "iso_3166": "RO-BC",
    "country": "RO"
  },
  {
    "abbreviation": "BH",
    "name": "Bihor",
    "iso_3166": "RO-BH",
    "country": "RO"
  },
  {
    "abbreviation": "BN",
    "name": "Bistrita-Nasaud",
    "iso_3166": "RO-BN",
    "country": "RO"
  },
  {
    "abbreviation": "BT",
    "name": "Botosani",
    "iso_3166": "RO-BT",
    "country": "RO"
  },
  {
    "abbreviation": "BR",
    "name": "Braila",
    "iso_3166": "RO-BR",
    "country": "RO"
  },
  {
    "abbreviation": "BV",
    "name": "Brasov",
    "iso_3166": "RO-BV",
    "country": "RO"
  },
  {
    "abbreviation": "B",
    "name": "Bucuresti",
    "iso_3166": "RO-B",
    "country": "RO"
  },
  {
    "abbreviation": "BZ",
    "name": "Buzau",
    "iso_3166": "RO-BZ",
    "country": "RO"
  },
  {
    "abbreviation": "CL",
    "name": "Calarasi",
    "iso_3166": "RO-CL",
    "country": "RO"
  },
  {
    "abbreviation": "CS",
    "name": "Caras-Severin",
    "iso_3166": "RO-CS",
    "country": "RO"
  },
  {
    "abbreviation": "CJ",
    "name": "Cluj",
    "iso_3166": "RO-CJ",
    "country": "RO"
  },
  {
    "abbreviation": "CT",
    "name": "Constanta",
    "iso_3166": "RO-CT",
    "country": "RO"
  },
  {
    "abbreviation": "CV",
    "name": "Covasna",
    "iso_3166": "RO-CV",
    "country": "RO"
  },
  {
    "abbreviation": "DB",
    "name": "Dambovita",
    "iso_3166": "RO-DB",
    "country": "RO"
  },
  {
    "abbreviation": "DJ",
    "name": "Dolj",
    "iso_3166": "RO-DJ",
    "country": "RO"
  },
  {
    "abbreviation": "GL",
    "name": "Galati",
    "iso_3166": "RO-GL",
    "country": "RO"
  },
  {
    "abbreviation": "GR",
    "name": "Giurgiu",
    "iso_3166": "RO-GR",
    "country": "RO"
  },
  {
    "abbreviation": "GJ",
    "name": "Gorj",
    "iso_3166": "RO-GJ",
    "country": "RO"
  },
  {
    "abbreviation": "HR",
    "name": "Harghita",
    "iso_3166": "RO-HR",
    "country": "RO"
  },
  {
    "abbreviation": "HD",
    "name": "Hunedoara",
    "iso_3166": "RO-HD",
    "country": "RO"
  },
  {
    "abbreviation": "IL",
    "name": "Ialomita",
    "iso_3166": "RO-IL",
    "country": "RO"
  },
  {
    "abbreviation": "IS",
    "name": "Iasi",
    "iso_3166": "RO-IS",
    "country": "RO"
  },
  {
    "abbreviation": "IF",
    "name": "Ilfov",
    "iso_3166": "RO-IF",
    "country": "RO"
  },
  {
    "abbreviation": "MM",
    "name": "Maramures",
    "iso_3166": "RO-MM",
    "country": "RO"
  },
  {
    "abbreviation": "MH",
    "name": "Mehedinti",
    "iso_3166": "RO-MH",
    "country": "RO"
  },
  {
    "abbreviation": "MS",
    "name": "Mures",
    "iso_3166": "RO-MS",
    "country": "RO"
  },
  {
    "abbreviation": "NT",
    "name": "Neamt",
    "iso_3166": "RO-NT",
    "country": "RO"
  },
  {
    "abbreviation": "OT",
    "name": "Olt",
    "iso_3166": "RO-OT",
    "country": "RO"
  },
  {
    "abbreviation": "PH",
    "name": "Prahova",
    "iso_3166": "RO-PH",
    "country": "RO"
  },
  {
    "abbreviation": "SJ",
    "name": "Salaj",
    "iso_3166": "RO-SJ",
    "country": "RO"
  },
  {
    "abbreviation": "SM",
    "name": "Satu Mare",
    "iso_3166": "RO-SM",
    "country": "RO"
  },
  {
    "abbreviation": "SB",
    "name": "Sibiu",
    "iso_3166": "RO-SB",
    "country": "RO"
  },
  {
    "abbreviation": "SV",
    "name": "Suceava",
    "iso_3166": "RO-SV",
    "country": "RO"
  },
  {
    "abbreviation": "TR",
    "name": "Teleorman",
    "iso_3166": "RO-TR",
    "country": "RO"
  },
  {
    "abbreviation": "TM",
    "name": "Timis",
    "iso_3166": "RO-TM",
    "country": "RO"
  },
  {
    "abbreviation": "TL",
    "name": "Tulcea",
    "iso_3166": "RO-TL",
    "country": "RO"
  },
  {
    "abbreviation": "VL",
    "name": "Valcea",
    "iso_3166": "RO-VL",
    "country": "RO"
  },
  {
    "abbreviation": "VS",
    "name": "Vaslui",
    "iso_3166": "RO-VS",
    "country": "RO"
  },
  {
    "abbreviation": "VN",
    "name": "Vrancea",
    "iso_3166": "RO-VN",
    "country": "RO"
  },
  {
    "abbreviation": "AD",
    "name": "Adygeya, Respublika",
    "iso_3166": "RU-AD",
    "country": "RU"
  },
  {
    "abbreviation": "AL",
    "name": "Altay, Respublika",
    "iso_3166": "RU-AL",
    "country": "RU"
  },
  {
    "abbreviation": "ALT",
    "name": "Altayskiy kray",
    "iso_3166": "RU-ALT",
    "country": "RU"
  },
  {
    "abbreviation": "AMU",
    "name": "Amurskaya oblast'",
    "iso_3166": "RU-AMU",
    "country": "RU"
  },
  {
    "abbreviation": "ARK",
    "name": "Arkhangel'skaya oblast'",
    "iso_3166": "RU-ARK",
    "country": "RU"
  },
  {
    "abbreviation": "AST",
    "name": "Astrakhanskaya oblast'",
    "iso_3166": "RU-AST",
    "country": "RU"
  },
  {
    "abbreviation": "BA",
    "name": "Bashkortostan, Respublika",
    "iso_3166": "RU-BA",
    "country": "RU"
  },
  {
    "abbreviation": "BEL",
    "name": "Belgorodskaya oblast'",
    "iso_3166": "RU-BEL",
    "country": "RU"
  },
  {
    "abbreviation": "BRY",
    "name": "Bryanskaya oblast'",
    "iso_3166": "RU-BRY",
    "country": "RU"
  },
  {
    "abbreviation": "BU",
    "name": "Buryatiya, Respublika",
    "iso_3166": "RU-BU",
    "country": "RU"
  },
  {
    "abbreviation": "CE",
    "name": "Chechenskaya Respublika",
    "iso_3166": "RU-CE",
    "country": "RU"
  },
  {
    "abbreviation": "CHE",
    "name": "Chelyabinskaya oblast'",
    "iso_3166": "RU-CHE",
    "country": "RU"
  },
  {
    "abbreviation": "CHU",
    "name": "Chukotskiy avtonomnyy okrug",
    "iso_3166": "RU-CHU",
    "country": "RU"
  },
  {
    "abbreviation": "CU",
    "name": "Chuvashskaya Respublika",
    "iso_3166": "RU-CU",
    "country": "RU"
  },
  {
    "abbreviation": "DA",
    "name": "Dagestan, Respublika",
    "iso_3166": "RU-DA",
    "country": "RU"
  },
  {
    "abbreviation": "IN",
    "name": "Ingushetiya, Respublika",
    "iso_3166": "RU-IN",
    "country": "RU"
  },
  {
    "abbreviation": "IRK",
    "name": "Irkutskaya oblast'",
    "iso_3166": "RU-IRK",
    "country": "RU"
  },
  {
    "abbreviation": "IVA",
    "name": "Ivanovskaya oblast'",
    "iso_3166": "RU-IVA",
    "country": "RU"
  },
  {
    "abbreviation": "KB",
    "name": "Kabardino-Balkarskaya Respublika",
    "iso_3166": "RU-KB",
    "country": "RU"
  },
  {
    "abbreviation": "KGD",
    "name": "Kaliningradskaya oblast'",
    "iso_3166": "RU-KGD",
    "country": "RU"
  },
  {
    "abbreviation": "KL",
    "name": "Kalmykiya, Respublika",
    "iso_3166": "RU-KL",
    "country": "RU"
  },
  {
    "abbreviation": "KLU",
    "name": "Kaluzhskaya oblast'",
    "iso_3166": "RU-KLU",
    "country": "RU"
  },
  {
    "abbreviation": "KAM",
    "name": "Kamchatskiy kray",
    "iso_3166": "RU-KAM",
    "country": "RU"
  },
  {
    "abbreviation": "KC",
    "name": "Karachayevo-Cherkesskaya Respublika",
    "iso_3166": "RU-KC",
    "country": "RU"
  },
  {
    "abbreviation": "KR",
    "name": "Kareliya, Respublika",
    "iso_3166": "RU-KR",
    "country": "RU"
  },
  {
    "abbreviation": "KEM",
    "name": "Kemerovskaya oblast'",
    "iso_3166": "RU-KEM",
    "country": "RU"
  },
  {
    "abbreviation": "KHA",
    "name": "Khabarovskiy kray",
    "iso_3166": "RU-KHA",
    "country": "RU"
  },
  {
    "abbreviation": "KK",
    "name": "Khakasiya, Respublika",
    "iso_3166": "RU-KK",
    "country": "RU"
  },
  {
    "abbreviation": "KHM",
    "name": "Khanty-Mansiyskiy avtonomnyy okrug",
    "iso_3166": "RU-KHM",
    "country": "RU"
  },
  {
    "abbreviation": "KIR",
    "name": "Kirovskaya oblast'",
    "iso_3166": "RU-KIR",
    "country": "RU"
  },
  {
    "abbreviation": "KO",
    "name": "Komi, Respublika",
    "iso_3166": "RU-KO",
    "country": "RU"
  },
  {
    "abbreviation": "KOS",
    "name": "Kostromskaya oblast'",
    "iso_3166": "RU-KOS",
    "country": "RU"
  },
  {
    "abbreviation": "KDA",
    "name": "Krasnodarskiy kray",
    "iso_3166": "RU-KDA",
    "country": "RU"
  },
  {
    "abbreviation": "KYA",
    "name": "Krasnoyarskiy kray",
    "iso_3166": "RU-KYA",
    "country": "RU"
  },
  {
    "abbreviation": "KGN",
    "name": "Kurganskaya oblast'",
    "iso_3166": "RU-KGN",
    "country": "RU"
  },
  {
    "abbreviation": "KRS",
    "name": "Kurskaya oblast'",
    "iso_3166": "RU-KRS",
    "country": "RU"
  },
  {
    "abbreviation": "LEN",
    "name": "Leningradskaya oblast'",
    "iso_3166": "RU-LEN",
    "country": "RU"
  },
  {
    "abbreviation": "LIP",
    "name": "Lipetskaya oblast'",
    "iso_3166": "RU-LIP",
    "country": "RU"
  },
  {
    "abbreviation": "MAG",
    "name": "Magadanskaya oblast'",
    "iso_3166": "RU-MAG",
    "country": "RU"
  },
  {
    "abbreviation": "ME",
    "name": "Mariy El, Respublika",
    "iso_3166": "RU-ME",
    "country": "RU"
  },
  {
    "abbreviation": "MO",
    "name": "Mordoviya, Respublika",
    "iso_3166": "RU-MO",
    "country": "RU"
  },
  {
    "abbreviation": "MOS",
    "name": "Moskovskaya oblast'",
    "iso_3166": "RU-MOS",
    "country": "RU"
  },
  {
    "abbreviation": "MOW",
    "name": "Moskva",
    "iso_3166": "RU-MOW",
    "country": "RU"
  },
  {
    "abbreviation": "MUR",
    "name": "Murmanskaya oblast'",
    "iso_3166": "RU-MUR",
    "country": "RU"
  },
  {
    "abbreviation": "NEN",
    "name": "Nenetskiy avtonomnyy okrug",
    "iso_3166": "RU-NEN",
    "country": "RU"
  },
  {
    "abbreviation": "NIZ",
    "name": "Nizhegorodskaya oblast'",
    "iso_3166": "RU-NIZ",
    "country": "RU"
  },
  {
    "abbreviation": "NGR",
    "name": "Novgorodskaya oblast'",
    "iso_3166": "RU-NGR",
    "country": "RU"
  },
  {
    "abbreviation": "NVS",
    "name": "Novosibirskaya oblast'",
    "iso_3166": "RU-NVS",
    "country": "RU"
  },
  {
    "abbreviation": "OMS",
    "name": "Omskaya oblast'",
    "iso_3166": "RU-OMS",
    "country": "RU"
  },
  {
    "abbreviation": "ORE",
    "name": "Orenburgskaya oblast'",
    "iso_3166": "RU-ORE",
    "country": "RU"
  },
  {
    "abbreviation": "ORL",
    "name": "Orlovskaya oblast'",
    "iso_3166": "RU-ORL",
    "country": "RU"
  },
  {
    "abbreviation": "PNZ",
    "name": "Penzenskaya oblast'",
    "iso_3166": "RU-PNZ",
    "country": "RU"
  },
  {
    "abbreviation": "PER",
    "name": "Permskiy kray",
    "iso_3166": "RU-PER",
    "country": "RU"
  },
  {
    "abbreviation": "PRI",
    "name": "Primorskiy kray",
    "iso_3166": "RU-PRI",
    "country": "RU"
  },
  {
    "abbreviation": "PSK",
    "name": "Pskovskaya oblast'",
    "iso_3166": "RU-PSK",
    "country": "RU"
  },
  {
    "abbreviation": "ROS",
    "name": "Rostovskaya oblast'",
    "iso_3166": "RU-ROS",
    "country": "RU"
  },
  {
    "abbreviation": "RYA",
    "name": "Ryazanskaya oblast'",
    "iso_3166": "RU-RYA",
    "country": "RU"
  },
  {
    "abbreviation": "SA",
    "name": "Saha, Respublika",
    "iso_3166": "RU-SA",
    "country": "RU"
  },
  {
    "abbreviation": "SAK",
    "name": "Sakhalinskaya oblast'",
    "iso_3166": "RU-SAK",
    "country": "RU"
  },
  {
    "abbreviation": "SAM",
    "name": "Samarskaya oblast'",
    "iso_3166": "RU-SAM",
    "country": "RU"
  },
  {
    "abbreviation": "SPE",
    "name": "Sankt-Peterburg",
    "iso_3166": "RU-SPE",
    "country": "RU"
  },
  {
    "abbreviation": "SAR",
    "name": "Saratovskaya oblast'",
    "iso_3166": "RU-SAR",
    "country": "RU"
  },
  {
    "abbreviation": "SE",
    "name": "Severnaya Osetiya, Respublika",
    "iso_3166": "RU-SE",
    "country": "RU"
  },
  {
    "abbreviation": "SMO",
    "name": "Smolenskaya oblast'",
    "iso_3166": "RU-SMO",
    "country": "RU"
  },
  {
    "abbreviation": "STA",
    "name": "Stavropol'skiy kray",
    "iso_3166": "RU-STA",
    "country": "RU"
  },
  {
    "abbreviation": "SVE",
    "name": "Sverdlovskaya oblast'",
    "iso_3166": "RU-SVE",
    "country": "RU"
  },
  {
    "abbreviation": "TAM",
    "name": "Tambovskaya oblast'",
    "iso_3166": "RU-TAM",
    "country": "RU"
  },
  {
    "abbreviation": "TA",
    "name": "Tatarstan, Respublika",
    "iso_3166": "RU-TA",
    "country": "RU"
  },
  {
    "abbreviation": "TOM",
    "name": "Tomskaya oblast'",
    "iso_3166": "RU-TOM",
    "country": "RU"
  },
  {
    "abbreviation": "TUL",
    "name": "Tul'skaya oblast'",
    "iso_3166": "RU-TUL",
    "country": "RU"
  },
  {
    "abbreviation": "TVE",
    "name": "Tverskaya oblast'",
    "iso_3166": "RU-TVE",
    "country": "RU"
  },
  {
    "abbreviation": "TYU",
    "name": "Tyumenskaya oblast'",
    "iso_3166": "RU-TYU",
    "country": "RU"
  },
  {
    "abbreviation": "TY",
    "name": "Tyva, Respublika",
    "iso_3166": "RU-TY",
    "country": "RU"
  },
  {
    "abbreviation": "UD",
    "name": "Udmurtskaya Respublika",
    "iso_3166": "RU-UD",
    "country": "RU"
  },
  {
    "abbreviation": "ULY",
    "name": "Ul'yanovskaya oblast'",
    "iso_3166": "RU-ULY",
    "country": "RU"
  },
  {
    "abbreviation": "VLA",
    "name": "Vladimirskaya oblast'",
    "iso_3166": "RU-VLA",
    "country": "RU"
  },
  {
    "abbreviation": "VGG",
    "name": "Volgogradskaya oblast'",
    "iso_3166": "RU-VGG",
    "country": "RU"
  },
  {
    "abbreviation": "VLG",
    "name": "Vologodskaya oblast'",
    "iso_3166": "RU-VLG",
    "country": "RU"
  },
  {
    "abbreviation": "VOR",
    "name": "Voronezhskaya oblast'",
    "iso_3166": "RU-VOR",
    "country": "RU"
  },
  {
    "abbreviation": "YAN",
    "name": "Yamalo-Nenetskiy avtonomnyy okrug",
    "iso_3166": "RU-YAN",
    "country": "RU"
  },
  {
    "abbreviation": "YAR",
    "name": "Yaroslavskaya oblast'",
    "iso_3166": "RU-YAR",
    "country": "RU"
  },
  {
    "abbreviation": "YEV",
    "name": "Yevreyskaya avtonomnaya oblast'",
    "iso_3166": "RU-YEV",
    "country": "RU"
  },
  {
    "abbreviation": "ZAB",
    "name": "Zabaykal'skiy kray",
    "iso_3166": "RU-ZAB",
    "country": "RU"
  },
  {
    "abbreviation": "02",
    "name": "Est",
    "iso_3166": "RW-02",
    "country": "RW"
  },
  {
    "abbreviation": "03",
    "name": "Nord",
    "iso_3166": "RW-03",
    "country": "RW"
  },
  {
    "abbreviation": "04",
    "name": "Ouest",
    "iso_3166": "RW-04",
    "country": "RW"
  },
  {
    "abbreviation": "05",
    "name": "Sud",
    "iso_3166": "RW-05",
    "country": "RW"
  },
  {
    "abbreviation": "01",
    "name": "Ville de Kigali",
    "iso_3166": "RW-01",
    "country": "RW"
  },
  {
    "abbreviation": "-",
    "name": "Saint Barthelemy",
    "iso_3166": "-",
    "country": "BL"
  },
  {
    "abbreviation": "HL",
    "name": "Saint Helena",
    "iso_3166": "SH-HL",
    "country": "SH"
  },
  {
    "abbreviation": "01",
    "name": "Christ Church Nichola Town",
    "iso_3166": "KN-01",
    "country": "KN"
  },
  {
    "abbreviation": "02",
    "name": "Saint Anne Sandy Point",
    "iso_3166": "KN-02",
    "country": "KN"
  },
  {
    "abbreviation": "03",
    "name": "Saint George Basseterre",
    "iso_3166": "KN-03",
    "country": "KN"
  },
  {
    "abbreviation": "05",
    "name": "Saint James Windward",
    "iso_3166": "KN-05",
    "country": "KN"
  },
  {
    "abbreviation": "06",
    "name": "Saint John Capisterre",
    "iso_3166": "KN-06",
    "country": "KN"
  },
  {
    "abbreviation": "07",
    "name": "Saint John Figtree",
    "iso_3166": "KN-07",
    "country": "KN"
  },
  {
    "abbreviation": "08",
    "name": "Saint Mary Cayon",
    "iso_3166": "KN-08",
    "country": "KN"
  },
  {
    "abbreviation": "09",
    "name": "Saint Paul Capisterre",
    "iso_3166": "KN-09",
    "country": "KN"
  },
  {
    "abbreviation": "10",
    "name": "Saint Paul Charlestown",
    "iso_3166": "KN-10",
    "country": "KN"
  },
  {
    "abbreviation": "11",
    "name": "Saint Peter Basseterre",
    "iso_3166": "KN-11",
    "country": "KN"
  },
  {
    "abbreviation": "12",
    "name": "Saint Thomas Lowland",
    "iso_3166": "KN-12",
    "country": "KN"
  },
  {
    "abbreviation": "13",
    "name": "Saint Thomas Middle Island",
    "iso_3166": "KN-13",
    "country": "KN"
  },
  {
    "abbreviation": "15",
    "name": "Trinity Palmetto Point",
    "iso_3166": "KN-15",
    "country": "KN"
  },
  {
    "abbreviation": "01",
    "name": "Anse la Raye",
    "iso_3166": "LC-01",
    "country": "LC"
  },
  {
    "abbreviation": "02",
    "name": "Castries",
    "iso_3166": "LC-02",
    "country": "LC"
  },
  {
    "abbreviation": "03",
    "name": "Choiseul",
    "iso_3166": "LC-03",
    "country": "LC"
  },
  {
    "abbreviation": "05",
    "name": "Dennery",
    "iso_3166": "LC-05",
    "country": "LC"
  },
  {
    "abbreviation": "06",
    "name": "Gros Islet",
    "iso_3166": "LC-06",
    "country": "LC"
  },
  {
    "abbreviation": "07",
    "name": "Laborie",
    "iso_3166": "LC-07",
    "country": "LC"
  },
  {
    "abbreviation": "08",
    "name": "Micoud",
    "iso_3166": "LC-08",
    "country": "LC"
  },
  {
    "abbreviation": "10",
    "name": "Soufriere",
    "iso_3166": "LC-10",
    "country": "LC"
  },
  {
    "abbreviation": "11",
    "name": "Vieux Fort",
    "iso_3166": "LC-11",
    "country": "LC"
  },
  {
    "abbreviation": "-",
    "name": "Saint Martin (French Part)",
    "iso_3166": "-",
    "country": "MF"
  },
  {
    "abbreviation": "-",
    "name": "Saint Pierre and Miquelon",
    "iso_3166": "-",
    "country": "PM"
  },
  {
    "abbreviation": "01",
    "name": "Charlotte",
    "iso_3166": "VC-01",
    "country": "VC"
  },
  {
    "abbreviation": "06",
    "name": "Grenadines",
    "iso_3166": "VC-06",
    "country": "VC"
  },
  {
    "abbreviation": "04",
    "name": "Saint George",
    "iso_3166": "VC-04",
    "country": "VC"
  },
  {
    "abbreviation": "05",
    "name": "Saint Patrick",
    "iso_3166": "VC-05",
    "country": "VC"
  },
  {
    "abbreviation": "AT",
    "name": "Atua",
    "iso_3166": "WS-AT",
    "country": "WS"
  },
  {
    "abbreviation": "FA",
    "name": "Fa'asaleleaga",
    "iso_3166": "WS-FA",
    "country": "WS"
  },
  {
    "abbreviation": "GI",
    "name": "Gagaifomauga",
    "iso_3166": "WS-GI",
    "country": "WS"
  },
  {
    "abbreviation": "TU",
    "name": "Tuamasaga",
    "iso_3166": "WS-TU",
    "country": "WS"
  },
  {
    "abbreviation": "02",
    "name": "Chiesanuova",
    "iso_3166": "SM-02",
    "country": "SM"
  },
  {
    "abbreviation": "07",
    "name": "Citta di San Marino",
    "iso_3166": "SM-07",
    "country": "SM"
  },
  {
    "abbreviation": "04",
    "name": "Faetano",
    "iso_3166": "SM-04",
    "country": "SM"
  },
  {
    "abbreviation": "09",
    "name": "Serravalle",
    "iso_3166": "SM-09",
    "country": "SM"
  },
  {
    "abbreviation": "01",
    "name": "Agua Grande",
    "iso_3166": "ST-01",
    "country": "ST"
  },
  {
    "abbreviation": "14",
    "name": "'Asir",
    "iso_3166": "SA-14",
    "country": "SA"
  },
  {
    "abbreviation": "11",
    "name": "Al Bahah",
    "iso_3166": "SA-11",
    "country": "SA"
  },
  {
    "abbreviation": "08",
    "name": "Al Hudud ash Shamaliyah",
    "iso_3166": "SA-08",
    "country": "SA"
  },
  {
    "abbreviation": "12",
    "name": "Al Jawf",
    "iso_3166": "SA-12",
    "country": "SA"
  },
  {
    "abbreviation": "03",
    "name": "Al Madinah al Munawwarah",
    "iso_3166": "SA-03",
    "country": "SA"
  },
  {
    "abbreviation": "05",
    "name": "Al Qasim",
    "iso_3166": "SA-05",
    "country": "SA"
  },
  {
    "abbreviation": "01",
    "name": "Ar Riyad",
    "iso_3166": "SA-01",
    "country": "SA"
  },
  {
    "abbreviation": "04",
    "name": "Ash Sharqiyah",
    "iso_3166": "SA-04",
    "country": "SA"
  },
  {
    "abbreviation": "06",
    "name": "Ha'il",
    "iso_3166": "SA-06",
    "country": "SA"
  },
  {
    "abbreviation": "09",
    "name": "Jazan",
    "iso_3166": "SA-09",
    "country": "SA"
  },
  {
    "abbreviation": "02",
    "name": "Makkah al Mukarramah",
    "iso_3166": "SA-02",
    "country": "SA"
  },
  {
    "abbreviation": "10",
    "name": "Najran",
    "iso_3166": "SA-10",
    "country": "SA"
  },
  {
    "abbreviation": "07",
    "name": "Tabuk",
    "iso_3166": "SA-07",
    "country": "SA"
  },
  {
    "abbreviation": "DK",
    "name": "Dakar",
    "iso_3166": "SN-DK",
    "country": "SN"
  },
  {
    "abbreviation": "DB",
    "name": "Diourbel",
    "iso_3166": "SN-DB",
    "country": "SN"
  },
  {
    "abbreviation": "FK",
    "name": "Fatick",
    "iso_3166": "SN-FK",
    "country": "SN"
  },
  {
    "abbreviation": "KA",
    "name": "Kaffrine",
    "iso_3166": "SN-KA",
    "country": "SN"
  },
  {
    "abbreviation": "KL",
    "name": "Kaolack",
    "iso_3166": "SN-KL",
    "country": "SN"
  },
  {
    "abbreviation": "KE",
    "name": "Kedougou",
    "iso_3166": "SN-KE",
    "country": "SN"
  },
  {
    "abbreviation": "KD",
    "name": "Kolda",
    "iso_3166": "SN-KD",
    "country": "SN"
  },
  {
    "abbreviation": "LG",
    "name": "Louga",
    "iso_3166": "SN-LG",
    "country": "SN"
  },
  {
    "abbreviation": "MT",
    "name": "Matam",
    "iso_3166": "SN-MT",
    "country": "SN"
  },
  {
    "abbreviation": "SL",
    "name": "Saint-Louis",
    "iso_3166": "SN-SL",
    "country": "SN"
  },
  {
    "abbreviation": "SE",
    "name": "Sedhiou",
    "iso_3166": "SN-SE",
    "country": "SN"
  },
  {
    "abbreviation": "TC",
    "name": "Tambacounda",
    "iso_3166": "SN-TC",
    "country": "SN"
  },
  {
    "abbreviation": "TH",
    "name": "Thies",
    "iso_3166": "SN-TH",
    "country": "SN"
  },
  {
    "abbreviation": "ZG",
    "name": "Ziguinchor",
    "iso_3166": "SN-ZG",
    "country": "SN"
  },
  {
    "abbreviation": "00",
    "name": "Beograd",
    "iso_3166": "RS-00",
    "country": "RS"
  },
  {
    "abbreviation": "14",
    "name": "Borski okrug",
    "iso_3166": "RS-14",
    "country": "RS"
  },
  {
    "abbreviation": "11",
    "name": "Branicevski okrug",
    "iso_3166": "RS-11",
    "country": "RS"
  },
  {
    "abbreviation": "23",
    "name": "Jablanicki okrug",
    "iso_3166": "RS-23",
    "country": "RS"
  },
  {
    "abbreviation": "06",
    "name": "Juznobacki okrug",
    "iso_3166": "RS-06",
    "country": "RS"
  },
  {
    "abbreviation": "04",
    "name": "Juznobanatski okrug",
    "iso_3166": "RS-04",
    "country": "RS"
  },
  {
    "abbreviation": "09",
    "name": "Kolubarski okrug",
    "iso_3166": "RS-09",
    "country": "RS"
  },
  {
    "abbreviation": "28",
    "name": "Kosovsko-Mitrovacki okrug",
    "iso_3166": "RS-28",
    "country": "RS"
  },
  {
    "abbreviation": "08",
    "name": "Macvanski okrug",
    "iso_3166": "RS-08",
    "country": "RS"
  },
  {
    "abbreviation": "17",
    "name": "Moravicki okrug",
    "iso_3166": "RS-17",
    "country": "RS"
  },
  {
    "abbreviation": "20",
    "name": "Nisavski okrug",
    "iso_3166": "RS-20",
    "country": "RS"
  },
  {
    "abbreviation": "24",
    "name": "Pcinjski okrug",
    "iso_3166": "RS-24",
    "country": "RS"
  },
  {
    "abbreviation": "26",
    "name": "Pecki okrug",
    "iso_3166": "RS-26",
    "country": "RS"
  },
  {
    "abbreviation": "22",
    "name": "Pirotski okrug",
    "iso_3166": "RS-22",
    "country": "RS"
  },
  {
    "abbreviation": "10",
    "name": "Podunavski okrug",
    "iso_3166": "RS-10",
    "country": "RS"
  },
  {
    "abbreviation": "13",
    "name": "Pomoravski okrug",
    "iso_3166": "RS-13",
    "country": "RS"
  },
  {
    "abbreviation": "27",
    "name": "Prizrenski okrug",
    "iso_3166": "RS-27",
    "country": "RS"
  },
  {
    "abbreviation": "19",
    "name": "Rasinski okrug",
    "iso_3166": "RS-19",
    "country": "RS"
  },
  {
    "abbreviation": "18",
    "name": "Raski okrug",
    "iso_3166": "RS-18",
    "country": "RS"
  },
  {
    "abbreviation": "01",
    "name": "Severnobacki okrug",
    "iso_3166": "RS-01",
    "country": "RS"
  },
  {
    "abbreviation": "03",
    "name": "Severnobanatski okrug",
    "iso_3166": "RS-03",
    "country": "RS"
  },
  {
    "abbreviation": "02",
    "name": "Srednjebanatski okrug",
    "iso_3166": "RS-02",
    "country": "RS"
  },
  {
    "abbreviation": "07",
    "name": "Sremski okrug",
    "iso_3166": "RS-07",
    "country": "RS"
  },
  {
    "abbreviation": "12",
    "name": "Sumadijski okrug",
    "iso_3166": "RS-12",
    "country": "RS"
  },
  {
    "abbreviation": "21",
    "name": "Toplicki okrug",
    "iso_3166": "RS-21",
    "country": "RS"
  },
  {
    "abbreviation": "15",
    "name": "Zajecarski okrug",
    "iso_3166": "RS-15",
    "country": "RS"
  },
  {
    "abbreviation": "05",
    "name": "Zapadnobacki okrug",
    "iso_3166": "RS-05",
    "country": "RS"
  },
  {
    "abbreviation": "16",
    "name": "Zlatiborski okrug",
    "iso_3166": "RS-16",
    "country": "RS"
  },
  {
    "abbreviation": "02",
    "name": "Anse Boileau",
    "iso_3166": "SC-02",
    "country": "SC"
  },
  {
    "abbreviation": "05",
    "name": "Anse Royale",
    "iso_3166": "SC-05",
    "country": "SC"
  },
  {
    "abbreviation": "01",
    "name": "Anse aux Pins",
    "iso_3166": "SC-01",
    "country": "SC"
  },
  {
    "abbreviation": "06",
    "name": "Baie Lazare",
    "iso_3166": "SC-06",
    "country": "SC"
  },
  {
    "abbreviation": "07",
    "name": "Baie Sainte Anne",
    "iso_3166": "SC-07",
    "country": "SC"
  },
  {
    "abbreviation": "08",
    "name": "Beau Vallon",
    "iso_3166": "SC-08",
    "country": "SC"
  },
  {
    "abbreviation": "10",
    "name": "Bel Ombre",
    "iso_3166": "SC-10",
    "country": "SC"
  },
  {
    "abbreviation": "11",
    "name": "Cascade",
    "iso_3166": "SC-11",
    "country": "SC"
  },
  {
    "abbreviation": "16",
    "name": "English River",
    "iso_3166": "SC-16",
    "country": "SC"
  },
  {
    "abbreviation": "13",
    "name": "Grand Anse Mahe",
    "iso_3166": "SC-13",
    "country": "SC"
  },
  {
    "abbreviation": "14",
    "name": "Grand Anse Praslin",
    "iso_3166": "SC-14",
    "country": "SC"
  },
  {
    "abbreviation": "15",
    "name": "La Digue",
    "iso_3166": "SC-15",
    "country": "SC"
  },
  {
    "abbreviation": "20",
    "name": "Pointe Larue",
    "iso_3166": "SC-20",
    "country": "SC"
  },
  {
    "abbreviation": "23",
    "name": "Takamaka",
    "iso_3166": "SC-23",
    "country": "SC"
  },
  {
    "abbreviation": "E",
    "name": "Eastern",
    "iso_3166": "SL-E",
    "country": "SL"
  },
  {
    "abbreviation": "NW",
    "name": "North Western",
    "iso_3166": "SL-NW",
    "country": "SL"
  },
  {
    "abbreviation": "N",
    "name": "Northern",
    "iso_3166": "SL-N",
    "country": "SL"
  },
  {
    "abbreviation": "S",
    "name": "Southern",
    "iso_3166": "SL-S",
    "country": "SL"
  },
  {
    "abbreviation": "W",
    "name": "Western Area",
    "iso_3166": "SL-W",
    "country": "SL"
  },
  {
    "abbreviation": "-",
    "name": "Singapore",
    "iso_3166": "-",
    "country": "SG"
  },
  {
    "abbreviation": "-",
    "name": "Sint Maarten (Dutch Part)",
    "iso_3166": "-",
    "country": "SX"
  },
  {
    "abbreviation": "BC",
    "name": "Banskobystricky kraj",
    "iso_3166": "SK-BC",
    "country": "SK"
  },
  {
    "abbreviation": "BL",
    "name": "Bratislavsky kraj",
    "iso_3166": "SK-BL",
    "country": "SK"
  },
  {
    "abbreviation": "KI",
    "name": "Kosicky kraj",
    "iso_3166": "SK-KI",
    "country": "SK"
  },
  {
    "abbreviation": "NI",
    "name": "Nitriansky kraj",
    "iso_3166": "SK-NI",
    "country": "SK"
  },
  {
    "abbreviation": "PV",
    "name": "Presovsky kraj",
    "iso_3166": "SK-PV",
    "country": "SK"
  },
  {
    "abbreviation": "TC",
    "name": "Trenciansky kraj",
    "iso_3166": "SK-TC",
    "country": "SK"
  },
  {
    "abbreviation": "TA",
    "name": "Trnavsky kraj",
    "iso_3166": "SK-TA",
    "country": "SK"
  },
  {
    "abbreviation": "ZI",
    "name": "Zilinsky kraj",
    "iso_3166": "SK-ZI",
    "country": "SK"
  },
  {
    "abbreviation": "001",
    "name": "Ajdovscina",
    "iso_3166": "SI-001",
    "country": "SI"
  },
  {
    "abbreviation": "213",
    "name": "Ankaran",
    "iso_3166": "SI-213",
    "country": "SI"
  },
  {
    "abbreviation": "195",
    "name": "Apace",
    "iso_3166": "SI-195",
    "country": "SI"
  },
  {
    "abbreviation": "002",
    "name": "Beltinci",
    "iso_3166": "SI-002",
    "country": "SI"
  },
  {
    "abbreviation": "148",
    "name": "Benedikt",
    "iso_3166": "SI-148",
    "country": "SI"
  },
  {
    "abbreviation": "149",
    "name": "Bistrica ob Sotli",
    "iso_3166": "SI-149",
    "country": "SI"
  },
  {
    "abbreviation": "003",
    "name": "Bled",
    "iso_3166": "SI-003",
    "country": "SI"
  },
  {
    "abbreviation": "150",
    "name": "Bloke",
    "iso_3166": "SI-150",
    "country": "SI"
  },
  {
    "abbreviation": "004",
    "name": "Bohinj",
    "iso_3166": "SI-004",
    "country": "SI"
  },
  {
    "abbreviation": "005",
    "name": "Borovnica",
    "iso_3166": "SI-005",
    "country": "SI"
  },
  {
    "abbreviation": "006",
    "name": "Bovec",
    "iso_3166": "SI-006",
    "country": "SI"
  },
  {
    "abbreviation": "151",
    "name": "Braslovce",
    "iso_3166": "SI-151",
    "country": "SI"
  },
  {
    "abbreviation": "007",
    "name": "Brda",
    "iso_3166": "SI-007",
    "country": "SI"
  },
  {
    "abbreviation": "009",
    "name": "Brezice",
    "iso_3166": "SI-009",
    "country": "SI"
  },
  {
    "abbreviation": "008",
    "name": "Brezovica",
    "iso_3166": "SI-008",
    "country": "SI"
  },
  {
    "abbreviation": "152",
    "name": "Cankova",
    "iso_3166": "SI-152",
    "country": "SI"
  },
  {
    "abbreviation": "011",
    "name": "Celje",
    "iso_3166": "SI-011",
    "country": "SI"
  },
  {
    "abbreviation": "012",
    "name": "Cerklje na Gorenjskem",
    "iso_3166": "SI-012",
    "country": "SI"
  },
  {
    "abbreviation": "013",
    "name": "Cerknica",
    "iso_3166": "SI-013",
    "country": "SI"
  },
  {
    "abbreviation": "014",
    "name": "Cerkno",
    "iso_3166": "SI-014",
    "country": "SI"
  },
  {
    "abbreviation": "196",
    "name": "Cirkulane",
    "iso_3166": "SI-196",
    "country": "SI"
  },
  {
    "abbreviation": "015",
    "name": "Crensovci",
    "iso_3166": "SI-015",
    "country": "SI"
  },
  {
    "abbreviation": "017",
    "name": "Crnomelj",
    "iso_3166": "SI-017",
    "country": "SI"
  },
  {
    "abbreviation": "018",
    "name": "Destrnik",
    "iso_3166": "SI-018",
    "country": "SI"
  },
  {
    "abbreviation": "019",
    "name": "Divaca",
    "iso_3166": "SI-019",
    "country": "SI"
  },
  {
    "abbreviation": "154",
    "name": "Dobje",
    "iso_3166": "SI-154",
    "country": "SI"
  },
  {
    "abbreviation": "020",
    "name": "Dobrepolje",
    "iso_3166": "SI-020",
    "country": "SI"
  },
  {
    "abbreviation": "155",
    "name": "Dobrna",
    "iso_3166": "SI-155",
    "country": "SI"
  },
  {
    "abbreviation": "021",
    "name": "Dobrova-Polhov Gradec",
    "iso_3166": "SI-021",
    "country": "SI"
  },
  {
    "abbreviation": "156",
    "name": "Dobrovnik",
    "iso_3166": "SI-156",
    "country": "SI"
  },
  {
    "abbreviation": "023",
    "name": "Domzale",
    "iso_3166": "SI-023",
    "country": "SI"
  },
  {
    "abbreviation": "024",
    "name": "Dornava",
    "iso_3166": "SI-024",
    "country": "SI"
  },
  {
    "abbreviation": "025",
    "name": "Dravograd",
    "iso_3166": "SI-025",
    "country": "SI"
  },
  {
    "abbreviation": "026",
    "name": "Duplek",
    "iso_3166": "SI-026",
    "country": "SI"
  },
  {
    "abbreviation": "207",
    "name": "Gorje",
    "iso_3166": "SI-207",
    "country": "SI"
  },
  {
    "abbreviation": "029",
    "name": "Gornja Radgona",
    "iso_3166": "SI-029",
    "country": "SI"
  },
  {
    "abbreviation": "031",
    "name": "Gornji Petrovci",
    "iso_3166": "SI-031",
    "country": "SI"
  },
  {
    "abbreviation": "158",
    "name": "Grad",
    "iso_3166": "SI-158",
    "country": "SI"
  },
  {
    "abbreviation": "032",
    "name": "Grosuplje",
    "iso_3166": "SI-032",
    "country": "SI"
  },
  {
    "abbreviation": "159",
    "name": "Hajdina",
    "iso_3166": "SI-159",
    "country": "SI"
  },
  {
    "abbreviation": "160",
    "name": "Hoce-Slivnica",
    "iso_3166": "SI-160",
    "country": "SI"
  },
  {
    "abbreviation": "161",
    "name": "Hodos",
    "iso_3166": "SI-161",
    "country": "SI"
  },
  {
    "abbreviation": "162",
    "name": "Horjul",
    "iso_3166": "SI-162",
    "country": "SI"
  },
  {
    "abbreviation": "034",
    "name": "Hrastnik",
    "iso_3166": "SI-034",
    "country": "SI"
  },
  {
    "abbreviation": "035",
    "name": "Hrpelje-Kozina",
    "iso_3166": "SI-035",
    "country": "SI"
  },
  {
    "abbreviation": "036",
    "name": "Idrija",
    "iso_3166": "SI-036",
    "country": "SI"
  },
  {
    "abbreviation": "037",
    "name": "Ig",
    "iso_3166": "SI-037",
    "country": "SI"
  },
  {
    "abbreviation": "038",
    "name": "Ilirska Bistrica",
    "iso_3166": "SI-038",
    "country": "SI"
  },
  {
    "abbreviation": "039",
    "name": "Ivancna Gorica",
    "iso_3166": "SI-039",
    "country": "SI"
  },
  {
    "abbreviation": "040",
    "name": "Izola",
    "iso_3166": "SI-040",
    "country": "SI"
  },
  {
    "abbreviation": "041",
    "name": "Jesenice",
    "iso_3166": "SI-041",
    "country": "SI"
  },
  {
    "abbreviation": "042",
    "name": "Jursinci",
    "iso_3166": "SI-042",
    "country": "SI"
  },
  {
    "abbreviation": "043",
    "name": "Kamnik",
    "iso_3166": "SI-043",
    "country": "SI"
  },
  {
    "abbreviation": "044",
    "name": "Kanal",
    "iso_3166": "SI-044",
    "country": "SI"
  },
  {
    "abbreviation": "045",
    "name": "Kidricevo",
    "iso_3166": "SI-045",
    "country": "SI"
  },
  {
    "abbreviation": "046",
    "name": "Kobarid",
    "iso_3166": "SI-046",
    "country": "SI"
  },
  {
    "abbreviation": "047",
    "name": "Kobilje",
    "iso_3166": "SI-047",
    "country": "SI"
  },
  {
    "abbreviation": "048",
    "name": "Kocevje",
    "iso_3166": "SI-048",
    "country": "SI"
  },
  {
    "abbreviation": "049",
    "name": "Komen",
    "iso_3166": "SI-049",
    "country": "SI"
  },
  {
    "abbreviation": "164",
    "name": "Komenda",
    "iso_3166": "SI-164",
    "country": "SI"
  },
  {
    "abbreviation": "050",
    "name": "Koper",
    "iso_3166": "SI-050",
    "country": "SI"
  },
  {
    "abbreviation": "197",
    "name": "Kosanjevica na Krki",
    "iso_3166": "SI-197",
    "country": "SI"
  },
  {
    "abbreviation": "165",
    "name": "Kostel",
    "iso_3166": "SI-165",
    "country": "SI"
  },
  {
    "abbreviation": "052",
    "name": "Kranj",
    "iso_3166": "SI-052",
    "country": "SI"
  },
  {
    "abbreviation": "053",
    "name": "Kranjska Gora",
    "iso_3166": "SI-053",
    "country": "SI"
  },
  {
    "abbreviation": "166",
    "name": "Krizevci",
    "iso_3166": "SI-166",
    "country": "SI"
  },
  {
    "abbreviation": "054",
    "name": "Krsko",
    "iso_3166": "SI-054",
    "country": "SI"
  },
  {
    "abbreviation": "055",
    "name": "Kungota",
    "iso_3166": "SI-055",
    "country": "SI"
  },
  {
    "abbreviation": "056",
    "name": "Kuzma",
    "iso_3166": "SI-056",
    "country": "SI"
  },
  {
    "abbreviation": "057",
    "name": "Lasko",
    "iso_3166": "SI-057",
    "country": "SI"
  },
  {
    "abbreviation": "058",
    "name": "Lenart",
    "iso_3166": "SI-058",
    "country": "SI"
  },
  {
    "abbreviation": "059",
    "name": "Lendava",
    "iso_3166": "SI-059",
    "country": "SI"
  },
  {
    "abbreviation": "060",
    "name": "Litija",
    "iso_3166": "SI-060",
    "country": "SI"
  },
  {
    "abbreviation": "061",
    "name": "Ljubljana",
    "iso_3166": "SI-061",
    "country": "SI"
  },
  {
    "abbreviation": "063",
    "name": "Ljutomer",
    "iso_3166": "SI-063",
    "country": "SI"
  },
  {
    "abbreviation": "208",
    "name": "Log-Dragomer",
    "iso_3166": "SI-208",
    "country": "SI"
  },
  {
    "abbreviation": "064",
    "name": "Logatec",
    "iso_3166": "SI-064",
    "country": "SI"
  },
  {
    "abbreviation": "065",
    "name": "Loska dolina",
    "iso_3166": "SI-065",
    "country": "SI"
  },
  {
    "abbreviation": "066",
    "name": "Loski Potok",
    "iso_3166": "SI-066",
    "country": "SI"
  },
  {
    "abbreviation": "167",
    "name": "Lovrenc na Pohorju",
    "iso_3166": "SI-167",
    "country": "SI"
  },
  {
    "abbreviation": "067",
    "name": "Luce",
    "iso_3166": "SI-067",
    "country": "SI"
  },
  {
    "abbreviation": "068",
    "name": "Lukovica",
    "iso_3166": "SI-068",
    "country": "SI"
  },
  {
    "abbreviation": "069",
    "name": "Majsperk",
    "iso_3166": "SI-069",
    "country": "SI"
  },
  {
    "abbreviation": "198",
    "name": "Makole",
    "iso_3166": "SI-198",
    "country": "SI"
  },
  {
    "abbreviation": "070",
    "name": "Maribor",
    "iso_3166": "SI-070",
    "country": "SI"
  },
  {
    "abbreviation": "168",
    "name": "Markovci",
    "iso_3166": "SI-168",
    "country": "SI"
  },
  {
    "abbreviation": "071",
    "name": "Medvode",
    "iso_3166": "SI-071",
    "country": "SI"
  },
  {
    "abbreviation": "072",
    "name": "Menges",
    "iso_3166": "SI-072",
    "country": "SI"
  },
  {
    "abbreviation": "073",
    "name": "Metlika",
    "iso_3166": "SI-073",
    "country": "SI"
  },
  {
    "abbreviation": "074",
    "name": "Mezica",
    "iso_3166": "SI-074",
    "country": "SI"
  },
  {
    "abbreviation": "169",
    "name": "Miklavz na Dravskem polju",
    "iso_3166": "SI-169",
    "country": "SI"
  },
  {
    "abbreviation": "075",
    "name": "Miren-Kostanjevica",
    "iso_3166": "SI-075",
    "country": "SI"
  },
  {
    "abbreviation": "212",
    "name": "Mirna",
    "iso_3166": "SI-212",
    "country": "SI"
  },
  {
    "abbreviation": "170",
    "name": "Mirna Pec",
    "iso_3166": "SI-170",
    "country": "SI"
  },
  {
    "abbreviation": "076",
    "name": "Mislinja",
    "iso_3166": "SI-076",
    "country": "SI"
  },
  {
    "abbreviation": "199",
    "name": "Mokronog-Trebelno",
    "iso_3166": "SI-199",
    "country": "SI"
  },
  {
    "abbreviation": "077",
    "name": "Moravce",
    "iso_3166": "SI-077",
    "country": "SI"
  },
  {
    "abbreviation": "079",
    "name": "Mozirje",
    "iso_3166": "SI-079",
    "country": "SI"
  },
  {
    "abbreviation": "080",
    "name": "Murska Sobota",
    "iso_3166": "SI-080",
    "country": "SI"
  },
  {
    "abbreviation": "081",
    "name": "Muta",
    "iso_3166": "SI-081",
    "country": "SI"
  },
  {
    "abbreviation": "082",
    "name": "Naklo",
    "iso_3166": "SI-082",
    "country": "SI"
  },
  {
    "abbreviation": "083",
    "name": "Nazarje",
    "iso_3166": "SI-083",
    "country": "SI"
  },
  {
    "abbreviation": "084",
    "name": "Nova Gorica",
    "iso_3166": "SI-084",
    "country": "SI"
  },
  {
    "abbreviation": "085",
    "name": "Novo Mesto",
    "iso_3166": "SI-085",
    "country": "SI"
  },
  {
    "abbreviation": "086",
    "name": "Odranci",
    "iso_3166": "SI-086",
    "country": "SI"
  },
  {
    "abbreviation": "171",
    "name": "Oplotnica",
    "iso_3166": "SI-171",
    "country": "SI"
  },
  {
    "abbreviation": "087",
    "name": "Ormoz",
    "iso_3166": "SI-087",
    "country": "SI"
  },
  {
    "abbreviation": "090",
    "name": "Piran",
    "iso_3166": "SI-090",
    "country": "SI"
  },
  {
    "abbreviation": "091",
    "name": "Pivka",
    "iso_3166": "SI-091",
    "country": "SI"
  },
  {
    "abbreviation": "092",
    "name": "Podcetrtek",
    "iso_3166": "SI-092",
    "country": "SI"
  },
  {
    "abbreviation": "172",
    "name": "Podlehnik",
    "iso_3166": "SI-172",
    "country": "SI"
  },
  {
    "abbreviation": "200",
    "name": "Poljcane",
    "iso_3166": "SI-200",
    "country": "SI"
  },
  {
    "abbreviation": "173",
    "name": "Polzela",
    "iso_3166": "SI-173",
    "country": "SI"
  },
  {
    "abbreviation": "094",
    "name": "Postojna",
    "iso_3166": "SI-094",
    "country": "SI"
  },
  {
    "abbreviation": "174",
    "name": "Prebold",
    "iso_3166": "SI-174",
    "country": "SI"
  },
  {
    "abbreviation": "095",
    "name": "Preddvor",
    "iso_3166": "SI-095",
    "country": "SI"
  },
  {
    "abbreviation": "175",
    "name": "Prevalje",
    "iso_3166": "SI-175",
    "country": "SI"
  },
  {
    "abbreviation": "096",
    "name": "Ptuj",
    "iso_3166": "SI-096",
    "country": "SI"
  },
  {
    "abbreviation": "097",
    "name": "Puconci",
    "iso_3166": "SI-097",
    "country": "SI"
  },
  {
    "abbreviation": "098",
    "name": "Race-Fram",
    "iso_3166": "SI-098",
    "country": "SI"
  },
  {
    "abbreviation": "099",
    "name": "Radece",
    "iso_3166": "SI-099",
    "country": "SI"
  },
  {
    "abbreviation": "100",
    "name": "Radenci",
    "iso_3166": "SI-100",
    "country": "SI"
  },
  {
    "abbreviation": "101",
    "name": "Radlje ob Dravi",
    "iso_3166": "SI-101",
    "country": "SI"
  },
  {
    "abbreviation": "102",
    "name": "Radovljica",
    "iso_3166": "SI-102",
    "country": "SI"
  },
  {
    "abbreviation": "103",
    "name": "Ravne na Koroskem",
    "iso_3166": "SI-103",
    "country": "SI"
  },
  {
    "abbreviation": "176",
    "name": "Razkrizje",
    "iso_3166": "SI-176",
    "country": "SI"
  },
  {
    "abbreviation": "209",
    "name": "Recica ob Savinji",
    "iso_3166": "SI-209",
    "country": "SI"
  },
  {
    "abbreviation": "201",
    "name": "Rence-Vogrsko",
    "iso_3166": "SI-201",
    "country": "SI"
  },
  {
    "abbreviation": "104",
    "name": "Ribnica",
    "iso_3166": "SI-104",
    "country": "SI"
  },
  {
    "abbreviation": "106",
    "name": "Rogaska Slatina",
    "iso_3166": "SI-106",
    "country": "SI"
  },
  {
    "abbreviation": "105",
    "name": "Rogasovci",
    "iso_3166": "SI-105",
    "country": "SI"
  },
  {
    "abbreviation": "108",
    "name": "Ruse",
    "iso_3166": "SI-108",
    "country": "SI"
  },
  {
    "abbreviation": "033",
    "name": "Salovci",
    "iso_3166": "SI-033",
    "country": "SI"
  },
  {
    "abbreviation": "109",
    "name": "Semic",
    "iso_3166": "SI-109",
    "country": "SI"
  },
  {
    "abbreviation": "183",
    "name": "Sempeter-Vrtojba",
    "iso_3166": "SI-183",
    "country": "SI"
  },
  {
    "abbreviation": "117",
    "name": "Sencur",
    "iso_3166": "SI-117",
    "country": "SI"
  },
  {
    "abbreviation": "118",
    "name": "Sentilj",
    "iso_3166": "SI-118",
    "country": "SI"
  },
  {
    "abbreviation": "119",
    "name": "Sentjernej",
    "iso_3166": "SI-119",
    "country": "SI"
  },
  {
    "abbreviation": "120",
    "name": "Sentjur",
    "iso_3166": "SI-120",
    "country": "SI"
  },
  {
    "abbreviation": "211",
    "name": "Sentrupert",
    "iso_3166": "SI-211",
    "country": "SI"
  },
  {
    "abbreviation": "110",
    "name": "Sevnica",
    "iso_3166": "SI-110",
    "country": "SI"
  },
  {
    "abbreviation": "111",
    "name": "Sezana",
    "iso_3166": "SI-111",
    "country": "SI"
  },
  {
    "abbreviation": "121",
    "name": "Skocjan",
    "iso_3166": "SI-121",
    "country": "SI"
  },
  {
    "abbreviation": "122",
    "name": "Skofja Loka",
    "iso_3166": "SI-122",
    "country": "SI"
  },
  {
    "abbreviation": "123",
    "name": "Skofljica",
    "iso_3166": "SI-123",
    "country": "SI"
  },
  {
    "abbreviation": "112",
    "name": "Slovenj Gradec",
    "iso_3166": "SI-112",
    "country": "SI"
  },
  {
    "abbreviation": "113",
    "name": "Slovenska Bistrica",
    "iso_3166": "SI-113",
    "country": "SI"
  },
  {
    "abbreviation": "114",
    "name": "Slovenske Konjice",
    "iso_3166": "SI-114",
    "country": "SI"
  },
  {
    "abbreviation": "124",
    "name": "Smarje pri Jelsah",
    "iso_3166": "SI-124",
    "country": "SI"
  },
  {
    "abbreviation": "206",
    "name": "Smarjeske Toplice",
    "iso_3166": "SI-206",
    "country": "SI"
  },
  {
    "abbreviation": "125",
    "name": "Smartno ob Paki",
    "iso_3166": "SI-125",
    "country": "SI"
  },
  {
    "abbreviation": "194",
    "name": "Smartno pri Litiji",
    "iso_3166": "SI-194",
    "country": "SI"
  },
  {
    "abbreviation": "179",
    "name": "Sodrazica",
    "iso_3166": "SI-179",
    "country": "SI"
  },
  {
    "abbreviation": "180",
    "name": "Solcava",
    "iso_3166": "SI-180",
    "country": "SI"
  },
  {
    "abbreviation": "126",
    "name": "Sostanj",
    "iso_3166": "SI-126",
    "country": "SI"
  },
  {
    "abbreviation": "115",
    "name": "Starse",
    "iso_3166": "SI-115",
    "country": "SI"
  },
  {
    "abbreviation": "127",
    "name": "Store",
    "iso_3166": "SI-127",
    "country": "SI"
  },
  {
    "abbreviation": "203",
    "name": "Straza",
    "iso_3166": "SI-203",
    "country": "SI"
  },
  {
    "abbreviation": "204",
    "name": "Sveta Trojica v Slovenskih goricah",
    "iso_3166": "SI-204",
    "country": "SI"
  },
  {
    "abbreviation": "182",
    "name": "Sveti Andraz v Slovenskih Goricah",
    "iso_3166": "SI-182",
    "country": "SI"
  },
  {
    "abbreviation": "116",
    "name": "Sveti Jurij ob Scavnici",
    "iso_3166": "SI-116",
    "country": "SI"
  },
  {
    "abbreviation": "210",
    "name": "Sveti Jurij v Slovenskih goricah",
    "iso_3166": "SI-210",
    "country": "SI"
  },
  {
    "abbreviation": "205",
    "name": "Sveti Tomaz",
    "iso_3166": "SI-205",
    "country": "SI"
  },
  {
    "abbreviation": "184",
    "name": "Tabor",
    "iso_3166": "SI-184",
    "country": "SI"
  },
  {
    "abbreviation": "010",
    "name": "Tisina",
    "iso_3166": "SI-010",
    "country": "SI"
  },
  {
    "abbreviation": "128",
    "name": "Tolmin",
    "iso_3166": "SI-128",
    "country": "SI"
  },
  {
    "abbreviation": "129",
    "name": "Trbovlje",
    "iso_3166": "SI-129",
    "country": "SI"
  },
  {
    "abbreviation": "130",
    "name": "Trebnje",
    "iso_3166": "SI-130",
    "country": "SI"
  },
  {
    "abbreviation": "185",
    "name": "Trnovska Vas",
    "iso_3166": "SI-185",
    "country": "SI"
  },
  {
    "abbreviation": "131",
    "name": "Trzic",
    "iso_3166": "SI-131",
    "country": "SI"
  },
  {
    "abbreviation": "186",
    "name": "Trzin",
    "iso_3166": "SI-186",
    "country": "SI"
  },
  {
    "abbreviation": "132",
    "name": "Turnisce",
    "iso_3166": "SI-132",
    "country": "SI"
  },
  {
    "abbreviation": "133",
    "name": "Velenje",
    "iso_3166": "SI-133",
    "country": "SI"
  },
  {
    "abbreviation": "187",
    "name": "Velika Polana",
    "iso_3166": "SI-187",
    "country": "SI"
  },
  {
    "abbreviation": "134",
    "name": "Velike Lasce",
    "iso_3166": "SI-134",
    "country": "SI"
  },
  {
    "abbreviation": "188",
    "name": "Verzej",
    "iso_3166": "SI-188",
    "country": "SI"
  },
  {
    "abbreviation": "135",
    "name": "Videm",
    "iso_3166": "SI-135",
    "country": "SI"
  },
  {
    "abbreviation": "136",
    "name": "Vipava",
    "iso_3166": "SI-136",
    "country": "SI"
  },
  {
    "abbreviation": "137",
    "name": "Vitanje",
    "iso_3166": "SI-137",
    "country": "SI"
  },
  {
    "abbreviation": "138",
    "name": "Vodice",
    "iso_3166": "SI-138",
    "country": "SI"
  },
  {
    "abbreviation": "139",
    "name": "Vojnik",
    "iso_3166": "SI-139",
    "country": "SI"
  },
  {
    "abbreviation": "189",
    "name": "Vransko",
    "iso_3166": "SI-189",
    "country": "SI"
  },
  {
    "abbreviation": "140",
    "name": "Vrhnika",
    "iso_3166": "SI-140",
    "country": "SI"
  },
  {
    "abbreviation": "141",
    "name": "Vuzenica",
    "iso_3166": "SI-141",
    "country": "SI"
  },
  {
    "abbreviation": "142",
    "name": "Zagorje ob Savi",
    "iso_3166": "SI-142",
    "country": "SI"
  },
  {
    "abbreviation": "190",
    "name": "Zalec",
    "iso_3166": "SI-190",
    "country": "SI"
  },
  {
    "abbreviation": "143",
    "name": "Zavrc",
    "iso_3166": "SI-143",
    "country": "SI"
  },
  {
    "abbreviation": "146",
    "name": "Zelezniki",
    "iso_3166": "SI-146",
    "country": "SI"
  },
  {
    "abbreviation": "191",
    "name": "Zetale",
    "iso_3166": "SI-191",
    "country": "SI"
  },
  {
    "abbreviation": "147",
    "name": "Ziri",
    "iso_3166": "SI-147",
    "country": "SI"
  },
  {
    "abbreviation": "144",
    "name": "Zrece",
    "iso_3166": "SI-144",
    "country": "SI"
  },
  {
    "abbreviation": "193",
    "name": "Zuzemberk",
    "iso_3166": "SI-193",
    "country": "SI"
  },
  {
    "abbreviation": "CH",
    "name": "Choiseul",
    "iso_3166": "SB-CH",
    "country": "SB"
  },
  {
    "abbreviation": "GU",
    "name": "Guadalcanal",
    "iso_3166": "SB-GU",
    "country": "SB"
  },
  {
    "abbreviation": "WE",
    "name": "Western",
    "iso_3166": "SB-WE",
    "country": "SB"
  },
  {
    "abbreviation": "AW",
    "name": "Awdal",
    "iso_3166": "SO-AW",
    "country": "SO"
  },
  {
    "abbreviation": "BN",
    "name": "Banaadir",
    "iso_3166": "SO-BN",
    "country": "SO"
  },
  {
    "abbreviation": "BR",
    "name": "Bari",
    "iso_3166": "SO-BR",
    "country": "SO"
  },
  {
    "abbreviation": "BY",
    "name": "Bay",
    "iso_3166": "SO-BY",
    "country": "SO"
  },
  {
    "abbreviation": "GA",
    "name": "Galguduud",
    "iso_3166": "SO-GA",
    "country": "SO"
  },
  {
    "abbreviation": "GE",
    "name": "Gedo",
    "iso_3166": "SO-GE",
    "country": "SO"
  },
  {
    "abbreviation": "HI",
    "name": "Hiiraan",
    "iso_3166": "SO-HI",
    "country": "SO"
  },
  {
    "abbreviation": "JH",
    "name": "Jubbada Hoose",
    "iso_3166": "SO-JH",
    "country": "SO"
  },
  {
    "abbreviation": "MU",
    "name": "Mudug",
    "iso_3166": "SO-MU",
    "country": "SO"
  },
  {
    "abbreviation": "NU",
    "name": "Nugaal",
    "iso_3166": "SO-NU",
    "country": "SO"
  },
  {
    "abbreviation": "SO",
    "name": "Sool",
    "iso_3166": "SO-SO",
    "country": "SO"
  },
  {
    "abbreviation": "TO",
    "name": "Togdheer",
    "iso_3166": "SO-TO",
    "country": "SO"
  },
  {
    "abbreviation": "WO",
    "name": "Woqooyi Galbeed",
    "iso_3166": "SO-WO",
    "country": "SO"
  },
  {
    "abbreviation": "EC",
    "name": "Eastern Cape",
    "iso_3166": "ZA-EC",
    "country": "ZA"
  },
  {
    "abbreviation": "FS",
    "name": "Free State",
    "iso_3166": "ZA-FS",
    "country": "ZA"
  },
  {
    "abbreviation": "GP",
    "name": "Gauteng",
    "iso_3166": "ZA-GP",
    "country": "ZA"
  },
  {
    "abbreviation": "KZN",
    "name": "Kwazulu-Natal",
    "iso_3166": "ZA-KZN",
    "country": "ZA"
  },
  {
    "abbreviation": "LP",
    "name": "Limpopo",
    "iso_3166": "ZA-LP",
    "country": "ZA"
  },
  {
    "abbreviation": "MP",
    "name": "Mpumalanga",
    "iso_3166": "ZA-MP",
    "country": "ZA"
  },
  {
    "abbreviation": "NW",
    "name": "North-West",
    "iso_3166": "ZA-NW",
    "country": "ZA"
  },
  {
    "abbreviation": "NC",
    "name": "Northern Cape",
    "iso_3166": "ZA-NC",
    "country": "ZA"
  },
  {
    "abbreviation": "WC",
    "name": "Western Cape",
    "iso_3166": "ZA-WC",
    "country": "ZA"
  },
  {
    "abbreviation": "-",
    "name": "South Georgia and the South Sandwich Islands",
    "iso_3166": "-",
    "country": "GS"
  },
  {
    "abbreviation": "26",
    "name": "Busan-gwangyeoksi",
    "iso_3166": "KR-26",
    "country": "KR"
  },
  {
    "abbreviation": "43",
    "name": "Chungcheongbuk-do",
    "iso_3166": "KR-43",
    "country": "KR"
  },
  {
    "abbreviation": "44",
    "name": "Chungcheongnam-do",
    "iso_3166": "KR-44",
    "country": "KR"
  },
  {
    "abbreviation": "27",
    "name": "Daegu-gwangyeoksi",
    "iso_3166": "KR-27",
    "country": "KR"
  },
  {
    "abbreviation": "30",
    "name": "Daejeon-gwangyeoksi",
    "iso_3166": "KR-30",
    "country": "KR"
  },
  {
    "abbreviation": "42",
    "name": "Gangwon-do",
    "iso_3166": "KR-42",
    "country": "KR"
  },
  {
    "abbreviation": "29",
    "name": "Gwangju-gwangyeoksi",
    "iso_3166": "KR-29",
    "country": "KR"
  },
  {
    "abbreviation": "41",
    "name": "Gyeonggi-do",
    "iso_3166": "KR-41",
    "country": "KR"
  },
  {
    "abbreviation": "47",
    "name": "Gyeongsangbuk-do",
    "iso_3166": "KR-47",
    "country": "KR"
  },
  {
    "abbreviation": "48",
    "name": "Gyeongsangnam-do",
    "iso_3166": "KR-48",
    "country": "KR"
  },
  {
    "abbreviation": "28",
    "name": "Incheon-gwangyeoksi",
    "iso_3166": "KR-28",
    "country": "KR"
  },
  {
    "abbreviation": "49",
    "name": "Jeju-teukbyeoljachido",
    "iso_3166": "KR-49",
    "country": "KR"
  },
  {
    "abbreviation": "45",
    "name": "Jeollabuk-do",
    "iso_3166": "KR-45",
    "country": "KR"
  },
  {
    "abbreviation": "46",
    "name": "Jeollanam-do",
    "iso_3166": "KR-46",
    "country": "KR"
  },
  {
    "abbreviation": "11",
    "name": "Seoul-teukbyeolsi",
    "iso_3166": "KR-11",
    "country": "KR"
  },
  {
    "abbreviation": "31",
    "name": "Ulsan-gwangyeoksi",
    "iso_3166": "KR-31",
    "country": "KR"
  },
  {
    "abbreviation": "EC",
    "name": "Central Equatoria",
    "iso_3166": "SS-EC",
    "country": "SS"
  },
  {
    "abbreviation": "EE",
    "name": "Eastern Equatoria",
    "iso_3166": "SS-EE",
    "country": "SS"
  },
  {
    "abbreviation": "BN",
    "name": "Northern Bahr el Ghazal",
    "iso_3166": "SS-BN",
    "country": "SS"
  },
  {
    "abbreviation": "UY",
    "name": "Unity",
    "iso_3166": "SS-UY",
    "country": "SS"
  },
  {
    "abbreviation": "NU",
    "name": "Upper Nile",
    "iso_3166": "SS-NU",
    "country": "SS"
  },
  {
    "abbreviation": "EW",
    "name": "Western Equatoria",
    "iso_3166": "SS-EW",
    "country": "SS"
  },
  {
    "abbreviation": "AN",
    "name": "Andalucia",
    "iso_3166": "ES-AN",
    "country": "ES"
  },
  {
    "abbreviation": "AR",
    "name": "Aragon",
    "iso_3166": "ES-AR",
    "country": "ES"
  },
  {
    "abbreviation": "AS",
    "name": "Asturias, Principado de",
    "iso_3166": "ES-AS",
    "country": "ES"
  },
  {
    "abbreviation": "CN",
    "name": "Canarias",
    "iso_3166": "ES-CN",
    "country": "ES"
  },
  {
    "abbreviation": "CB",
    "name": "Cantabria",
    "iso_3166": "ES-CB",
    "country": "ES"
  },
  {
    "abbreviation": "CL",
    "name": "Castilla y Leon",
    "iso_3166": "ES-CL",
    "country": "ES"
  },
  {
    "abbreviation": "CM",
    "name": "Castilla-La Mancha",
    "iso_3166": "ES-CM",
    "country": "ES"
  },
  {
    "abbreviation": "CT",
    "name": "Catalunya",
    "iso_3166": "ES-CT",
    "country": "ES"
  },
  {
    "abbreviation": "CE",
    "name": "Ceuta",
    "iso_3166": "ES-CE",
    "country": "ES"
  },
  {
    "abbreviation": "EX",
    "name": "Extremadura",
    "iso_3166": "ES-EX",
    "country": "ES"
  },
  {
    "abbreviation": "GA",
    "name": "Galicia",
    "iso_3166": "ES-GA",
    "country": "ES"
  },
  {
    "abbreviation": "IB",
    "name": "Illes Balears",
    "iso_3166": "ES-IB",
    "country": "ES"
  },
  {
    "abbreviation": "RI",
    "name": "La Rioja",
    "iso_3166": "ES-RI",
    "country": "ES"
  },
  {
    "abbreviation": "MD",
    "name": "Madrid, Comunidad de",
    "iso_3166": "ES-MD",
    "country": "ES"
  },
  {
    "abbreviation": "ML",
    "name": "Melilla",
    "iso_3166": "ES-ML",
    "country": "ES"
  },
  {
    "abbreviation": "MC",
    "name": "Murcia, Region de",
    "iso_3166": "ES-MC",
    "country": "ES"
  },
  {
    "abbreviation": "NC",
    "name": "Navarra, Comunidad Foral de",
    "iso_3166": "ES-NC",
    "country": "ES"
  },
  {
    "abbreviation": "PV",
    "name": "Pais Vasco",
    "iso_3166": "ES-PV",
    "country": "ES"
  },
  {
    "abbreviation": "VC",
    "name": "Valenciana, Comunidad",
    "iso_3166": "ES-VC",
    "country": "ES"
  },
  {
    "abbreviation": "2",
    "name": "Central Province",
    "iso_3166": "LK-2",
    "country": "LK"
  },
  {
    "abbreviation": "5",
    "name": "Eastern Province",
    "iso_3166": "LK-5",
    "country": "LK"
  },
  {
    "abbreviation": "7",
    "name": "North Central Province",
    "iso_3166": "LK-7",
    "country": "LK"
  },
  {
    "abbreviation": "6",
    "name": "North Western Province",
    "iso_3166": "LK-6",
    "country": "LK"
  },
  {
    "abbreviation": "4",
    "name": "Northern Province",
    "iso_3166": "LK-4",
    "country": "LK"
  },
  {
    "abbreviation": "9",
    "name": "Sabaragamuwa Province",
    "iso_3166": "LK-9",
    "country": "LK"
  },
  {
    "abbreviation": "3",
    "name": "Southern Province",
    "iso_3166": "LK-3",
    "country": "LK"
  },
  {
    "abbreviation": "8",
    "name": "Uva Province",
    "iso_3166": "LK-8",
    "country": "LK"
  },
  {
    "abbreviation": "1",
    "name": "Western Province",
    "iso_3166": "LK-1",
    "country": "LK"
  },
  {
    "abbreviation": "NB",
    "name": "Blue Nile",
    "iso_3166": "SD-NB",
    "country": "SD"
  },
  {
    "abbreviation": "DC",
    "name": "Central Darfur",
    "iso_3166": "SD-DC",
    "country": "SD"
  },
  {
    "abbreviation": "GD",
    "name": "Gedaref",
    "iso_3166": "SD-GD",
    "country": "SD"
  },
  {
    "abbreviation": "GZ",
    "name": "Gezira",
    "iso_3166": "SD-GZ",
    "country": "SD"
  },
  {
    "abbreviation": "KA",
    "name": "Kassala",
    "iso_3166": "SD-KA",
    "country": "SD"
  },
  {
    "abbreviation": "KH",
    "name": "Khartoum",
    "iso_3166": "SD-KH",
    "country": "SD"
  },
  {
    "abbreviation": "DN",
    "name": "North Darfur",
    "iso_3166": "SD-DN",
    "country": "SD"
  },
  {
    "abbreviation": "KN",
    "name": "North Kordofan",
    "iso_3166": "SD-KN",
    "country": "SD"
  },
  {
    "abbreviation": "NO",
    "name": "Northern",
    "iso_3166": "SD-NO",
    "country": "SD"
  },
  {
    "abbreviation": "RS",
    "name": "Red Sea",
    "iso_3166": "SD-RS",
    "country": "SD"
  },
  {
    "abbreviation": "NR",
    "name": "River Nile",
    "iso_3166": "SD-NR",
    "country": "SD"
  },
  {
    "abbreviation": "SI",
    "name": "Sennar",
    "iso_3166": "SD-SI",
    "country": "SD"
  },
  {
    "abbreviation": "DS",
    "name": "South Darfur",
    "iso_3166": "SD-DS",
    "country": "SD"
  },
  {
    "abbreviation": "KS",
    "name": "South Kordofan",
    "iso_3166": "SD-KS",
    "country": "SD"
  },
  {
    "abbreviation": "DW",
    "name": "West Darfur",
    "iso_3166": "SD-DW",
    "country": "SD"
  },
  {
    "abbreviation": "GK",
    "name": "West Kordofan",
    "iso_3166": "SD-GK",
    "country": "SD"
  },
  {
    "abbreviation": "NW",
    "name": "White Nile",
    "iso_3166": "SD-NW",
    "country": "SD"
  },
  {
    "abbreviation": "BR",
    "name": "Brokopondo",
    "iso_3166": "SR-BR",
    "country": "SR"
  },
  {
    "abbreviation": "CM",
    "name": "Commewijne",
    "iso_3166": "SR-CM",
    "country": "SR"
  },
  {
    "abbreviation": "CR",
    "name": "Coronie",
    "iso_3166": "SR-CR",
    "country": "SR"
  },
  {
    "abbreviation": "NI",
    "name": "Nickerie",
    "iso_3166": "SR-NI",
    "country": "SR"
  },
  {
    "abbreviation": "PR",
    "name": "Para",
    "iso_3166": "SR-PR",
    "country": "SR"
  },
  {
    "abbreviation": "PM",
    "name": "Paramaribo",
    "iso_3166": "SR-PM",
    "country": "SR"
  },
  {
    "abbreviation": "SA",
    "name": "Saramacca",
    "iso_3166": "SR-SA",
    "country": "SR"
  },
  {
    "abbreviation": "SI",
    "name": "Sipaliwini",
    "iso_3166": "SR-SI",
    "country": "SR"
  },
  {
    "abbreviation": "WA",
    "name": "Wanica",
    "iso_3166": "SR-WA",
    "country": "SR"
  },
  {
    "abbreviation": "-",
    "name": "Svalbard and Jan Mayen",
    "iso_3166": "-",
    "country": "SJ"
  },
  {
    "abbreviation": "HH",
    "name": "Hhohho",
    "iso_3166": "SZ-HH",
    "country": "SZ"
  },
  {
    "abbreviation": "LU",
    "name": "Lubombo",
    "iso_3166": "SZ-LU",
    "country": "SZ"
  },
  {
    "abbreviation": "MA",
    "name": "Manzini",
    "iso_3166": "SZ-MA",
    "country": "SZ"
  },
  {
    "abbreviation": "K",
    "name": "Blekinge lan",
    "iso_3166": "SE-K",
    "country": "SE"
  },
  {
    "abbreviation": "W",
    "name": "Dalarnas lan",
    "iso_3166": "SE-W",
    "country": "SE"
  },
  {
    "abbreviation": "X",
    "name": "Gavleborgs lan",
    "iso_3166": "SE-X",
    "country": "SE"
  },
  {
    "abbreviation": "I",
    "name": "Gotlands lan",
    "iso_3166": "SE-I",
    "country": "SE"
  },
  {
    "abbreviation": "N",
    "name": "Hallands lan",
    "iso_3166": "SE-N",
    "country": "SE"
  },
  {
    "abbreviation": "Z",
    "name": "Jamtlands lan",
    "iso_3166": "SE-Z",
    "country": "SE"
  },
  {
    "abbreviation": "F",
    "name": "Jonkopings lan",
    "iso_3166": "SE-F",
    "country": "SE"
  },
  {
    "abbreviation": "H",
    "name": "Kalmar lan",
    "iso_3166": "SE-H",
    "country": "SE"
  },
  {
    "abbreviation": "G",
    "name": "Kronobergs lan",
    "iso_3166": "SE-G",
    "country": "SE"
  },
  {
    "abbreviation": "BD",
    "name": "Norrbottens lan",
    "iso_3166": "SE-BD",
    "country": "SE"
  },
  {
    "abbreviation": "T",
    "name": "Orebro lan",
    "iso_3166": "SE-T",
    "country": "SE"
  },
  {
    "abbreviation": "E",
    "name": "Ostergotlands lan",
    "iso_3166": "SE-E",
    "country": "SE"
  },
  {
    "abbreviation": "M",
    "name": "Skane lan",
    "iso_3166": "SE-M",
    "country": "SE"
  },
  {
    "abbreviation": "D",
    "name": "Sodermanlands lan",
    "iso_3166": "SE-D",
    "country": "SE"
  },
  {
    "abbreviation": "AB",
    "name": "Stockholms lan",
    "iso_3166": "SE-AB",
    "country": "SE"
  },
  {
    "abbreviation": "C",
    "name": "Uppsala lan",
    "iso_3166": "SE-C",
    "country": "SE"
  },
  {
    "abbreviation": "S",
    "name": "Varmlands lan",
    "iso_3166": "SE-S",
    "country": "SE"
  },
  {
    "abbreviation": "AC",
    "name": "Vasterbottens lan",
    "iso_3166": "SE-AC",
    "country": "SE"
  },
  {
    "abbreviation": "Y",
    "name": "Vasternorrlands lan",
    "iso_3166": "SE-Y",
    "country": "SE"
  },
  {
    "abbreviation": "U",
    "name": "Vastmanlands lan",
    "iso_3166": "SE-U",
    "country": "SE"
  },
  {
    "abbreviation": "O",
    "name": "Vastra Gotalands lan",
    "iso_3166": "SE-O",
    "country": "SE"
  },
  {
    "abbreviation": "AG",
    "name": "Aargau",
    "iso_3166": "CH-AG",
    "country": "CH"
  },
  {
    "abbreviation": "AR",
    "name": "Appenzell Ausserrhoden",
    "iso_3166": "CH-AR",
    "country": "CH"
  },
  {
    "abbreviation": "AI",
    "name": "Appenzell Innerrhoden",
    "iso_3166": "CH-AI",
    "country": "CH"
  },
  {
    "abbreviation": "BL",
    "name": "Basel-Landschaft",
    "iso_3166": "CH-BL",
    "country": "CH"
  },
  {
    "abbreviation": "BS",
    "name": "Basel-Stadt",
    "iso_3166": "CH-BS",
    "country": "CH"
  },
  {
    "abbreviation": "BE",
    "name": "Bern",
    "iso_3166": "CH-BE",
    "country": "CH"
  },
  {
    "abbreviation": "FR",
    "name": "Fribourg",
    "iso_3166": "CH-FR",
    "country": "CH"
  },
  {
    "abbreviation": "GE",
    "name": "Geneve",
    "iso_3166": "CH-GE",
    "country": "CH"
  },
  {
    "abbreviation": "GL",
    "name": "Glarus",
    "iso_3166": "CH-GL",
    "country": "CH"
  },
  {
    "abbreviation": "GR",
    "name": "Graubunden",
    "iso_3166": "CH-GR",
    "country": "CH"
  },
  {
    "abbreviation": "JU",
    "name": "Jura",
    "iso_3166": "CH-JU",
    "country": "CH"
  },
  {
    "abbreviation": "LU",
    "name": "Luzern",
    "iso_3166": "CH-LU",
    "country": "CH"
  },
  {
    "abbreviation": "NE",
    "name": "Neuchatel",
    "iso_3166": "CH-NE",
    "country": "CH"
  },
  {
    "abbreviation": "NW",
    "name": "Nidwalden",
    "iso_3166": "CH-NW",
    "country": "CH"
  },
  {
    "abbreviation": "OW",
    "name": "Obwalden",
    "iso_3166": "CH-OW",
    "country": "CH"
  },
  {
    "abbreviation": "SG",
    "name": "Sankt Gallen",
    "iso_3166": "CH-SG",
    "country": "CH"
  },
  {
    "abbreviation": "SH",
    "name": "Schaffhausen",
    "iso_3166": "CH-SH",
    "country": "CH"
  },
  {
    "abbreviation": "SZ",
    "name": "Schwyz",
    "iso_3166": "CH-SZ",
    "country": "CH"
  },
  {
    "abbreviation": "SO",
    "name": "Solothurn",
    "iso_3166": "CH-SO",
    "country": "CH"
  },
  {
    "abbreviation": "TG",
    "name": "Thurgau",
    "iso_3166": "CH-TG",
    "country": "CH"
  },
  {
    "abbreviation": "TI",
    "name": "Ticino",
    "iso_3166": "CH-TI",
    "country": "CH"
  },
  {
    "abbreviation": "UR",
    "name": "Uri",
    "iso_3166": "CH-UR",
    "country": "CH"
  },
  {
    "abbreviation": "VS",
    "name": "Valais",
    "iso_3166": "CH-VS",
    "country": "CH"
  },
  {
    "abbreviation": "VD",
    "name": "Vaud",
    "iso_3166": "CH-VD",
    "country": "CH"
  },
  {
    "abbreviation": "ZG",
    "name": "Zug",
    "iso_3166": "CH-ZG",
    "country": "CH"
  },
  {
    "abbreviation": "ZH",
    "name": "Zurich",
    "iso_3166": "CH-ZH",
    "country": "CH"
  },
  {
    "abbreviation": "HA",
    "name": "Al Hasakah",
    "iso_3166": "SY-HA",
    "country": "SY"
  },
  {
    "abbreviation": "LA",
    "name": "Al Ladhiqiyah",
    "iso_3166": "SY-LA",
    "country": "SY"
  },
  {
    "abbreviation": "QU",
    "name": "Al Qunaytirah",
    "iso_3166": "SY-QU",
    "country": "SY"
  },
  {
    "abbreviation": "RA",
    "name": "Ar Raqqah",
    "iso_3166": "SY-RA",
    "country": "SY"
  },
  {
    "abbreviation": "SU",
    "name": "As Suwayda'",
    "iso_3166": "SY-SU",
    "country": "SY"
  },
  {
    "abbreviation": "DR",
    "name": "Dar'a",
    "iso_3166": "SY-DR",
    "country": "SY"
  },
  {
    "abbreviation": "DY",
    "name": "Dayr az Zawr",
    "iso_3166": "SY-DY",
    "country": "SY"
  },
  {
    "abbreviation": "DI",
    "name": "Dimashq",
    "iso_3166": "SY-DI",
    "country": "SY"
  },
  {
    "abbreviation": "HL",
    "name": "Halab",
    "iso_3166": "SY-HL",
    "country": "SY"
  },
  {
    "abbreviation": "HM",
    "name": "Hamah",
    "iso_3166": "SY-HM",
    "country": "SY"
  },
  {
    "abbreviation": "HI",
    "name": "Hims",
    "iso_3166": "SY-HI",
    "country": "SY"
  },
  {
    "abbreviation": "ID",
    "name": "Idlib",
    "iso_3166": "SY-ID",
    "country": "SY"
  },
  {
    "abbreviation": "RD",
    "name": "Rif Dimashq",
    "iso_3166": "SY-RD",
    "country": "SY"
  },
  {
    "abbreviation": "TA",
    "name": "Tartus",
    "iso_3166": "SY-TA",
    "country": "SY"
  },
  {
    "abbreviation": "CHA",
    "name": "Changhua",
    "iso_3166": "TW-CHA",
    "country": "TW"
  },
  {
    "abbreviation": "CYQ",
    "name": "Chiayi",
    "iso_3166": "TW-CYQ",
    "country": "TW"
  },
  {
    "abbreviation": "HSQ",
    "name": "Hsinchu",
    "iso_3166": "TW-HSQ",
    "country": "TW"
  },
  {
    "abbreviation": "HUA",
    "name": "Hualien",
    "iso_3166": "TW-HUA",
    "country": "TW"
  },
  {
    "abbreviation": "KHH",
    "name": "Kaohsiung",
    "iso_3166": "TW-KHH",
    "country": "TW"
  },
  {
    "abbreviation": "KEE",
    "name": "Keelung",
    "iso_3166": "TW-KEE",
    "country": "TW"
  },
  {
    "abbreviation": "KIN",
    "name": "Kinmen",
    "iso_3166": "TW-KIN",
    "country": "TW"
  },
  {
    "abbreviation": "LIE",
    "name": "Lienchiang",
    "iso_3166": "TW-LIE",
    "country": "TW"
  },
  {
    "abbreviation": "MIA",
    "name": "Miaoli",
    "iso_3166": "TW-MIA",
    "country": "TW"
  },
  {
    "abbreviation": "NAN",
    "name": "Nantou",
    "iso_3166": "TW-NAN",
    "country": "TW"
  },
  {
    "abbreviation": "NWT",
    "name": "New Taipei",
    "iso_3166": "TW-NWT",
    "country": "TW"
  },
  {
    "abbreviation": "PEN",
    "name": "Penghu",
    "iso_3166": "TW-PEN",
    "country": "TW"
  },
  {
    "abbreviation": "PIF",
    "name": "Pingtung",
    "iso_3166": "TW-PIF",
    "country": "TW"
  },
  {
    "abbreviation": "TXG",
    "name": "Taichung",
    "iso_3166": "TW-TXG",
    "country": "TW"
  },
  {
    "abbreviation": "TNN",
    "name": "Tainan",
    "iso_3166": "TW-TNN",
    "country": "TW"
  },
  {
    "abbreviation": "TPE",
    "name": "Taipei",
    "iso_3166": "TW-TPE",
    "country": "TW"
  },
  {
    "abbreviation": "TTT",
    "name": "Taitung",
    "iso_3166": "TW-TTT",
    "country": "TW"
  },
  {
    "abbreviation": "TAO",
    "name": "Taoyuan",
    "iso_3166": "TW-TAO",
    "country": "TW"
  },
  {
    "abbreviation": "ILA",
    "name": "Yilan",
    "iso_3166": "TW-ILA",
    "country": "TW"
  },
  {
    "abbreviation": "YUN",
    "name": "Yunlin",
    "iso_3166": "TW-YUN",
    "country": "TW"
  },
  {
    "abbreviation": "DU",
    "name": "Dushanbe",
    "iso_3166": "TJ-DU",
    "country": "TJ"
  },
  {
    "abbreviation": "KT",
    "name": "Khatlon",
    "iso_3166": "TJ-KT",
    "country": "TJ"
  },
  {
    "abbreviation": "GB",
    "name": "Kuhistoni Badakhshon",
    "iso_3166": "TJ-GB",
    "country": "TJ"
  },
  {
    "abbreviation": "RA",
    "name": "Nohiyahoi Tobei Jumhuri",
    "iso_3166": "TJ-RA",
    "country": "TJ"
  },
  {
    "abbreviation": "SU",
    "name": "Sughd",
    "iso_3166": "TJ-SU",
    "country": "TJ"
  },
  {
    "abbreviation": "01",
    "name": "Arusha",
    "iso_3166": "TZ-01",
    "country": "TZ"
  },
  {
    "abbreviation": "02",
    "name": "Dar es Salaam",
    "iso_3166": "TZ-02",
    "country": "TZ"
  },
  {
    "abbreviation": "03",
    "name": "Dodoma",
    "iso_3166": "TZ-03",
    "country": "TZ"
  },
  {
    "abbreviation": "27",
    "name": "Geita",
    "iso_3166": "TZ-27",
    "country": "TZ"
  },
  {
    "abbreviation": "04",
    "name": "Iringa",
    "iso_3166": "TZ-04",
    "country": "TZ"
  },
  {
    "abbreviation": "05",
    "name": "Kagera",
    "iso_3166": "TZ-05",
    "country": "TZ"
  },
  {
    "abbreviation": "06",
    "name": "Kaskazini Pemba",
    "iso_3166": "TZ-06",
    "country": "TZ"
  },
  {
    "abbreviation": "07",
    "name": "Kaskazini Unguja",
    "iso_3166": "TZ-07",
    "country": "TZ"
  },
  {
    "abbreviation": "28",
    "name": "Katavi",
    "iso_3166": "TZ-28",
    "country": "TZ"
  },
  {
    "abbreviation": "08",
    "name": "Kigoma",
    "iso_3166": "TZ-08",
    "country": "TZ"
  },
  {
    "abbreviation": "09",
    "name": "Kilimanjaro",
    "iso_3166": "TZ-09",
    "country": "TZ"
  },
  {
    "abbreviation": "10",
    "name": "Kusini Pemba",
    "iso_3166": "TZ-10",
    "country": "TZ"
  },
  {
    "abbreviation": "11",
    "name": "Kusini Unguja",
    "iso_3166": "TZ-11",
    "country": "TZ"
  },
  {
    "abbreviation": "12",
    "name": "Lindi",
    "iso_3166": "TZ-12",
    "country": "TZ"
  },
  {
    "abbreviation": "26",
    "name": "Manyara",
    "iso_3166": "TZ-26",
    "country": "TZ"
  },
  {
    "abbreviation": "13",
    "name": "Mara",
    "iso_3166": "TZ-13",
    "country": "TZ"
  },
  {
    "abbreviation": "14",
    "name": "Mbeya",
    "iso_3166": "TZ-14",
    "country": "TZ"
  },
  {
    "abbreviation": "15",
    "name": "Mjini Magharibi",
    "iso_3166": "TZ-15",
    "country": "TZ"
  },
  {
    "abbreviation": "16",
    "name": "Morogoro",
    "iso_3166": "TZ-16",
    "country": "TZ"
  },
  {
    "abbreviation": "17",
    "name": "Mtwara",
    "iso_3166": "TZ-17",
    "country": "TZ"
  },
  {
    "abbreviation": "18",
    "name": "Mwanza",
    "iso_3166": "TZ-18",
    "country": "TZ"
  },
  {
    "abbreviation": "29",
    "name": "Njombe",
    "iso_3166": "TZ-29",
    "country": "TZ"
  },
  {
    "abbreviation": "19",
    "name": "Pwani",
    "iso_3166": "TZ-19",
    "country": "TZ"
  },
  {
    "abbreviation": "20",
    "name": "Rukwa",
    "iso_3166": "TZ-20",
    "country": "TZ"
  },
  {
    "abbreviation": "21",
    "name": "Ruvuma",
    "iso_3166": "TZ-21",
    "country": "TZ"
  },
  {
    "abbreviation": "22",
    "name": "Shinyanga",
    "iso_3166": "TZ-22",
    "country": "TZ"
  },
  {
    "abbreviation": "30",
    "name": "Simiyu",
    "iso_3166": "TZ-30",
    "country": "TZ"
  },
  {
    "abbreviation": "23",
    "name": "Singida",
    "iso_3166": "TZ-23",
    "country": "TZ"
  },
  {
    "abbreviation": "31",
    "name": "Songwe",
    "iso_3166": "TZ-31",
    "country": "TZ"
  },
  {
    "abbreviation": "24",
    "name": "Tabora",
    "iso_3166": "TZ-24",
    "country": "TZ"
  },
  {
    "abbreviation": "25",
    "name": "Tanga",
    "iso_3166": "TZ-25",
    "country": "TZ"
  },
  {
    "abbreviation": "37",
    "name": "Amnat Charoen",
    "iso_3166": "TH-37",
    "country": "TH"
  },
  {
    "abbreviation": "15",
    "name": "Ang Thong",
    "iso_3166": "TH-15",
    "country": "TH"
  },
  {
    "abbreviation": "38",
    "name": "Bueng Kan",
    "iso_3166": "TH-38",
    "country": "TH"
  },
  {
    "abbreviation": "31",
    "name": "Buri Ram",
    "iso_3166": "TH-31",
    "country": "TH"
  },
  {
    "abbreviation": "24",
    "name": "Chachoengsao",
    "iso_3166": "TH-24",
    "country": "TH"
  },
  {
    "abbreviation": "18",
    "name": "Chai Nat",
    "iso_3166": "TH-18",
    "country": "TH"
  },
  {
    "abbreviation": "36",
    "name": "Chaiyaphum",
    "iso_3166": "TH-36",
    "country": "TH"
  },
  {
    "abbreviation": "22",
    "name": "Chanthaburi",
    "iso_3166": "TH-22",
    "country": "TH"
  },
  {
    "abbreviation": "50",
    "name": "Chiang Mai",
    "iso_3166": "TH-50",
    "country": "TH"
  },
  {
    "abbreviation": "57",
    "name": "Chiang Rai",
    "iso_3166": "TH-57",
    "country": "TH"
  },
  {
    "abbreviation": "20",
    "name": "Chon Buri",
    "iso_3166": "TH-20",
    "country": "TH"
  },
  {
    "abbreviation": "86",
    "name": "Chumphon",
    "iso_3166": "TH-86",
    "country": "TH"
  },
  {
    "abbreviation": "46",
    "name": "Kalasin",
    "iso_3166": "TH-46",
    "country": "TH"
  },
  {
    "abbreviation": "62",
    "name": "Kamphaeng Phet",
    "iso_3166": "TH-62",
    "country": "TH"
  },
  {
    "abbreviation": "71",
    "name": "Kanchanaburi",
    "iso_3166": "TH-71",
    "country": "TH"
  },
  {
    "abbreviation": "40",
    "name": "Khon Kaen",
    "iso_3166": "TH-40",
    "country": "TH"
  },
  {
    "abbreviation": "81",
    "name": "Krabi",
    "iso_3166": "TH-81",
    "country": "TH"
  },
  {
    "abbreviation": "10",
    "name": "Krung Thep Maha Nakhon",
    "iso_3166": "TH-10",
    "country": "TH"
  },
  {
    "abbreviation": "52",
    "name": "Lampang",
    "iso_3166": "TH-52",
    "country": "TH"
  },
  {
    "abbreviation": "51",
    "name": "Lamphun",
    "iso_3166": "TH-51",
    "country": "TH"
  },
  {
    "abbreviation": "42",
    "name": "Loei",
    "iso_3166": "TH-42",
    "country": "TH"
  },
  {
    "abbreviation": "16",
    "name": "Lop Buri",
    "iso_3166": "TH-16",
    "country": "TH"
  },
  {
    "abbreviation": "58",
    "name": "Mae Hong Son",
    "iso_3166": "TH-58",
    "country": "TH"
  },
  {
    "abbreviation": "44",
    "name": "Maha Sarakham",
    "iso_3166": "TH-44",
    "country": "TH"
  },
  {
    "abbreviation": "49",
    "name": "Mukdahan",
    "iso_3166": "TH-49",
    "country": "TH"
  },
  {
    "abbreviation": "26",
    "name": "Nakhon Nayok",
    "iso_3166": "TH-26",
    "country": "TH"
  },
  {
    "abbreviation": "73",
    "name": "Nakhon Pathom",
    "iso_3166": "TH-73",
    "country": "TH"
  },
  {
    "abbreviation": "48",
    "name": "Nakhon Phanom",
    "iso_3166": "TH-48",
    "country": "TH"
  },
  {
    "abbreviation": "30",
    "name": "Nakhon Ratchasima",
    "iso_3166": "TH-30",
    "country": "TH"
  },
  {
    "abbreviation": "60",
    "name": "Nakhon Sawan",
    "iso_3166": "TH-60",
    "country": "TH"
  },
  {
    "abbreviation": "80",
    "name": "Nakhon Si Thammarat",
    "iso_3166": "TH-80",
    "country": "TH"
  },
  {
    "abbreviation": "55",
    "name": "Nan",
    "iso_3166": "TH-55",
    "country": "TH"
  },
  {
    "abbreviation": "96",
    "name": "Narathiwat",
    "iso_3166": "TH-96",
    "country": "TH"
  },
  {
    "abbreviation": "39",
    "name": "Nong Bua Lam Phu",
    "iso_3166": "TH-39",
    "country": "TH"
  },
  {
    "abbreviation": "43",
    "name": "Nong Khai",
    "iso_3166": "TH-43",
    "country": "TH"
  },
  {
    "abbreviation": "12",
    "name": "Nonthaburi",
    "iso_3166": "TH-12",
    "country": "TH"
  },
  {
    "abbreviation": "13",
    "name": "Pathum Thani",
    "iso_3166": "TH-13",
    "country": "TH"
  },
  {
    "abbreviation": "94",
    "name": "Pattani",
    "iso_3166": "TH-94",
    "country": "TH"
  },
  {
    "abbreviation": "82",
    "name": "Phangnga",
    "iso_3166": "TH-82",
    "country": "TH"
  },
  {
    "abbreviation": "93",
    "name": "Phatthalung",
    "iso_3166": "TH-93",
    "country": "TH"
  },
  {
    "abbreviation": "56",
    "name": "Phayao",
    "iso_3166": "TH-56",
    "country": "TH"
  },
  {
    "abbreviation": "67",
    "name": "Phetchabun",
    "iso_3166": "TH-67",
    "country": "TH"
  },
  {
    "abbreviation": "76",
    "name": "Phetchaburi",
    "iso_3166": "TH-76",
    "country": "TH"
  },
  {
    "abbreviation": "66",
    "name": "Phichit",
    "iso_3166": "TH-66",
    "country": "TH"
  },
  {
    "abbreviation": "65",
    "name": "Phitsanulok",
    "iso_3166": "TH-65",
    "country": "TH"
  },
  {
    "abbreviation": "14",
    "name": "Phra Nakhon Si Ayutthaya",
    "iso_3166": "TH-14",
    "country": "TH"
  },
  {
    "abbreviation": "54",
    "name": "Phrae",
    "iso_3166": "TH-54",
    "country": "TH"
  },
  {
    "abbreviation": "83",
    "name": "Phuket",
    "iso_3166": "TH-83",
    "country": "TH"
  },
  {
    "abbreviation": "25",
    "name": "Prachin Buri",
    "iso_3166": "TH-25",
    "country": "TH"
  },
  {
    "abbreviation": "77",
    "name": "Prachuap Khiri Khan",
    "iso_3166": "TH-77",
    "country": "TH"
  },
  {
    "abbreviation": "85",
    "name": "Ranong",
    "iso_3166": "TH-85",
    "country": "TH"
  },
  {
    "abbreviation": "70",
    "name": "Ratchaburi",
    "iso_3166": "TH-70",
    "country": "TH"
  },
  {
    "abbreviation": "21",
    "name": "Rayong",
    "iso_3166": "TH-21",
    "country": "TH"
  },
  {
    "abbreviation": "45",
    "name": "Roi Et",
    "iso_3166": "TH-45",
    "country": "TH"
  },
  {
    "abbreviation": "27",
    "name": "Sa Kaeo",
    "iso_3166": "TH-27",
    "country": "TH"
  },
  {
    "abbreviation": "47",
    "name": "Sakon Nakhon",
    "iso_3166": "TH-47",
    "country": "TH"
  },
  {
    "abbreviation": "11",
    "name": "Samut Prakan",
    "iso_3166": "TH-11",
    "country": "TH"
  },
  {
    "abbreviation": "74",
    "name": "Samut Sakhon",
    "iso_3166": "TH-74",
    "country": "TH"
  },
  {
    "abbreviation": "75",
    "name": "Samut Songkhram",
    "iso_3166": "TH-75",
    "country": "TH"
  },
  {
    "abbreviation": "19",
    "name": "Saraburi",
    "iso_3166": "TH-19",
    "country": "TH"
  },
  {
    "abbreviation": "91",
    "name": "Satun",
    "iso_3166": "TH-91",
    "country": "TH"
  },
  {
    "abbreviation": "33",
    "name": "Si Sa Ket",
    "iso_3166": "TH-33",
    "country": "TH"
  },
  {
    "abbreviation": "17",
    "name": "Sing Buri",
    "iso_3166": "TH-17",
    "country": "TH"
  },
  {
    "abbreviation": "90",
    "name": "Songkhla",
    "iso_3166": "TH-90",
    "country": "TH"
  },
  {
    "abbreviation": "64",
    "name": "Sukhothai",
    "iso_3166": "TH-64",
    "country": "TH"
  },
  {
    "abbreviation": "72",
    "name": "Suphan Buri",
    "iso_3166": "TH-72",
    "country": "TH"
  },
  {
    "abbreviation": "84",
    "name": "Surat Thani",
    "iso_3166": "TH-84",
    "country": "TH"
  },
  {
    "abbreviation": "32",
    "name": "Surin",
    "iso_3166": "TH-32",
    "country": "TH"
  },
  {
    "abbreviation": "63",
    "name": "Tak",
    "iso_3166": "TH-63",
    "country": "TH"
  },
  {
    "abbreviation": "92",
    "name": "Trang",
    "iso_3166": "TH-92",
    "country": "TH"
  },
  {
    "abbreviation": "23",
    "name": "Trat",
    "iso_3166": "TH-23",
    "country": "TH"
  },
  {
    "abbreviation": "34",
    "name": "Ubon Ratchathani",
    "iso_3166": "TH-34",
    "country": "TH"
  },
  {
    "abbreviation": "41",
    "name": "Udon Thani",
    "iso_3166": "TH-41",
    "country": "TH"
  },
  {
    "abbreviation": "61",
    "name": "Uthai Thani",
    "iso_3166": "TH-61",
    "country": "TH"
  },
  {
    "abbreviation": "53",
    "name": "Uttaradit",
    "iso_3166": "TH-53",
    "country": "TH"
  },
  {
    "abbreviation": "95",
    "name": "Yala",
    "iso_3166": "TH-95",
    "country": "TH"
  },
  {
    "abbreviation": "35",
    "name": "Yasothon",
    "iso_3166": "TH-35",
    "country": "TH"
  },
  {
    "abbreviation": "AL",
    "name": "Aileu",
    "iso_3166": "TL-AL",
    "country": "TL"
  },
  {
    "abbreviation": "AN",
    "name": "Ainaro",
    "iso_3166": "TL-AN",
    "country": "TL"
  },
  {
    "abbreviation": "CO",
    "name": "Cova Lima",
    "iso_3166": "TL-CO",
    "country": "TL"
  },
  {
    "abbreviation": "DI",
    "name": "Dili",
    "iso_3166": "TL-DI",
    "country": "TL"
  },
  {
    "abbreviation": "LI",
    "name": "Liquica",
    "iso_3166": "TL-LI",
    "country": "TL"
  },
  {
    "abbreviation": "C",
    "name": "Centrale",
    "iso_3166": "TG-C",
    "country": "TG"
  },
  {
    "abbreviation": "K",
    "name": "Kara",
    "iso_3166": "TG-K",
    "country": "TG"
  },
  {
    "abbreviation": "M",
    "name": "Maritime",
    "iso_3166": "TG-M",
    "country": "TG"
  },
  {
    "abbreviation": "P",
    "name": "Plateaux",
    "iso_3166": "TG-P",
    "country": "TG"
  },
  {
    "abbreviation": "S",
    "name": "Savanes",
    "iso_3166": "TG-S",
    "country": "TG"
  },
  {
    "abbreviation": "-",
    "name": "Tokelau",
    "iso_3166": "-",
    "country": "TK"
  },
  {
    "abbreviation": "01",
    "name": "'Eua",
    "iso_3166": "TO-01",
    "country": "TO"
  },
  {
    "abbreviation": "02",
    "name": "Ha'apai",
    "iso_3166": "TO-02",
    "country": "TO"
  },
  {
    "abbreviation": "03",
    "name": "Niuas",
    "iso_3166": "TO-03",
    "country": "TO"
  },
  {
    "abbreviation": "04",
    "name": "Tongatapu",
    "iso_3166": "TO-04",
    "country": "TO"
  },
  {
    "abbreviation": "05",
    "name": "Vava'u",
    "iso_3166": "TO-05",
    "country": "TO"
  },
  {
    "abbreviation": "ARI",
    "name": "Arima",
    "iso_3166": "TT-ARI",
    "country": "TT"
  },
  {
    "abbreviation": "CHA",
    "name": "Chaguanas",
    "iso_3166": "TT-CHA",
    "country": "TT"
  },
  {
    "abbreviation": "CTT",
    "name": "Couva-Tabaquite-Talparo",
    "iso_3166": "TT-CTT",
    "country": "TT"
  },
  {
    "abbreviation": "DMN",
    "name": "Diego Martin",
    "iso_3166": "TT-DMN",
    "country": "TT"
  },
  {
    "abbreviation": "MRC",
    "name": "Mayaro-Rio Claro",
    "iso_3166": "TT-MRC",
    "country": "TT"
  },
  {
    "abbreviation": "PED",
    "name": "Penal-Debe",
    "iso_3166": "TT-PED",
    "country": "TT"
  },
  {
    "abbreviation": "PTF",
    "name": "Point Fortin",
    "iso_3166": "TT-PTF",
    "country": "TT"
  },
  {
    "abbreviation": "POS",
    "name": "Port of Spain",
    "iso_3166": "TT-POS",
    "country": "TT"
  },
  {
    "abbreviation": "PRT",
    "name": "Princes Town",
    "iso_3166": "TT-PRT",
    "country": "TT"
  },
  {
    "abbreviation": "SFO",
    "name": "San Fernando",
    "iso_3166": "TT-SFO",
    "country": "TT"
  },
  {
    "abbreviation": "SJL",
    "name": "San Juan-Laventille",
    "iso_3166": "TT-SJL",
    "country": "TT"
  },
  {
    "abbreviation": "SGE",
    "name": "Sangre Grande",
    "iso_3166": "TT-SGE",
    "country": "TT"
  },
  {
    "abbreviation": "SIP",
    "name": "Siparia",
    "iso_3166": "TT-SIP",
    "country": "TT"
  },
  {
    "abbreviation": "TOB",
    "name": "Tobago",
    "iso_3166": "TT-TOB",
    "country": "TT"
  },
  {
    "abbreviation": "TUP",
    "name": "Tunapuna-Piarco",
    "iso_3166": "TT-TUP",
    "country": "TT"
  },
  {
    "abbreviation": "31",
    "name": "Beja",
    "iso_3166": "TN-31",
    "country": "TN"
  },
  {
    "abbreviation": "13",
    "name": "Ben Arous",
    "iso_3166": "TN-13",
    "country": "TN"
  },
  {
    "abbreviation": "23",
    "name": "Bizerte",
    "iso_3166": "TN-23",
    "country": "TN"
  },
  {
    "abbreviation": "81",
    "name": "Gabes",
    "iso_3166": "TN-81",
    "country": "TN"
  },
  {
    "abbreviation": "71",
    "name": "Gafsa",
    "iso_3166": "TN-71",
    "country": "TN"
  },
  {
    "abbreviation": "32",
    "name": "Jendouba",
    "iso_3166": "TN-32",
    "country": "TN"
  },
  {
    "abbreviation": "41",
    "name": "Kairouan",
    "iso_3166": "TN-41",
    "country": "TN"
  },
  {
    "abbreviation": "42",
    "name": "Kasserine",
    "iso_3166": "TN-42",
    "country": "TN"
  },
  {
    "abbreviation": "73",
    "name": "Kebili",
    "iso_3166": "TN-73",
    "country": "TN"
  },
  {
    "abbreviation": "12",
    "name": "L'Ariana",
    "iso_3166": "TN-12",
    "country": "TN"
  },
  {
    "abbreviation": "14",
    "name": "La Manouba",
    "iso_3166": "TN-14",
    "country": "TN"
  },
  {
    "abbreviation": "33",
    "name": "Le Kef",
    "iso_3166": "TN-33",
    "country": "TN"
  },
  {
    "abbreviation": "53",
    "name": "Mahdia",
    "iso_3166": "TN-53",
    "country": "TN"
  },
  {
    "abbreviation": "82",
    "name": "Medenine",
    "iso_3166": "TN-82",
    "country": "TN"
  },
  {
    "abbreviation": "52",
    "name": "Monastir",
    "iso_3166": "TN-52",
    "country": "TN"
  },
  {
    "abbreviation": "21",
    "name": "Nabeul",
    "iso_3166": "TN-21",
    "country": "TN"
  },
  {
    "abbreviation": "61",
    "name": "Sfax",
    "iso_3166": "TN-61",
    "country": "TN"
  },
  {
    "abbreviation": "43",
    "name": "Sidi Bouzid",
    "iso_3166": "TN-43",
    "country": "TN"
  },
  {
    "abbreviation": "34",
    "name": "Siliana",
    "iso_3166": "TN-34",
    "country": "TN"
  },
  {
    "abbreviation": "51",
    "name": "Sousse",
    "iso_3166": "TN-51",
    "country": "TN"
  },
  {
    "abbreviation": "83",
    "name": "Tataouine",
    "iso_3166": "TN-83",
    "country": "TN"
  },
  {
    "abbreviation": "72",
    "name": "Tozeur",
    "iso_3166": "TN-72",
    "country": "TN"
  },
  {
    "abbreviation": "11",
    "name": "Tunis",
    "iso_3166": "TN-11",
    "country": "TN"
  },
  {
    "abbreviation": "22",
    "name": "Zaghouan",
    "iso_3166": "TN-22",
    "country": "TN"
  },
  {
    "abbreviation": "01",
    "name": "Adana",
    "iso_3166": "TR-01",
    "country": "TR"
  },
  {
    "abbreviation": "02",
    "name": "Adiyaman",
    "iso_3166": "TR-02",
    "country": "TR"
  },
  {
    "abbreviation": "03",
    "name": "Afyonkarahisar",
    "iso_3166": "TR-03",
    "country": "TR"
  },
  {
    "abbreviation": "04",
    "name": "Agri",
    "iso_3166": "TR-04",
    "country": "TR"
  },
  {
    "abbreviation": "68",
    "name": "Aksaray",
    "iso_3166": "TR-68",
    "country": "TR"
  },
  {
    "abbreviation": "05",
    "name": "Amasya",
    "iso_3166": "TR-05",
    "country": "TR"
  },
  {
    "abbreviation": "06",
    "name": "Ankara",
    "iso_3166": "TR-06",
    "country": "TR"
  },
  {
    "abbreviation": "07",
    "name": "Antalya",
    "iso_3166": "TR-07",
    "country": "TR"
  },
  {
    "abbreviation": "75",
    "name": "Ardahan",
    "iso_3166": "TR-75",
    "country": "TR"
  },
  {
    "abbreviation": "08",
    "name": "Artvin",
    "iso_3166": "TR-08",
    "country": "TR"
  },
  {
    "abbreviation": "09",
    "name": "Aydin",
    "iso_3166": "TR-09",
    "country": "TR"
  },
  {
    "abbreviation": "10",
    "name": "Balikesir",
    "iso_3166": "TR-10",
    "country": "TR"
  },
  {
    "abbreviation": "74",
    "name": "Bartin",
    "iso_3166": "TR-74",
    "country": "TR"
  },
  {
    "abbreviation": "72",
    "name": "Batman",
    "iso_3166": "TR-72",
    "country": "TR"
  },
  {
    "abbreviation": "69",
    "name": "Bayburt",
    "iso_3166": "TR-69",
    "country": "TR"
  },
  {
    "abbreviation": "11",
    "name": "Bilecik",
    "iso_3166": "TR-11",
    "country": "TR"
  },
  {
    "abbreviation": "12",
    "name": "Bingol",
    "iso_3166": "TR-12",
    "country": "TR"
  },
  {
    "abbreviation": "13",
    "name": "Bitlis",
    "iso_3166": "TR-13",
    "country": "TR"
  },
  {
    "abbreviation": "14",
    "name": "Bolu",
    "iso_3166": "TR-14",
    "country": "TR"
  },
  {
    "abbreviation": "15",
    "name": "Burdur",
    "iso_3166": "TR-15",
    "country": "TR"
  },
  {
    "abbreviation": "16",
    "name": "Bursa",
    "iso_3166": "TR-16",
    "country": "TR"
  },
  {
    "abbreviation": "17",
    "name": "Canakkale",
    "iso_3166": "TR-17",
    "country": "TR"
  },
  {
    "abbreviation": "18",
    "name": "Cankiri",
    "iso_3166": "TR-18",
    "country": "TR"
  },
  {
    "abbreviation": "19",
    "name": "Corum",
    "iso_3166": "TR-19",
    "country": "TR"
  },
  {
    "abbreviation": "20",
    "name": "Denizli",
    "iso_3166": "TR-20",
    "country": "TR"
  },
  {
    "abbreviation": "21",
    "name": "Diyarbakir",
    "iso_3166": "TR-21",
    "country": "TR"
  },
  {
    "abbreviation": "81",
    "name": "Duzce",
    "iso_3166": "TR-81",
    "country": "TR"
  },
  {
    "abbreviation": "22",
    "name": "Edirne",
    "iso_3166": "TR-22",
    "country": "TR"
  },
  {
    "abbreviation": "23",
    "name": "Elazig",
    "iso_3166": "TR-23",
    "country": "TR"
  },
  {
    "abbreviation": "24",
    "name": "Erzincan",
    "iso_3166": "TR-24",
    "country": "TR"
  },
  {
    "abbreviation": "25",
    "name": "Erzurum",
    "iso_3166": "TR-25",
    "country": "TR"
  },
  {
    "abbreviation": "26",
    "name": "Eskisehir",
    "iso_3166": "TR-26",
    "country": "TR"
  },
  {
    "abbreviation": "27",
    "name": "Gaziantep",
    "iso_3166": "TR-27",
    "country": "TR"
  },
  {
    "abbreviation": "28",
    "name": "Giresun",
    "iso_3166": "TR-28",
    "country": "TR"
  },
  {
    "abbreviation": "29",
    "name": "Gumushane",
    "iso_3166": "TR-29",
    "country": "TR"
  },
  {
    "abbreviation": "30",
    "name": "Hakkari",
    "iso_3166": "TR-30",
    "country": "TR"
  },
  {
    "abbreviation": "31",
    "name": "Hatay",
    "iso_3166": "TR-31",
    "country": "TR"
  },
  {
    "abbreviation": "76",
    "name": "Igdir",
    "iso_3166": "TR-76",
    "country": "TR"
  },
  {
    "abbreviation": "32",
    "name": "Isparta",
    "iso_3166": "TR-32",
    "country": "TR"
  },
  {
    "abbreviation": "34",
    "name": "Istanbul",
    "iso_3166": "TR-34",
    "country": "TR"
  },
  {
    "abbreviation": "35",
    "name": "Izmir",
    "iso_3166": "TR-35",
    "country": "TR"
  },
  {
    "abbreviation": "46",
    "name": "Kahramanmaras",
    "iso_3166": "TR-46",
    "country": "TR"
  },
  {
    "abbreviation": "78",
    "name": "Karabuk",
    "iso_3166": "TR-78",
    "country": "TR"
  },
  {
    "abbreviation": "70",
    "name": "Karaman",
    "iso_3166": "TR-70",
    "country": "TR"
  },
  {
    "abbreviation": "36",
    "name": "Kars",
    "iso_3166": "TR-36",
    "country": "TR"
  },
  {
    "abbreviation": "37",
    "name": "Kastamonu",
    "iso_3166": "TR-37",
    "country": "TR"
  },
  {
    "abbreviation": "38",
    "name": "Kayseri",
    "iso_3166": "TR-38",
    "country": "TR"
  },
  {
    "abbreviation": "79",
    "name": "Kilis",
    "iso_3166": "TR-79",
    "country": "TR"
  },
  {
    "abbreviation": "71",
    "name": "Kirikkale",
    "iso_3166": "TR-71",
    "country": "TR"
  },
  {
    "abbreviation": "39",
    "name": "Kirklareli",
    "iso_3166": "TR-39",
    "country": "TR"
  },
  {
    "abbreviation": "40",
    "name": "Kirsehir",
    "iso_3166": "TR-40",
    "country": "TR"
  },
  {
    "abbreviation": "41",
    "name": "Kocaeli",
    "iso_3166": "TR-41",
    "country": "TR"
  },
  {
    "abbreviation": "42",
    "name": "Konya",
    "iso_3166": "TR-42",
    "country": "TR"
  },
  {
    "abbreviation": "43",
    "name": "Kutahya",
    "iso_3166": "TR-43",
    "country": "TR"
  },
  {
    "abbreviation": "44",
    "name": "Malatya",
    "iso_3166": "TR-44",
    "country": "TR"
  },
  {
    "abbreviation": "45",
    "name": "Manisa",
    "iso_3166": "TR-45",
    "country": "TR"
  },
  {
    "abbreviation": "47",
    "name": "Mardin",
    "iso_3166": "TR-47",
    "country": "TR"
  },
  {
    "abbreviation": "33",
    "name": "Mersin",
    "iso_3166": "TR-33",
    "country": "TR"
  },
  {
    "abbreviation": "48",
    "name": "Mugla",
    "iso_3166": "TR-48",
    "country": "TR"
  },
  {
    "abbreviation": "49",
    "name": "Mus",
    "iso_3166": "TR-49",
    "country": "TR"
  },
  {
    "abbreviation": "50",
    "name": "Nevsehir",
    "iso_3166": "TR-50",
    "country": "TR"
  },
  {
    "abbreviation": "51",
    "name": "Nigde",
    "iso_3166": "TR-51",
    "country": "TR"
  },
  {
    "abbreviation": "52",
    "name": "Ordu",
    "iso_3166": "TR-52",
    "country": "TR"
  },
  {
    "abbreviation": "80",
    "name": "Osmaniye",
    "iso_3166": "TR-80",
    "country": "TR"
  },
  {
    "abbreviation": "53",
    "name": "Rize",
    "iso_3166": "TR-53",
    "country": "TR"
  },
  {
    "abbreviation": "54",
    "name": "Sakarya",
    "iso_3166": "TR-54",
    "country": "TR"
  },
  {
    "abbreviation": "55",
    "name": "Samsun",
    "iso_3166": "TR-55",
    "country": "TR"
  },
  {
    "abbreviation": "63",
    "name": "Sanliurfa",
    "iso_3166": "TR-63",
    "country": "TR"
  },
  {
    "abbreviation": "56",
    "name": "Siirt",
    "iso_3166": "TR-56",
    "country": "TR"
  },
  {
    "abbreviation": "57",
    "name": "Sinop",
    "iso_3166": "TR-57",
    "country": "TR"
  },
  {
    "abbreviation": "73",
    "name": "Sirnak",
    "iso_3166": "TR-73",
    "country": "TR"
  },
  {
    "abbreviation": "58",
    "name": "Sivas",
    "iso_3166": "TR-58",
    "country": "TR"
  },
  {
    "abbreviation": "59",
    "name": "Tekirdag",
    "iso_3166": "TR-59",
    "country": "TR"
  },
  {
    "abbreviation": "60",
    "name": "Tokat",
    "iso_3166": "TR-60",
    "country": "TR"
  },
  {
    "abbreviation": "61",
    "name": "Trabzon",
    "iso_3166": "TR-61",
    "country": "TR"
  },
  {
    "abbreviation": "62",
    "name": "Tunceli",
    "iso_3166": "TR-62",
    "country": "TR"
  },
  {
    "abbreviation": "64",
    "name": "Usak",
    "iso_3166": "TR-64",
    "country": "TR"
  },
  {
    "abbreviation": "65",
    "name": "Van",
    "iso_3166": "TR-65",
    "country": "TR"
  },
  {
    "abbreviation": "77",
    "name": "Yalova",
    "iso_3166": "TR-77",
    "country": "TR"
  },
  {
    "abbreviation": "66",
    "name": "Yozgat",
    "iso_3166": "TR-66",
    "country": "TR"
  },
  {
    "abbreviation": "67",
    "name": "Zonguldak",
    "iso_3166": "TR-67",
    "country": "TR"
  },
  {
    "abbreviation": "A",
    "name": "Ahal",
    "iso_3166": "TM-A",
    "country": "TM"
  },
  {
    "abbreviation": "B",
    "name": "Balkan",
    "iso_3166": "TM-B",
    "country": "TM"
  },
  {
    "abbreviation": "D",
    "name": "Dasoguz",
    "iso_3166": "TM-D",
    "country": "TM"
  },
  {
    "abbreviation": "L",
    "name": "Lebap",
    "iso_3166": "TM-L",
    "country": "TM"
  },
  {
    "abbreviation": "M",
    "name": "Mary",
    "iso_3166": "TM-M",
    "country": "TM"
  },
  {
    "abbreviation": "-",
    "name": "Turks and Caicos Islands",
    "iso_3166": "-",
    "country": "TC"
  },
  {
    "abbreviation": "FUN",
    "name": "Funafuti",
    "iso_3166": "TV-FUN",
    "country": "TV"
  },
  {
    "abbreviation": "314",
    "name": "Abim",
    "iso_3166": "UG-314",
    "country": "UG"
  },
  {
    "abbreviation": "301",
    "name": "Adjumani",
    "iso_3166": "UG-301",
    "country": "UG"
  },
  {
    "abbreviation": "322",
    "name": "Agago",
    "iso_3166": "UG-322",
    "country": "UG"
  },
  {
    "abbreviation": "323",
    "name": "Alebtong",
    "iso_3166": "UG-323",
    "country": "UG"
  },
  {
    "abbreviation": "302",
    "name": "Apac",
    "iso_3166": "UG-302",
    "country": "UG"
  },
  {
    "abbreviation": "303",
    "name": "Arua",
    "iso_3166": "UG-303",
    "country": "UG"
  },
  {
    "abbreviation": "218",
    "name": "Bududa",
    "iso_3166": "UG-218",
    "country": "UG"
  },
  {
    "abbreviation": "201",
    "name": "Bugiri",
    "iso_3166": "UG-201",
    "country": "UG"
  },
  {
    "abbreviation": "420",
    "name": "Buhweju",
    "iso_3166": "UG-420",
    "country": "UG"
  },
  {
    "abbreviation": "117",
    "name": "Buikwe",
    "iso_3166": "UG-117",
    "country": "UG"
  },
  {
    "abbreviation": "219",
    "name": "Bukedea",
    "iso_3166": "UG-219",
    "country": "UG"
  },
  {
    "abbreviation": "118",
    "name": "Bukomansibi",
    "iso_3166": "UG-118",
    "country": "UG"
  },
  {
    "abbreviation": "225",
    "name": "Bulambuli",
    "iso_3166": "UG-225",
    "country": "UG"
  },
  {
    "abbreviation": "401",
    "name": "Bundibugyo",
    "iso_3166": "UG-401",
    "country": "UG"
  },
  {
    "abbreviation": "402",
    "name": "Bushenyi",
    "iso_3166": "UG-402",
    "country": "UG"
  },
  {
    "abbreviation": "202",
    "name": "Busia",
    "iso_3166": "UG-202",
    "country": "UG"
  },
  {
    "abbreviation": "120",
    "name": "Buvuma",
    "iso_3166": "UG-120",
    "country": "UG"
  },
  {
    "abbreviation": "226",
    "name": "Buyende",
    "iso_3166": "UG-226",
    "country": "UG"
  },
  {
    "abbreviation": "121",
    "name": "Gomba",
    "iso_3166": "UG-121",
    "country": "UG"
  },
  {
    "abbreviation": "304",
    "name": "Gulu",
    "iso_3166": "UG-304",
    "country": "UG"
  },
  {
    "abbreviation": "403",
    "name": "Hoima",
    "iso_3166": "UG-403",
    "country": "UG"
  },
  {
    "abbreviation": "417",
    "name": "Ibanda",
    "iso_3166": "UG-417",
    "country": "UG"
  },
  {
    "abbreviation": "203",
    "name": "Iganga",
    "iso_3166": "UG-203",
    "country": "UG"
  },
  {
    "abbreviation": "418",
    "name": "Isingiro",
    "iso_3166": "UG-418",
    "country": "UG"
  },
  {
    "abbreviation": "204",
    "name": "Jinja",
    "iso_3166": "UG-204",
    "country": "UG"
  },
  {
    "abbreviation": "318",
    "name": "Kaabong",
    "iso_3166": "UG-318",
    "country": "UG"
  },
  {
    "abbreviation": "404",
    "name": "Kabale",
    "iso_3166": "UG-404",
    "country": "UG"
  },
  {
    "abbreviation": "405",
    "name": "Kabarole",
    "iso_3166": "UG-405",
    "country": "UG"
  },
  {
    "abbreviation": "213",
    "name": "Kaberamaido",
    "iso_3166": "UG-213",
    "country": "UG"
  },
  {
    "abbreviation": "101",
    "name": "Kalangala",
    "iso_3166": "UG-101",
    "country": "UG"
  },
  {
    "abbreviation": "222",
    "name": "Kaliro",
    "iso_3166": "UG-222",
    "country": "UG"
  },
  {
    "abbreviation": "122",
    "name": "Kalungu",
    "iso_3166": "UG-122",
    "country": "UG"
  },
  {
    "abbreviation": "102",
    "name": "Kampala",
    "iso_3166": "UG-102",
    "country": "UG"
  },
  {
    "abbreviation": "205",
    "name": "Kamuli",
    "iso_3166": "UG-205",
    "country": "UG"
  },
  {
    "abbreviation": "413",
    "name": "Kamwenge",
    "iso_3166": "UG-413",
    "country": "UG"
  },
  {
    "abbreviation": "414",
    "name": "Kanungu",
    "iso_3166": "UG-414",
    "country": "UG"
  },
  {
    "abbreviation": "206",
    "name": "Kapchorwa",
    "iso_3166": "UG-206",
    "country": "UG"
  },
  {
    "abbreviation": "406",
    "name": "Kasese",
    "iso_3166": "UG-406",
    "country": "UG"
  },
  {
    "abbreviation": "207",
    "name": "Katakwi",
    "iso_3166": "UG-207",
    "country": "UG"
  },
  {
    "abbreviation": "112",
    "name": "Kayunga",
    "iso_3166": "UG-112",
    "country": "UG"
  },
  {
    "abbreviation": "407",
    "name": "Kibaale",
    "iso_3166": "UG-407",
    "country": "UG"
  },
  {
    "abbreviation": "103",
    "name": "Kiboga",
    "iso_3166": "UG-103",
    "country": "UG"
  },
  {
    "abbreviation": "227",
    "name": "Kibuku",
    "iso_3166": "UG-227",
    "country": "UG"
  },
  {
    "abbreviation": "419",
    "name": "Kiruhura",
    "iso_3166": "UG-419",
    "country": "UG"
  },
  {
    "abbreviation": "421",
    "name": "Kiryandongo",
    "iso_3166": "UG-421",
    "country": "UG"
  },
  {
    "abbreviation": "408",
    "name": "Kisoro",
    "iso_3166": "UG-408",
    "country": "UG"
  },
  {
    "abbreviation": "305",
    "name": "Kitgum",
    "iso_3166": "UG-305",
    "country": "UG"
  },
  {
    "abbreviation": "319",
    "name": "Koboko",
    "iso_3166": "UG-319",
    "country": "UG"
  },
  {
    "abbreviation": "325",
    "name": "Kole",
    "iso_3166": "UG-325",
    "country": "UG"
  },
  {
    "abbreviation": "228",
    "name": "Kween",
    "iso_3166": "UG-228",
    "country": "UG"
  },
  {
    "abbreviation": "123",
    "name": "Kyankwanzi",
    "iso_3166": "UG-123",
    "country": "UG"
  },
  {
    "abbreviation": "422",
    "name": "Kyegegwa",
    "iso_3166": "UG-422",
    "country": "UG"
  },
  {
    "abbreviation": "415",
    "name": "Kyenjojo",
    "iso_3166": "UG-415",
    "country": "UG"
  },
  {
    "abbreviation": "326",
    "name": "Lamwo",
    "iso_3166": "UG-326",
    "country": "UG"
  },
  {
    "abbreviation": "307",
    "name": "Lira",
    "iso_3166": "UG-307",
    "country": "UG"
  },
  {
    "abbreviation": "229",
    "name": "Luuka",
    "iso_3166": "UG-229",
    "country": "UG"
  },
  {
    "abbreviation": "104",
    "name": "Luwero",
    "iso_3166": "UG-104",
    "country": "UG"
  },
  {
    "abbreviation": "124",
    "name": "Lwengo",
    "iso_3166": "UG-124",
    "country": "UG"
  },
  {
    "abbreviation": "114",
    "name": "Lyantonde",
    "iso_3166": "UG-114",
    "country": "UG"
  },
  {
    "abbreviation": "223",
    "name": "Manafwa",
    "iso_3166": "UG-223",
    "country": "UG"
  },
  {
    "abbreviation": "320",
    "name": "Maracha",
    "iso_3166": "UG-320",
    "country": "UG"
  },
  {
    "abbreviation": "105",
    "name": "Masaka",
    "iso_3166": "UG-105",
    "country": "UG"
  },
  {
    "abbreviation": "409",
    "name": "Masindi",
    "iso_3166": "UG-409",
    "country": "UG"
  },
  {
    "abbreviation": "214",
    "name": "Mayuge",
    "iso_3166": "UG-214",
    "country": "UG"
  },
  {
    "abbreviation": "209",
    "name": "Mbale",
    "iso_3166": "UG-209",
    "country": "UG"
  },
  {
    "abbreviation": "410",
    "name": "Mbarara",
    "iso_3166": "UG-410",
    "country": "UG"
  },
  {
    "abbreviation": "423",
    "name": "Mitooma",
    "iso_3166": "UG-423",
    "country": "UG"
  },
  {
    "abbreviation": "115",
    "name": "Mityana",
    "iso_3166": "UG-115",
    "country": "UG"
  },
  {
    "abbreviation": "308",
    "name": "Moroto",
    "iso_3166": "UG-308",
    "country": "UG"
  },
  {
    "abbreviation": "309",
    "name": "Moyo",
    "iso_3166": "UG-309",
    "country": "UG"
  },
  {
    "abbreviation": "106",
    "name": "Mpigi",
    "iso_3166": "UG-106",
    "country": "UG"
  },
  {
    "abbreviation": "107",
    "name": "Mubende",
    "iso_3166": "UG-107",
    "country": "UG"
  },
  {
    "abbreviation": "108",
    "name": "Mukono",
    "iso_3166": "UG-108",
    "country": "UG"
  },
  {
    "abbreviation": "311",
    "name": "Nakapiripirit",
    "iso_3166": "UG-311",
    "country": "UG"
  },
  {
    "abbreviation": "116",
    "name": "Nakaseke",
    "iso_3166": "UG-116",
    "country": "UG"
  },
  {
    "abbreviation": "109",
    "name": "Nakasongola",
    "iso_3166": "UG-109",
    "country": "UG"
  },
  {
    "abbreviation": "230",
    "name": "Namayingo",
    "iso_3166": "UG-230",
    "country": "UG"
  },
  {
    "abbreviation": "327",
    "name": "Napak",
    "iso_3166": "UG-327",
    "country": "UG"
  },
  {
    "abbreviation": "310",
    "name": "Nebbi",
    "iso_3166": "UG-310",
    "country": "UG"
  },
  {
    "abbreviation": "424",
    "name": "Ntoroko",
    "iso_3166": "UG-424",
    "country": "UG"
  },
  {
    "abbreviation": "411",
    "name": "Ntungamo",
    "iso_3166": "UG-411",
    "country": "UG"
  },
  {
    "abbreviation": "328",
    "name": "Nwoya",
    "iso_3166": "UG-328",
    "country": "UG"
  },
  {
    "abbreviation": "321",
    "name": "Oyam",
    "iso_3166": "UG-321",
    "country": "UG"
  },
  {
    "abbreviation": "312",
    "name": "Pader",
    "iso_3166": "UG-312",
    "country": "UG"
  },
  {
    "abbreviation": "110",
    "name": "Rakai",
    "iso_3166": "UG-110",
    "country": "UG"
  },
  {
    "abbreviation": "425",
    "name": "Rubirizi",
    "iso_3166": "UG-425",
    "country": "UG"
  },
  {
    "abbreviation": "412",
    "name": "Rukungiri",
    "iso_3166": "UG-412",
    "country": "UG"
  },
  {
    "abbreviation": "111",
    "name": "Sembabule",
    "iso_3166": "UG-111",
    "country": "UG"
  },
  {
    "abbreviation": "426",
    "name": "Sheema",
    "iso_3166": "UG-426",
    "country": "UG"
  },
  {
    "abbreviation": "215",
    "name": "Sironko",
    "iso_3166": "UG-215",
    "country": "UG"
  },
  {
    "abbreviation": "211",
    "name": "Soroti",
    "iso_3166": "UG-211",
    "country": "UG"
  },
  {
    "abbreviation": "212",
    "name": "Tororo",
    "iso_3166": "UG-212",
    "country": "UG"
  },
  {
    "abbreviation": "113",
    "name": "Wakiso",
    "iso_3166": "UG-113",
    "country": "UG"
  },
  {
    "abbreviation": "313",
    "name": "Yumbe",
    "iso_3166": "UG-313",
    "country": "UG"
  },
  {
    "abbreviation": "330",
    "name": "Zombo",
    "iso_3166": "UG-330",
    "country": "UG"
  },
  {
    "abbreviation": "43",
    "name": "Avtonomna Respublika Krym",
    "iso_3166": "UA-43",
    "country": "UA"
  },
  {
    "abbreviation": "71",
    "name": "Cherkaska oblast",
    "iso_3166": "UA-71",
    "country": "UA"
  },
  {
    "abbreviation": "74",
    "name": "Chernihivska oblast",
    "iso_3166": "UA-74",
    "country": "UA"
  },
  {
    "abbreviation": "77",
    "name": "Chernivetska oblast",
    "iso_3166": "UA-77",
    "country": "UA"
  },
  {
    "abbreviation": "12",
    "name": "Dnipropetrovska oblast",
    "iso_3166": "UA-12",
    "country": "UA"
  },
  {
    "abbreviation": "14",
    "name": "Donetska oblast",
    "iso_3166": "UA-14",
    "country": "UA"
  },
  {
    "abbreviation": "26",
    "name": "Ivano-Frankivska oblast",
    "iso_3166": "UA-26",
    "country": "UA"
  },
  {
    "abbreviation": "63",
    "name": "Kharkivska oblast",
    "iso_3166": "UA-63",
    "country": "UA"
  },
  {
    "abbreviation": "65",
    "name": "Khersonska oblast",
    "iso_3166": "UA-65",
    "country": "UA"
  },
  {
    "abbreviation": "68",
    "name": "Khmelnytska oblast",
    "iso_3166": "UA-68",
    "country": "UA"
  },
  {
    "abbreviation": "35",
    "name": "Kirovohradska oblast",
    "iso_3166": "UA-35",
    "country": "UA"
  },
  {
    "abbreviation": "30",
    "name": "Kyiv",
    "iso_3166": "UA-30",
    "country": "UA"
  },
  {
    "abbreviation": "32",
    "name": "Kyivska oblast",
    "iso_3166": "UA-32",
    "country": "UA"
  },
  {
    "abbreviation": "09",
    "name": "Luhanska oblast",
    "iso_3166": "UA-09",
    "country": "UA"
  },
  {
    "abbreviation": "46",
    "name": "Lvivska oblast",
    "iso_3166": "UA-46",
    "country": "UA"
  },
  {
    "abbreviation": "48",
    "name": "Mykolaivska oblast",
    "iso_3166": "UA-48",
    "country": "UA"
  },
  {
    "abbreviation": "51",
    "name": "Odeska oblast",
    "iso_3166": "UA-51",
    "country": "UA"
  },
  {
    "abbreviation": "53",
    "name": "Poltavska oblast",
    "iso_3166": "UA-53",
    "country": "UA"
  },
  {
    "abbreviation": "56",
    "name": "Rivnenska oblast",
    "iso_3166": "UA-56",
    "country": "UA"
  },
  {
    "abbreviation": "40",
    "name": "Sevastopol",
    "iso_3166": "UA-40",
    "country": "UA"
  },
  {
    "abbreviation": "59",
    "name": "Sumska oblast",
    "iso_3166": "UA-59",
    "country": "UA"
  },
  {
    "abbreviation": "61",
    "name": "Ternopilska oblast",
    "iso_3166": "UA-61",
    "country": "UA"
  },
  {
    "abbreviation": "05",
    "name": "Vinnytska oblast",
    "iso_3166": "UA-05",
    "country": "UA"
  },
  {
    "abbreviation": "07",
    "name": "Volynska oblast",
    "iso_3166": "UA-07",
    "country": "UA"
  },
  {
    "abbreviation": "21",
    "name": "Zakarpatska oblast",
    "iso_3166": "UA-21",
    "country": "UA"
  },
  {
    "abbreviation": "23",
    "name": "Zaporizka oblast",
    "iso_3166": "UA-23",
    "country": "UA"
  },
  {
    "abbreviation": "18",
    "name": "Zhytomyrska oblast",
    "iso_3166": "UA-18",
    "country": "UA"
  },
  {
    "abbreviation": "AJ",
    "name": "'Ajman",
    "iso_3166": "AE-AJ",
    "country": "AE"
  },
  {
    "abbreviation": "AZ",
    "name": "Abu Zaby",
    "iso_3166": "AE-AZ",
    "country": "AE"
  },
  {
    "abbreviation": "FU",
    "name": "Al Fujayrah",
    "iso_3166": "AE-FU",
    "country": "AE"
  },
  {
    "abbreviation": "SH",
    "name": "Ash Shariqah",
    "iso_3166": "AE-SH",
    "country": "AE"
  },
  {
    "abbreviation": "DU",
    "name": "Dubayy",
    "iso_3166": "AE-DU",
    "country": "AE"
  },
  {
    "abbreviation": "RK",
    "name": "Ra's al Khaymah",
    "iso_3166": "AE-RK",
    "country": "AE"
  },
  {
    "abbreviation": "UQ",
    "name": "Umm al Qaywayn",
    "iso_3166": "AE-UQ",
    "country": "AE"
  },
  {
    "abbreviation": "ENG",
    "name": "England",
    "iso_3166": "GB-ENG",
    "country": "GB"
  },
  {
    "abbreviation": "NIR",
    "name": "Northern Ireland",
    "iso_3166": "GB-NIR",
    "country": "GB"
  },
  {
    "abbreviation": "SCT",
    "name": "Scotland",
    "iso_3166": "GB-SCT",
    "country": "GB"
  },
  {
    "abbreviation": "WLS",
    "name": "Wales",
    "iso_3166": "GB-WLS",
    "country": "GB"
  },
  {
    "abbreviation": "AR",
    "name": "Artigas",
    "iso_3166": "UY-AR",
    "country": "UY"
  },
  {
    "abbreviation": "CA",
    "name": "Canelones",
    "iso_3166": "UY-CA",
    "country": "UY"
  },
  {
    "abbreviation": "CL",
    "name": "Cerro Largo",
    "iso_3166": "UY-CL",
    "country": "UY"
  },
  {
    "abbreviation": "CO",
    "name": "Colonia",
    "iso_3166": "UY-CO",
    "country": "UY"
  },
  {
    "abbreviation": "DU",
    "name": "Durazno",
    "iso_3166": "UY-DU",
    "country": "UY"
  },
  {
    "abbreviation": "FS",
    "name": "Flores",
    "iso_3166": "UY-FS",
    "country": "UY"
  },
  {
    "abbreviation": "FD",
    "name": "Florida",
    "iso_3166": "UY-FD",
    "country": "UY"
  },
  {
    "abbreviation": "LA",
    "name": "Lavalleja",
    "iso_3166": "UY-LA",
    "country": "UY"
  },
  {
    "abbreviation": "MA",
    "name": "Maldonado",
    "iso_3166": "UY-MA",
    "country": "UY"
  },
  {
    "abbreviation": "MO",
    "name": "Montevideo",
    "iso_3166": "UY-MO",
    "country": "UY"
  },
  {
    "abbreviation": "PA",
    "name": "Paysandu",
    "iso_3166": "UY-PA",
    "country": "UY"
  },
  {
    "abbreviation": "RN",
    "name": "Rio Negro",
    "iso_3166": "UY-RN",
    "country": "UY"
  },
  {
    "abbreviation": "RV",
    "name": "Rivera",
    "iso_3166": "UY-RV",
    "country": "UY"
  },
  {
    "abbreviation": "RO",
    "name": "Rocha",
    "iso_3166": "UY-RO",
    "country": "UY"
  },
  {
    "abbreviation": "SA",
    "name": "Salto",
    "iso_3166": "UY-SA",
    "country": "UY"
  },
  {
    "abbreviation": "SJ",
    "name": "San Jose",
    "iso_3166": "UY-SJ",
    "country": "UY"
  },
  {
    "abbreviation": "SO",
    "name": "Soriano",
    "iso_3166": "UY-SO",
    "country": "UY"
  },
  {
    "abbreviation": "TA",
    "name": "Tacuarembo",
    "iso_3166": "UY-TA",
    "country": "UY"
  },
  {
    "abbreviation": "TT",
    "name": "Treinta y Tres",
    "iso_3166": "UY-TT",
    "country": "UY"
  },
  {
    "abbreviation": "AN",
    "name": "Andijon",
    "iso_3166": "UZ-AN",
    "country": "UZ"
  },
  {
    "abbreviation": "BU",
    "name": "Buxoro",
    "iso_3166": "UZ-BU",
    "country": "UZ"
  },
  {
    "abbreviation": "FA",
    "name": "Farg'ona",
    "iso_3166": "UZ-FA",
    "country": "UZ"
  },
  {
    "abbreviation": "JI",
    "name": "Jizzax",
    "iso_3166": "UZ-JI",
    "country": "UZ"
  },
  {
    "abbreviation": "NG",
    "name": "Namangan",
    "iso_3166": "UZ-NG",
    "country": "UZ"
  },
  {
    "abbreviation": "NW",
    "name": "Navoiy",
    "iso_3166": "UZ-NW",
    "country": "UZ"
  },
  {
    "abbreviation": "QA",
    "name": "Qashqadaryo",
    "iso_3166": "UZ-QA",
    "country": "UZ"
  },
  {
    "abbreviation": "QR",
    "name": "Qoraqalpog'iston Respublikasi",
    "iso_3166": "UZ-QR",
    "country": "UZ"
  },
  {
    "abbreviation": "SA",
    "name": "Samarqand",
    "iso_3166": "UZ-SA",
    "country": "UZ"
  },
  {
    "abbreviation": "SI",
    "name": "Sirdaryo",
    "iso_3166": "UZ-SI",
    "country": "UZ"
  },
  {
    "abbreviation": "SU",
    "name": "Surxondaryo",
    "iso_3166": "UZ-SU",
    "country": "UZ"
  },
  {
    "abbreviation": "TK",
    "name": "Toshkent",
    "iso_3166": "UZ-TK",
    "country": "UZ"
  },
  {
    "abbreviation": "XO",
    "name": "Xorazm",
    "iso_3166": "UZ-XO",
    "country": "UZ"
  },
  {
    "abbreviation": "SAM",
    "name": "Sanma",
    "iso_3166": "VU-SAM",
    "country": "VU"
  },
  {
    "abbreviation": "SEE",
    "name": "Shefa",
    "iso_3166": "VU-SEE",
    "country": "VU"
  },
  {
    "abbreviation": "TAE",
    "name": "Tafea",
    "iso_3166": "VU-TAE",
    "country": "VU"
  },
  {
    "abbreviation": "TOB",
    "name": "Torba",
    "iso_3166": "VU-TOB",
    "country": "VU"
  },
  {
    "abbreviation": "Z",
    "name": "Amazonas",
    "iso_3166": "VE-Z",
    "country": "VE"
  },
  {
    "abbreviation": "B",
    "name": "Anzoategui",
    "iso_3166": "VE-B",
    "country": "VE"
  },
  {
    "abbreviation": "C",
    "name": "Apure",
    "iso_3166": "VE-C",
    "country": "VE"
  },
  {
    "abbreviation": "D",
    "name": "Aragua",
    "iso_3166": "VE-D",
    "country": "VE"
  },
  {
    "abbreviation": "E",
    "name": "Barinas",
    "iso_3166": "VE-E",
    "country": "VE"
  },
  {
    "abbreviation": "F",
    "name": "Bolivar",
    "iso_3166": "VE-F",
    "country": "VE"
  },
  {
    "abbreviation": "G",
    "name": "Carabobo",
    "iso_3166": "VE-G",
    "country": "VE"
  },
  {
    "abbreviation": "H",
    "name": "Cojedes",
    "iso_3166": "VE-H",
    "country": "VE"
  },
  {
    "abbreviation": "Y",
    "name": "Delta Amacuro",
    "iso_3166": "VE-Y",
    "country": "VE"
  },
  {
    "abbreviation": "W",
    "name": "Dependencias Federales",
    "iso_3166": "VE-W",
    "country": "VE"
  },
  {
    "abbreviation": "A",
    "name": "Distrito Capital",
    "iso_3166": "VE-A",
    "country": "VE"
  },
  {
    "abbreviation": "I",
    "name": "Falcon",
    "iso_3166": "VE-I",
    "country": "VE"
  },
  {
    "abbreviation": "J",
    "name": "Guarico",
    "iso_3166": "VE-J",
    "country": "VE"
  },
  {
    "abbreviation": "X",
    "name": "La Guaira",
    "iso_3166": "VE-X",
    "country": "VE"
  },
  {
    "abbreviation": "K",
    "name": "Lara",
    "iso_3166": "VE-K",
    "country": "VE"
  },
  {
    "abbreviation": "L",
    "name": "Merida",
    "iso_3166": "VE-L",
    "country": "VE"
  },
  {
    "abbreviation": "M",
    "name": "Miranda",
    "iso_3166": "VE-M",
    "country": "VE"
  },
  {
    "abbreviation": "N",
    "name": "Monagas",
    "iso_3166": "VE-N",
    "country": "VE"
  },
  {
    "abbreviation": "O",
    "name": "Nueva Esparta",
    "iso_3166": "VE-O",
    "country": "VE"
  },
  {
    "abbreviation": "P",
    "name": "Portuguesa",
    "iso_3166": "VE-P",
    "country": "VE"
  },
  {
    "abbreviation": "R",
    "name": "Sucre",
    "iso_3166": "VE-R",
    "country": "VE"
  },
  {
    "abbreviation": "S",
    "name": "Tachira",
    "iso_3166": "VE-S",
    "country": "VE"
  },
  {
    "abbreviation": "T",
    "name": "Trujillo",
    "iso_3166": "VE-T",
    "country": "VE"
  },
  {
    "abbreviation": "U",
    "name": "Yaracuy",
    "iso_3166": "VE-U",
    "country": "VE"
  },
  {
    "abbreviation": "V",
    "name": "Zulia",
    "iso_3166": "VE-V",
    "country": "VE"
  },
  {
    "abbreviation": "44",
    "name": "An Giang",
    "iso_3166": "VN-44",
    "country": "VN"
  },
  {
    "abbreviation": "43",
    "name": "Ba Ria - Vung Tau",
    "iso_3166": "VN-43",
    "country": "VN"
  },
  {
    "abbreviation": "54",
    "name": "Bac Giang",
    "iso_3166": "VN-54",
    "country": "VN"
  },
  {
    "abbreviation": "53",
    "name": "Bac Kan",
    "iso_3166": "VN-53",
    "country": "VN"
  },
  {
    "abbreviation": "55",
    "name": "Bac Lieu",
    "iso_3166": "VN-55",
    "country": "VN"
  },
  {
    "abbreviation": "56",
    "name": "Bac Ninh",
    "iso_3166": "VN-56",
    "country": "VN"
  },
  {
    "abbreviation": "50",
    "name": "Ben Tre",
    "iso_3166": "VN-50",
    "country": "VN"
  },
  {
    "abbreviation": "31",
    "name": "Binh Dinh",
    "iso_3166": "VN-31",
    "country": "VN"
  },
  {
    "abbreviation": "57",
    "name": "Binh Duong",
    "iso_3166": "VN-57",
    "country": "VN"
  },
  {
    "abbreviation": "58",
    "name": "Binh Phuoc",
    "iso_3166": "VN-58",
    "country": "VN"
  },
  {
    "abbreviation": "40",
    "name": "Binh Thuan",
    "iso_3166": "VN-40",
    "country": "VN"
  },
  {
    "abbreviation": "59",
    "name": "Ca Mau",
    "iso_3166": "VN-59",
    "country": "VN"
  },
  {
    "abbreviation": "CT",
    "name": "Can Tho",
    "iso_3166": "VN-CT",
    "country": "VN"
  },
  {
    "abbreviation": "04",
    "name": "Cao Bang",
    "iso_3166": "VN-04",
    "country": "VN"
  },
  {
    "abbreviation": "DN",
    "name": "Da Nang",
    "iso_3166": "VN-DN",
    "country": "VN"
  },
  {
    "abbreviation": "33",
    "name": "Dak Lak",
    "iso_3166": "VN-33",
    "country": "VN"
  },
  {
    "abbreviation": "72",
    "name": "Dak Nong",
    "iso_3166": "VN-72",
    "country": "VN"
  },
  {
    "abbreviation": "71",
    "name": "Dien Bien",
    "iso_3166": "VN-71",
    "country": "VN"
  },
  {
    "abbreviation": "39",
    "name": "Dong Nai",
    "iso_3166": "VN-39",
    "country": "VN"
  },
  {
    "abbreviation": "45",
    "name": "Dong Thap",
    "iso_3166": "VN-45",
    "country": "VN"
  },
  {
    "abbreviation": "30",
    "name": "Gia Lai",
    "iso_3166": "VN-30",
    "country": "VN"
  },
  {
    "abbreviation": "03",
    "name": "Ha Giang",
    "iso_3166": "VN-03",
    "country": "VN"
  },
  {
    "abbreviation": "63",
    "name": "Ha Nam",
    "iso_3166": "VN-63",
    "country": "VN"
  },
  {
    "abbreviation": "HN",
    "name": "Ha Noi",
    "iso_3166": "VN-HN",
    "country": "VN"
  },
  {
    "abbreviation": "23",
    "name": "Ha Tinh",
    "iso_3166": "VN-23",
    "country": "VN"
  },
  {
    "abbreviation": "61",
    "name": "Hai Duong",
    "iso_3166": "VN-61",
    "country": "VN"
  },
  {
    "abbreviation": "HP",
    "name": "Hai Phong",
    "iso_3166": "VN-HP",
    "country": "VN"
  },
  {
    "abbreviation": "73",
    "name": "Hau Giang",
    "iso_3166": "VN-73",
    "country": "VN"
  },
  {
    "abbreviation": "SG",
    "name": "Ho Chi Minh",
    "iso_3166": "VN-SG",
    "country": "VN"
  },
  {
    "abbreviation": "14",
    "name": "Hoa Binh",
    "iso_3166": "VN-14",
    "country": "VN"
  },
  {
    "abbreviation": "66",
    "name": "Hung Yen",
    "iso_3166": "VN-66",
    "country": "VN"
  },
  {
    "abbreviation": "34",
    "name": "Khanh Hoa",
    "iso_3166": "VN-34",
    "country": "VN"
  },
  {
    "abbreviation": "47",
    "name": "Kien Giang",
    "iso_3166": "VN-47",
    "country": "VN"
  },
  {
    "abbreviation": "28",
    "name": "Kon Tum",
    "iso_3166": "VN-28",
    "country": "VN"
  },
  {
    "abbreviation": "01",
    "name": "Lai Chau",
    "iso_3166": "VN-01",
    "country": "VN"
  },
  {
    "abbreviation": "35",
    "name": "Lam Dong",
    "iso_3166": "VN-35",
    "country": "VN"
  },
  {
    "abbreviation": "09",
    "name": "Lang Son",
    "iso_3166": "VN-09",
    "country": "VN"
  },
  {
    "abbreviation": "02",
    "name": "Lao Cai",
    "iso_3166": "VN-02",
    "country": "VN"
  },
  {
    "abbreviation": "41",
    "name": "Long An",
    "iso_3166": "VN-41",
    "country": "VN"
  },
  {
    "abbreviation": "67",
    "name": "Nam Dinh",
    "iso_3166": "VN-67",
    "country": "VN"
  },
  {
    "abbreviation": "22",
    "name": "Nghe An",
    "iso_3166": "VN-22",
    "country": "VN"
  },
  {
    "abbreviation": "18",
    "name": "Ninh Binh",
    "iso_3166": "VN-18",
    "country": "VN"
  },
  {
    "abbreviation": "36",
    "name": "Ninh Thuan",
    "iso_3166": "VN-36",
    "country": "VN"
  },
  {
    "abbreviation": "68",
    "name": "Phu Tho",
    "iso_3166": "VN-68",
    "country": "VN"
  },
  {
    "abbreviation": "32",
    "name": "Phu Yen",
    "iso_3166": "VN-32",
    "country": "VN"
  },
  {
    "abbreviation": "24",
    "name": "Quang Binh",
    "iso_3166": "VN-24",
    "country": "VN"
  },
  {
    "abbreviation": "27",
    "name": "Quang Nam",
    "iso_3166": "VN-27",
    "country": "VN"
  },
  {
    "abbreviation": "29",
    "name": "Quang Ngai",
    "iso_3166": "VN-29",
    "country": "VN"
  },
  {
    "abbreviation": "13",
    "name": "Quang Ninh",
    "iso_3166": "VN-13",
    "country": "VN"
  },
  {
    "abbreviation": "25",
    "name": "Quang Tri",
    "iso_3166": "VN-25",
    "country": "VN"
  },
  {
    "abbreviation": "52",
    "name": "Soc Trang",
    "iso_3166": "VN-52",
    "country": "VN"
  },
  {
    "abbreviation": "05",
    "name": "Son La",
    "iso_3166": "VN-05",
    "country": "VN"
  },
  {
    "abbreviation": "37",
    "name": "Tay Ninh",
    "iso_3166": "VN-37",
    "country": "VN"
  },
  {
    "abbreviation": "20",
    "name": "Thai Binh",
    "iso_3166": "VN-20",
    "country": "VN"
  },
  {
    "abbreviation": "69",
    "name": "Thai Nguyen",
    "iso_3166": "VN-69",
    "country": "VN"
  },
  {
    "abbreviation": "21",
    "name": "Thanh Hoa",
    "iso_3166": "VN-21",
    "country": "VN"
  },
  {
    "abbreviation": "26",
    "name": "Thua Thien-Hue",
    "iso_3166": "VN-26",
    "country": "VN"
  },
  {
    "abbreviation": "46",
    "name": "Tien Giang",
    "iso_3166": "VN-46",
    "country": "VN"
  },
  {
    "abbreviation": "51",
    "name": "Tra Vinh",
    "iso_3166": "VN-51",
    "country": "VN"
  },
  {
    "abbreviation": "07",
    "name": "Tuyen Quang",
    "iso_3166": "VN-07",
    "country": "VN"
  },
  {
    "abbreviation": "49",
    "name": "Vinh Long",
    "iso_3166": "VN-49",
    "country": "VN"
  },
  {
    "abbreviation": "70",
    "name": "Vinh Phuc",
    "iso_3166": "VN-70",
    "country": "VN"
  },
  {
    "abbreviation": "06",
    "name": "Yen Bai",
    "iso_3166": "VN-06",
    "country": "VN"
  },
  {
    "abbreviation": "SG",
    "name": "Sigave",
    "iso_3166": "WF-SG",
    "country": "WF"
  },
  {
    "abbreviation": "UV",
    "name": "Uvea",
    "iso_3166": "WF-UV",
    "country": "WF"
  },
  {
    "abbreviation": "-",
    "name": "Western Sahara",
    "iso_3166": "-",
    "country": "EH"
  },
  {
    "abbreviation": "AD",
    "name": "'Adan",
    "iso_3166": "YE-AD",
    "country": "YE"
  },
  {
    "abbreviation": "AM",
    "name": "'Amran",
    "iso_3166": "YE-AM",
    "country": "YE"
  },
  {
    "abbreviation": "DA",
    "name": "Ad Dali'",
    "iso_3166": "YE-DA",
    "country": "YE"
  },
  {
    "abbreviation": "BA",
    "name": "Al Bayda'",
    "iso_3166": "YE-BA",
    "country": "YE"
  },
  {
    "abbreviation": "HU",
    "name": "Al Hudaydah",
    "iso_3166": "YE-HU",
    "country": "YE"
  },
  {
    "abbreviation": "JA",
    "name": "Al Jawf",
    "iso_3166": "YE-JA",
    "country": "YE"
  },
  {
    "abbreviation": "MW",
    "name": "Al Mahwit",
    "iso_3166": "YE-MW",
    "country": "YE"
  },
  {
    "abbreviation": "SA",
    "name": "Amanat al 'Asimah",
    "iso_3166": "YE-SA",
    "country": "YE"
  },
  {
    "abbreviation": "DH",
    "name": "Dhamar",
    "iso_3166": "YE-DH",
    "country": "YE"
  },
  {
    "abbreviation": "HD",
    "name": "Hadramawt",
    "iso_3166": "YE-HD",
    "country": "YE"
  },
  {
    "abbreviation": "HJ",
    "name": "Hajjah",
    "iso_3166": "YE-HJ",
    "country": "YE"
  },
  {
    "abbreviation": "IB",
    "name": "Ibb",
    "iso_3166": "YE-IB",
    "country": "YE"
  },
  {
    "abbreviation": "LA",
    "name": "Lahij",
    "iso_3166": "YE-LA",
    "country": "YE"
  },
  {
    "abbreviation": "MA",
    "name": "Ma'rib",
    "iso_3166": "YE-MA",
    "country": "YE"
  },
  {
    "abbreviation": "RA",
    "name": "Raymah",
    "iso_3166": "YE-RA",
    "country": "YE"
  },
  {
    "abbreviation": "SD",
    "name": "Sa'dah",
    "iso_3166": "YE-SD",
    "country": "YE"
  },
  {
    "abbreviation": "SN",
    "name": "San'a'",
    "iso_3166": "YE-SN",
    "country": "YE"
  },
  {
    "abbreviation": "SH",
    "name": "Shabwah",
    "iso_3166": "YE-SH",
    "country": "YE"
  },
  {
    "abbreviation": "TA",
    "name": "Ta'izz",
    "iso_3166": "YE-TA",
    "country": "YE"
  },
  {
    "abbreviation": "02",
    "name": "Central",
    "iso_3166": "ZM-02",
    "country": "ZM"
  },
  {
    "abbreviation": "08",
    "name": "Copperbelt",
    "iso_3166": "ZM-08",
    "country": "ZM"
  },
  {
    "abbreviation": "03",
    "name": "Eastern",
    "iso_3166": "ZM-03",
    "country": "ZM"
  },
  {
    "abbreviation": "04",
    "name": "Luapula",
    "iso_3166": "ZM-04",
    "country": "ZM"
  },
  {
    "abbreviation": "09",
    "name": "Lusaka",
    "iso_3166": "ZM-09",
    "country": "ZM"
  },
  {
    "abbreviation": "10",
    "name": "Muchinga",
    "iso_3166": "ZM-10",
    "country": "ZM"
  },
  {
    "abbreviation": "06",
    "name": "North-Western",
    "iso_3166": "ZM-06",
    "country": "ZM"
  },
  {
    "abbreviation": "05",
    "name": "Northern",
    "iso_3166": "ZM-05",
    "country": "ZM"
  },
  {
    "abbreviation": "07",
    "name": "Southern",
    "iso_3166": "ZM-07",
    "country": "ZM"
  },
  {
    "abbreviation": "01",
    "name": "Western",
    "iso_3166": "ZM-01",
    "country": "ZM"
  },
  {
    "abbreviation": "BU",
    "name": "Bulawayo",
    "iso_3166": "ZW-BU",
    "country": "ZW"
  },
  {
    "abbreviation": "HA",
    "name": "Harare",
    "iso_3166": "ZW-HA",
    "country": "ZW"
  },
  {
    "abbreviation": "MA",
    "name": "Manicaland",
    "iso_3166": "ZW-MA",
    "country": "ZW"
  },
  {
    "abbreviation": "MC",
    "name": "Mashonaland Central",
    "iso_3166": "ZW-MC",
    "country": "ZW"
  },
  {
    "abbreviation": "ME",
    "name": "Mashonaland East",
    "iso_3166": "ZW-ME",
    "country": "ZW"
  },
  {
    "abbreviation": "MW",
    "name": "Mashonaland West",
    "iso_3166": "ZW-MW",
    "country": "ZW"
  },
  {
    "abbreviation": "MV",
    "name": "Masvingo",
    "iso_3166": "ZW-MV",
    "country": "ZW"
  },
  {
    "abbreviation": "MN",
    "name": "Matabeleland North",
    "iso_3166": "ZW-MN",
    "country": "ZW"
  },
  {
    "abbreviation": "MS",
    "name": "Matabeleland South",
    "iso_3166": "ZW-MS",
    "country": "ZW"
  },
  {
    "abbreviation": "MI",
    "name": "Midlands",
    "iso_3166": "ZW-MI",
    "country": "ZW"
  }
];

export default states;
